// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/icomoon.eot?buz9qd", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/icomoon.ttf?buz9qd", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/icomoon.woff?buz9qd", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/icomoon.svg?buz9qd", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___, { hash: "#icomoon" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes anim {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes heroShapeFour {
  0%, 100% {
    border-radius: 42% 58% 70% 30%/45% 45% 55% 55%;
    transform: translate3d(0, 0, 0) rotateZ(0.02deg);
  }
  35% {
    border-radius: 70% 30% 46% 54%/30% 29% 71% 70%;
    transform: translate3d(0, 10px, 0) rotateZ(0.02deg);
  }
  50% {
    transform: translate3d(0, 0, 0) rotateZ(0.02deg);
  }
  65% {
    border-radius: 100% 60% 60% 100%/100% 100% 60% 60%;
    transform: translate3d(0, 20px, 0) rotateZ(0.03deg);
  }
}
/* banner__section  end */
/* service__section */
/* service__section  end */
/* about-section  */
/* about-section  end */
/* choose__us-section */
/* choose__us-section  end */
/* team-section   */
/* team-section end*/
/* accomplised-section   */
/* accomplised-section  end */
/* testimonial -section */
/* testimonial-section  end */
/* brand__section  */
/* brand__section end */
/* blog__section  */
/* blog__section end */
/*** 

====================================================================
                        Home-Page-Two
====================================================================

***/
/** header-two **/
/** header-two **/
/** banner-section **/
/* slider text animation */
/* slider text animation end */
/* accomplised-section */
/* accomplised-section-end */
/* brand-section */
/* brand-section-end */
/* progress-section */
/* progress-section-end */
/* about-section */
/* about-section-end */
/* service__two-section */
/* service__two-section-end */
/* choose___two-section-end */
/* choose___two-section-end */
/* price-section */
/* price-section-end */
/* portfolio-section */
/* portfolio-section-end */
/* portfolio-section-end */
/* portfolio-section-end */
/* About Page */
/* About Page End*/
/* Service Page */
/* Service Page End*/
/* testimonial page */
/* testimonial page end */
/* blog-details */
/* blog-details end */
/* contact page */
/* contact page */
/* service page */
/* service page */
/* brand new */
@keyframes aspro-scroller {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(-100%, 0);
  }
}
@keyframes aspro-scroller-reverse {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(100%, 0);
  }
}
/* brand new end */
/*** 

====================================================================
                        Home-Page-Three
====================================================================

***/
/* header__three */
/* header__three end */
/* about__three  */
/* about__three end */
/* banner__three */
/* banner__three end*/
/* choose__three */
/* choose__three end*/
/* portfolio three */
/* portfolio three end*/
/* accomplised */
/* accomplised end */
/* consultation  */
/* consultation end */
/*** 

====================================================================
                        Service Details
====================================================================

***/
/*** 

====================================================================
                        404 Page
====================================================================

***/
/*** 

====================================================================
                        Project Details
====================================================================

***/
.circle-main {
  text-align: center;
  height: 230px;
  width: 230px;
  display: block;
  background: #f6ec4f;
  border-radius: 50%;
  position: relative;
}
.circle-main .circle h1 {
  font-size: 100px;
  font-weight: 600;
  line-height: 1.8em;
  padding-top: 20px;
  color: #00061a;
}
.circle-main .circle img {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.circle-main:before {
  content: "";
  position: absolute;
  height: 210px;
  width: 210px;
  border-radius: 50%;
  border: 1px dashed #00061a;
  top: 10px;
  right: 10px;
}

.round-text {
  position: relative;
  width: 200px;
  height: 200px;
  border-radius: 50%;
}
.round-text .text_1 {
  width: 100%;
  height: 100%;
  position: absolute;
  animation: anim 20s linear infinite;
  top: 14px;
  right: -14px;
}

.text_1 span {
  position: absolute;
  left: 50%;
  transform-origin: 0 100px;
}
.text_1 .text_2 {
  font-size: 16px;
  font-weight: 400;
  text-transform: uppercase;
  color: #00061a;
}

.banner__one .banner__bg {
  left: 0;
  top: -14px;
  width: 100%;
  height: 100%;
  position: absolute;
  background-repeat: no-repeat;
  will-change: border-radius, transform, opacity;
  animation: heroShapeFour 3s linear infinite;
}

.banner__right figure.image-box img {
  border-radius: 20px 20px 213px 213px;
}

.icon__image__banner {
  position: absolute;
  left: -109px;
  bottom: -61px;
}

.banner__title h1 {
  color: #fff;
  font-family: Archivo;
  font-size: 80px;
  font-style: normal;
  font-weight: 700;
  line-height: 90px;
  padding: 20px 0px;
}
.banner__title h1 span {
  font-weight: 400;
}

.text p {
  padding: 0px 31px 30px 0px;
}

.btn-box {
  display: flex;
}

.banner__left {
  padding-top: 26px;
}

.banner__icon {
  background-repeat: no-repeat;
  right: 0;
  top: 22px;
  width: 370px;
  height: 469px;
}

.banner__data {
  padding: 90px 0px 140px;
}
.banner__data:before {
  content: "";
  border-radius: 679.189px;
  background: linear-gradient(192deg, rgba(246, 236, 79, 0.32) 0%, rgba(150, 6, 147, 0.6) 100%);
  filter: blur(150px);
  width: 460.256px;
  height: 679.189px;
  transform: rotate(21.269deg);
  flex-shrink: 0;
  position: absolute;
  z-index: -1;
  left: 40%;
}

section.banner__one {
  overflow: hidden;
}

.product__block__wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 40px;
  flex-wrap: wrap;
  height: max-content;
  padding-bottom: 10px;
}

.new__service__block__wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 30px;
  flex-wrap: wrap;
  height: max-content;
  padding: 0;
}

.product__block {
  width: 200px;
  height: max-content;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  cursor: pointer;
}
.product__block:hover .product__text h4 {
  color: #ff8c2e;
}

.product__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  height: 220px;
  background: linear-gradient(192deg, #ff8c2e 0%, #7e2100 100%);
  clip-path: polygon(50% 0, 100% 27%, 100% 73%, 50% 100%, 0 73%, 0 27%);
}
.product__icon i {
  width: 200px;
  height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-style: normal;
  font-size: 100px;
  font-weight: 500;
  color: #fff;
}
.product__icon img {
  width: 150px;
  padding: 40px 32px;
  margin: 0 auto;
  font-size: 50px;
  position: relative;
  z-index: 1;
}

.product__text button h4 {
  color: #fff;
}

.industry__block__wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 30px;
  flex-wrap: wrap;
  height: max-content;
  padding-bottom: 10px;
}

.industry__block {
  width: 200px;
  height: max-content;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  cursor: pointer;
}
.industry__block:hover .industry__text h4 {
  color: #ff8c2e;
}

.industry__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 110px;
  background: linear-gradient(192deg, #ff8c2e 0%, #7e2100 100%);
  clip-path: polygon(50% 0, 100% 27%, 100% 73%, 50% 100%, 0 73%, 0 27%);
}
.industry__icon i {
  width: 100px;
  height: 110px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-style: normal;
  font-size: 60px;
  font-weight: 500;
  color: #fff;
}
.industry__icon img {
  width: 150px;
  padding: 40px 32px;
  margin: 0 auto;
  font-size: 50px;
  position: relative;
  z-index: 1;
}

.industry__text button h4 {
  color: #fff;
}

.service__block {
  position: relative;
  padding: 36px 42px;
  text-align: center;
  border-bottom: none;
}
.service__block:hover .service__icon__two:after {
  background: #ff8c2e;
}
.service__block:hover .service__icon__two:before {
  background: #ff8c2e;
}
.service__block:hover .service__button a {
  transform: scale(1.1);
  color: #000;
}

.service__icon {
  position: relative;
  padding-bottom: 70px;
}
.service__icon i {
  width: 110px;
  height: 126px;
  background: linear-gradient(192deg, #ff8c2e 0%, #7e2100 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  font-size: 50px;
  clip-path: polygon(50% 0, 100% 27%, 100% 73%, 50% 100%, 0 73%, 0 27%);
  position: relative;
  margin-top: 10px;
  z-index: 1;
}
.service__icon img {
  padding: 40px 32px;
  background: linear-gradient(192deg, #ff8c2e 0%, #7e2100 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  font-size: 50px;
  clip-path: polygon(50% 0, 100% 27%, 100% 73%, 50% 100%, 0 73%, 0 27%);
  position: relative;
  z-index: 1;
}
.service__icon:before {
  content: "";
  width: 110px;
  height: 126px;
  position: absolute;
  background: rgba(128, 5, 153, 0.3);
  top: -11px;
  left: 50%;
  z-index: -1;
  clip-path: polygon(50% 0, 100% 27%, 100% 73%, 50% 100%, 0 73%, 0 27%);
  transform: translate(-50%, 0%);
}

.service__icon__two:after {
  width: 15px;
  content: "";
  height: 18px;
  background: #800599;
  clip-path: polygon(50% 0, 100% 25%, 100% 85%, 50% 100%, 0 85%, 0 25%);
  margin: 0 auto;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0%);
  bottom: 20px;
  transition: all 500ms ease;
}
.service__icon__two:before {
  content: "";
  width: 1px;
  height: 34px;
  background: rgba(255, 255, 255, 0.2);
  position: absolute;
  bottom: 37px;
  left: 50%;
  transform: translate(-50%, 0%);
  transition: all 500ms ease;
}

.service__button {
  position: absolute;
  left: 50%;
  bottom: 28px;
  transform: translate(-50%, 0%);
}
.service__button a {
  width: 40px;
  height: 40px;
  background: #ff8c2e;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transform: scale(0);
  transition: all 500ms ease;
}

.service__data {
  border-radius: 5px;
  background: #060e26;
  padding: 56px;
}

.funfact__content.about {
  background-repeat: no-repeat;
  position: absolute;
  right: 0;
  bottom: 0;
  width: 196px;
  height: 201px;
  padding: 66px 36px 40px;
}
.funfact__content.about h1.count-text {
  color: #00061a;
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 50px;
}
.funfact__content.about .count-outer.count-box.counted {
  display: flex;
  align-items: center;
  justify-content: center;
}
.funfact__content.about .count-outer.count-box.counted span {
  color: #00061a;
  font-size: 38px;
  font-style: normal;
  font-weight: 700;
  line-height: 49px;
}
.funfact__content.about p {
  color: #00061a;
}

.title.two h2 span {
  color: #ff0e75;
}

.about__text__block .texts {
  padding: 35px 0px;
}

.boild__text h1 {
  font-family: Rubik;
  font-size: 300px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-transform: uppercase;
  position: absolute;
  left: 50%;
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: #00061a;
  color: transparent;
  top: 50%;
  margin-top: -17px;
  transform: translate(-50%, -50%);
  text-align: center;
  width: 100%;
}

.about__section .pattern-2 {
  left: 0;
  width: 299px;
  height: 300px;
  background-repeat: no-repeat;
  top: -90px;
}
.about__section:before {
  content: "";
  width: 412.862px;
  height: 609.251px;
  transform: rotate(21.269deg);
  position: absolute;
  border-radius: 609.251px;
  background: linear-gradient(192deg, rgba(246, 236, 79, 0.21) 0%, rgba(150, 6, 147, 0.4) 100%);
  filter: blur(150px);
  left: 50%;
  transform: translate(-50%, 0%);
  bottom: 0;
}

.choose__us__data {
  padding: 100px 0px;
}
.choose__us__data:before {
  content: "";
  background: #00061a;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 300px;
  top: 0;
}

.choose__us:before {
  content: "";
  width: 574.366px;
  height: 847.578px;
  transform: rotate(21.269deg);
  border-radius: 847.578px;
  background: linear-gradient(192deg, rgba(246, 236, 79, 0.21) 0%, rgba(150, 6, 147, 0.4) 100%);
  filter: blur(150px);
  position: absolute;
  left: 80px;
  bottom: -325px;
}

.choose__block {
  position: relative;
  padding-top: 130px;
}
.choose__block:before {
  content: "";
  width: 349.864px;
  height: 516.286px;
  transform: rotate(21.269deg);
  border-radius: 516.286px;
  background: linear-gradient(192deg, rgba(246, 236, 79, 0.32) 0%, rgba(150, 6, 147, 0.6) 100%);
  filter: blur(150px);
  position: absolute;
  left: 0;
}

.team__data {
  display: flex;
  gap: 30px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  padding: 30px 0px;
}
.team__data:nth-child(2) {
  padding-top: 0px;
}
.team__data:nth-child(4) {
  padding-bottom: 0;
  border-bottom: none;
}

.team__data__left img {
  width: 80px;
  padding-top: 8px;
}

.team__data__right h3 {
  font-size: 26px;
  line-height: 36px;
  padding-bottom: 10px;
}

.team__img {
  position: relative;
}
.team__img img {
  width: 100%;
  clip-path: polygon(50% 0, 100% 25%, 100% 75%, 50% 100%, 0 75%, 0 25%);
}
.team__img:before {
  content: "";
  background: rgba(128, 5, 153, 0.3);
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  clip-path: polygon(50% 0, 100% 25%, 100% 75%, 50% 100%, 0 75%, 0 25%);
  transition: all 500ms ease;
  top: -30px;
}

.team__block {
  text-align: center;
}
.team__block:hover .team__img:before {
  background: #ff8c2e;
  opacity: 0.3;
}

.team__name {
  padding: 20px 0px 10px;
}

.team__media ul {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.team__media ul a {
  color: #800599;
  font-weight: 600;
  font-size: 20px;
  font-family: Rubik;
  line-height: 30px;
}
.team__media ul a:hover {
  color: #ff8c2e;
}

.team__section .pattern-3 {
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: -1;
  background-repeat: no-repeat;
}
.team__section:before {
  content: "";
  width: 574.366px;
  height: 847.578px;
  transform: rotate(21.269deg);
  border-radius: 847.578px;
  background: linear-gradient(192deg, rgba(246, 236, 79, 0.21) 0%, rgba(150, 6, 147, 0.4) 100%);
  filter: blur(150px);
  position: absolute;
  right: -44px;
  top: -200px;
}
.team__section:after {
  content: "";
  width: 358.308px;
  height: 528.747px;
  transform: rotate(21.269deg);
  border-radius: 528.747px;
  background: linear-gradient(192deg, rgba(246, 236, 79, 0.26) 0%, rgba(150, 6, 147, 0.5) 100%);
  filter: blur(150px);
  position: absolute;
  bottom: -30px;
  left: 5%;
  z-index: -1;
}

.accomplised__section {
  padding-top: 140px;
}

.accomplised__data {
  border-radius: 10px;
  background: #060e26;
  padding: 120px 90px 120px 70px;
}
.accomplised__data .pattern-4 {
  width: 100%;
  height: 100%;
  top: 0;
  background-repeat: no-repeat;
  left: 15%;
}
.accomplised__data:before {
  width: 358.308px;
  height: 528.747px;
  transform: rotate(21.269deg);
  border-radius: 528.747px;
  background: linear-gradient(192deg, rgba(246, 236, 79, 0.16) 0%, rgba(150, 6, 147, 0.3) 100%);
  filter: blur(150px);
  content: "";
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0%);
  bottom: -100px;
}

.funfact__data {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 27px;
}
.funfact__data .count-outer span {
  color: #fff;
  font-family: Rubik;
  font-size: 32px;
  font-style: normal;
  font-weight: 300;
  line-height: 42px;
}
.funfact__data .count-outer h1.count-text {
  color: #fff;
  font-family: Rubik;
  font-size: 40px;
  font-style: normal;
  font-weight: 600;
  line-height: 42px;
}
.funfact__data .count-outer span.two {
  font-weight: 600 !important;
}
.funfact__data .funfact__content {
  width: 150px;
  height: 170px;
  text-align: center;
  clip-path: polygon(50% 0, 100% 27%, 100% 73%, 50% 100%, 0 73%, 0 27%);
  padding: 45px 27px;
}
.funfact__data .funfact__content .count-outer {
  display: flex;
}
.funfact__data .funfact__content p {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}

.funfact__content.one {
  background: #ff0e75;
}

.funfact__content.two {
  background: linear-gradient(192deg, rgba(246, 236, 79, 0.32) 0%, rgba(150, 6, 147, 0.6) 100%);
}

.funfact__content.three {
  background: #800599;
  margin-top: -48px;
}

.vision_mission_wrapper {
  margin: 80px auto;
  gap: 96px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}

.core_value_wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 27px;
  width: 100%;
}

.core_value_content {
  width: 200px;
  height: 220px;
  text-align: center;
  clip-path: polygon(50% 0, 100% 27%, 100% 73%, 50% 100%, 0 73%, 0 27%);
  padding: 45px 27px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.core_value_content p {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}

.core_value_content.one {
  background: linear-gradient(192deg, #ff8c2e 0%, rgba(150, 6, 147, 0.6) 100%);
}

.core_value_content.two {
  background: linear-gradient(192deg, #ffc34e 0%, rgba(150, 6, 147, 0.6) 100%);
}

.core_value_content.remove_gap_core_value_1,
.core_value_content.remove_gap_core_value_2 {
  margin-top: -65px;
}

.partner_client_item_wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
}
.partner_client_item_wrapper h6 {
  text-align: center;
}
.partner_client_item_wrapper .img__box {
  display: flex;
  flex-shrink: 0;
}

.swiper__button {
  display: flex;
  align-items: center;
  gap: 20px;
  padding-bottom: 20px;
}
.swiper__button .button_prev {
  background: #fff;
  width: 40px;
  height: 40px;
  color: rgb(0, 6, 26);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.swiper__button .button_prev:before {
  content: "";
  background: #f6ec4f;
  position: absolute;
  width: 100%;
  height: 100%;
  display: inline-block;
  border-radius: 50%;
  transform: scale(0);
  transition: all 500ms ease;
}
.swiper__button .button_prev:hover:before {
  transform: scale(1.1);
}
.swiper__button .button_next {
  background: #fff;
  width: 40px;
  height: 40px;
  color: rgb(0, 6, 26);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.swiper__button .button_next:before {
  content: "";
  background: #f6ec4f;
  position: absolute;
  width: 100%;
  height: 100%;
  display: inline-block;
  border-radius: 50%;
  transform: scale(0);
  transition: all 500ms ease;
}
.swiper__button .button_next:hover:before {
  transform: scale(1.1);
}
.swiper__button i {
  position: relative;
}

.testimonial__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.testimonials__info {
  background: rgb(6, 14, 38);
  text-align: center;
  padding: 40px 49px 80px;
  clip-path: polygon(50% 0, 100% 25%, 100% 75%, 50% 100%, 0 75%, 0 25%);
}

.testimonial__section {
  padding-bottom: 55px;
}
.testimonial__section:before {
  content: "";
  width: 790px;
  height: 790px;
  position: absolute;
  border-radius: 50%;
  background: linear-gradient(192deg, rgba(246, 236, 79, 0.32) 0%, rgba(150, 6, 147, 0.6) 100%);
  filter: blur(300px);
  left: 50%;
  transform: translate(-50%, 0%);
}
.testimonial__section .swiper-wrapper > *:nth-child(even) {
  margin-top: 200px;
}

.authore__rating ul {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 15px 0px 5px;
}
.authore__rating ul li {
  color: rgb(246, 236, 79);
}

.authore__info h5 {
  color: #fff;
  text-align: center;
  font-size: 26px;
  font-style: normal;
  font-weight: 500;
  line-height: 36px;
}
.authore__info p {
  color: #666;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 29px;
}

.testimonials__block__one {
  padding: 20px 20px;
}
.testimonials__block__one .quote {
  position: absolute;
  bottom: 11px;
  left: 50%;
  width: 53px;
  height: 62px;
  transform: translate(-50%, 0%);
  background: #666;
  display: flex;
  align-items: center;
  justify-content: center;
  clip-path: polygon(50% 0, 100% 27%, 100% 73%, 50% 100%, 0 73%, 0 27%);
  transition: all 500ms ease;
}
.testimonials__block__one .quote span {
  font-size: 25px;
}
.testimonials__block__one:hover .quote {
  background: #f6ec4f;
}
.testimonials__block__one:hover .test__bg {
  opacity: 1;
}

.test__bg {
  background: linear-gradient(175deg, rgba(246, 236, 79, 0.53) 0%, rgb(150, 6, 147) 100%);
  width: 400px;
  height: 487px;
  position: absolute;
  left: 20px;
  clip-path: polygon(50% 0, 100% 25%, 100% 75%, 50% 100%, 0 75%, 0 25%);
  top: 20px;
  transform: rotate(12deg);
  opacity: 0;
  transition: all 500ms ease;
}

.authore__img img {
  width: 121px;
  height: 138px;
  clip-path: polygon(50% 0, 100% 25%, 100% 75%, 50% 100%, 0 75%, 0 25%);
}

.brand__section .owl-dots.disabled {
  display: none;
}
.brand__section .brand-carousel {
  position: relative;
  transform: rotate(-10deg);
  padding: 35px 0px;
}
.brand__section .brand-carousel:before {
  content: "";
  background: #f6ec4f;
  position: absolute;
  width: calc(100% + 5em);
  height: 126px;
  left: -3em;
  top: 0px;
}
.brand__section .pattern-3 {
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}

.brand__content .brand__name h1 {
  font-family: Rubik;
  font-size: 50px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 5px;
  text-transform: uppercase;
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: #191f31;
  color: transparent;
}

.inner-box .image-box {
  display: block;
  overflow: hidden;
  background: transparent;
  border-radius: 5px 5px 0px 0px;
}
.inner-box .image-box img {
  width: 100%;
  height: 400px;
  transition: all 500ms ease;
  object-fit: cover;
}
.inner-box:hover .image-box img {
  transform: scale(1.05);
}
.inner-box:hover .theme__btn__two i {
  transform: rotate(0deg);
}
.inner-box:hover a.theme__btn__two {
  background: linear-gradient(219deg, #ff8c2e 0%, #7e2100 100%);
}
.inner-box:hover div.theme__btn__two {
  background: linear-gradient(219deg, #ff8c2e 0%, #7e2100 100%);
}

.post__date {
  position: absolute;
  bottom: 0px;
  width: 100%;
}
.post__date ul {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 20px 30px;
  border-radius: 5px 5px 0px 0px;
  background: #060e26;
}
.post__date ul li {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #fff;
  font-size: 15px;
}
.post__date ul li i {
  width: 29px;
  height: 35px;
  background: linear-gradient(219deg, #ff8c2e 0%, #7e2100 100%);
  display: flex;
  font-size: 15px;
  align-items: center;
  justify-content: center;
  clip-path: polygon(50% 0, 100% 27%, 100% 73%, 50% 100%, 0 73%, 0 27%);
  transition: all 500ms ease;
  color: #fff;
}
.post__date ul li.two {
  width: 6px;
  height: 6px;
  background: linear-gradient(219deg, #ff8c2e 0%, #7e2100 100%);
  border-radius: 50%;
}

.detail__post__date {
  position: absolute;
  bottom: 0px;
  width: 100%;
}
.detail__post__date ul {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 24px;
  padding: 20px 30px;
  border-radius: 5px 5px 0px 0px;
  background: #060e26;
}
.detail__post__date ul li {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #fff;
  font-size: 15px;
}
.detail__post__date ul li i {
  width: 29px;
  height: 35px;
  background: linear-gradient(219deg, #ff8c2e 0%, #7e2100 100%);
  display: flex;
  font-size: 15px;
  align-items: center;
  justify-content: center;
  clip-path: polygon(50% 0, 100% 27%, 100% 73%, 50% 100%, 0 73%, 0 27%);
  transition: all 500ms ease;
  color: #fff;
}
.detail__post__date ul li.two {
  width: 6px;
  height: 6px;
  background: linear-gradient(219deg, #ff8c2e 0%, #7e2100 100%);
  border-radius: 50%;
}

.lower___content h4 {
  margin-bottom: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-align: start;
}
.lower___content p {
  margin-bottom: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  text-align: start;
}

.news___block {
  margin-bottom: 30px;
  width: auto;
  max-width: 400px;
}
.news___block .lower___content {
  background: #060e26;
  padding: 25px 30px 20px;
}

.btn__box__two a.theme__btn__two {
  width: 29px;
  height: 35px;
  background: linear-gradient(219deg, #ff8c2e 0%, #7e2100 100%);
  display: flex;
  font-size: 15px;
  align-items: center;
  justify-content: center;
  clip-path: polygon(50% 0, 100% 27%, 100% 73%, 50% 100%, 0 73%, 0 27%);
  transition: all 500ms ease;
  color: #fff;
  margin: 0 0 0 auto;
}
.btn__box__two a.theme__btn__two i {
  transform: rotate(45deg);
  transition: all 500ms ease;
}
.btn__box__two div.theme__btn__two {
  width: 29px;
  height: 35px;
  background: linear-gradient(219deg, #ff8c2e 0%, #7e2100 100%);
  display: flex;
  font-size: 15px;
  align-items: center;
  justify-content: center;
  clip-path: polygon(50% 0, 100% 27%, 100% 73%, 50% 100%, 0 73%, 0 27%);
  transition: all 500ms ease;
  color: #fff;
  margin: 0 0 0 auto;
}
.btn__box__two div.theme__btn__two i {
  transform: rotate(45deg);
  transition: all 500ms ease;
}

.blog__section:before {
  content: "";
  width: 574.366px;
  height: 847.578px;
  border-radius: 847.578px;
  background: linear-gradient(192deg, rgba(246, 236, 79, 0.21) 0%, rgba(150, 6, 147, 0.4) 100%);
  filter: blur(150px);
  position: absolute;
  right: 0;
  transform: rotate(21.269deg);
  bottom: -300px;
}
.blog__section .normaol__text {
  padding-left: 65px;
}

.home__two {
  background: #fff;
}
.home__two h1 {
  color: #00061a;
}
.home__two h2 {
  color: #00061a;
}

.footer-top.two .top-inner {
  background: linear-gradient(238deg, #f6ec4f 0%, #00061a 100%) !important;
}

.blog__section.two .normaol__text p {
  color: #666;
}

.accomplised__section__two {
  background: #060e26;
}
.accomplised__section__two h2 {
  color: #fff !important;
}
.accomplised__section__two .btn-box {
  padding-left: 60px;
}

.main-header.two {
  position: absolute;
  top: 48px;
  left: 0;
}
.main-header.two .header-lower .outer-box {
  border-radius: 5px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: #00061a;
  padding: 0px 20px;
}
.main-header.two .outer-box .logo-box {
  padding: 20px 0px;
}
.main-header.two .outer-box .main-menu .navigation > li > a {
  padding: 36px 0px;
}
.main-header.two .outer-box .main-menu .dropdown-btn {
  top: 40px;
}

.slider-two {
  position: relative;
  overflow: hidden;
}
.slider-two .pattern-1 {
  width: 506px;
  height: 469px;
  left: 0;
  bottom: 0;
  background-repeat: no-repeat;
  z-index: 1;
}

.banner-carousel .slide-item {
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
.banner-carousel .content-box {
  position: relative;
  width: 100%;
}
.banner-carousel .content-box h2 {
  color: #fff;
  opacity: 0;
  transition: all 1000ms ease;
  transform: scaleX(0);
}
.banner-carousel .content-box h4 {
  color: #fff;
  opacity: 0;
  transition: all 1000ms ease;
  transform: scaleX(0);
}
.banner-carousel .content-box p {
  line-height: 28px;
  color: #fff;
  opacity: 0;
  transform: translateY(100px);
  transition: all 1000ms ease;
}
.banner-carousel .content-box .btn-box {
  position: relative;
  opacity: 0;
  transform: translateY(50px);
  transition: all 1000ms ease;
}
.banner-carousel .active .content-box h2 {
  opacity: 1;
  transform: scaleX(1);
}
.banner-carousel .active .content-box h4 {
  opacity: 1;
  transform: scaleX(1);
}
.banner-carousel .active .content-box p {
  opacity: 1;
  transform: translateY(0);
  transition-delay: 1000ms;
}
.banner-carousel .active .content-box .btn-box {
  opacity: 1;
  transform: translateY(0);
  transition-delay: 1300ms;
}

.banner__two .image-layer {
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
.banner__two .content-box {
  padding-bottom: 83px;
}
.banner__two .content-box h2 {
  font-family: Archivo;
  font-size: 80px;
  font-style: normal;
  font-weight: 700;
  line-height: 90px;
}
.banner__two .content-box p {
  padding-bottom: 40px;
  padding-right: 30px;
}

section.banner__two {
  padding-top: 313px;
}
section.banner__two:before {
  content: "";
  width: 460.256px;
  height: 679.189px;
  transform: rotate(21.269deg);
  position: absolute;
  border-radius: 679.189px;
  background: linear-gradient(192deg, rgba(246, 236, 79, 0.32) 0%, rgba(150, 6, 147, 0.6) 100%);
  filter: blur(150px);
  left: 0;
  top: -100px;
  z-index: 1;
}

.mission__block {
  padding: 50px 60px;
  border-right: 1px solid rgba(255, 255, 255, 0.1);
}

.banner__mission__block {
  border-radius: 10px 0px 0px 0px;
  background: rgba(255, 255, 255, 0.05);
  -webkit-backdrop-filter: blur(15px);
          backdrop-filter: blur(15px);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.slider-text-anim.title__last {
  font-weight: 400;
  letter-spacing: 16px;
}
.slider-text-anim.title__last span {
  color: #f6ec4f;
}

.slider-text-anim {
  display: inline-block;
  overflow: hidden;
  position: relative;
  padding-bottom: 5px;
}
.slider-text-anim:before {
  content: "";
  width: 101%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 100%;
  background: #fff;
  transition: 1s cubic-bezier(0.858, 0.01, 0.068, 0.99);
  z-index: 3;
  transform: translateX(-100%);
  transition-delay: 1s;
}

.slider-text-anim.black-bg:before {
  background: #222;
}

.active .slider-text-anim:before {
  transform: translateX(1%);
}

.slider-text-anim.two:before {
  background: #f6ec4f;
}

.accomplised__data.two {
  padding: 0px 90px 0px 70px;
  background: inherit;
}

.brand__section_two {
  padding-bottom: 100px;
  margin: 0px 20px;
}
.brand__section_two .brand__content .brand__name h1 {
  font-size: 60px;
}

.progress-box .bar-inner {
  background: #f6ec4f;
  position: relative;
  display: block;
  width: 0px;
  height: 6px;
  transition: all 1500ms ease;
}
.progress-box .bar-inner:before {
  content: "";
  width: 5px;
  height: 9px;
  background: #f6ec4f;
  position: absolute;
  top: 50%;
  transform: translate(0%, -50%);
  right: 0;
}
.progress-box .bar {
  position: relative;
  width: 100%;
  height: 6px;
  background: #ebebeb;
  margin-bottom: 30px;
}

.about__two__img__block {
  padding-top: 60px;
}
.about__two__img__block .about__two__circle {
  position: absolute;
  top: 0px;
  right: -20px;
}

.about__two__circle .circle-main {
  width: 182px;
  height: 182px;
}
.about__two__circle .circle-main:before {
  height: 166px;
  width: 166px;
  top: 8px;
  right: 8px;
}
.about__two__circle .circle-main .round-text {
  width: 156px;
  height: 156px;
}
.about__two__circle .circle-main .round-text .text_1 {
  top: 12px;
  right: -12px;
}
.about__two__circle .circle-main .round-text .text_1 span {
  transform-origin: 0 80px;
}
.about__two__circle .circle-main .circle {
  height: 100px;
}
.about__two__circle .pattern-2 {
  width: 58.18px;
  height: 313.33px;
  right: 36px;
  top: 157px;
}

.about__text__two {
  display: flex;
  align-items: center;
  gap: 20px;
  padding-top: 20px;
  justify-content: center;
}
.about__text__two h4 {
  color: #00061a;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 2.88px;
}
.about__text__two h4 span {
  color: #f6ec4f;
}
.about__text__two img {
  width: 25px;
}

.about___two .about__text__block .texts {
  padding: 25px 0px;
}
.about___two .about__text__block .texts p {
  color: #666;
}
.about___two .pattern-1 {
  width: 486px;
  height: 486px;
  left: 0;
  bottom: 0;
  background-repeat: no-repeat;
}

.content_block_three h6 {
  color: #00061a;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  padding-bottom: 22px;
}

.service__two {
  background: #00061a;
}
.service__two .pattern-1 {
  width: 100%;
  height: 100%;
  top: 0;
  left: 30%;
  background-repeat: no-repeat;
}
.service__two .pattern-2 {
  width: 100%;
  height: 100%;
  left: 40%;
  top: 0;
  background-repeat: no-repeat;
}
.service__two:before {
  content: "";
  width: 392.703px;
  height: 579.502px;
  border-radius: 579.502px;
  background: linear-gradient(192deg, rgba(246, 236, 79, 0.26) 0%, rgba(150, 6, 147, 0.5) 100%);
  filter: blur(150px);
  left: 50%;
  bottom: 0;
  z-index: 1;
  position: absolute;
  transform: translate(-50%, 0%);
}

.service__block__two {
  padding: 163px 80px 50px;
  overflow: hidden;
}
.service__block__two .service__image {
  position: absolute;
  top: 0;
  left: 0;
  transform: translateX(1000px);
  opacity: 0;
  transition: all 500ms ease;
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  height: 100%;
}
.service__block__two:hover .service__image {
  opacity: 1;
  transform: translate(0px);
}
.service__block__two .service__icon {
  padding-bottom: 22px;
}
.service__block__two .service__icon:before {
  left: 0%;
  transform: translate(0%, 0%);
}
.service__block__two .service__icon i {
  margin: 0;
}
.service__block__two .service__text p {
  padding: 20px 0px 160px;
}

.service__number h1 {
  color: rgba(255, 255, 255, 0.1) !important;
  font-size: 100px;
  font-style: normal;
  font-weight: 700;
  line-height: 90px;
  position: absolute;
  top: -70px;
  left: -4px;
}

.service__button__two {
  position: relative;
}
.service__button__two a {
  color: #ff0e75;
  font-size: 16px;
  font-style: normal;
  font-weight: 800;
  line-height: 29px;
  letter-spacing: 3.2px;
  text-transform: uppercase;
}
.service__button__two a:hover {
  letter-spacing: 4.2px;
  color: #f6ec4f;
}

.choose__text__block {
  padding-top: 130px;
}
.choose__text__block .normal__text {
  padding: 20px 0px 43px;
  border-bottom: 1px solid rgba(128, 5, 153, 0.4);
  position: relative;
}
.choose__text__block .normal__text p {
  color: #666;
}
.choose__text__block .normal__text:before {
  content: "";
  background: #f6ec4f;
  position: absolute;
  width: 14px;
  height: 15px;
  left: 0;
  bottom: -8px;
  clip-path: polygon(50% 0, 100% 25%, 100% 75%, 50% 100%, 0 75%, 0 25%);
}
.choose__text__block .normal__text:after {
  content: "";
  background: #f6ec4f;
  position: absolute;
  width: 14px;
  height: 15px;
  left: 50%;
  bottom: -8px;
  clip-path: polygon(50% 0, 100% 25%, 100% 75%, 50% 100%, 0 75%, 0 25%);
  transform: translate(-50%, 0%);
}

.customaize__solution {
  display: flex;
  align-items: center;
  gap: 32px;
  padding-top: 23px;
}
.customaize__solution h5 {
  color: #00061a;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px;
}
.customaize__solution p {
  color: #00061a;
}

.choose_img__block img {
  clip-path: polygon(50% 0, 100% 25%, 100% 75%, 50% 100%, 0 75%, 0 25%);
}

.choose___two .pattern-1 {
  width: 433px;
  height: 526px;
  top: 140px;
  right: 0px;
}

.choose_img__two .pattern-3 {
  width: 268px;
  height: 216px;
  z-index: 1;
  right: 10px;
  top: 0;
}
.choose_img__two .pattern-4 {
  width: 275px;
  height: 222px;
  z-index: 1;
  bottom: 0;
  left: 0;
}

.price__block {
  background: rgb(6, 14, 38);
  text-align: center;
  padding: 180px 0px 18px;
  margin-top: 50px;
  clip-path: polygon(50% 0, 100% 25%, 100% 75%, 50% 100%, 0 75%, 0 25%);
}

.price__data {
  background: #f6ec4f;
  width: 183px;
  height: 203px;
  position: absolute;
  top: -50px;
  padding: 60px 25px;
  left: 50%;
  transform: translate(-50%, 0%);
  clip-path: polygon(50% 0, 100% 25%, 100% 75%, 50% 100%, 0 75%, 0 25%);
  z-index: 1;
  text-align: center;
  transition: all 500ms ease;
}
.price__data h5 {
  color: #00061a;
  font-size: 26px;
  font-style: normal;
  font-weight: 500;
  text-align: center;
  transition: all 500ms ease;
}
.price__data h4 {
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 42px;
  color: #00061a;
  transition: all 500ms ease;
}
.price__data h4 span {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}

.price__list li {
  padding-bottom: 18px;
}
.price__list li:last-child {
  padding-bottom: 50px;
}

.price__icon {
  background: #800599;
  width: 40px;
  height: 49px;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0%);
  bottom: -23px;
  display: flex;
  align-items: center;
  justify-content: center;
  clip-path: polygon(50% 0, 100% 25%, 100% 75%, 50% 100%, 0 75%, 0 25%);
  transition: all 500ms ease;
}

.price__content:hover .price__data {
  background: #800599;
}
.price__content:hover .price__data h5 {
  color: #fff;
}
.price__content:hover .price__data h4 {
  color: #fff;
}
.price__content:hover .price__icon {
  background: #f6ec4f;
  color: rgb(0, 6, 26);
}

.pricing__section .pattern-1 {
  width: 100%;
  height: 900px;
  background-repeat: no-repeat;
  top: 0;
}
.pricing__section .pattern-4 {
  width: 100%;
  height: 100%;
  top: 0;
  background-repeat: no-repeat;
  left: 20%;
}

.portfolio-layer {
  width: 100%;
  height: 100%;
  top: 0;
  background-repeat: no-repeat;
  background-size: cover;
}

.portfolio {
  padding: 119px 0px 0px;
}
.portfolio h2 {
  color: #fff !important;
}

.protfolio__inner {
  position: relative;
  margin-right: -445px;
  overflow: hidden;
}

.portfolio__block {
  overflow: hidden;
}
.portfolio__block .lower__content {
  background: linear-gradient(180deg, rgba(255, 14, 117, 0.6) 0%, rgba(146, 6, 148, 0.6) 100%);
  width: 100%;
  height: 100%;
  z-index: 1;
  top: 0;
  left: 0;
  opacity: 0;
  transition: all 500ms ease;
  padding: 30px;
  transform: translateX(-100%);
}
.portfolio__block:hover .lower__content {
  transform: translateX(0%);
  opacity: 1;
}

.protfolio__text {
  display: flex;
  justify-content: space-between;
}

.text__block h4 {
  font-weight: 600;
}

.text__block_two h5 {
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
}

.protfolio__button {
  position: absolute;
  bottom: 30px;
  left: 30px;
  width: 86%;
}
.protfolio__button a.theme-btn.theme-btn-one {
  background: #f6ec4f;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 29px;
  color: #00061a !important;
  text-transform: capitalize;
}

.page__title {
  margin-top: 30px;
  padding: 232px 0px;
  text-align: center;
}
.page__title .bg-layer {
  width: 100%;
  height: 100%;
  position: absolute;
  left: -1px;
  top: 0;
  background-repeat: no-repeat;
  background-size: cover;
}
.page__title .title {
  font-family: Archivo;
  font-size: 80px;
  font-style: normal;
  font-weight: 700;
  line-height: 90px;
}

.bread__crumb {
  display: flex;
  justify-content: flex-start;
  padding: 64px 0 0;
  gap: 8px;
  white-space: nowrap;
  flex: 1 1;
  overflow-y: auto;
}
.bread__crumb li {
  text-align: center;
  font-family: Archivo;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 2px;
  color: #fff;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 24px;
}
.bread__crumb li button {
  text-align: center;
  font-family: Archivo;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 2px;
  color: #fff;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  gap: 8px;
}
.bread__crumb li button:hover {
  color: #ff8c2e !important;
}

.about__section.about__page .pattern-2 {
  top: 0 !important;
}

.pride__layer {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  position: absolute;
  top: 0;
  background-size: cover;
}

.pride__block {
  text-align: center;
}
.pride__block figure img {
  position: relative;
}
.pride__block h1 {
  font-size: 80px;
  font-style: normal;
  font-weight: 400;
  line-height: 90px;
  padding: 0px 175px;
}

.service__page .service__block {
  margin-bottom: 20px;
}
.service__page .service__block:before {
  padding: 1px;
}

.project__page {
  margin: 0px 120px;
}
.project__page .portfolio__block {
  margin-bottom: 24px;
}
.project__page img {
  width: 100%;
}

.team__page .team__block {
  margin-bottom: 50px;
}

.testimonial___data .row > div:nth-child(even) {
  margin-top: 150px;
}

.testimonials__block__one.page {
  padding: 0px 20px;
  position: relative;
}
.testimonials__block__one.page .testimonials__info {
  background: transparent;
  padding: 0px 49px 80px;
}
.testimonials__block__one.page .quote {
  bottom: -10px;
}

.blog__details__content .blog__image img {
  width: 100%;
  height: 720px;
  border-radius: 5px 5px 0px 0px;
}
.blog__details__content .post__date ul, .blog__details__content .detail__post__date ul {
  padding: 32px 40px;
}

h3.blog__title {
  font-size: 26px;
  font-style: normal;
  font-weight: 500;
  line-height: 36px;
  padding-bottom: 24px;
}

.blog__inner__box {
  padding: 20px 40px 52px;
  background: #060e26;
}

.blog__details__text p {
  padding-bottom: 20px;
  white-space: pre-wrap;
}
.blog__details__text ul li {
  list-style: disc;
}
.blog__details__text a {
  color: #ff8c2e;
  text-decoration: underline;
  transition: all 500ms ease;
  -moz-transition: all 500ms ease;
  -webkit-transition: all 500ms ease;
  -ms-transition: all 500ms ease;
  -o-transition: all 500ms ease;
}
.blog__details__text a:hover {
  color: #ff8c2e;
  opacity: 0.9;
  text-decoration: underline;
  outline: none;
}

.blog__tags__box {
  padding: 25px;
  background: #060e26;
  margin: 50px 0px;
}

.tags__left {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  flex-direction: column;
}
.tags__left h3 {
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 36px;
}

.tags-list-1 {
  display: flex;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
}
.tags-list-1 li a {
  color: #00061a;
  background: rgba(255, 255, 255, 0.5);
  padding: 8px;
  border-radius: 4px;
  text-transform: capitalize;
}

.blog__comments__area {
  padding: 40px;
  background: #060e26;
}

h3.comments__title {
  font-size: 26px;
  font-style: normal;
  font-weight: 600;
  line-height: 36px;
  padding-bottom: 30px;
}

.comments__box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 60px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  margin-top: 60px;
  gap: 26px;
}
.comments__box .image__box {
  flex-shrink: 0;
  display: flex;
}
.comments__box .image__box img {
  width: 117px;
  height: 117px;
  border-radius: 50%;
}
.comments__box:nth-last-child(-n+2) {
  border: none;
}

.comments__content .upper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 20px;
}
.comments__content .upper h4 {
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
}
.comments__content .upper .reply-btn {
  background: #ff0e75;
  padding: 5px 20px;
}

.comments__form.contact__section {
  padding: 40px;
  background: #060e26;
  margin-top: 60px;
}

.form__inner input {
  border-radius: 5px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  width: 100%;
  color: rgba(255, 255, 255, 0.25);
  font-family: Rubik;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 2.4px;
  padding: 22px;
}
.form__inner textarea {
  border-radius: 5px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  width: 100%;
  color: rgba(255, 255, 255, 0.25);
  font-family: Rubik;
  font-size: 12px;
  font-style: normal;
  height: 164px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 2.4px;
  padding: 22px;
}

.sidebar__search__box input {
  border-radius: 5px;
  color: rgba(255, 255, 255, 0.25);
  font-family: Rubik;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 2.4px;
  text-transform: uppercase;
  border: 1px solid rgba(255, 255, 255, 0.25);
  padding: 20px;
  width: 100%;
}
.sidebar__search__box button {
  position: absolute;
  right: 22px;
  color: rgb(255, 255, 255);
  top: 50%;
  transform: translate(0%, -50%);
}

.single__sidebar__box {
  background: #060e26;
  padding: 30px;
  margin-bottom: 40px;
}
.single__sidebar__box h3 {
  font-size: 26px;
  font-style: normal;
  font-weight: 500;
  line-height: 36px;
  padding-bottom: 40px;
}

.sidebar__blog__post .inner {
  display: flex;
  align-items: center;
  gap: 20px;
}
.sidebar__blog__post .inner .img__box {
  display: flex;
  flex-shrink: 0;
}
.sidebar__blog__post .inner .img__box img {
  width: 150px;
  aspect-ratio: 4/3;
}
.sidebar__blog__post .title__box h4 {
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 26px;
}
.sidebar__blog__post li {
  margin-bottom: 20px;
  cursor: pointer;
  transition: all 500ms ease;
}
.sidebar__blog__post li:hover {
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.1);
  -webkit-backdrop-filter: 1px;
          backdrop-filter: 1px;
}
.sidebar__blog__post .date {
  color: #ff8c2e;
  display: flex;
  align-items: center;
  gap: 8px;
}
.sidebar__blog__post .date i {
  color: #ff8c2e;
}

.sidebar-categories-box li a {
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 26px;
  display: flex;
  align-items: center;
  gap: 16px;
  padding-bottom: 20px;
}
.sidebar-categories-box li a i {
  color: rgb(246, 236, 79);
}

.contact__right {
  background: #060e26;
  padding: 80px;
}

.form-inner input {
  color: #fff;
  font-family: Rubik;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 2.4px;
  border-radius: 5px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  padding: 22px;
  width: 100%;
}
.form-inner select {
  color: #fff;
  font-family: Rubik;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 2.4px;
  border-radius: 5px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  padding: 22px;
  width: 100%;
  appearance: none;
  background-image: linear-gradient(45deg, transparent 50%, rgba(255, 255, 255, 0.25) 50%), linear-gradient(135deg, rgba(255, 255, 255, 0.25) 50%, transparent 50%);
  background-position: calc(100% - 20px) 50%, calc(100% - 15px) 50%;
  background-size: 5px 5px, 5px 5px;
  background-repeat: no-repeat;
}
.form-inner select:invalid {
  color: rgba(255, 255, 255, 0.25);
}
.form-inner select:focus {
  color: #ff8c2e;
  border-color: #ff8c2e;
}
.form-inner input:focus,
.form-inner textarea:focus {
  color: #ff8c2e;
  border-color: #ff8c2e;
}
.form-inner input::placeholder {
  color: rgba(255, 255, 255, 0.25);
}
.form-inner input::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.25);
}
.form-inner input:-moz-placeholder {
  color: rgba(255, 255, 255, 0.25);
}
.form-inner input::-moz-placeholder {
  color: rgba(255, 255, 255, 0.25);
}
.form-inner input:-ms-input-placeholder {
  color: rgba(255, 255, 255, 0.25);
}
.form-inner textarea {
  border-radius: 5px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: #fff;
  font-family: Rubik;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 2.4px;
  width: 100%;
  padding: 22px;
  height: 235px;
}
.form-inner textarea::placeholder {
  color: rgba(255, 255, 255, 0.25);
}
.form-inner textarea::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.25);
}
.form-inner textarea:-moz-placeholder {
  color: rgba(255, 255, 255, 0.25);
}
.form-inner textarea::-moz-placeholder {
  color: rgba(255, 255, 255, 0.25);
}
.form-inner textarea:-ms-input-placeholder {
  color: rgba(255, 255, 255, 0.25);
}

.contact__left h4 {
  font-size: 38px;
  font-style: normal;
  font-weight: 700;
  line-height: 50px;
  padding: 30px 0px;
}

.contact__block {
  display: flex;
  align-items: center;
  gap: 27px;
  padding-bottom: 40px;
}
.contact__block i {
  border-radius: 2px;
  background: #f6ec4f;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  font-size: 30px;
  color: rgb(0, 6, 26);
  justify-content: center;
}
.contact__block .two i {
  background: #ff0e75;
  color: #fff;
}

.google__map {
  width: 100%;
  height: 780px;
}
.google__map img {
  width: 100%;
}

.service__contact__block {
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: #060e26;
}

.service__form__data {
  padding: 90px 0px 160px 90px;
}

.service__contact__img {
  position: absolute;
  bottom: 0;
  right: 12px;
}

.feature-three__wrap {
  position: relative;
  display: block;
  animation: aspro-scroller 27s linear infinite;
  will-change: transform;
  white-space: nowrap;
}
.feature-three__wrap:hover {
  animation-play-state: paused;
}

.feature-three__list {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
  min-width: 100vw;
}
.feature-three__list li {
  position: relative;
  display: block;
}
.feature-three__list li + li {
  margin-left: 30px;
}

.feature-three__title-box {
  position: relative;
  display: flex;
  align-items: center;
}

.feature-three__title {
  font-family: Rubik;
  font-size: 60px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 5px;
  text-transform: uppercase;
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: #191f31;
  color: transparent !important;
}
.feature-three__title span {
  font-family: Rubik;
  font-size: 60px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 5px;
  text-transform: uppercase;
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: #191f31;
  color: transparent;
}

.feature-three--four {
  padding: 0 0 108px;
}

.header__three .logo-box {
  position: absolute;
  top: 25px;
  padding: 0 !important;
  left: 50%;
  transform: translate(-50%, 0%);
}
.header__three .logo-box img {
  width: 42px;
  height: 58px;
}
.header__three .menu-area {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, 50%);
}
.header__three .menu-area nav {
  display: none;
}
.header__three .menu-area .mobile-nav-toggler {
  display: block !important;
  float: left;
}
.header__three .outer-box {
  display: block !important;
  height: 100vh;
}
.header__three figure.logo {
  min-width: 0px !important;
  display: flex;
  justify-content: center;
}
.header__three .banner__media_two {
  position: absolute;
  left: 50%;
  bottom: 30px;
  transform: translate(-50%, 0%);
}

.main-header.header__three {
  position: fixed;
  background: #060e26;
  width: 100px;
}

.banner__media_two li a {
  font-weight: 600;
  line-height: 46.5px;
}

.home__three .pattern-4 {
  width: 506px;
  height: 469px;
  right: 0;
  bottom: -140px;
}
.home__three .about__block {
  margin-top: -140px;
}
.home__three .about__section:before {
  content: "";
  width: 412.862px;
  height: 609.251px;
  transform: rotate(21.269deg);
  position: absolute;
  border-radius: 847.578px;
  background: linear-gradient(192deg, rgba(246, 236, 79, 0.21) 0%, rgba(150, 6, 147, 0.4) 100%);
  filter: blur(150px);
  filter: blur(150px);
  left: inherit;
  transform: translate(-50%, 0%);
  bottom: inherit;
  right: -100px;
  top: -100px;
}

.home__three__banner {
  position: relative;
}
.home__three__banner .image-layer {
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
.home__three__banner .banner__data {
  padding: 0;
}
.home__three__banner h1 span {
  font-weight: 700;
}
.home__three__banner h1 span.color {
  color: #f6ec4f;
}
.home__three__banner .btn-box {
  padding-bottom: 120px;
}
.home__three__banner .banner__mission__block {
  border-radius: 0;
}
.home__three__banner .banner__bottom {
  border-radius: 0px 10px 0px 0px;
}
.home__three__banner .pattern-3 {
  width: 299px;
  height: 411px;
  left: 233px;
  bottom: 240px;
}

.banner__media {
  padding: 54px 0px 100px;
}
.banner__media ul {
  display: flex;
  align-items: center;
  gap: 65px;
  justify-content: flex-end;
}

.choose__us.three .pattern-2 {
  width: 299px;
  height: 300px;
  background-repeat: no-repeat;
  left: 100px;
  top: -80px;
  width: 299px;
  height: 300px;
  background-repeat: no-repeat;
  left: 100px;
  top: -80px;
}
.choose__us.three:before {
  display: none;
}

.choose_us_block h2 {
  padding-bottom: 30px;
}
.choose_us_block li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: Rubik;
  font-size: 26px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  padding: 20px 0px;
}
.choose_us_block li:nth-child(1) {
  padding-top: 0;
}
.choose_us_block li:nth-child(4) {
  border: none;
}

.portfolio.home__three__p {
  border-radius: 5px;
  background: #060e26;
  border: 1px solid rgba(255, 255, 255, 0.2);
  margin-top: 140px;
  padding: 140px 0px 120px;
}

.accomplised__data.two.three {
  background: #060e26 !important;
  border-radius: 10px;
  padding: 120px 90px 120px 70px;
}

section.accomplised__section__two.see__pad.three:before {
  content: "";
  position: absolute;
  border-radius: 528.747px;
  background: linear-gradient(192deg, rgba(246, 236, 79, 0.26) 0%, rgba(150, 6, 147, 0.5) 100%);
  filter: blur(150px);
  width: 358.308px;
  height: 528.747px;
  transform: rotate(21.269deg);
  flex-shrink: 0;
  left: 100px;
  bottom: -104px;
}

.accomplised__section__two.see__pad.three {
  background: #00061a;
  position: relative;
}

.consultation__list {
  padding-top: 41px;
}
.consultation__list li a {
  width: 100%;
  font-family: Rubik;
  font-size: 26px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px;
  padding: 35px 0px 35px 85px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  position: relative;
}
.consultation__list li a span {
  height: 100%;
  padding: 0px 16px;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  position: absolute;
  display: flex;
  align-items: center;
  border-right: 1px solid rgba(255, 255, 255, 0.2);
  width: 52px;
  left: 0;
}

.consultation__img {
  margin-top: -50px;
}

.consultation__text {
  position: absolute;
  width: 460px;
  left: 80px;
  top: 50%;
  transform: translate(0%, -50%);
}
.consultation__text h3 {
  padding-bottom: 30px;
}
.consultation__text p {
  padding-bottom: 20px;
}

.consultation__button {
  padding-top: 20px;
}
.consultation__button a:hover {
  letter-spacing: 3px;
}

.pricing__section.three:before {
  content: "";
  width: 790px;
  height: 790px;
  flex-shrink: 0;
  border-radius: 790px;
  background: var(--shadow, linear-gradient(192deg, rgba(246, 236, 79, 0.32) 0%, rgba(150, 6, 147, 0.6) 100%));
  filter: blur(300px);
  position: absolute;
  top: -27%;
  left: 34%;
}

.service__contact.three {
  padding-bottom: 140px;
}
.service__contact.three:after {
  content: "";
  width: 574.366px;
  height: 847.578px;
  transform: rotate(21.269deg);
  flex-shrink: 0;
  border-radius: 847.578px;
  background: var(--shadow-2, linear-gradient(180deg, rgba(246, 236, 79, 0.32) 0%, rgba(150, 6, 147, 0.14) 90.86%));
  filter: blur(150px);
  position: absolute;
  right: 0;
}

.service__details {
  padding: 140px 0px 0px;
}

.all__service h3 {
  background: #ff8c2e;
  padding: 14px 30px;
}

.sidebar__widget {
  position: relative;
  padding: 24px;
}
.sidebar__widget:before {
  content: "";
  position: absolute;
  inset: 0;
  padding: 1px;
  background: linear-gradient(180deg, rgba(246, 236, 79, 0.08), rgba(150, 6, 147, 0.23));
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  mask-composite: exclude;
  z-index: -1;
  border-radius: 4px;
}

ul.service__details__1__cat {
  padding: 30px 0px;
}

.service__details__1__cat a {
  padding: 10px 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: Archivo;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 29px;
  cursor: pointer;
  position: relative;
  margin-bottom: 10px;
  transition: all 150ms ease-in-out;
}
.service__details__1__cat a:before {
  content: "";
  position: absolute;
  inset: 0;
  padding: 1px;
  background: linear-gradient(192deg, #ff8c2e 0%, rgba(150, 6, 147, 0.6) 100%);
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  mask-composite: exclude;
  z-index: -1;
  border-radius: 4px;
}
.service__details__1__cat a:hover {
  color: #fff;
  font-weight: 600;
}
.service__details__1__cat a.active {
  color: #fff;
  font-weight: 600;
  background: linear-gradient(192deg, #ff8c2e 0%, rgba(150, 6, 147, 0.6) 100%);
  border-radius: 4px;
}

.sidebar__widget_network {
  margin-top: 40px;
  padding: 120px 60px;
  text-align: center;
  background-size: cover;
  background-repeat: no-repeat;
}
.sidebar__widget_network .services__icon i {
  width: 90px;
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(192deg, #ff8c2e 0%, #7e2100 100%);
  margin: 20px auto;
  font-size: 40px;
  border-radius: 50%;
}

.service__right {
  position: relative;
}
.service__right h2 {
  padding: 40px 0px 35px;
}
.service__right h2 span {
  color: #ff0e75;
}
.service__right h3 {
  margin: 0 0 24px;
}
.service__right .row {
  padding: 30px 0px 0px;
}
.service__right li a {
  position: relative;
  font-family: Rubik;
  font-size: 22px;
  font-style: normal;
  font-weight: 600;
  line-height: 36px;
  padding: 10px 20px;
  width: 100%;
  align-items: center;
  display: flex;
  gap: 18px;
  margin-bottom: 40px;
}
.service__right li a:before {
  content: "";
  position: absolute;
  inset: 0;
  padding: 1px;
  background: linear-gradient(192deg, #ff8c2e 0%, rgba(150, 6, 147, 0.23) 100%);
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  mask-composite: exclude;
  z-index: -1;
  border-radius: 4px;
}
.service__right li a i {
  width: 70px;
  height: 70px;
  background: #666;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  font-size: 40px;
  transition: all 500ms ease;
}
.service__right li a:hover i {
  background: #ff8c2e;
  color: #fff;
}
.service__right:before {
  width: 412.862px;
  height: 609.251px;
  transform: rotate(21.269deg);
  flex-shrink: 0;
  border-radius: 609.251px;
  background: linear-gradient(192deg, rgba(246, 236, 79, 0.21) 0%, rgba(150, 6, 147, 0.4) 100%);
  filter: blur(150px);
  position: absolute;
  content: "";
  left: -16%;
  top: 4%;
}

.error__page h1.title {
  text-align: center;
  font-family: Rubik;
  font-size: 400px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.error__page h1.title span {
  color: #ff8c2e;
}

.page__title.error__page {
  margin-top: 0;
  padding: 0;
  width: 100%;
  height: 100dvh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.page__title.error__page .btn-box {
  justify-content: center;
  padding-top: 40px;
}

.project__details {
  padding-top: 140px;
}
.project__details .image img {
  border-radius: 5px;
}
.project__details .data h4 {
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: 42px;
  padding: 50px 0px 35px;
}
.project__details .data__list {
  padding: 40px 0px 100px;
}
.project__details .data__list li {
  font-family: Archivo;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 29px;
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  gap: 15px;
}
.project__details .data__list li i {
  width: 20px;
  height: 20px;
  background: #666;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.project__details .project__button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 30px 50px;
  border-top: 1px solid rgba(234, 234, 234, 0.1);
  border-bottom: 1px solid rgba(234, 234, 234, 0.1);
}
.project__details .button__one a {
  font-family: Rubik;
  font-size: 26px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px;
}

.pro__info {
  background: #ff0e75;
  border-radius: 10px;
  padding: 60px;
  max-width: 800px;
  margin: -94px auto 0;
  position: relative;
}
.pro__info ul {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.pro__info .name__two h4 {
  font-size: 30px;
  font-style: normal;
  font-weight: 600;
  line-height: 40px;
}

@media (min-width: 768px) {
  .feature-three__list li + li {
    margin-left: 50px;
  }
}
@media (min-width: 1200px) {
  .feature-three__list li + li {
    margin-left: 70px;
  }
}
@media (min-width: 768px) {
  .feature-three__list li + li {
    margin-left: 50px;
  }
}
@media (min-width: 1200px) {
  .feature-three__list li + li {
    margin-left: 70px;
  }
}
.mobile-menu .navigation li .dropdown-btn.open + ul {
  display: block;
}

.form-inner .form-group {
  margin-bottom: 1rem;
}

.account-info-wrapper {
  display: flex;
  gap: 8px;
  align-items: center;
  transition: all 500ms ease;
}
.account-info-wrapper svg {
  fill: #fff;
}
.account-info-wrapper svg path,
.account-info-wrapper a {
  transition: all 500ms ease;
  fill: #fff;
  color: #fff;
}

.account-info-wrapper:hover svg path,
.account-info-wrapper:hover a {
  fill: #ff8c2e;
  color: #ff8c2e !important;
}

.map-popup .leaflet-popup-content-wrapper {
  border-radius: 6px;
  padding: 8px 12px;
}
.map-popup .leaflet-popup-tip-container {
  display: none;
}
.map-popup .leaflet-popup-content,
.map-popup .leaflet-popup-content p {
  padding: 0;
  margin: 0;
  color: #00061a;
  font-family: Archivo;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  text-align: center;
}
.map-popup .leaflet-popup-close-button {
  display: none;
}

.office-wrapper {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

.office-map-wrapper {
  width: 100%;
  height: 780px;
}

.news-articles-wrapper {
  margin-top: 32px;
  width: 100%;
  gap: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.editorial-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 12px;
}
.editorial-wrapper a {
  color: #ff8c2e;
  transition: all 500ms ease;
  -moz-transition: all 500ms ease;
  -webkit-transition: all 500ms ease;
  -ms-transition: all 500ms ease;
  -o-transition: all 500ms ease;
}
.editorial-wrapper a:hover {
  color: #ff8c2e;
  opacity: 0.9;
  outline: none;
}
.editorial-wrapper p {
  text-align: center;
}

.social-media-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}
.social-media-wrapper div {
  display: inherit;
  gap: 8px;
}
.social-media-wrapper div > div {
  display: inherit;
}
.social-media-wrapper div > div svg {
  fill: #ffffff;
}
.social-media-wrapper div > div svg path,
.social-media-wrapper div > div a {
  transition: all 500ms ease;
  fill: #ffffff;
  color: #ffffff;
}
.social-media-wrapper div > div:hover svg path,
.social-media-wrapper div > div:hover a {
  fill: #ff8c2e;
  color: #ff8c2e !important;
}

.content-markdown p:has(img) {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}
@media (max-width: 768px) {
  .content-markdown p:has(img) {
    grid-template-columns: 1fr;
  }
}

.image-content-markdown {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 20px auto;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
}

/*!
Animate.css - http://daneden.me/animate
Licensed under the MIT license - http://opensource.org/licenses/MIT

Copyright (c) 2023 Daniel Eden
*/
@keyframes "zoomInOut" {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.8);
  }
  to {
    transform: scale(1);
  }
}
@keyframes "moveLeftBounce" {
  0% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(50px) translateY(20px);
  }
  to {
    transform: translateX(0);
  }
}
@keyframes "animationFramesOne" {
  0% {
    transform: translate(0) rotate(0deg);
  }
  20% {
    transform: translate(73px, -1px) rotate(36deg);
  }
  40% {
    transform: translate(141px, 72px) rotate(72deg);
  }
  60% {
    transform: translate(83px, 122px) rotate(108deg);
  }
  80% {
    transform: translate(-40px, 72px) rotate(144deg);
  }
  to {
    transform: translate(0) rotate(0deg);
  }
}
@keyframes "rotateme" {
  0% {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(1turn);
  }
}
@keyframes "float-bob-y" {
  0% {
    transform: translateY(-20px);
  }
  50% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(-20px);
  }
}
.animation-moveLeftBounce {
  animation: moveLeftBounce 3s linear infinite;
}

.animation-zoomInOut {
  animation: zoomInOut 3s linear infinite;
}

.animation-animationFramesOne {
  animation: animationFramesOne 20s linear infinite;
}

.animation-rotateme {
  animation-name: rotateme;
  animation-duration: 20s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

.float-bob-y {
  animation-name: float-bob-y;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  -webkit-animation-name: float-bob-y;
  -webkit-animation-duration: 2s;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-timing-function: linear;
  -moz-animation-name: float-bob-y;
  -moz-animation-duration: 2s;
  -moz-animation-iteration-count: infinite;
  -moz-animation-timing-function: linear;
  -ms-animation-name: float-bob-y;
  -ms-animation-duration: 2s;
  -ms-animation-iteration-count: infinite;
  -ms-animation-timing-function: linear;
  -o-animation-name: float-bob-y;
  -o-animation-duration: 2s;
  -o-animation-iteration-count: infinite;
  -o-animation-timing-function: linear;
}

.blog-standard-content .news-block-one .lower-content .category a:hover {
  text-decoration: underline;
}
.blog-standard-content .news-block-one .inner-box {
  border-bottom: 1px solid #e5e5e5;
}

.news-block-one.video-block .image-box .video-btn {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.news-block-one.video-block .image-box .video-btn a {
  background: #fff;
}
.news-block-one.video-block .image-box .video-btn a:before {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: transparent;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation-delay: 0.9s;
  content: "";
  position: absolute;
  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.9);
  animation: ripple 3s infinite;
  transition: all 0.4s ease;
}
.news-block-one.video-block .image-box .video-btn a:after {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: transparent;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation-delay: 0.9s;
  content: "";
  position: absolute;
  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.9);
  animation: ripple 3s infinite;
  transition: all 0.4s ease;
  animation-delay: 0.6s;
}
.news-block-one.video-block .image-box img {
  opacity: 1 !important;
  border-radius: 5px;
}
.news-block-one.video-block .image-box .image:before {
  position: absolute;
  content: "";
  background: #000;
  width: 100%;
  height: 100%;
  left: 0px;
  top: 0px;
  opacity: 0.3;
  z-index: 1;
  border-radius: 5px;
}

.news-block-one.carousel-block .inner-box .image img {
  opacity: 1 !important;
  border-radius: 5px;
}
.news-block-one.carousel-block .owl-nav {
  position: absolute;
  left: 0px;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
}
.news-block-one.carousel-block .owl-nav button {
  position: absolute;
  display: inline-block;
  width: 50px;
  height: 50px;
  line-height: 50px;
  background: #fff;
  font-size: 20px;
  color: #141417;
  text-align: center;
  border-radius: 50%;
  transition: all 500ms ease;
}
.news-block-one.carousel-block .owl-nav button:hover {
  color: #fff;
}
.news-block-one.carousel-block .owl-nav button.owl-prev {
  left: 30px;
}
.news-block-one.carousel-block .owl-nav button.owl-next {
  right: 30px;
}

.news-block-one .inner-box blockquote .icon-box {
  color: #fceee7;
}
.news-block-one .inner-box blockquote h5.name:before {
  position: absolute;
  content: "";
  background: #141417;
  width: 15px;
  height: 2px;
  left: 0px;
  top: 12px;
}

.news-block-one.quote-block .inner-box {
  overflow: visible;
}

.sidebar-page-container .pagination li {
  border-radius: 5px;
}
.sidebar-page-container .pagination li a {
  border-radius: 5px;
}
.sidebar-page-container .inner-container {
  background: #fff;
}
.sidebar-page-container .inner-container:before {
  position: absolute;
  content: "";
  background: #fff;
  width: calc(100% + 140px);
  height: 100%;
  left: -70px;
  top: 0px;
}
.sidebar-page-container .theme-btn {
  border: 1px solid #e7e7e7;
  color: #141417 !important;
  padding: 11px 32px;
}
.sidebar-page-container .theme-btn:hover {
  color: #fff !important;
  border-color: #e45712;
}

.blog-sidebar .sidebar-widget {
  background: #f7f7f7;
}
.blog-sidebar .search-widget .search-form .form-group input[type=search] {
  position: relative;
  display: inline-block;
  width: 100%;
  height: 60px;
  border: 1px solid #e5e5e5;
  border-radius: 5px;
  font-size: 16px;
  color: #808080;
  font-family: "Poppins", sans-serif;
  padding: 10px 20px 10px 60px;
  transition: all 500ms ease;
  background: #f7f7f7;
}
.blog-sidebar .search-widget .search-form .form-group button {
  position: absolute;
  left: 28px;
  top: 18px;
  font-size: 18px;
  color: #808080;
  cursor: pointer;
  transition: all 500ms ease;
}
.blog-sidebar .post-widget .post {
  border-bottom: 1px solid #e5e5e5;
  min-height: 104px;
}
.blog-sidebar .post-widget .post:last-child {
  border-bottom: none;
}
.blog-sidebar .post-widget .post .post-thumb img {
  width: 100%;
  border-radius: 5px;
}
.blog-sidebar .post-widget .post:hover .post-thumb img {
  opacity: 0.2;
}
.blog-sidebar .post-widget .post h5 {
  line-height: 24px;
}
.blog-sidebar .tags-widget .tags-list {
  margin: 0px -5px;
}
.blog-sidebar .tags-widget .tags-list li a {
  padding: 5px 14px;
  border: 1px solid #e5e5e5;
}
.blog-sidebar .tags-widget .tags-list li a:hover {
  color: #fff;
}

.blog-standard-2 .blog-standard-content .news-block-one .inner-box {
  border-bottom: none;
}
.blog-standard-2 .news-block-one .inner-box blockquote {
  border-left: none;
  background: #302f2f;
}
.blog-standard-2 .news-block-one .inner-box blockquote .icon-box {
  color: #454444;
  left: 50%;
  transform: translateX(-50%);
}
.blog-standard-2 .news-block-one .inner-box blockquote h5 {
  color: #fff;
}
.blog-standard-2 .news-block-one .inner-box blockquote h5:before {
  display: none;
}
.blog-standard-2 .blog-sidebar .sidebar-widget {
  background: transparent;
}

.blog-grid-one .news-block-one .inner-box .post-date-two {
  background: #fff;
}
.blog-grid-one .news-block-one .inner-box .post-date-two h4 {
  color: #141417;
}
.blog-grid-one .news-block-one .inner-box .theme-btn {
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  border-radius: 0px;
  padding: 11px 32px;
}

.blog-grid-two .news-block-one .inner-box .theme-btn {
  font-size: 16px;
  border-radius: 30px;
  padding-top: 11px;
  padding-bottom: 11px;
}
.blog-grid-two .news-block-one .inner-box .theme-btn:hover {
  border-color: #e45712;
  background: #e45712;
}
.blog-grid-two .pagination li a {
  border-radius: 50%;
}

.blog-masonry-two .more-btn .theme-btn {
  background: #e45712;
  padding: 12px 40px;
}
.blog-masonry-two .news-block-one .inner-box blockquote {
  border-left: none;
  background: #302f2f;
}
.blog-masonry-two .news-block-one .inner-box blockquote .icon-box {
  color: #454444;
  left: 50%;
  transform: translateX(-50%);
}
.blog-masonry-two .news-block-one .inner-box blockquote h5 {
  color: #fff;
}
.blog-masonry-two .news-block-one .inner-box blockquote h5:before {
  display: none;
}
.blog-masonry-two .news-block-one.carousel-block .inner-box .image img {
  border-radius: 0px;
}

.blog-list-content .news-block-one .inner-box {
  padding-left: 370px;
}
.blog-list-content .news-block-one .inner-box .image-box {
  width: 370px;
  height: 370px;
}
.blog-list-content .news-block-one .inner-box .post-date-two {
  background: #fff;
}
.blog-list-content .news-block-one .inner-box .post-date-two h4 {
  color: #141417;
}
.blog-list-content .news-block-one .inner-box .theme-btn {
  border-radius: 0px;
}

.blog-details-content .blog-post .content-one .post-title .post-info li:before {
  position: absolute;
  content: "";
  background: #e5e5e5;
  width: 6px;
  height: 6px;
  top: 12px;
  right: -19px;
  border-radius: 50%;
}
.blog-details-content .blog-post .content-one .post-title .post-info li:last-child:before {
  display: none;
}
.blog-details-content .blog-post .image-box img {
  border-radius: 5px;
  width: 100%;
}
.blog-details-content blockquote .icon-box {
  color: #fceee7;
}
.blog-details-content blockquote h5.name:before {
  position: absolute;
  content: "";
  background: #141417;
  width: 15px;
  height: 2px;
  left: 0px;
  top: 12px;
}
.blog-details-content .list li:before {
  position: absolute;
  content: "";
  left: 0px;
  top: 6px;
  width: 12px;
  height: 12px;
  border: 2px solid #141417;
  border-radius: 50%;
}
.blog-details-content .post-share-option {
  border-top: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;
}
.blog-details-content .post-share-option .tags-list li a {
  padding: 9px 14px;
  border: 1px solid #e5e5e5;
}
.blog-details-content .post-share-option .tags-list li a:hover {
  color: #fff;
}
.blog-details-content .post-share-option .social-list li a {
  border: 1px solid #e6e6e6;
  color: #808080;
}
.blog-details-content .post-share-option .social-list li a:hover {
  color: #fff;
}
.blog-details-content .nav-btn .single-btn {
  border: 1px solid #e7e7e7;
}
.blog-details-content .nav-btn .single-btn:hover {
  border-color: transparent;
  box-shadow: 0px 5px 30px 0px rgba(0, 0, 0, 0.07);
}
.blog-details-content .nav-btn .single-btn h6 i {
  position: relative;
  font-size: 22px;
  top: 3px;
}
.blog-details-content .nav-btn .single-btn.prev-btn h6 i {
  margin-right: 8px;
}
.blog-details-content .nav-btn .single-btn.next-btn h6 i {
  margin-left: 8px;
}
.blog-details-content .author-box {
  box-shadow: 0px 5px 30px 0px rgba(0, 0, 0, 0.07);
}
.blog-details-content .author-box .author-thumb img {
  width: 100%;
  border-radius: 50%;
}
.blog-details-content .comments-form-area .form-group {
  margin-bottom: 20px;
}
.blog-details-content .comments-form-area .form-group:last-child {
  margin-bottom: 0px;
}
.blog-details-content .comments-form-area .form-group input[type=text] {
  position: relative;
  display: inline-block;
  width: 100%;
  height: 50px;
  font-size: 16px;
  font-family: "Poppins", sans-serif;
  color: #808080;
  border-bottom: 1px solid #e5e5e5;
  transition: all 500ms ease;
}
.blog-details-content .comments-form-area .form-group input[type=email] {
  position: relative;
  display: inline-block;
  width: 100%;
  height: 50px;
  font-size: 16px;
  font-family: "Poppins", sans-serif;
  color: #808080;
  border-bottom: 1px solid #e5e5e5;
  transition: all 500ms ease;
}
.blog-details-content .comments-form-area .form-group textarea {
  position: relative;
  display: inline-block;
  width: 100%;
  height: 50px;
  font-size: 16px;
  font-family: "Poppins", sans-serif;
  color: #808080;
  border-bottom: 1px solid #e5e5e5;
  transition: all 500ms ease;
  height: 60px;
  resize: none;
}
.blog-details-content .comments-form-area .check-box label {
  color: #808080;
}
.blog-details-content .comments-form-area .theme-btn {
  padding: 13px 31px;
  background: #e35712;
  color: #fff !important;
  border: none;
}

.page-title .post-title h2 {
  color: #fff;
}
.page-title .post-title .post-info li {
  color: #fff;
}
.page-title .post-title .post-info li:before {
  position: absolute;
  content: "";
  background: #e5e5e5;
  width: 6px;
  height: 6px;
  top: 12px;
  right: -19px;
  border-radius: 50%;
}
.page-title .post-title .post-info li:last-child:before {
  display: none;
}

.page-title.blog-details {
  padding-top: 237px;
  padding-bottom: 182px;
}

.sidebar-page-container.blog-details-3 {
  padding-top: 420px;
}
.sidebar-page-container.blog-details-3 .bg-image {
  width: 100%;
  height: 722px;
  background-size: cover;
  border-radius: inherit;
  background-position: bottom center;
}

/* template-color */
.handle-preloader {
  background: linear-gradient(224deg, #800599 0%, #FF0E75 100%);
}

.handle-preloader.home-2 {
  background: -webkit-linear-gradient(0deg, #41a0ea, #f18e95 75%);
}

.theme-btn-one {
  background: linear-gradient(219deg, #ff8c2e 0%, #7E2100 100%);
}
.theme-btn-one:before {
  background: linear-gradient(219deg, #ff8c2e 0%, #7E2100 100%);
}

/*** use-font ***/
/*** 

====================================================================
  Reset
====================================================================

 ***/
/*** 

====================================================================
  Global Settings
====================================================================

 ***/
/** use-font-family **/
/* Preloader */
@keyframes spin-1 {
  from {
    transform: rotateY(0) rotateX(30deg);
  }
  to {
    transform: rotateY(1turn) rotateX(30deg);
  }
}
@keyframes spin-2 {
  from {
    transform: rotateY(0);
  }
  to {
    transform: rotateY(1turn);
  }
}
@keyframes shine {
  100% {
    left: 125%;
  }
}
@keyframes circle {
  0% {
    opacity: 1;
  }
  40% {
    opacity: 1;
  }
  100% {
    width: 200%;
    height: 200%;
    opacity: 0;
  }
}
@keyframes ripple {
  70% {
    box-shadow: 0 0 0 40px rgba(255, 255, 255, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
  }
}
@keyframes slide {
  from {
    background-position: 0 0;
  }
  to {
    background-position: 1920px 0;
  }
}
* {
  margin: 0px;
  padding: 0px;
  border: none;
  outline: none;
}

body {
  font-size: 16px;
  color: #fff;
  line-height: 28px;
  font-weight: 400;
  background: #00061A;
  font-family: "Archivo", sans-serif;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center top;
  -webkit-font-smoothing: antialiased;
}

.auto-container {
  position: static;
  max-width: 1296px;
  padding: 0px 15px;
  margin: 0 auto;
}

.small-container {
  max-width: 680px;
  margin: 0 auto;
}

.boxed_wrapper {
  position: relative;
  margin: 0 auto;
  overflow: hidden !important;
  width: 100%;
  min-width: 300px;
}

a {
  color: #fff;
  text-decoration: none;
  transition: all 500ms ease;
  -moz-transition: all 500ms ease;
  -webkit-transition: all 500ms ease;
  -ms-transition: all 500ms ease;
  -o-transition: all 500ms ease;
}
a:hover {
  color: #ff8c2e;
  text-decoration: none;
  outline: none;
}

input {
  font-family: "Archivo", sans-serif;
  font-weight: 400;
  font-size: 16px;
  background: transparent;
  transition: all 500ms ease;
}
input:focus {
  outline: none;
  box-shadow: none;
  transition: all 500ms ease;
}

button {
  font-family: "Archivo", sans-serif;
  font-weight: 400;
  font-size: 16px;
  background: transparent;
}
button:focus {
  outline: none;
  box-shadow: none;
  transition: all 500ms ease;
}

select {
  font-family: "Archivo", sans-serif;
  font-weight: 400;
  font-size: 16px;
  background: transparent;
}

textarea {
  font-family: "Archivo", sans-serif;
  font-weight: 400;
  font-size: 16px;
  background: transparent;
}
textarea:focus {
  outline: none;
  box-shadow: none;
  transition: all 500ms ease;
}

::-webkit-input-placeholder {
  color: inherit;
}

::-moz-input-placeholder {
  color: inherit;
}

::-ms-input-placeholder {
  color: inherit;
}

ul {
  list-style: none;
  padding: 0px;
  margin: 0px;
}

li {
  list-style: none;
  padding: 0px;
  margin: 0px;
}

p {
  position: relative;
  font-family: "Archivo", sans-serif;
  color: #fff;
  font-size: 16px;
  line-height: 29px;
  margin-bottom: 0px;
  font-weight: 400;
  transition: all 500ms ease;
}
p:last-child {
  margin-bottom: 0px;
}

h1 {
  position: relative;
  font-family: "Rubik", sans-serif;
  font-weight: 400;
  color: #fff;
  line-height: 29px;
  margin: 0px;
  transition: all 500ms ease;
  font-size: 50px;
  line-height: 60px;
}

h2 {
  position: relative;
  font-family: "Rubik", sans-serif;
  font-weight: 400;
  color: #fff;
  line-height: 29px;
  margin: 0px;
  transition: all 500ms ease;
  font-size: 40px;
  font-weight: 700;
  line-height: 50px;
}

h3 {
  position: relative;
  font-family: "Rubik", sans-serif;
  font-weight: 400;
  color: #fff;
  line-height: 29px;
  margin: 0px;
  transition: all 500ms ease;
  font-size: 32px;
  font-weight: 600;
  line-height: 42px;
}

h4 {
  position: relative;
  font-family: "Rubik", sans-serif;
  font-weight: 400;
  color: #fff;
  line-height: 29px;
  margin: 0px;
  transition: all 500ms ease;
  font-size: 26px;
  font-weight: 500;
  line-height: 36px;
}

h5 {
  position: relative;
  font-family: "Rubik", sans-serif;
  font-weight: 400;
  color: #fff;
  line-height: 29px;
  margin: 0px;
  transition: all 500ms ease;
}

h6 {
  position: relative;
  font-family: "Rubik", sans-serif;
  font-weight: 400;
  color: #fff;
  line-height: 29px;
  margin: 0px;
  transition: all 500ms ease;
}

.font_family_rubik {
  font-family: "Rubik", sans-serif;
}

.font_family_archivo {
  font-family: "Archivo", sans-serif;
}

.loader-wrap {
  z-index: 9999;
  width: 100%;
  height: 100%;
  background: linear-gradient(219deg, #00061A 0%, #00061A 100%);
  position: fixed;
}

.preloader {
  display: flex;
  animation: spin-1 8s linear infinite;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: auto;
  width: 300px;
  height: 300px;
  color: #ff8c2e;
  transform-style: preserve-3d;
}

.preloader-ring {
  transform-style: preserve-3d;
  animation: spin-2 4s linear infinite;
  position: relative;
  height: 60px;
  width: 20px;
}
.preloader-ring:nth-child(even) {
  animation-direction: reverse;
}

.preloader-sector {
  font-size: 40px;
  line-height: 60px;
  font-weight: 600;
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
  text-transform: uppercase;
  transform: translateZ(160px);
  display: inline-block;
  width: 100%;
  height: 100%;
}
.preloader-sector:empty:before {
  display: inline-block;
  width: 100%;
  height: 100%;
  background: linear-gradient(transparent 50%, #ff8c2e 50% 55%, transparent 55%);
  content: "";
}

.hendel__preloder {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.centred {
  text-align: center;
}

.pull-left {
  float: left;
}

.pull-right {
  float: right;
}

figure {
  margin: 0px;
}

img {
  display: inline-block;
  max-width: 100%;
  height: auto;
  transition-delay: 0.1s;
  transition-timing-function: ease-in-out;
  transition-duration: 0.7s;
  transition-property: all;
}

.theme-btn {
  position: relative;
  display: flex;
  overflow: hidden;
  vertical-align: middle;
  font-size: 12px;
  line-height: 24px;
  font-weight: 500;
  font-family: "Rubik", sans-serif;
  color: #fff !important;
  text-align: center;
  padding: 15px 20px;
  border-radius: 5px;
  letter-spacing: 2.4px;
  text-transform: uppercase;
  z-index: 1;
  transition: all cubic-bezier(0.4, 0, 0.2, 1) 0.4s;
  align-items: center;
  gap: 10px;
}
.theme-btn i {
  position: relative;
  font-size: 15px;
}

.theme-btn-one:before {
  position: absolute;
  content: "";
  width: 0%;
  height: 100%;
  left: 0px;
  top: 0px;
  z-index: -1;
  transition: all 500ms ease;
}
.theme-btn-one:hover:before {
  width: 100%;
}

.theme-btn-two {
  background: #fff;
  padding: 12px 62px 12px 30px;
}
.theme-btn-two:hover {
  padding: 12px 69px 12px 30px;
}
.theme-btn-two:hover span:before {
  transform: translateY(-50%) translateX(-30px);
  opacity: 0;
}
.theme-btn-two:hover span:after {
  transform: translateY(-50%) translateX(0);
  opacity: 1;
}
.theme-btn-two:hover:before {
  transform: translateY(-50%) scaleX(1);
  width: 25px;
}
.theme-btn-two span {
  position: relative;
  color: transparent;
}
.theme-btn-two span:before {
  content: attr(data-text);
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%) translateX(0);
  width: 100%;
  transition: all cubic-bezier(0.4, 0, 0.2, 1) 0.4s;
  color: #141417;
}
.theme-btn-two span:after {
  content: attr(data-text);
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%) translateX(0);
  width: 100%;
  transition: all cubic-bezier(0.4, 0, 0.2, 1) 0.4s;
  color: #f4244f;
  opacity: 0;
}
.theme-btn-two:before {
  content: "";
  position: absolute;
  top: 50%;
  right: 32px;
  transform: translateY(-50%) scaleX(1);
  width: 18px;
  height: 2px;
  background: #141417;
  transition: all 500ms ease;
  transform-origin: right;
  transition: all 500ms ease;
  -moz-transition: all 500ms ease;
  -webkit-transition: all 500ms ease;
  -ms-transition: all 500ms ease;
  -o-transition: all 500ms ease;
}
.theme-btn-two:after {
  content: "";
  position: absolute;
  top: 50%;
  right: 32px;
  width: 9px;
  height: 9px;
  border-right: 2px solid #141417;
  border-top: 2px solid #141417;
  transform: translateY(-50%) rotate(45deg);
  transition: all 500ms ease;
  -moz-transition: all 500ms ease;
  -webkit-transition: all 500ms ease;
  -ms-transition: all 500ms ease;
  -o-transition: all 500ms ease;
}

.theme-btn-three {
  padding: 12px 62px 12px 30px;
}
.theme-btn-three:hover {
  padding: 12px 69px 12px 30px;
}
.theme-btn-three:hover span:before {
  transform: translateY(-50%) translateX(-30px);
  opacity: 0;
}
.theme-btn-three:hover span:after {
  transform: translateY(-50%) translateX(0);
  opacity: 1;
}
.theme-btn-three:hover:before {
  transform: translateY(-50%) scaleX(1);
  width: 25px;
}
.theme-btn-three span {
  position: relative;
  color: transparent;
}
.theme-btn-three span:before {
  content: attr(data-text);
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%) translateX(0);
  width: 100%;
  transition: all 500ms ease;
  color: #fff;
}
.theme-btn-three span:after {
  content: attr(data-text);
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%) translateX(0);
  width: 100%;
  transition: all 500ms ease;
  color: #141417;
  opacity: 0;
}
.theme-btn-three:before {
  content: "";
  position: absolute;
  top: 50%;
  right: 32px;
  transform: translateY(-50%) scaleX(1);
  width: 18px;
  height: 2px;
  background: #fff;
  transition: all 500ms ease;
  transform-origin: right;
}
.theme-btn-three:after {
  content: "";
  position: absolute;
  top: 50%;
  right: 32px;
  width: 9px;
  height: 9px;
  border-right: 2px solid #fff;
  border-top: 2px solid #fff;
  transform: translateY(-50%) rotate(45deg);
  transition: all 500ms ease;
}

.theme-btn-four {
  border-radius: 30px;
  background: #6a36ff;
}
.theme-btn-four:before {
  background-color: #141417;
  border-radius: 30px;
  content: "";
  display: block;
  height: 100%;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  transform: translate(-100%, 0) rotate(10deg);
  transform-origin: top left;
  transition: 0.3s transform ease-out;
  will-change: transform;
  z-index: -1;
}
.theme-btn-four:hover:before {
  transform: translate(0, 0);
}

.theme-btn-five {
  background: #612ade;
  padding: 17px 40px;
}
.theme-btn-five:before {
  position: absolute;
  content: "";
  background: #141417;
  width: 0%;
  height: 100%;
  left: 0px;
  top: 0px;
  z-index: -1;
  transition: all 500ms ease;
}
.theme-btn-five:hover:before {
  width: 100%;
}

.theme-btn-six {
  border: 1px solid #e7e7e7;
  padding: 16px 40px;
  color: #141417 !important;
}
.theme-btn-six:hover {
  color: #fff !important;
  border-color: #612ade;
}
.theme-btn-six:hover:before {
  width: 100%;
}
.theme-btn-six:before {
  position: absolute;
  content: "";
  background: #612ade;
  width: 0%;
  height: 100%;
  left: 0px;
  top: 0px;
  z-index: -1;
  transition: all 500ms ease;
}

.theme-btn-seven {
  background: #f1592a;
  border-radius: 30px;
  font-size: 17px;
  font-weight: 500;
  font-family: "Muli", sans-serif;
  padding: 17px 35px;
  letter-spacing: 1px;
}
.theme-btn-seven:before {
  position: absolute;
  content: "";
  background: #141417;
  width: 0%;
  height: 100%;
  top: 0px;
  right: 0px;
  border-radius: 30px;
  z-index: -1;
  transition: all 500ms ease;
}
.theme-btn-seven:hover:before {
  width: 100%;
  left: 0px;
}

.theme-btn-eight {
  font-weight: 500;
  font-family: "Spartan", sans-serif;
  border-radius: 0px;
  padding: 13px 26px 11px 26px;
  background: #ff7f4c;
}
.theme-btn-eight:before {
  webkit-transition-duration: 800ms;
  transition-duration: 800ms;
  position: absolute;
  width: 200%;
  height: 200%;
  content: "";
  bottom: 110%;
  left: 50%;
  background-color: #141417;
  transform: translateX(-50%);
  border-radius: 50%;
  z-index: -1;
}
.theme-btn-eight:hover:before {
  bottom: -40%;
}

.theme-btn-nine {
  border-radius: 0px;
  font-family: "Jost", sans-serif;
  padding: 17px 40px;
  font-size: 17px;
  background: #fff;
  color: #141417 !important;
}
.theme-btn-nine:before {
  position: absolute;
  content: "";
  background: #141417;
  width: 100%;
  height: 0%;
  left: 0px;
  bottom: 0px;
  z-index: -1;
  transition: all 500ms ease;
}
.theme-btn-nine:hover {
  color: #fff !important;
}
.theme-btn-nine:hover:before {
  top: 0px;
  height: 100%;
}

.scroll-to-top {
  position: fixed;
  right: 15px;
  bottom: 20px;
  z-index: 99;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.scroll-to-top svg {
  width: 20px;
  visibility: visible !important;
  opacity: 1 !important;
  display: flex;
  align-items: center;
  transition: all cubic-bezier(0.4, 0, 0.2, 1) 0.4s;
}
.scroll-to-top .scroll-bar {
  width: 50px;
  height: 2px;
  margin-right: 10px;
  position: relative;
}
.scroll-to-top .scroll-bar:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  background-color: #f4244f;
  opacity: 0.3;
}
.scroll-to-top .scroll-bar .bar-inner {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  background-color: currentColor;
}
.scroll-to-top .scroll-bar-text {
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 500ms ease;
}
.scroll-to-top .scroll-bar-text:hover {
  transform: scale(1.1);
}

.float-bob-y {
  animation-name: float-bob-y;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  -webkit-animation-name: float-bob-y;
  -webkit-animation-duration: 2s;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-timing-function: linear;
  -moz-animation-name: float-bob-y;
  -moz-animation-duration: 2s;
  -moz-animation-iteration-count: infinite;
  -moz-animation-timing-function: linear;
  -ms-animation-name: float-bob-y;
  -ms-animation-duration: 2s;
  -ms-animation-iteration-count: infinite;
  -ms-animation-timing-function: linear;
  -o-animation-name: float-bob-y;
  -o-animation-duration: 2s;
  -o-animation-iteration-count: infinite;
  -o-animation-timing-function: linear;
}

.float-bob-x {
  animation-name: float-bob-x;
  animation-duration: 15s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  -webkit-animation-name: float-bob-x;
  -webkit-animation-duration: 15s;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-timing-function: linear;
  -moz-animation-name: float-bob-x;
  -moz-animation-duration: 15s;
  -moz-animation-iteration-count: infinite;
  -moz-animation-timing-function: linear;
  -ms-animation-name: float-bob-x;
  -ms-animation-duration: 15s;
  -ms-animation-iteration-count: infinite;
  -ms-animation-timing-function: linear;
  -o-animation-name: float-bob-x;
  -o-animation-duration: 15s;
  -o-animation-iteration-count: infinite;
  -o-animation-timing-function: linear;
}

.main-header {
  position: relative;
  left: 0px;
  top: 0px;
  right: 0px;
  z-index: 999;
  width: 100%;
  transition: all 500ms ease;
  -moz-transition: all 500ms ease;
  -webkit-transition: all 500ms ease;
  -ms-transition: all 500ms ease;
  -o-transition: all 500ms ease;
}
.main-header .outer-box {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}

.main-header-mobile {
  position: fixed;
  left: 0px;
  top: 0px;
  right: 0px;
  z-index: 999;
  width: 100%;
  transition: all 500ms ease;
  background-color: #00061A;
  -moz-transition: all 500ms ease;
  -webkit-transition: all 500ms ease;
  -ms-transition: all 500ms ease;
  -o-transition: all 500ms ease;
}
.main-header-mobile .outer-box {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}

.sticky-header {
  position: fixed;
  opacity: 0;
  visibility: hidden;
  left: 0px;
  top: 0px;
  width: 100%;
  z-index: 0;
  background-color: #00061A;
  box-shadow: 0px 10px 20px 0px rgba(27, 24, 47, 0.1);
  transition: all 500ms ease;
  -moz-transition: all 500ms ease;
  -webkit-transition: all 500ms ease;
  -ms-transition: all 500ms ease;
  -o-transition: all 500ms ease;
  transform: translateY(-100%);
  border-bottom: 0.5px solid #ff8c2e;
}
.sticky-header .main-menu .navigation li.dropdown .dropdown-btn {
  top: 33px;
}
.sticky-header .main-menu .navigation > li.current {
  border-bottom: none;
}
.sticky-header .main-menu .navigation > li a:before {
  display: none;
}
.sticky-header .main-menu .navigation > li > a {
  padding: 30px 0px;
}
.sticky-header .logo-box {
  padding: 14px 0px;
}
.sticky-header .nav-right {
  margin-left: 30px;
}

.fixed-header .sticky-header {
  z-index: 999;
  opacity: 1;
  visibility: visible;
  -op-animation-name: fadeInDown;
  animation-name: fadeInDown;
  -op-animation-duration: 500ms;
  animation-duration: 500ms;
  -op-animation-timing-function: linear;
  animation-timing-function: linear;
  -op-animation-iteration-count: 1;
  animation-iteration-count: 1;
  transform: translateY(0%);
}

.main-menu .navbar-collapse {
  padding: 0px;
  display: block !important;
}
.main-menu .navigation {
  margin: 0px;
}
.main-menu .navigation > li {
  position: relative;
  float: left;
  z-index: 2;
  margin: 0px 16px;
  transition: all 300ms ease;
}
.main-menu .navigation > li:last-child {
  margin-right: 0px !important;
}
.main-menu .navigation > li:first-child {
  margin-left: 0px !important;
}
.main-menu .navigation > li > a {
  position: relative;
  display: block;
  text-align: center;
  font-size: 18px;
  line-height: normal;
  font-family: "Rubik", sans-serif;
  padding: 50px 0px;
  font-weight: 500;
  opacity: 1;
  color: #fff;
  overflow: hidden;
  z-index: 1;
  transition: all 500ms ease;
}
.main-menu .navigation > li > ul {
  position: absolute;
  left: inherit;
  top: 100%;
  width: 230px;
  margin-top: 15px;
  z-index: 100;
  display: none;
  opacity: 0;
  padding-top: 0px;
  padding-bottom: 0px;
  visibility: hidden;
  background: rgb(0, 6, 26);
  border: 1px solid rgba(255, 255, 255, 0.15);
  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.07);
  transition: all 500ms ease;
  -moz-transition: all 500ms ease;
  -webkit-transition: all 500ms ease;
  -ms-transition: all 500ms ease;
  -o-transition: all 500ms ease;
  padding: 15px 24px;
}
.main-menu .navigation > li > ul > li {
  position: relative;
  width: 100%;
}
.main-menu .navigation > li > ul > li:hover > a {
  color: #ff8c2e !important;
}
.main-menu .navigation > li > ul > li > a {
  position: relative;
  display: block;
  padding: 10px 0px;
  line-height: 24px;
  font-weight: 400;
  font-size: 16px;
  font-family: "Rubik", sans-serif;
  text-transform: capitalize;
  color: #fff;
  text-align: left;
  transition: all 500ms ease;
  -moz-transition: all 500ms ease;
  -webkit-transition: all 500ms ease;
  -ms-transition: all 500ms ease;
  -o-transition: all 500ms ease;
  color: #fff !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
}
.main-menu .navigation > li > ul > li:last-child > a {
  border-bottom: none;
}
.main-menu .navigation > li > ul > li > ul {
  position: absolute;
  right: 100%;
  top: 0%;
  margin-top: 15px;
  width: 230px;
  z-index: 100;
  display: none;
  background: rgb(0, 6, 26);
  border: 1px solid rgba(255, 255, 255, 0.15);
  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.07);
  transition: all 500ms ease;
  -moz-transition: all 500ms ease;
  -webkit-transition: all 500ms ease;
  -ms-transition: all 500ms ease;
  -o-transition: all 500ms ease;
}
.main-menu .navigation > li > ul > li > ul > li {
  position: relative;
  width: 100%;
}
.main-menu .navigation > li > ul > li > ul > li:last-child {
  border-bottom: none;
}
.main-menu .navigation > li > ul > li > ul > li:last-child > a {
  border-bottom: none;
}
.main-menu .navigation > li > ul > li > ul > li > a {
  position: relative;
  display: block;
  padding: 8px 0px;
  line-height: 24px;
  font-weight: 500;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  font-size: 16px;
  font-family: "Rubik", sans-serif;
  text-transform: capitalize;
  color: #fff !important;
  text-align: left;
  transition: all 500ms ease;
  -moz-transition: all 500ms ease;
  -webkit-transition: all 500ms ease;
  -ms-transition: all 500ms ease;
  -o-transition: all 500ms ease;
}
.main-menu .navigation > li > ul > li > ul > li.dropdown > a:after {
  font-family: "Font Awesome 5 Pro";
  content: "\\f105";
  position: absolute;
  right: 20px;
  top: 12px;
  display: block;
  line-height: 24px;
  font-size: 16px;
  font-weight: 900;
  z-index: 5;
}
.main-menu .navigation > li > ul > li > ul.from-right {
  left: auto;
  right: 0px;
}
.main-menu .navigation > li > ul > li.dropdown > a:after {
  font-family: "icomoon" !important;
  content: "\\e906";
  position: absolute;
  right: 20px;
  top: 8px;
  display: block;
  line-height: 24px;
  font-size: 16px;
  font-weight: 800;
  text-align: center;
  z-index: 5;
}
.main-menu .navigation > li > .megamenu {
  position: absolute;
  left: inherit;
  top: 100%;
  width: 230px;
  margin-top: 15px;
  z-index: 100;
  display: none;
  opacity: 0;
  padding-top: 0px;
  padding-bottom: 0px;
  visibility: hidden;
  background: rgb(0, 6, 26);
  border: 1px solid rgba(255, 255, 255, 0.15);
  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.07);
  transition: all 500ms ease;
  -moz-transition: all 500ms ease;
  -webkit-transition: all 500ms ease;
  -ms-transition: all 500ms ease;
  -o-transition: all 500ms ease;
}
.main-menu .navigation > li > .megamenu li > a {
  position: relative;
  display: block;
  padding: 10px 0px;
  line-height: 24px;
  font-weight: 400;
  font-size: 16px;
  font-family: "Rubik", sans-serif;
  text-transform: capitalize;
  color: #fff;
  text-align: left;
  transition: all 500ms ease;
  -moz-transition: all 500ms ease;
  -webkit-transition: all 500ms ease;
  -ms-transition: all 500ms ease;
  -o-transition: all 500ms ease;
  padding: 6px 0px;
  display: inline-block;
}
.main-menu .navigation > li > .megamenu li > a:before {
  position: absolute;
  content: "";
  width: 0%;
  height: 1px;
  left: 0px;
  bottom: 8px;
  transition: all 500ms ease;
}
.main-menu .navigation > li > .megamenu li > a:hover {
  padding-left: 15px;
}
.main-menu .navigation > li > .megamenu li > a:hover:before {
  width: calc(100% - 15px);
  left: 15px;
}
.main-menu .navigation > li > .megamenu li:last-child > a {
  border-bottom: none;
}
.main-menu .navigation > li:hover a {
  color: #ff8c2e;
}
.main-menu .navigation > li:hover .dropdown-btn {
  color: #ff8c2e !important;
}
.main-menu .navigation > li:hover:before {
  width: 100%;
}
.main-menu .navigation > li a.active {
  color: #ff8c2e;
}
.main-menu .navigation > li > ul.from-right {
  left: auto;
  right: 0px;
}
.main-menu .navigation > li:before {
  content: "";
  background: #ff8c2e;
  width: 0%;
  height: 3px;
  position: absolute;
  left: 0;
  bottom: -3px;
  transition: all 500ms ease;
}
.main-menu .navigation > li .active {
  border-bottom: 3px solid #ff8c2e;
}
.main-menu .navigation > li.current .dropdown-btn {
  color: #ff8c2e !important;
}
.main-menu .navigation > li.dropdown:hover > ul {
  visibility: visible;
  opacity: 1;
  margin-top: 6px;
  top: 100%;
}
.main-menu .navigation > li.dropdown:hover > .megamenu {
  visibility: visible;
  opacity: 1;
  margin-top: 6px;
  top: 100%;
}
.main-menu .navigation > li.dropdown > .megamenu {
  position: absolute;
  width: 100%;
  padding: 30px 50px;
  left: 0px;
}
.main-menu .navigation li > ul > li.dropdown:hover > ul {
  visibility: visible;
  opacity: 1;
  top: 0%;
  margin-top: 0px;
  margin-right: 34px;
  padding: 15px 10px;
}
.main-menu .navigation li.dropdown .dropdown-btn {
  position: absolute;
  right: -23px;
  top: 53px;
  width: 15px;
  height: 15px;
  text-align: center;
  font-size: 14px;
  line-height: 26px;
  color: #fff;
  cursor: pointer;
  z-index: 5;
  transition: all 500ms ease;
}
.main-menu .navigation li.dropdown ul li.dropdown .dropdown-btn {
  display: none;
}
.main-menu .navigation li.dropdown .megamenu li h6 {
  position: relative;
  display: block;
  border-bottom: 1px solid #e5e5e5;
  padding-bottom: 13px;
  padding-top: 13px;
  font-size: 16px;
  line-height: 26px;
  font-weight: 700;
  text-transform: uppercase;
  color: #141417;
  margin-bottom: 7px;
}

.header__style__one .outer-box {
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
}
.header__style__one .sticky-header .outer-box {
  border-bottom: none;
}

.menu-area .mobile-nav-toggler {
  position: relative;
  float: right;
  font-size: 40px;
  line-height: 50px;
  cursor: pointer;
  color: #3786ff;
  display: none;
}
.menu-area .mobile-nav-toggler .icon-bar {
  position: relative;
  height: 2px;
  width: 30px;
  display: block;
  margin-bottom: 5px;
  background-color: #ff8c2e;
  transition: all 300ms ease;
}
.menu-area .mobile-nav-toggler .icon-bar:last-child {
  margin-bottom: 0px;
}

.header-lower .theme-btn {
  padding: 15px 30px;
}
.header-lower .outer-box .logo-box {
  padding: 30px 0px;
}
.header-lower .outer-box .logo-box .logo {
  min-width: 200px;
}
.header-lower .outer-box .logo-box .logo img {
  width: 100%;
}

.nav-outer .mobile-nav-toggler {
  position: relative;
  float: right;
  font-size: 40px;
  line-height: 50px;
  cursor: pointer;
  color: #3786ff;
  display: none;
}

.mobile-menu {
  position: fixed;
  right: 0;
  top: 0;
  width: 300px;
  padding-right: 30px;
  max-width: 100%;
  height: 100%;
  opacity: 0;
  visibility: hidden;
  z-index: 999999;
  transition: all 900ms ease;
}
.mobile-menu .navbar-collapse {
  display: block !important;
}
.mobile-menu .nav-logo {
  position: relative;
  padding: 50px 25px;
  text-align: left;
  padding-bottom: 50px;
}
.mobile-menu .menu-backdrop {
  position: fixed;
  left: 0%;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  transition: all 900ms ease;
  background-color: #000;
}
.mobile-menu .menu-box {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  max-height: 100%;
  overflow-y: auto;
  background: #00061A;
  padding: 0px 0px;
  z-index: 5;
  opacity: 0;
  visibility: hidden;
  border-radius: 0px;
  transform: translateX(100%);
  transition: all 900ms ease !important;
}
.mobile-menu .close-btn {
  position: absolute;
  right: 25px;
  top: 10px;
  line-height: 30px;
  width: 24px;
  text-align: center;
  font-size: 16px;
  color: #ffffff;
  cursor: pointer;
  z-index: 10;
  transition: all 0.9s ease;
}
.mobile-menu .close-btn:hover {
  transform: rotate(90deg);
}
.mobile-menu .navigation {
  position: relative;
  display: block;
  width: 100%;
  float: none;
}
.mobile-menu .navigation li {
  position: relative;
  display: block;
}
.mobile-menu .navigation li > ul {
  display: none;
}
.mobile-menu .navigation li > ul > li:first-child {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}
.mobile-menu .navigation li > ul > li > ul {
  display: none;
}
.mobile-menu .navigation li > a {
  position: relative;
  display: block;
  line-height: 24px;
  padding: 10px 25px;
  font-size: 15px;
  font-weight: 500;
  color: #ffffff;
  text-transform: uppercase;
  transition: all 500ms ease;
}
.mobile-menu .navigation li > a:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  height: 0;
  border-left: 5px solid #fff;
  transition: all 500ms ease;
}
.mobile-menu .navigation li > a.active {
  color: #ff8c2e !important;
}
.mobile-menu .navigation li ul li > a {
  font-size: 16px;
  margin-left: 20px;
  text-transform: capitalize;
}
.mobile-menu .navigation li.current > a:before {
  height: 100%;
}
.mobile-menu .navigation li.dropdown .dropdown-btn {
  position: absolute;
  right: 6px;
  top: 6px;
  width: 32px;
  height: 32px;
  text-align: center;
  font-size: 16px;
  line-height: 32px;
  color: #ffffff;
  background: rgba(255, 255, 255, 0.1);
  cursor: pointer;
  border-radius: 2px;
  transition: all 500ms ease;
  z-index: 5;
}
.mobile-menu .navigation li.dropdown .dropdown-btn.open {
  color: #ffffff;
  transform: rotate(90deg);
}
.mobile-menu .navigation > li.dropdown > .megamenu {
  display: none;
}
.mobile-menu .social-links {
  position: relative;
  padding: 0px 25px;
}
.mobile-menu .social-links li {
  position: relative;
  display: inline-block;
  margin: 0px 10px 10px;
}
.mobile-menu .social-links li a {
  position: relative;
  line-height: 32px;
  font-size: 16px;
  color: #ffffff;
  transition: all 500ms ease;
}
.mobile-menu .contact-info {
  position: relative;
  padding: 120px 30px 20px 30px;
}
.mobile-menu .contact-info h4 {
  position: relative;
  font-size: 20px;
  color: #ffffff;
  font-weight: 700;
  margin-bottom: 20px;
}
.mobile-menu .contact-info ul li {
  position: relative;
  display: block;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 3px;
}
.mobile-menu .contact-info ul li a {
  color: rgba(255, 255, 255, 0.8);
}
.mobile-menu .contact-info ul li a:hover {
  text-decoration: underline;
}
.mobile-menu .contact-info ul li:last-child {
  margin-bottom: 0px;
}

.mobile-menu-visible {
  overflow: hidden;
}
.mobile-menu-visible .mobile-menu {
  opacity: 1;
  visibility: visible;
}
.mobile-menu-visible .mobile-menu .menu-backdrop {
  opacity: 0.7;
  visibility: visible;
  right: 100%;
  -webkit-transition: all 0.8s ease-out 0s;
  -o-transition: all 0.8s ease-out 0s;
}
.mobile-menu-visible .mobile-menu .menu-box {
  opacity: 1;
  visibility: visible;
  transition: all 0.7s ease;
  transform: translateX(0%);
}
.mobile-menu-visible .mobile-menu .close-btn {
  transform: rotate(360deg);
}

div#mCSB_1_container {
  top: 0px !important;
}

.header-top-one .top__inner {
  border-radius: 0px 0px 25px 25px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 30px;
}

.top__hrader__left ul {
  display: flex;
  align-items: center;
  gap: 22px;
}
.top__hrader__left li {
  font-size: 14px;
}
.top__hrader__left li span {
  color: #ff8c2e;
}
.top__hrader__left li a {
  color: #fff;
}

.top__hrader__right ul {
  display: flex;
  align-items: center;
  gap: 10px;
}
.top__hrader__right ul li a {
  border: 1px solid #272D40;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 12px;
  position: relative;
  z-index: 1;
  color: #fff;
}
.top__hrader__right ul li a:before {
  position: absolute;
  content: "";
  width: 100%;
  height: 100%;
  background-color: #800599;
  border: 1px solid #800599;
  transform: scale(0);
  transition: all 500ms ease;
  -moz-transition: all 500ms ease;
  -webkit-transition: all 500ms ease;
  -ms-transition: all 500ms ease;
  -o-transition: all 500ms ease;
  border-radius: 50%;
  z-index: -1;
}
.top__hrader__right ul li a:hover:before {
  transform: scale(1.1);
}

.mouse-pointer {
  position: fixed;
  top: 50%;
  left: -100px;
  transform: translate(-50%, -50%);
  width: 10px;
  height: 10px;
  pointer-events: none;
  box-sizing: border-box;
  z-index: 9999;
  transition-property: width, height, background;
  transition-duration: 0.9s;
  transition-timing-function: cubic-bezier(0.19, 0.94, 0.336, 1);
  border-radius: 50%;
  background: linear-gradient(224deg, #ff8c2e 0%, #7E2100 100%);
  overflow: hidden;
}
.mouse-pointer .icon {
  color: #fff;
  font-size: 14px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-100%, -50%);
  opacity: 0;
  transition: 0.4s cubic-bezier(0.225, 1, 0.316, 0.99);
}
.mouse-pointer .icon i {
  margin: 0px 3px;
}

.mouse-pointer.display_none {
  display: none;
}

body.out .mouse-pointer {
  width: 0;
  height: 0;
}

.mouse-pointer.large {
  width: 65px;
  height: 65px;
  background: rgba(224, 36, 79, 0) !important;
  box-shadow: 0 0 30px rgba(224, 36, 79, 0.4);
  display: block !important;
}

.mouse-pointer.style-two {
  background: #41a0ea;
}

.mouse-pointer.style-two.large {
  box-shadow: 0 0 30px rgba(65, 160, 234, 0.4);
}

.mouse-pointer.style-three {
  background: #6a36ff;
}

.mouse-pointer.style-three.large {
  box-shadow: 0 0 30px rgba(106, 54, 255, 0.4);
}

.mouse-pointer.style-four {
  background: #bc8664;
}

.mouse-pointer.style-four.large {
  box-shadow: 0 0 30px rgba(188, 134, 100, 0.4);
}

.mouse-pointer.style-five {
  background: #f1592a;
}

.mouse-pointer.style-five.large {
  box-shadow: 0 0 30px rgba(241, 89, 42, 0.4);
}

.mouse-pointer.style-six {
  background: #e93421;
}

.mouse-pointer.style-six.large {
  box-shadow: 0 0 30px rgba(233, 52, 33, 0.4);
}

.mouse-pointer.style-seven {
  background: #f38836;
}

.mouse-pointer.style-seven.large {
  box-shadow: 0 0 30px rgba(243, 136, 54, 0.4);
}

.mouse-pointer.style-eight {
  background: #ff7f4c;
}

.mouse-pointer.style-eight.large {
  box-shadow: 0 0 30px rgba(255, 127, 76, 0.4);
}

.mouse-pointer.style-nine {
  background: #ae8c64;
}

.mouse-pointer.style-nine.large {
  box-shadow: 0 0 30px rgba(174, 140, 100, 0.4);
}

.mouse-pointer.style-ten {
  background: #ff5e14;
}

.mouse-pointer.style-ten.large {
  box-shadow: 0 0 30px rgba(255, 94, 20, 0.4);
}

.mouse-pointer.style-11 {
  background: #fb4754;
}

.mouse-pointer.style-11.large {
  box-shadow: 0 0 30px rgba(251, 71, 84, 0.4);
}

.mouse-pointer.style-12 {
  background: #00d0f5;
}

.mouse-pointer.style-12.large {
  box-shadow: 0 0 30px rgba(0, 208, 245, 0.4);
}

.mouse-pointer.style-13 {
  background: #a44ac5;
}

.mouse-pointer.style-13.large {
  box-shadow: 0 0 30px rgba(164, 74, 197, 0.4);
}

.mouse-pointer.style-14 {
  background: #17be74;
}

.mouse-pointer.style-14.large {
  box-shadow: 0 0 30px rgba(23, 190, 116, 0.4);
}

.mouse-pointer.small {
  width: 25px;
  height: 25px;
  background: rgba(227, 87, 18, 0);
  box-shadow: 0 0 30px #e35712;
}

.mouse-pointer.right {
  width: 50px;
  height: 50px;
  background: #000 !important;
}
.mouse-pointer.right .icon {
  opacity: 1;
  transform: translate(-50%, -50%);
  transition-delay: 0.2s;
}

.mouse-pointer.right.large {
  background: transparent !important;
}
.mouse-pointer.right.large .icon {
  opacity: 0;
}

.mouse-pointer.zoom {
  width: 80px;
  height: 80px;
  background: rgba(227, 87, 18, 0);
  border: 2px solid #e35712;
}

.mouse-pointer.open {
  width: 80px;
  height: 80px;
  background: rgba(227, 87, 18, 0);
  border: 2px solid #e35712;
}

.mouse-pointer.black {
  background: #000;
}

.mouse-pointer.black.large {
  background: rgba(0, 0, 0, 0.4);
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.2);
}

.mouse-pointer.black.small {
  background: rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.2);
}

.mouse-pointer.black.right {
  background: rgba(0, 0, 0, 0);
  border: 2px solid #000;
}

.mouse-pointer.black.zoom {
  background: rgba(0, 0, 0, 0);
  border: 2px solid #000;
}

.mouse-pointer.black.open {
  background: rgba(0, 0, 0, 0);
  border: 2px solid #000;
}

.touch .mouse-pointer {
  display: none;
}

.mouse-pointer.transparent {
  display: none;
  transition: all 500ms ease;
}

.main__footer .top-inner {
  background: linear-gradient(238deg, #00061A 0%, #060E26 100%) !important;
  padding: 23px 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 4px;
}
.main__footer .inner__box {
  overflow: hidden;
  transition: all 500ms ease;
}
.main__footer .inner__box:hover .image__box a:before {
  opacity: 0.2;
  transform: scale(1.1);
}
.main__footer .image__box {
  overflow: hidden;
  position: relative;
}
.main__footer .image__box img {
  width: 100%;
  transition: all 500ms ease;
}
.main__footer .image__box a:before {
  content: "";
  background: -webkit-linear-gradient(0deg, #c335da, #fc2643 100%);
  position: absolute;
  width: 100%;
  height: 100%;
  transform: scale(0);
  transition: all 500ms ease;
}

.left__top h3 {
  font-weight: 400;
}

.footer__one {
  background: #00061A;
  padding: 150px 0px 30px;
  position: relative;
  overflow: hidden;
}

.footer-widget .text p {
  color: #fff;
}
.footer-widget .widget-title {
  padding-bottom: 40px;
  position: relative;
}
.footer-widget .widget-title:after {
  content: "";
  background: #ff8c2e;
  width: 37px;
  height: 2px;
  position: absolute;
  left: 0;
  top: 37px;
}
.footer-widget .btn-box {
  display: flex;
}

.footer-logo-widget .text p {
  padding: 30px 0px 20px;
}

.news-letter-widget .form-group {
  padding-top: 22px;
  position: relative;
}
.news-letter-widget .form-group input {
  border-radius: 5px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: rgba(255, 255, 255, 0.25);
  font-family: Rubik;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 2.4px;
  text-transform: uppercase;
  width: 100%;
  padding: 22px;
}
.news-letter-widget .form-group .btn-box {
  position: absolute;
  right: 8px;
  top: 30px;
}

.widget_content ul.instagram_list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
}

.footer-bottom {
  padding-top: 120px;
}
.footer-bottom .copyright {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 32px;
  width: 100%;
}
.footer-bottom .copyright p {
  text-align: center;
  color: #fff;
}
.footer-bottom .copyright p a {
  color: #ff8c2e;
}

.footer-top {
  position: relative;
  margin-bottom: -60px;
  z-index: 9;
}

.see__pad {
  padding: 60px 0px;
}

.p_relative {
  position: relative !important;
}

.p_absolute {
  position: absolute !important;
}

.mt-5 {
  margin-top: 5px !important;
}

.mt-10 {
  margin-top: 10px !important;
}

.mt-15 {
  margin-top: 15px !important;
}

.mt-20 {
  margin-top: 20px !important;
}

.mt-25 {
  margin-top: 25px !important;
}

.mt-30 {
  margin-top: 30px !important;
}

.mt-35 {
  margin-top: 35px !important;
}

.mt-40 {
  margin-top: 40px !important;
}

.mt-45 {
  margin-top: 45px !important;
}

.mt-50 {
  margin-top: 50px !important;
}

.mt-55 {
  margin-top: 55px !important;
}

.mt-60 {
  margin-top: 60px !important;
}

.mt-65 {
  margin-top: 65px !important;
}

.mt-70 {
  margin-top: 70px !important;
}

.mt-75 {
  margin-top: 75px !important;
}

.mt-80 {
  margin-top: 80px !important;
}

.mb-5 {
  margin-bottom: 5px !important;
  margin-bottom: 5px !important;
}

.mb-10 {
  margin-bottom: 10px !important;
}

.mb-15 {
  margin-bottom: 15px !important;
}

.mb-20 {
  margin-bottom: 20px !important;
}

.mb-25 {
  margin-bottom: 25px !important;
}

.mb-30 {
  margin-bottom: 30px !important;
}

.mb-35 {
  margin-bottom: 35px !important;
}

.mb-40 {
  margin-bottom: 40px !important;
}

.mb-45 {
  margin-bottom: 45px !important;
}

.mb-50 {
  margin-bottom: 50px !important;
}

.mb-55 {
  margin-bottom: 55px !important;
}

.mb-60 {
  margin-bottom: 60px !important;
}

.mb-65 {
  margin-bottom: 65px !important;
}

.mb-70 {
  margin-bottom: 70px !important;
}

.mb-75 {
  margin-bottom: 75px !important;
}

.mb-80 {
  margin-bottom: 80px !important;
}

.ml-0 {
  margin-left: 0px !important;
  margin-left: 0px !important;
}

.mr-0 {
  margin-right: 0px !important;
  margin-right: 0px !important;
}

.mb-0 {
  margin-bottom: 0px !important;
}

.ml-5 {
  margin-left: 5px !important;
}

.ml-10 {
  margin-left: 10px !important;
}

.ml-15 {
  margin-left: 15px !important;
}

.ml-20 {
  margin-left: 20px !important;
}

.ml-25 {
  margin-left: 25px !important;
}

.ml-30 {
  margin-left: 30px !important;
}

.ml-35 {
  margin-left: 35px !important;
}

.ml-40 {
  margin-left: 40px !important;
}

.ml-45 {
  margin-left: 45px !important;
}

.ml-50 {
  margin-left: 50px !important;
}

.ml-55 {
  margin-left: 55px !important;
}

.ml-60 {
  margin-left: 60px !important;
}

.ml-65 {
  margin-left: 65px !important;
}

.ml-70 {
  margin-left: 70px !important;
}

.ml-75 {
  margin-left: 75px !important;
}

.ml-80 {
  margin-left: 80px !important;
}

.mr-5 {
  margin-right: 5px !important;
}

.mr-10 {
  margin-right: 10px !important;
}

.mr-15 {
  margin-right: 15px !important;
}

.mr-20 {
  margin-right: 20px !important;
}

.mr-25 {
  margin-right: 25px !important;
}

.mr-30 {
  margin-right: 30px !important;
}

.mr-35 {
  margin-right: 35px !important;
}

.mr-40 {
  margin-right: 40px !important;
}

.mr-45 {
  margin-right: 45px !important;
}

.mr-50 {
  margin-right: 50px !important;
}

.mr-55 {
  margin-right: 55px !important;
}

.mr-60 {
  margin-right: 60px !important;
}

.mr-65 {
  margin-right: 65px !important;
}

.mr-70 {
  margin-right: 70px !important;
}

.mr-75 {
  margin-right: 75px !important;
}

.mr-80 {
  margin-right: 80px !important;
}

.pt-0 {
  padding-top: 0px !important;
}

.pl-0 {
  padding-left: 0px !important;
}

.pr-0 {
  padding-right: 0px !important;
}

.pb-5 {
  padding-bottom: 5px !important;
  padding-bottom: 5px !important;
}

.mt-0 {
  margin-top: 0px !important;
}

.pt-10 {
  padding-top: 10px !important;
}

.pt-15 {
  padding-top: 15px !important;
}

.pt-20 {
  padding-top: 20px !important;
}

.pt-25 {
  padding-top: 25px !important;
}

.pt-30 {
  padding-top: 30px !important;
}

.pt-35 {
  padding-top: 35px !important;
}

.pt-40 {
  padding-top: 40px !important;
}

.pt-45 {
  padding-top: 45px !important;
}

.pt-50 {
  padding-top: 50px !important;
}

.pt-55 {
  padding-top: 55px !important;
}

.pt-60 {
  padding-top: 60px !important;
}

.pt-65 {
  padding-top: 65px !important;
}

.pt-70 {
  padding-top: 70px !important;
}

.pt-75 {
  padding-top: 75px !important;
}

.pt-80 {
  padding-top: 80px !important;
}

.pt-100 {
  padding-top: 100px !important;
}

.pt-140 {
  padding-top: 140px;
}

.pb-10 {
  padding-bottom: 10px !important;
}

.pb-15 {
  padding-bottom: 15px !important;
}

.pb-20 {
  padding-bottom: 20px !important;
}

.pb-25 {
  padding-bottom: 25px !important;
}

.pb-24 {
  padding-bottom: 24px !important;
}

.pb-30 {
  padding-bottom: 30px !important;
}

.pb-35 {
  padding-bottom: 35px !important;
}

.pb-40 {
  padding-bottom: 40px !important;
}

.pb-45 {
  padding-bottom: 45px !important;
}

.pb-50 {
  padding-bottom: 50px !important;
}

.pb-55 {
  padding-bottom: 55px !important;
}

.pb-60 {
  padding-bottom: 60px !important;
}

.pb-65 {
  padding-bottom: 65px !important;
}

.pb-70 {
  padding-bottom: 70px !important;
}

.pb-75 {
  padding-bottom: 75px !important;
}

.pb-80 {
  padding-bottom: 80px !important;
}

.pb-100 {
  padding-bottom: 100px !important;
}

.pb-140 {
  padding-bottom: 140px;
}

.pl-5 {
  padding-left: 5px !important;
}

.pl-10 {
  padding-left: 10px !important;
}

.pl-15 {
  padding-left: 15px !important;
}

.pl-20 {
  padding-left: 20px !important;
}

.pl-25 {
  padding-left: 25px !important;
}

.pl-30 {
  padding-left: 30px !important;
}

.pl-35 {
  padding-left: 35px !important;
}

.pl-40 {
  padding-left: 40px !important;
}

.pl-45 {
  padding-left: 45px !important;
}

.pl-50 {
  padding-left: 50px !important;
}

.pl-55 {
  padding-left: 55px !important;
}

.pl-60 {
  padding-left: 60px !important;
}

.pl-65 {
  padding-left: 65px !important;
}

.pl-70 {
  padding-left: 70px !important;
}

.pl-75 {
  padding-left: 75px !important;
}

.pl-80 {
  padding-left: 80px !important;
}

.pr-5 {
  padding-right: 5px !important;
}

.pr-10 {
  padding-right: 10px !important;
}

.pr-15 {
  padding-right: 15px !important;
}

.pr-20 {
  padding-right: 20px !important;
}

.pr-25 {
  padding-right: 25px !important;
}

.pr-30 {
  padding-right: 30px !important;
}

.pr-35 {
  padding-right: 35px !important;
}

.pr-40 {
  padding-right: 40px !important;
}

.pr-45 {
  padding-right: 45px !important;
}

.pr-50 {
  padding-right: 50px !important;
}

.pr-55 {
  padding-right: 55px !important;
}

.pr-60 {
  padding-right: 60px !important;
}

.pr-65 {
  padding-right: 65px !important;
}

.pr-70 {
  padding-right: 70px !important;
}

.pr-75 {
  padding-right: 75px !important;
}

.pr-80 {
  padding-right: 80px !important;
}

.sub__title h4 {
  color: #ff8c2e;
  font-family: Archivo;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 13.2px;
  text-transform: uppercase;
}

.title__data {
  position: relative;
  padding-bottom: 60px;
}

.title {
  padding-top: 10px;
}

.owl-nav {
  display: none;
}

.owl-dots {
  display: none;
}

@media (min-width: 1296px) {
  .container {
    max-width: 1296px;
    padding: 0px 15px;
  }
}
@media only screen and (max-width: 991px) {
  .see__pad {
    margin: 120px 0px 60px !important;
  }
}
/* Responsive Css */
@media only screen and (max-width: 1800px) {
  .choose___two .pattern-1 {
    display: none;
  }
  .choose__us__data:before {
    left: 0px;
  }
}
@media only screen and (max-width: 1449px) {
  .post__date ul li.two {
    display: none;
  }
  .choose__us.three .pattern-2 {
    left: 0;
  }
  .consultation__text {
    position: relative;
    width: auto;
    left: 0;
    position: relative;
    left: 0;
  }
  .consultation__img {
    margin-top: 50px;
    margin-top: 50px;
  }
  .home__three {
    padding-left: 100px;
  }
  .service__block__two {
    padding: 155px 70px 50px;
  }
}
@media only screen and (max-width: 1231px) {
  .funfact__content.three {
    margin-top: 0;
  }
}
@media only screen and (max-width: 1231px) {
  .funfact__content.three {
    margin-top: 0;
  }
}
@media only screen and (max-width: 1319px) {
  .home__three .funfact__content.three {
    margin-top: 0;
  }
}
@media only screen and (max-width: 1200px) {
  .main-header.header__style__one .btn-box {
    display: none;
  }
  .choose__us__data:before {
    left: 0;
  }
  .testimonial__section .swiper-wrapper > *:nth-child(even) {
    margin-top: 0px;
  }
  .see__pad {
    padding: 50px 0px;
  }
  br {
    display: none;
  }
  .banner__one .banner__bg {
    display: none;
  }
  .accomplised__section {
    padding-top: 40px;
  }
  .funfact__content.three {
    margin-top: 0px;
  }
  .test__bg {
    display: none;
  }
  .news__block {
    margin-bottom: 20px;
  }
  .post__date ul, .detail__post__date ul {
    gap: 20px;
  }
  .protfolio__inner {
    margin-right: 0;
  }
  .portfolio__block img {
    width: 100%;
  }
  .page__title {
    padding: 150px 0px;
  }
  .page__title .title {
    font-size: 60px;
    line-height: 70px;
  }
  .pride__block h1 {
    font-size: 60px;
    line-height: 70px;
    padding: 0px 20px;
  }
  .testimonial___data .row > div:nth-child(even) {
    margin-top: 0px;
  }
  .testimonials__block__one.page {
    margin-bottom: 50px;
  }
  .comments__box {
    display: block;
  }
  .blog__inner__box {
    padding: 40px;
  }
  .home__three .about__block {
    margin-top: 0;
  }
  .consultation__text {
    padding-top: 50px;
  }
  .footer__one {
    padding-top: 100px;
  }
  .service__contact.three {
    padding-bottom: 100px;
  }
  .main-header.header__three {
    position: relative;
    width: auto;
  }
  .header__three .outer-box {
    display: flex !important;
    height: auto;
    justify-content: space-between;
    padding: 0px 20px;
  }
  .header__three .logo-box {
    position: relative;
    left: 0 !important;
    padding: 30px 0px !important;
    transform: translate(0px, 0px);
    top: 0;
  }
  .header__three .menu-area {
    position: relative;
    left: 0;
    top: 0;
    transform: translate(0px, 0px);
  }
  .header__three .banner__media_two {
    display: none;
  }
  .home__three {
    padding-left: 0px;
  }
  .service__details__left {
    margin-bottom: 50px;
  }
  .error__page h1.title {
    font-size: 200px;
  }
  .core_value_content.remove_gap_core_value {
    margin-top: 0;
  }
}
@media only screen and (min-width: 768px) {
  .main-menu .navigation > li > ul {
    display: block !important;
    visibility: hidden;
    opacity: 0;
  }
  .main-menu .navigation > li > ul > li > ul {
    display: block !important;
    visibility: hidden;
    opacity: 0;
  }
  .main-menu .navigation > li > .megamenu {
    display: block !important;
    visibility: hidden;
    opacity: 0;
  }
}
@media only screen and (max-width: 1199px) {
  .core_value_content.remove_gap_core_value_1 {
    margin-top: 0;
  }
  .core_value_content.remove_gap_core_value_2 {
    margin-top: -65px;
  }
}
@media only screen and (max-width: 1087px) {
  .core_value_content.remove_gap_core_value_1 {
    margin-top: -65px;
  }
  .core_value_content.remove_gap_core_value_2 {
    margin-top: -65px;
  }
}
@media only screen and (max-width: 991px) {
  .main-menu {
    display: none !important;
  }
  .sticky-header {
    display: none !important;
  }
  .main-header.style-one .outer-container:before {
    display: none !important;
  }
  .menu-area .mobile-nav-toggler {
    display: block;
    padding: 10px;
  }
  .megamenu ul li:first-child {
    display: none;
  }
  .pattern-layer {
    display: none;
  }
  .header-top-one .top__inner {
    display: none;
  }
  .brand__content .brand__name h1 {
    font-size: 40px;
  }
  .brand__section .brand-carousel {
    padding: 40px 0px;
  }
  .icon__image__banner {
    position: absolute;
    left: 50%;
    bottom: -61px;
    transform: translate(-50%, 0%);
  }
  .banner__right {
    padding-top: 100px;
  }
  .banner__right figure.image-box img {
    width: 100%;
  }
  .scroll-to-top {
    display: none;
  }
  .service__block {
    margin-bottom: 20px;
  }
  .service__block:before {
    padding: 1px;
  }
  .about__block {
    padding-bottom: 50px;
  }
  .funfact__content.about {
    bottom: 50px;
  }
  .choose__block {
    padding: 0px 0px 50px;
  }
  .team__block {
    margin-bottom: 60px;
  }
  .funfact__data {
    justify-content: start;
    padding-top: 50px;
  }
  .vision_mission_wrapper {
    grid-template-columns: repeat(1, 1fr);
    width: 80%;
  }
  .office-wrapper {
    grid-template-columns: repeat(1, 1fr);
    width: 100%;
    gap: 32px;
  }
  .office-map-wrapper {
    height: 480px;
  }
  .news-articles-wrapper {
    flex-direction: column;
    gap: 20px;
    padding: 0 12px;
  }
  .accomplised__data {
    padding: 100px 20px;
  }
  .testimonials__info {
    padding: 100px;
  }
  .blog__section .normaol__text {
    padding-left: 0;
    padding-bottom: 50px;
  }
  .main__footer .top-inner {
    display: block;
  }
  .main__footer .top-inner .right__top {
    padding-top: 20px;
  }
  .footer-column {
    padding-bottom: 20px;
  }
  .main-header.two {
    top: 20px;
  }
  .about__two__img__block figure img {
    width: 100%;
  }
  .about__two__img__block .about__two__circle {
    right: 20px;
  }
  .about__text__two {
    padding-bottom: 20px;
    justify-content: start;
  }
  .choose_img__block img {
    width: 100%;
  }
  .choose__text__block {
    padding-top: 50px;
  }
  .accomplised__data.two {
    padding: 0;
  }
  .brand__section_two {
    padding: 0px 20px 100px;
  }
  .price__content {
    margin-bottom: 60px;
  }
  .service__form__data {
    padding: 0;
  }
  .service__contact__block {
    padding: 80px 40px;
  }
  .service__contact__img {
    position: relative;
    padding-top: 50px;
  }
  .project__page {
    margin: 0 20px;
  }
  .contact__right {
    padding: 40px;
  }
  .banner__media {
    display: none;
  }
  section.banner__one {
    margin-top: 120px;
  }
  .banner__one.home__three__banner {
    padding-top: 100px;
  }
  .consultation__img img {
    width: 100%;
  }
  .accomplised__data.two.three {
    padding: 20px;
  }
  .home__three__banner .banner__mission__block h3 {
    padding-bottom: 10px;
  }
  .pro__info {
    margin: 50px 0px 0px;
    width: 100%;
    max-width: 100%;
  }
  .news___block {
    width: 100%;
  }
  .inner-box .image-box img {
    height: 300px;
  }
  .blog__details__content .blog__image img {
    height: 480px;
  }
  .post__date ul {
    flex-direction: column;
    align-items: flex-start;
  }
  .core_value_content.remove_gap_core_value_1 {
    margin-top: 0px;
  }
  .core_value_content.remove_gap_core_value_2 {
    margin-top: -65px;
  }
  .industry__block {
    width: 150px;
  }
  .industry__icon {
    width: 100px;
    height: 110px;
  }
  .industry__icon i {
    width: 100px;
    height: 110px;
  }
  .industry__icon img {
    width: 150px;
  }
  .industry__text button h4 {
    font-size: 16px;
  }
  .footer-bottom .copyright {
    flex-direction: column-reverse;
  }
  .social-media-wrapper {
    margin-bottom: 64px;
  }
}
@media only screen and (max-width: 910px) {
  .core_value_content.remove_gap_core_value_1 {
    margin-top: -65px;
  }
  .core_value_content.remove_gap_core_value_2 {
    margin-top: -65px;
  }
}
@media only screen and (max-width: 767px) {
  .banner__title h1 {
    font-size: 50px;
    line-height: 60px;
  }
  .sub__title h4 {
    font-size: 16px;
    letter-spacing: 5.2px;
  }
  h2 {
    font-size: 30px;
    font-weight: 700;
    line-height: 40px;
  }
  .team__data {
    display: block;
  }
  .team__data .team__data__left {
    padding-bottom: 20px;
  }
  .brand__section.p_relative.see__pad {
    padding: 50px 0px 0px;
  }
  .mission__block {
    padding: 40px;
  }
  .home__three__banner .banner__mission__block {
    margin-bottom: 20px;
  }
  .pro__info {
    margin: 50px 0px 0px;
    width: 100%;
    max-width: 100%;
  }
  .pro__info ul {
    display: block;
  }
  .pro__info ul li {
    margin-bottom: 20px;
  }
  .core_value_content.remove_gap_core_value_1 {
    margin-top: -65px;
  }
  .core_value_content.remove_gap_core_value_2 {
    margin-top: -65px;
  }
}
@media only screen and (max-width: 683px) {
  .core_value_content.remove_gap_core_value_1 {
    margin-top: 0px;
  }
  .core_value_content.remove_gap_core_value_2 {
    margin-top: -65px;
  }
}
@media only screen and (max-width: 599px) {
  .product__block__wrapper {
    padding: 0 40px 100px;
  }
  .industry__block__wrapper {
    padding: 0 40px 100px;
  }
  .new__service__block__wrapper {
    padding: 0 40px 100px;
  }
  .service__block {
    padding: 40px 30px 80px;
  }
  .service__data {
    padding: 90px 10px 0px;
  }
  .testimonials__info {
    padding: 40px 49px 80px;
  }
  .testimonial__top {
    display: block;
  }
  .main__footer .top-inner {
    padding: 20px;
  }
  .main__footer .left__top h3 {
    font-size: 25px;
    line-height: 35px;
  }
  .banner__two .content-box h2 {
    font-size: 50px;
    line-height: 60px;
  }
  section.banner__two {
    padding-top: 200px;
  }
  .banner__mission__block {
    display: block;
  }
  .pride__block h1 {
    font-size: 40px;
    line-height: 50px;
    padding: 0px 20px;
  }
  .bread__crumb li {
    letter-spacing: 4px;
  }
  .core_value_content.remove_gap_core_value_1 {
    margin-top: 0;
  }
  .core_value_content.remove_gap_core_value_2 {
    margin-top: -65px;
  }
}
@media only screen and (max-width: 499px) {
  .mobile-menu {
    width: 100%;
  }
  .main-header .btn-box {
    display: none;
  }
  .main-header .search-box-outer .dropdown-menu {
    width: 300px;
  }
  .funfact__data {
    justify-content: center;
  }
  .vision_mission_wrapper {
    grid-template-columns: repeat(1, 1fr);
    width: 80%;
  }
  .office-wrapper {
    grid-template-columns: repeat(1, 1fr);
    width: 100%;
    gap: 32px;
  }
  .office-map-wrapper {
    height: 480px;
  }
  .news-articles-wrapper {
    flex-direction: column;
    gap: 20px;
    padding: 0 12px;
  }
  .brand__content .brand__name h1 {
    font-size: 30px;
  }
  .brand__section .brand-carousel {
    padding: 45px 20px;
  }
  .banner__two .content-box h2 {
    font-size: 40px;
    line-height: 50px;
  }
  .service__block__two {
    padding: 100px 40px 50px;
  }
  .brand__section_two .brand__content .brand__name h1 {
    font-size: 35px;
  }
  .choose_us_block li {
    font-size: 20px;
    line-height: 30px;
    padding: 15px 0px;
  }
  .consultation__list li a {
    font-size: 20px;
    padding: 20px 0px 20px 85px;
  }
  .sidebar__widget_network {
    padding: 100px 20px;
  }
  .error__page h1.title {
    font-size: 100px;
  }
  .news___block {
    width: 100%;
  }
  .inner-box .image-box img {
    height: 300px;
  }
  .blog__details__content .blog__image img {
    height: 300px;
  }
  .core_value_content.remove_gap_core_value_1 {
    margin-top: 0;
  }
  .core_value_content.remove_gap_core_value_2 {
    margin-top: 0;
  }
}
@media only screen and (max-width: 399px) {
  .header-top-one .top-right li.search-box-outer {
    display: none;
  }
  .banner__left {
    padding-top: 26px;
  }
  .testimonials__info {
    clip-path: none;
    padding: 41px 30px 80px;
  }
  .protfolio__button {
    width: 80%;
  }
  .contact__right {
    padding: 40px 20px;
  }
  .pro__info {
    padding: 40px;
  }
}
@font-face {
  font-family: "icomoon";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}
[class^=icon-], [class*=" icon-"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "icomoon" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-17:before {
  content: "\\e910";
}

.icon-18:before {
  content: "\\e911";
}

.icon-16:before {
  content: "\\e90f";
}

.icon-01:before {
  content: "\\e900";
}

.icon-02:before {
  content: "\\e901";
}

.icon-03:before {
  content: "\\e902";
}

.icon-04:before {
  content: "\\e903";
}

.icon-05:before {
  content: "\\e904";
}

.icon-06:before {
  content: "\\e905";
}

.icon-07:before {
  content: "\\e906";
}

.icon-08:before {
  content: "\\e907";
}

.icon-09:before {
  content: "\\e908";
}

.icon-10:before {
  content: "\\e909";
}

.icon-11:before {
  content: "\\e90a";
}

.icon-12:before {
  content: "\\e90b";
}

.icon-13:before {
  content: "\\e90c";
}

.icon-14:before {
  content: "\\e90d";
}

.icon-15:before {
  content: "\\e90e";
}

.icon-19:before {
  content: "\\e912";
}

.icon-20:before {
  content: "\\e913";
}

.icon-fa-times:before {
  content: "\\e914";
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/default/All.scss","webpack://./src/assets/scss/Style.scss","webpack://./src/assets/scss/default/Animate.scss","webpack://./src/assets/scss/default/Blog.scss","webpack://./src/assets/scss/default/Color.scss","webpack://./src/assets/scss/default/Global.scss","webpack://./src/assets/scss/default/Responsive.scss","webpack://./src/assets/scss/Flaticon.scss"],"names":[],"mappings":"AAoBA;EACE;IACE,uBAAA;ECjBF;EDmBA;IACE,yBAAA;ECjBF;AACF;ADmBA;EACE;IAEE,8CAAA;IACA,gDAAA;EClBF;EDoBA;IACE,8CAAA;IACA,mDAAA;EClBF;EDoBA;IACE,gDAAA;EClBF;EDoBA;IACE,kDAAA;IACA,mDAAA;EClBF;AACF;ADoBA,yBAAA;AACA,qBAAA;AACA,0BAAA;AACA,mBAAA;AACA,uBAAA;AACA,uBAAA;AACA,4BAAA;AACA,mBAAA;AACA,oBAAA;AACA,0BAAA;AACA,6BAAA;AACA,yBAAA;AACA,6BAAA;AACA,oBAAA;AACA,uBAAA;AACA,mBAAA;AACA,sBAAA;AACA;;;;;;GAAA;AAOA,iBAAA;AACA,iBAAA;AACA,qBAAA;AACA,0BAAA;AACA,8BAAA;AACA,wBAAA;AACA,4BAAA;AACA,kBAAA;AACA,sBAAA;AACA,qBAAA;AACA,yBAAA;AACA,kBAAA;AACA,sBAAA;AACA,yBAAA;AACA,6BAAA;AACA,6BAAA;AACA,6BAAA;AACA,kBAAA;AACA,sBAAA;AACA,sBAAA;AACA,0BAAA;AACA,0BAAA;AACA,0BAAA;AACA,eAAA;AACA,kBAAA;AACA,iBAAA;AACA,oBAAA;AACA,qBAAA;AACA,yBAAA;AACA,iBAAA;AACA,qBAAA;AACA,iBAAA;AACA,iBAAA;AACA,iBAAA;AACA,iBAAA;AACA,cAAA;AACA;EACE;IACE,0BAAA;EClBF;EDoBA;IACE,8BAAA;EClBF;AACF;ADoBA;EACE;IACE,0BAAA;EClBF;EDoBA;IACE,6BAAA;EClBF;AACF;ADoBA,kBAAA;AACA;;;;;;GAAA;AAOA,kBAAA;AACA,sBAAA;AACA,kBAAA;AACA,qBAAA;AACA,kBAAA;AACA,qBAAA;AACA,kBAAA;AACA,qBAAA;AACA,oBAAA;AACA,uBAAA;AACA,gBAAA;AACA,oBAAA;AACA,kBAAA;AACA,qBAAA;AACA;;;;;;GAAA;AAOA;;;;;;GAAA;AAOA;;;;;;GAAA;AAOA;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AClBF;ADoBI;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAhLI;AC8JV;ADoBI;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;AClBN;ADqBE;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,0BAAA;EACA,SAAA;EACA,WAAA;ACnBJ;;ADsBA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;ACnBF;ADoBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mCAAA;EACA,SAAA;EACA,YAAA;AClBJ;;ADsBE;EACE,kBAAA;EACA,SAAA;EACA,yBAAA;ACnBJ;ADqBE;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,cA5NM;ACyMV;;ADuBE;EACE,OAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,4BAAA;EACA,8CAAA;EACA,2CAAA;ACpBJ;;ADyBI;EACE,oCAAA;ACtBN;;AD0BA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;ACvBF;;AD0BE;EACE,WAxPM;EAyPN,oBA5OY;EA6OZ,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;ACvBJ;ADwBI;EACE,gBAAA;ACtBN;;AD2BE;EACE,0BAAA;ACxBJ;;AD2BA;EACE,aAAA;ACxBF;;AD0BA;EACE,iBAAA;ACvBF;;ADyBA;EACE,4BAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;ACtBF;;ADwBA;EACE,uBAAA;ACrBF;ADsBE;EACE,WAAA;EACA,wBAAA;EACA,6FAAA;EAKA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,4BAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;ACxBJ;;AD2BA;EACE,gBAAA;ACxBF;;AD0BA;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;ACvBF;;ADyBA;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;EACA,UAAA;ACtBF;;ADwBA;EACE,YAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EAEA,eAAA;ACtBF;ADyBM;EACE,cAlVQ;AC2ThB;;AD4BA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,6DAAA;EACA,qEAAA;ACzBF;AD0BE;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WApWM;AC4UV;AD0BE;EACE,YAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;ACxBJ;;AD4BE;EACE,WAjXM;ACwVV;;AD4BA;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;ACzBF;;AD2BA;EACE,YAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;ACxBF;AD2BM;EACE,cA9YQ;ACqXhB;;AD8BA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,6DAAA;EACA,qEAAA;AC3BF;AD4BE;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAhaM;ACsYV;AD4BE;EACE,YAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;AC1BJ;;AD8BE;EACE,WA7aM;ACkZV;;AD8BA;EACE,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AC3BF;AD8BM;EACE,mBA5bQ;ACgahB;AD8BM;EACE,mBA/bQ;ACmahB;ADgCM;EACE,qBAAA;EACA,WAhcE;ACkaV;;AD8CA;EA0CE,kBAAA;EACA,oBAAA;ACpFF;AD0CE;EACE,YAAA;EACA,aAAA;EACA,6DAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,qEAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;ACxCJ;AD0CE;EAGE,kBAAA;EACA,6DAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,qEAAA;EACA,kBAAA;EAEA,UAAA;AC3CJ;AD6CE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kCAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,qEAAA;EACA,8BAAA;AC3CJ;;ADiDE;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,qEAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,8BAAA;EACA,YAAA;EACA,0BAAA;AC9CJ;ADgDE;EACE,WAAA;EACA,UAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,8BAAA;EACA,0BAAA;AC9CJ;;ADiDA;EAYE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,8BAAA;ACzDF;AD2CE;EACE,WAAA;EACA,YAAA;EACA,mBAhiBY;EAiiBZ,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,0BAAA;ACzCJ;;ADgDA;EAEE,kBAAA;EACA,mBAAA;EACA,aAAA;AC9CF;;ADiDA;EACE,4BAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;AC9CF;AD+CE;EACE,cA1jBM;EA2jBN,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AC7CJ;AD+CE;EAQE,aAAA;EACA,mBAAA;EACA,uBAAA;ACpDJ;AD2CI;EACE,cAlkBI;EAmkBJ,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ACzCN;AD+CE;EACE,cA7kBM;ACgiBV;;ADkDI;EACE,cAhlBI;ACiiBV;;ADoDE;EACE,iBAAA;ACjDJ;;ADqDE;EACE,kBA/kBY;EAglBZ,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,SAAA;EACA,8BAAA;EACA,kCAAA;EACA,kBApmBM;EAqmBN,QAAA;EACA,iBAAA;EACA,gCAAA;EACA,kBAAA;EACA,WAAA;AClDJ;;ADsDE;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,4BAAA;EACA,UAAA;ACnDJ;ADqDE;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,4BAAA;EACA,kBAAA;EACA,wBAAA;EACA,6FAAA;EAKA,mBAAA;EACA,SAAA;EACA,8BAAA;EACA,SAAA;ACvDJ;;AD0DA;EAUE,kBAAA;AChEF;ADuDE;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,MAAA;ACrDJ;;AD0DE;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,4BAAA;EACA,wBAAA;EACA,6FAAA;EAKA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;AC3DJ;;AD8DA;EACE,kBAAA;EACA,kBAAA;AC3DF;AD4DE;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,4BAAA;EACA,wBAAA;EACA,6FAAA;EAKA,mBAAA;EACA,kBAAA;EACA,OAAA;AC9DJ;;ADiEA;EACE,aAAA;EACA,SAAA;EACA,kDAAA;EACA,iBAAA;AC9DF;AD+DE;EACE,gBAAA;AC7DJ;AD+DE;EACE,iBAAA;EACA,mBAAA;AC7DJ;;ADiEE;EACE,WAAA;EACA,gBAAA;AC9DJ;;ADkEE;EACE,eAAA;EACA,iBAAA;EACA,oBAAA;AC/DJ;;ADkEA;EAKE,kBAAA;ACnEF;AD+DE;EACE,WAAA;EACA,qEAAA;AC7DJ;ADgEE;EACE,WAAA;EACA,kCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,qEAAA;EACA,0BAAA;EACA,UAAA;AC9DJ;;ADiEA;EASE,kBAAA;ACtEF;ADgEM;EACE,mBA9uBQ;EA+uBR,YAAA;AC9DR;;ADoEA;EACE,sBAAA;ACjEF;;ADoEE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;ACjEJ;ADkEI;EACE,cAvvBI;EAwvBJ,gBAAA;EACA,eAAA;EACA,kBAhvBU;EAivBV,iBAAA;AChEN;ADiEM;EACE,cArwBQ;ACssBhB;;ADqEE;EACE,WAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,4BAAA;AClEJ;ADoEE;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,4BAAA;EACA,wBAAA;EACA,6FAAA;EAKA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;ACtEJ;ADwEE;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,4BAAA;EACA,wBAAA;EACA,6FAAA;EAKA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,QAAA;EACA,WAAA;AC1EJ;;AD6EA;EACE,kBAAA;AC1EF;;AD4EA;EACE,mBAAA;EACA,mBAAA;EACA,8BAAA;ACzEF;AD0EE;EACE,WAAA;EACA,YAAA;EACA,MAAA;EACA,4BAAA;EACA,SAAA;ACxEJ;AD0EE;EACE,gBAAA;EACA,iBAAA;EACA,4BAAA;EACA,wBAAA;EACA,6FAAA;EAKA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,8BAAA;EACA,cAAA;AC5EJ;;AD+EA;EAsCE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;ACjHF;ADyEI;EACE,WAp1BI;EAq1BJ,kBAv0BU;EAw0BV,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ACvEN;ADyEI;EACE,WA51BI;EA61BJ,kBA/0BU;EAg1BV,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ACvEN;ADyEI;EACE,2BAAA;ACvEN;AD0EE;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,qEAAA;EACA,kBAAA;ACxEJ;ADyEI;EACE,aAAA;ACvEN;ADyEI;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ACvEN;;ADgFA;EACE,mBAAA;AC7EF;;AD+EA;EACE,6FAAA;AC5EF;;ADkFA;EACE,mBAAA;EACA,iBAAA;AC/EF;;ADiFA;EACE,iBAAA;EACA,SAAA;EACA,aAAA;EACA,qCAAA;AC9EF;;ADgFA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;AC7EF;;AD+EA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,qEAAA;EACA,kBAAA;EAOA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AClFF;ADyEE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ACvEJ;;AD8EA;EACE,4EAAA;AC3EF;;ADiFA;EACE,4EAAA;AC9EF;;ADgFA;;EAEE,iBAAA;AC7EF;;AD+EA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AC5EF;AD6EE;EACE,kBAAA;AC3EJ;AD6EE;EACE,aAAA;EACA,cAAA;AC3EJ;;AD8EA;EA2DE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,oBAAA;ACrIF;ADwEE;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAr8BM;EAs8BN,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;ACtEJ;ADuEI;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,0BAAA;ACrEN;ADwEM;EACE,qBAAA;ACtER;AD0EE;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAl+BM;EAm+BN,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;ACxEJ;ADyEI;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,0BAAA;ACvEN;AD0EM;EACE,qBAAA;ACxER;ADgFE;EACE,kBAAA;AC9EJ;;ADiFA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AC9EF;;ADgFA;EACE,0BAAA;EACA,kBAAA;EACA,uBAAA;EACA,qEAAA;AC7EF;;AD+EA;EACE,oBAAA;AC5EF;AD6EE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,6FAAA;EAKA,mBAAA;EACA,SAAA;EACA,8BAAA;AC/EJ;ADmFM;EACE,iBAAA;ACjFR;;ADuFE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,qBAAA;ACpFJ;ADqFI;EACE,wBA9iCI;AC29BV;;ADwFE;EACE,WA3jCM;EA4jCN,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ACrFJ;ADuFE;EACE,WA3jCO;EA4jCP,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ACrFJ;;ADwFA;EA0BE,kBAAA;AC9GF;ADqFE;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qEAAA;EACA,0BAAA;ACnFJ;ADoFI;EACE,eAAA;AClFN;ADsFI;EACE,mBAAA;ACpFN;ADsFI;EACE,UAAA;ACpFN;;ADyFA;EACE,uFAAA;EAKA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,qEAAA;EACA,SAAA;EACA,wBAAA;EACA,UAAA;EACA,0BAAA;AC1FF;;AD6FE;EACE,YAAA;EACA,aAAA;EACA,qEAAA;AC1FJ;;AD8FE;EACE,aAAA;AC3FJ;AD6FE;EACE,kBAAA;EACA,yBAAA;EACA,iBAAA;AC3FJ;AD4FI;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,aAAA;EACA,UAAA;EACA,QAAA;AC1FN;AD6FE;EACE,WAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;AC3FJ;;ADgGI;EACE,kBA5oCU;EA6oCV,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,8BAAA;EACA,kCAAA;EACA,kBAhqCI;ACmkCV;;ADkGE;EACE,cAAA;EACA,gBAAA;EAEA,uBAAA;EACA,8BAAA;AChGJ;ADiGI;EACE,WAAA;EACA,aAAA;EACA,0BAAA;EACA,iBAAA;AC/FN;ADoGM;EACE,sBAAA;AClGR;ADuGM;EACE,uBAAA;ACrGR;ADwGI;EAEE,6DAAA;ACvGN;ADyGI;EAEE,6DAAA;ACxGN;;AD6GA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;AC1GF;AD2GE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,kBAAA;EAEA,8BAAA;EACA,mBAAA;AC1GJ;AD2GI;EAcE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WA1uCI;EA2uCJ,eAAA;ACtHN;ADqGM;EACE,WAAA;EACA,YAAA;EAEA,6DAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,qEAAA;EACA,0BAAA;EACA,WAruCE;ACioCV;AD4GI;EACE,UAAA;EACA,WAAA;EACA,6DAAA;EACA,kBAAA;AC1GN;;AD8GA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;AC3GF;AD4GE;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,SAAA;EACA,kBAAA;EACA,8BAAA;EACA,mBAAA;AC1GJ;AD2GI;EAaE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAjxCI;EAkxCJ,eAAA;ACrHN;ADqGM;EACE,WAAA;EACA,YAAA;EACA,6DAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,qEAAA;EACA,0BAAA;EACA,WA5wCE;ACyqCV;AD2GI;EACE,UAAA;EACA,WAAA;EACA,6DAAA;EACA,kBAAA;ACzGN;;AD8GE;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,iBAAA;AC3GJ;AD6GE;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,iBAAA;AC3GJ;;AD8GA;EAKE,mBAAA;EACA,WAAA;EACA,gBAAA;AC/GF;ADyGE;EACE,mBAAA;EACA,uBAAA;ACvGJ;;AD8GE;EACE,WAAA;EACA,YAAA;EAEA,6DAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,qEAAA;EACA,0BAAA;EACA,WAr0CM;EAs0CN,kBAAA;AC5GJ;AD6GI;EACE,wBAAA;EACA,0BAAA;AC3GN;AD8GE;EACE,WAAA;EACA,YAAA;EAEA,6DAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,qEAAA;EACA,0BAAA;EACA,WAv1CM;EAw1CN,kBAAA;AC7GJ;AD8GI;EACE,wBAAA;EACA,0BAAA;AC5GN;;ADiHE;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;EACA,6FAAA;EAKA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,4BAAA;EACA,cAAA;AClHJ;ADoHE;EACE,kBAAA;AClHJ;;ADqHA;EACE,gBAAA;AClHF;ADmHE;EACE,cAx3CM;ACuwCV;ADmHE;EACE,cA33CM;AC0wCV;;ADqHE;EACE,wEAAA;AClHJ;;ADuHI;EACE,WA73CK;ACywCX;;ADwHA;EAOE,mBAAA;AC3HF;ADqHE;EACE,sBAAA;ACnHJ;ADqHE;EACE,kBAAA;ACnHJ;;ADuHA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;ACpHF;ADsHI;EACE,kBAAA;EACA,0CAAA;EACA,mBAAA;EACA,iBAAA;ACpHN;ADwHI;EACE,iBAAA;ACtHN;AD2HU;EACE,iBAAA;ACzHZ;AD6HM;EACE,SAAA;AC3HR;;ADgIA;EACE,kBAAA;EACA,gBAAA;AC7HF;AD8HE;EACE,YAAA;EACA,aAAA;EACA,OAAA;EACA,SAAA;EACA,4BAAA;EACA,UAAA;AC5HJ;;ADgIE;EACE,4BAAA;EACA,2BAAA;EACA,sBAAA;AC7HJ;AD+HE;EACE,kBAAA;EACA,WAAA;AC7HJ;AD8HI;EACE,WAt8CI;EAu8CJ,UAAA;EAKA,2BAAA;EACA,oBAAA;AC5HN;AD8HI;EACE,WAh9CI;EAi9CJ,UAAA;EAKA,2BAAA;EACA,oBAAA;AC5HN;AD8HI;EACE,iBAAA;EACA,WA39CI;EA49CJ,UAAA;EAKA,4BAAA;EAKA,2BAAA;AC5HN;AD8HI;EACE,kBAAA;EACA,UAAA;EAKA,2BAAA;EAKA,2BAAA;AC5HN;ADiIM;EACE,UAAA;EACA,oBAAA;AC/HR;ADiIM;EACE,UAAA;EACA,oBAAA;AC/HR;ADiIM;EACE,UAAA;EAKA,wBAAA;EAKA,wBAAA;AC/HR;ADiIM;EACE,UAAA;EAKA,wBAAA;EAKA,wBAAA;AC/HR;;ADqIE;EACE,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,2BAAA;EACA,sBAAA;AClIJ;ADoIE;EACE,oBAAA;AClIJ;ADmII;EACE,oBA9hDU;EA+hDV,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ACjIN;ADmII;EACE,oBAAA;EACA,mBAAA;ACjIN;;ADqIA;EACE,kBAAA;AClIF;ADmIE;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,4BAAA;EACA,kBAAA;EACA,wBAAA;EACA,6FAAA;EAKA,mBAAA;EACA,OAAA;EACA,WAAA;EACA,UAAA;ACrIJ;;ADwIA;EACE,kBAAA;EACA,gDAAA;ACrIF;;ADuIA;EACE,+BAAA;EACA,qCAAA;EACA,mCAAA;UAAA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;ACpIF;;ADsIA;EACE,gBAAA;EACA,oBAAA;ACnIF;ADoIE;EACE,cAtlDM;ACo9CV;;ADqIA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AClIF;ADmIE;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,gBAAA;EAGA,qDAAA;EACA,UAAA;EAGA,4BAAA;EAGA,oBAAA;ACjIJ;;ADqIE;EACE,gBAAA;AClIJ;;ADuII;EAGE,yBAAA;ACpIN;;ADyIE;EACE,mBAAA;ACtIJ;;ADyIA;EACE,0BAAA;EACA,mBAAA;ACtIF;;ADwIA;EAQE,qBAAA;EACA,gBAAA;AC5IF;ADsIM;EACE,eAAA;ACpIR;;AD4IE;EACE,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EAKA,2BAAA;ACzIJ;AD0II;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,8BAAA;EACA,QAAA;ACxIN;AD2IE;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;ACzIJ;;AD4IA;EAME,iBAAA;AC9IF;ADyIE;EACE,kBAAA;EACA,QAAA;EACA,YAAA;ACvIJ;;AD4IE;EACE,YAAA;EACA,aAAA;ACzIJ;AD0II;EACE,aAAA;EACA,YAAA;EACA,QAAA;EACA,UAAA;ACxIN;AD0II;EACE,YAAA;EACA,aAAA;ACxIN;ADyIM;EACE,SAAA;EACA,YAAA;ACvIR;ADwIQ;EACE,wBAAA;ACtIV;AD0II;EACE,aAAA;ACxIN;AD2IE;EACE,cAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;ACzIJ;;AD4IA;EAYE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,uBAAA;ACpJF;ADqIE;EACE,cAnuDM;EAouDN,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;ACnIJ;ADoII;EACE,cApuDI;ACkmDV;AD0IE;EACE,WAAA;ACxIJ;;AD6II;EAIE,iBAAA;AC7IN;AD0IM;EACE,WAjvDG;ACymDX;AD6IE;EACE,YAAA;EACA,aAAA;EACA,OAAA;EACA,SAAA;EACA,4BAAA;AC3IJ;;AD+IE;EACE,cAzwDM;EA0wDN,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;AC5IJ;;AD+IA;EACE,mBAAA;AC5IF;AD6IE;EACE,WAAA;EACA,YAAA;EACA,MAAA;EACA,SAAA;EACA,4BAAA;AC3IJ;AD6IE;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,MAAA;EACA,4BAAA;AC3IJ;AD6IE;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;EACA,6FAAA;EAKA,mBAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,8BAAA;AC/IJ;;ADkJA;EACE,wBAAA;EACA,gBAAA;AC/IF;ADgJE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,6BAAA;EACA,UAAA;EACA,0BAAA;EACA,4BAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;AC9IJ;ADiJI;EACE,UAAA;EACA,yBAAA;AC/IN;ADkJE;EACE,oBAAA;AChJJ;ADiJI;EACE,QAAA;EACA,4BAAA;AC/IN;ADiJI;EACE,SAAA;AC/IN;ADmJI;EACE,uBAAA;ACjJN;;ADsJE;EACE,0CAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;ACnJJ;;ADsJA;EAcE,kBAAA;AChKF;ADmJE;EACE,cAn2DM;EAo2DN,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,yBAAA;ACjJJ;ADkJI;EACE,qBAAA;EACA,cAz2DI;ACytDV;;ADqJA;EACE,kBAAA;AClJF;ADmJE;EAIE,sBAAA;EACA,+CAAA;EACA,kBAAA;ACpJJ;AD+II;EACE,WA/2DK;ACkuDX;ADkJI;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,YAAA;EACA,qEAAA;AChJN;ADkJI;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,YAAA;EACA,qEAAA;EACA,8BAAA;AChJN;;ADoJA;EAWE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;AC3JF;AD8IE;EACE,cAt5DM;EAu5DN,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AC5IJ;AD8IE;EACE,cA75DM;ACixDV;;ADoJE;EACE,qEAAA;ACjJJ;;ADqJE;EACE,YAAA;EACA,aAAA;EACA,UAAA;EACA,UAAA;AClJJ;;ADsJE;EACE,YAAA;EACA,aAAA;EACA,UAAA;EACA,WAAA;EACA,MAAA;ACnJJ;ADqJE;EACE,YAAA;EACA,aAAA;EACA,UAAA;EACA,SAAA;EACA,OAAA;ACnJJ;;ADsJA;EACE,0BAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,qEAAA;ACnJF;;ADqJA;EACE,mBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,8BAAA;EACA,qEAAA;EACA,UAAA;EACA,kBAAA;EACA,0BAAA;AClJF;ADmJE;EACE,cAt9DM;EAu9DN,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,0BAAA;ACjJJ;ADmJE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAl+DM;EAm+DN,0BAAA;ACjJJ;ADkJI;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;AChJN;;ADqJE;EACE,oBAAA;AClJJ;ADmJI;EACE,oBAAA;ACjJN;;ADqJA;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,8BAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qEAAA;EACA,0BAAA;AClJF;;ADsJI;EACE,mBAAA;ACnJN;ADoJM;EACE,WArgEE;ACm3DV;ADoJM;EACE,WAxgEE;ACs3DV;ADqJI;EACE,mBAAA;EACA,oBAvgEI;ACo3DV;;ADwJE;EACE,WAAA;EACA,aAAA;EACA,4BAAA;EACA,MAAA;ACrJJ;ADuJE;EACE,WAAA;EACA,YAAA;EACA,MAAA;EACA,4BAAA;EACA,SAAA;ACrJJ;;ADwJA;EACE,WAAA;EACA,YAAA;EACA,MAAA;EACA,4BAAA;EACA,sBAAA;ACrJF;;ADuJA;EACE,sBAAA;ACpJF;ADqJE;EACE,sBAAA;ACnJJ;;ADsJA;EACE,kBAAA;EACA,oBAAA;EACA,gBAAA;ACnJF;;ADqJA;EAuBE,gBAAA;ACxKF;ADkJE;EACE,4FAAA;EAKA,WAAA;EACA,YAAA;EACA,UAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,0BAAA;EACA,aAAA;EACA,4BAAA;ACpJJ;ADuJI;EACE,yBAAA;EACA,UAAA;ACrJN;;AD0JA;EACE,aAAA;EACA,8BAAA;ACvJF;;AD0JE;EACE,gBAAA;ACvJJ;;AD2JE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ACxJJ;;AD2JA;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;ACxJF;ADyJE;EACE,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,0BAAA;ACvJJ;;AD0JA;EACE,gBAAA;EACA,kBAAA;EACA,kBAAA;ACvJF;ADwJE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,4BAAA;EACA,sBAAA;ACtJJ;ADwJE;EACE,oBA5mEY;EA6mEZ,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ACtJJ;;ADyJA;EAmCE,aAAA;EACA,2BAAA;EACA,iBAAA;EACA,QAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;ACxLF;ADgJE;EACE,kBAAA;EACA,oBAtnEY;EAunEZ,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAzoEM;EA0oEN,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,oBAAA;AC9IJ;ADgJI;EACE,kBAAA;EACA,oBAroEU;EAsoEV,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAxpEI;EAypEJ,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AC9IN;ADgJM;EACE,yBAAA;AC9IR;;AD2JE;EACE,iBAAA;ACxJJ;;AD2JA;EACE,WAAA;EACA,YAAA;EACA,4BAAA;EACA,kBAAA;EACA,MAAA;EACA,sBAAA;ACxJF;;AD0JA;EAME,kBAAA;AC5JF;ADwJI;EACE,kBAAA;ACtJN;AD0JE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;ACxJJ;;AD4JE;EACE,mBAAA;ACzJJ;AD0JI;EACE,YAAA;ACxJN;;AD4JA;EAIE,iBAAA;AC5JF;ADyJE;EACE,mBAAA;ACvJJ;AD0JE;EACE,WAAA;ACxJJ;;AD4JE;EACE,mBAAA;ACzJJ;;AD+JM;EACE,iBAAA;AC5JR;;ADiKA;EACE,iBAAA;EACA,kBAAA;AC9JF;AD+JE;EACE,uBAAA;EACA,sBAAA;AC7JJ;AD+JE;EACE,aAAA;AC7JJ;;ADkKI;EACE,WAAA;EACA,aAAA;EACA,8BAAA;AC/JN;ADmKI;EACE,kBAAA;ACjKN;;ADqKA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;AClKF;;ADoKA;EAEE,uBAAA;EACA,mBAAA;AClKF;;ADqKE;EACE,oBAAA;EACA,qBAAA;AClKJ;ADqKI;EACE,gBAAA;ACnKN;ADsKE;EACE,cA1xEY;EA2xEZ,0BAAA;EACA,0BAAA;EACA,+BAAA;EACA,kCAAA;EACA,8BAAA;EACA,6BAAA;ACpKJ;ADqKI;EACE,cAlyEU;EAmyEV,YAAA;EACA,0BAAA;EACA,aAAA;ACnKN;;ADuKA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;ACpKF;;ADsKA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,sBAAA;ACnKF;ADoKE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AClKJ;;ADqKA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AClKF;ADoKI;EACE,cA9zEI;EA+zEJ,oCApzEK;EAqzEL,YAAA;EACA,kBAAA;EACA,0BAAA;AClKN;;ADsKA;EACE,aAAA;EACA,mBAAA;ACnKF;;ADqKA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;AClKF;;ADoKA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,oBAAA;EACA,kDAAA;EACA,gBAAA;EACA,SAAA;ACjKF;ADkKE;EAME,cAAA;EACA,aAAA;ACrKJ;AD+JI;EACE,YAAA;EACA,aAAA;EACA,kBAAA;AC7JN;ADkKE;EACE,YAAA;AChKJ;;ADoKE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;ACjKJ;ADkKI;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;AChKN;ADkKI;EACE,mBAAA;EACA,iBAAA;AChKN;;ADoKA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;ACjKF;;ADoKE;EACE,kBAAA;EACA,2CAAA;EACA,WAAA;EACA,gCAr3EO;EAs3EP,kBAn3EY;EAo3EZ,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EAEA,aAAA;AClKJ;ADoKE;EACE,kBAAA;EACA,2CAAA;EACA,WAAA;EACA,gCAn4EO;EAo4EP,kBAj4EY;EAk4EZ,eAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EAEA,aAAA;ACnKJ;;ADuKE;EACE,kBAAA;EACA,gCAl5EO;EAm5EP,kBAh5EY;EAi5EZ,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,yBAAA;EACA,2CAAA;EACA,aAAA;EACA,WAAA;ACpKJ;ADsKE;EACE,kBAAA;EACA,WAAA;EACA,yBAh6EO;EAi6EP,QAAA;EACA,8BAAA;ACpKJ;;ADuKA;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;ACpKF;ADqKE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;ACnKJ;;ADuKE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;ACpKJ;ADqKI;EACE,aAAA;EACA,cAAA;ACnKN;ADoKM;EACE,YAAA;EACA,iBAAA;AClKR;ADuKI;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ACrKN;ADwKE;EACE,mBAAA;EACA,eAAA;EACA,0BAAA;ACtKJ;ADwKI;EACE,kBAAA;EAEA,oCAAA;EACA,4BAAA;UAAA,oBAAA;ACvKN;AD0KE;EACE,cAp+EY;EAq+EZ,aAAA;EACA,mBAAA;EACA,QAAA;ACxKJ;ADyKI;EACE,cAz+EU;ACk0EhB;;AD6KI;EACE,kBA99EU;EA+9EV,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,oBAAA;AC1KN;AD2KM;EACE,wBA/+EE;ACs0EV;;AD8KA;EACE,mBAAA;EACA,aAAA;AC3KF;;AD8KE;EACE,WAjgFM;EAkgFN,kBAp/EY;EAq/EZ,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,2CAAA;EAEA,aAAA;EACA,WAAA;AC5KJ;AD8KE;EACE,WA/gFM;EAghFN,kBAlgFY;EAmgFZ,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,2CAAA;EACA,aAAA;EACA,WAAA;EAGA,gBAAA;EACA,iKAAA;EAEA,iEAAA;EACA,iCAAA;EACA,4BAAA;AC7KJ;AD+KE;EACE,gCAzhFO;AC42EX;AD+KE;EACE,cA3iFY;EA4iFZ,qBA5iFY;AC+3EhB;AD+KE;;EAEE,cAhjFY;EAijFZ,qBAjjFY;ACo4EhB;AD+KE;EACE,gCAriFO;ACw3EX;AD+KE;EACE,gCAxiFO;AC23EX;AD+KE;EACE,gCA3iFO;AC83EX;AD+KE;EACE,gCA9iFO;ACi4EX;AD+KE;EACE,gCAjjFO;ACo4EX;AD+KE;EACE,kBAAA;EACA,2CAAA;EACA,WAjkFM;EAkkFN,kBApjFY;EAqjFZ,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EAEA,WAAA;EACA,aAAA;EACA,aAAA;AC9KJ;ADgLE;EACE,gCAnkFO;ACq5EX;ADgLE;EACE,gCAtkFO;ACw5EX;ADgLE;EACE,gCAzkFO;AC25EX;ADgLE;EACE,gCA5kFO;AC85EX;ADgLE;EACE,gCA/kFO;ACi6EX;;ADkLE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AC/KJ;;ADkLA;EAYE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,oBAAA;AC1LF;AD4KE;EACE,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAzmFM;EA0mFN,uBAAA;AC1KJ;ADiLI;EACE,mBAAA;EACA,WAznFI;AC08EV;;ADmLA;EAIE,WAAA;EACA,aAAA;ACnLF;AD+KE;EACE,WAAA;AC7KJ;;ADkLA;EACE,mBAAA;EACA,0CAAA;EACA,mBAAA;AC/KF;;ADiLA;EACE,4BAAA;AC9KF;;ADgLA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AC7KF;;AD+KA;EACE,kBAAA;EACA,cAAA;EACA,6CAAA;EACA,sBAAA;EACA,mBAAA;AC5KF;AD6KE;EACE,4BAAA;AC3KJ;;AD8KA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,gBAAA;AC3KF;AD4KE;EACE,kBAAA;EACA,cAAA;AC1KJ;AD4KE;EACE,iBAAA;AC1KJ;;AD6KA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AC1KF;;AD4KA;EACE,kBAlqFc;EAmqFd,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,8BAAA;EACA,kCAAA;EACA,6BAAA;ACzKF;AD0KE;EACE,kBA7qFY;EA8qFZ,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,8BAAA;EACA,kCAAA;EACA,kBAjsFM;ACyhFV;;AD2KA;EACE,kBAAA;ACxKF;;AD2KE;EAKE,kBAAA;EACA,SAAA;EACA,qBAAA;EACA,SAAA;EACA,8BAAA;AC5KJ;ADoKI;EACE,WAAA;EACA,YAAA;AClKN;AD0KE;EAQE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,+BAAA;AC/KJ;ADqKI;EACE,aAAA;ACnKN;ADqKI;EACE,yBAAA;EACA,WAAA;ACnKN;AD0KE;EACE,yBAAA;EACA,aAAA;ACxKJ;AD0KE;EACE,yBAAA;EACA,aAAA;EACA,uBAAA;ACxKJ;AD0KE;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,8BAAA;ACxKJ;;AD2KA;EACE,eAAA;EACA,mBAAA;EACA,YAAA;ACxKF;;AD4KI;EACE,gBAAA;EACA,mBAAA;ACzKN;;AD8KE;EACE,YAAA;EACA,aAAA;EACA,QAAA;EACA,cAAA;AC3KJ;AD6KE;EACE,kBAAA;AC3KJ;AD8KI;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,4BAAA;EACA,kBAAA;EACA,wBAAA;EACA,6FAAA;EAKA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;AChLN;;ADoLA;EACE,kBAAA;ACjLF;ADkLE;EACE,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,2BAAA;EACA,sBAAA;AChLJ;ADkLE;EACE,UAAA;AChLJ;ADmLI;EACE,gBAAA;ACjLN;ADmLI;EACE,cA/yFI;AC8nFV;ADoLE;EACE,qBAAA;AClLJ;ADoLE;EACE,gBAAA;AClLJ;ADoLE;EACE,+BAAA;AClLJ;ADoLE;EACE,YAAA;EACA,aAAA;EACA,WAAA;EACA,aAAA;AClLJ;;ADqLA;EACE,uBAAA;AClLF;ADmLE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;ACjLJ;;ADqLE;EACE,YAAA;EACA,aAAA;EACA,4BAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,4BAAA;EACA,WAAA;EACA,UAAA;AClLJ;ADoLE;EACE,aAAA;AClLJ;;ADsLE;EACE,oBAAA;ACnLJ;ADqLE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBA31FY;EA41FZ,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iDAAA;EACA,iBAAA;ACnLJ;ADoLI;EACE,cAAA;AClLN;ADoLI;EACE,YAAA;AClLN;;ADsLA;EACE,kBAAA;EACA,mBAAA;EACA,0CAAA;EACA,iBAAA;EACA,wBAAA;ACnLF;;ADqLA;EACE,8BAAA;EACA,mBAAA;EACA,8BAAA;AClLF;;ADqLE;EACE,WAAA;EACA,kBAAA;EACA,wBAAA;EACA,6FAAA;EAKA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,4BAAA;EACA,cAAA;EACA,WAAA;EACA,cAAA;ACtLJ;;ADyLA;EACE,mBAAA;EACA,kBAAA;ACtLF;;ADwLA;EACE,iBAAA;ACrLF;ADuLI;EACE,WAAA;EACA,kBAl5FU;EAm5FV,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,2BAAA;EACA,iDAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;ACrLN;ADsLM;EACE,YAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,gDAAA;EACA,WAAA;EACA,OAAA;ACpLR;;ADyLA;EACE,iBAAA;ACtLF;;ADwLA;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,QAAA;EACA,8BAAA;ACrLF;ADsLE;EACE,oBAAA;ACpLJ;ADsLE;EACE,oBAAA;ACpLJ;;ADuLA;EACE,iBAAA;ACpLF;ADsLI;EACE,mBAAA;ACpLN;;ADyLE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,oBAAA;EACA,4GAAA;EAQA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;AC7LJ;;ADgMA;EAoBE,qBAAA;AChNF;AD6LE;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,4BAAA;EACA,cAAA;EACA,wBAAA;EACA,iHAAA;EAQA,mBAAA;EACA,kBAAA;EACA,QAAA;AClMJ;;ADsMA;EACE,sBAAA;ACnMF;;ADsME;EACE,mBAvgGY;EAwgGZ,kBAAA;ACnMJ;;ADsMA;EACE,kBAAA;EACA,aAAA;ACnMF;ADqME;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;EACA,sFAAA;EAKA,8EAAA;EAGA,uBAAA;EACA,WAAA;EACA,kBAAA;ACxMJ;;AD2MA;EACE,iBAAA;ACxMF;;AD2ME;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAzhGY;EA0hGZ,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,iCAAA;ACxMJ;ADyMI;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;EAEA,4EAAA;EAKA,8EAAA;EAGA,uBAAA;EACA,WAAA;EACA,kBAAA;AC7MN;AD+MI;EACE,WAlkGI;EAmkGJ,gBAAA;AC7MN;ADgNE;EACE,WAvkGM;EAwkGN,gBAAA;EACA,4EAAA;EAKA,kBAAA;AClNJ;;ADqNA;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,4BAAA;AClNF;ADoNI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6DAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AClNN;;ADsNA;EAgEE,kBAAA;AClRF;ADmNE;EACE,sBAAA;ACjNJ;ADkNI;EACE,cAvmGI;ACu5FV;ADmNE;EACE,gBAAA;ACjNJ;ADmNE;EACE,qBAAA;ACjNJ;ADoNI;EACE,kBAAA;EACA,kBAvmGU;EAwmGV,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;AClNN;ADmNM;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;EAEA,6EAAA;EAKA,8EAAA;EAGA,uBAAA;EACA,WAAA;EACA,kBAAA;ACvNR;ADyNM;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,0BAAA;ACvNR;AD0NQ;EACE,mBAnqGM;EAoqGN,WAhqGA;ACw8FV;AD8NE;EACE,gBAAA;EACA,iBAAA;EACA,4BAAA;EACA,cAAA;EACA,wBAAA;EACA,6FAAA;EAKA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,OAAA;AChOJ;;ADoOE;EACE,kBAAA;EACA,kBA7qGY;EA8qGZ,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;ACjOJ;ADkOI;EACE,cArsGU;ACq+FhB;;ADoOA;EACE,aAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;ACjOF;ADkOE;EACE,uBAAA;EACA,iBAAA;AChOJ;;ADmOA;EACE,kBAAA;AChOF;ADkOI;EACE,kBAAA;AChON;ADoOI;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AClON;ADqOE;EAqBE,uBAAA;ACvPJ;ADmOI;EACE,oBAvtGU;EAwtGV,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;ACjON;ADkOM;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AChOR;ADqOE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,8CAAA;EACA,iDAAA;ACnOJ;ADsOI;EACE,kBArvGU;EAsvGV,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ACpON;;ADwOA;EACE,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;ACrOF;ADsOE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;ACpOJ;ADuOI;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ACrON;;ADyOA;EAEI;IACE,iBAAA;ECvOJ;AACF;AD0OA;EAEI;IACE,iBAAA;ECzOJ;AACF;AD6OA;EAEI;IACE,iBAAA;EC5OJ;AACF;AD+OA;EAEI;IACE,iBAAA;EC9OJ;AACF;ADoPM;EACE,cAAA;AClPR;;ADwPE;EACE,mBAAA;ACrPJ;;ADyPA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,0BAAA;ACtPF;ADwPE;EACE,UAn1GM;AC6lGV;ADwPE;;EAEE,0BAAA;EACA,UAx1GM;EAy1GN,WAz1GM;ACmmGV;;AD0PA;;EAEE,aAn2Gc;EAo2Gd,yBAAA;ACvPF;;AD2PE;EACE,kBAAA;EACA,iBAAA;ACxPJ;AD0PE;EACE,aAAA;ACxPJ;AD0PE;;EAEE,UAAA;EACA,SAAA;EACA,cAh3GM;EAi3GN,oBAn2GY;EAo2GZ,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;ACxPJ;AD0PE;EACE,aAAA;ACxPJ;;AD4PA;EACE,aAAA;EACA,qCAAA;EACA,QAAA;ACzPF;;AD4PA;EACE,WAAA;EACA,aAAA;ACzPF;;AD4PA;EACE,gBAAA;EACA,WAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;ACzPF;;AD4PA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;ACzPF;AD0PE;EACE,cAAA;EACA,0BAAA;EACA,+BAAA;EACA,kCAAA;EACA,8BAAA;EACA,6BAAA;ACxPJ;ADyPI;EACE,cAAA;EACA,YAAA;EACA,aAAA;ACvPN;AD0PE;EACE,kBAAA;ACxPJ;;AD4PA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;ACzPF;AD0PE;EACE,gBAAA;EACA,QAAA;ACxPJ;AD2PE;EACE,gBAAA;ACzPJ;AD2PI;EACE,aAAA;ACzPN;AD2PI;;EAEE,0BAAA;EACA,aAAA;EACA,cAAA;ACzPN;AD4PE;;EAEE,aAAA;EACA,yBAAA;AC1PJ;;ADgQI;EACE,aAAA;EACA,qCAAA;EACA,SAAA;AC7PN;AD+PM;EALF;IAMI,0BAAA;EC5PN;AACF;;ADiQA;EACE,eAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;EACA,0CAAA;EACA,kBAAA;AC9PF;;AC/tGA;;;;;CAAA;AAMA;EACC;IACC,mBAAA;EDkuGA;EChuGD;IACC,qBAAA;EDkuGA;EChuGD;IACC,mBAAA;EDkuGA;AACF;AChuGA;EACC;IACC,wBAAA;EDkuGA;EChuGD;IACC,4CAAA;EDkuGA;EChuGD;IACC,wBAAA;EDkuGA;AACF;AChuGA;EACC;IACC,oCAAA;EDkuGA;EChuGD;IACC,8CAAA;EDkuGA;EChuGD;IACC,+CAAA;EDkuGA;EChuGD;IACC,gDAAA;EDkuGA;EChuGD;IACC,gDAAA;EDkuGA;EChuGD;IACC,oCAAA;EDkuGA;AACF;AChuGA;EACC;IACC,uBAAA;EDkuGA;EChuGD;IACC,wBAAA;EDkuGA;AACF;AChuGA;EACC;IAEC,4BAAA;EDkuGA;EChuGD;IAEC,4BAAA;EDkuGA;EChuGD;IAEC,4BAAA;EDkuGA;AACF;AChuGA;EACC,4CAAA;ADkuGD;;AChuGA;EACC,uCAAA;ADmuGD;;ACjuGA;EACC,iDAAA;ADouGD;;ACluGA;EACC,wBAAA;EACA,uBAAA;EACA,mCAAA;EACA,iCAAA;ADquGD;;ACnuGA;EACC,2BAAA;EACA,sBAAA;EACA,mCAAA;EACA,iCAAA;EACA,mCAAA;EACA,8BAAA;EACA,2CAAA;EACA,yCAAA;EACA,gCAAA;EACA,2BAAA;EACA,wCAAA;EACA,sCAAA;EACA,+BAAA;EACA,0BAAA;EACA,uCAAA;EACA,qCAAA;EACA,8BAAA;EACA,yBAAA;EACA,sCAAA;EACA,oCAAA;ADsuGD;;AE30GK;EACC,0BAAA;AF80GN;AEz0GE;EACC,gCAAA;AF20GH;;AEr0GE;EACC,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;AFw0GH;AEv0GG;EACC,gBAAA;AFy0GJ;AEx0GI;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EAEA,gCAAA;EAEA,qBAAA;EACA,WAAA;EACA,kBAAA;EAEA,4CAAA;EAEA,6BAAA;EAEA,yBAAA;AF00GL;AEx0GI;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EAEA,gCAAA;EAEA,qBAAA;EACA,WAAA;EACA,kBAAA;EAEA,4CAAA;EAEA,6BAAA;EAEA,yBAAA;EAEA,qBAAA;AF00GL;AEt0GE;EACC,qBAAA;EACA,kBAAA;AFw0GH;AEr0GG;EACC,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;AFu0GJ;;AE/zGG;EACC,qBAAA;EACA,kBAAA;AFk0GJ;AE9zGC;EACC,kBAAA;EACA,SAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;AFg0GF;AE/zGE;EACC,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,0BAAA;AFi0GH;AEh0GG;EACC,WAAA;AFk0GJ;AE/zGE;EACC,UAAA;AFi0GH;AE/zGE;EACC,WAAA;AFi0GH;;AE1zGG;EACC,cAAA;AF6zGJ;AE1zGI;EACC,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;AF4zGL;;AErzGC;EACC,iBAAA;AFwzGF;;AEnzGE;EACC,kBAAA;AFszGH;AErzGG;EACC,kBAAA;AFuzGJ;AEnzGC;EACC,gBAAA;AFqzGF;AEpzGE;EACC,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;AFszGH;AEnzGC;EACC,yBAAA;EACA,yBAAA;EACA,kBAAA;AFqzGF;AEpzGE;EACC,sBAAA;EACA,qBAAA;AFszGH;;AEjzGC;EACC,mBAAA;AFozGF;AE/yGI;EACC,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,kCAAA;EACA,4BAAA;EACA,0BAAA;EACA,mBAAA;AFizGL;AE/yGI;EACC,kBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,0BAAA;AFizGL;AE3yGE;EACC,gCAAA;EACA,iBAAA;AF6yGH;AE5yGG;EACC,mBAAA;AF8yGJ;AE3yGI;EACC,WAAA;EACA,kBAAA;AF6yGL;AExyGK;EACC,YAAA;AF0yGN;AEtyGG;EACC,iBAAA;AFwyGJ;AEnyGE;EACC,gBAAA;AFqyGH;AEnyGI;EACC,iBAAA;EACA,yBAAA;AFqyGL;AEpyGK;EACC,WAAA;AFsyGN;;AE5xGG;EACC,mBAAA;AF+xGJ;AEzxGG;EACC,iBAAA;EACA,mBAAA;AF2xGJ;AE1xGI;EACC,cAAA;EACA,SAAA;EACA,2BAAA;AF4xGL;AE1xGI;EACC,WAAA;AF4xGL;AE3xGK;EACC,aAAA;AF6xGN;AEtxGE;EACC,uBAAA;AFwxGH;;AEjxGG;EACC,gBAAA;AFoxGJ;AEnxGI;EACC,cAAA;AFqxGL;AElxGG;EACC,kCAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AFoxGJ;;AE5wGG;EACC,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;AF+wGJ;AE9wGI;EACC,qBAAA;EACA,mBAAA;AFgxGL;AEzwGG;EACC,kBAAA;AF2wGJ;;AEpwGE;EACC,mBAAA;EACA,kBAAA;AFuwGH;AElwGG;EACC,iBAAA;EACA,mBAAA;AFowGJ;AEnwGI;EACC,cAAA;EACA,SAAA;EACA,2BAAA;AFqwGL;AEnwGI;EACC,WAAA;AFqwGL;AEpwGK;EACC,aAAA;AFswGN;AE7vGI;EACC,kBAAA;AF+vGL;;AEvvGE;EACC,mBAAA;AF0vGH;AEzvGG;EACC,YAAA;EACA,aAAA;AF2vGJ;AEzvGG;EACC,gBAAA;AF2vGJ;AE1vGI;EACC,cAAA;AF4vGL;AEzvGG;EACC,kBAAA;AF2vGJ;;AEhvGM;EACC,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;AFmvGP;AEhvGO;EACC,aAAA;AFkvGR;AE1uGG;EACC,kBAAA;EACA,WAAA;AF4uGJ;AEvuGE;EACC,cAAA;AFyuGH;AEtuGG;EACC,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;AFwuGJ;AEluGG;EACC,kBAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;AFouGJ;AEhuGC;EAYC,6BAAA;EACA,gCAAA;AFutGF;AEjuGI;EACC,iBAAA;EACA,yBAAA;AFmuGL;AEluGK;EACC,WAAA;AFouGN;AE3tGI;EACC,yBAAA;EACA,cAAA;AF6tGL;AE5tGK;EACC,WAAA;AF8tGN;AEvtGE;EACC,yBAAA;AFytGH;AExtGG;EACC,yBAAA;EACA,gDAAA;AF0tGJ;AEvtGI;EACC,kBAAA;EACA,eAAA;EACA,QAAA;AFytGL;AEntGI;EACC,iBAAA;AFqtGL;AE/sGI;EACC,gBAAA;AFitGL;AE5sGC;EACC,gDAAA;AF8sGF;AE5sGG;EACC,WAAA;EACA,kBAAA;AF8sGJ;AEzsGE;EACC,mBAAA;AF2sGH;AE1sGG;EACC,kBAAA;AF4sGJ;AE1sGG;EACC,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,kCAAA;EACA,cAAA;EACA,gCAAA;EACA,0BAAA;AF4sGJ;AE1sGG;EACC,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,kCAAA;EACA,cAAA;EACA,gCAAA;EACA,0BAAA;AF4sGJ;AE1sGG;EACC,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,kCAAA;EACA,cAAA;EACA,gCAAA;EACA,0BAAA;EACA,YAAA;EACA,YAAA;AF4sGJ;AExsGG;EACC,cAAA;AF0sGJ;AEvsGE;EACC,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;AFysGH;;AEnsGE;EACC,WAAA;AFssGH;AEnsGG;EACC,WAAA;AFqsGJ;AEpsGI;EACC,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;AFssGL;AEnsGK;EACC,aAAA;AFqsGN;;AE9rGA;EACC,kBAAA;EACA,qBAAA;AFisGD;;AE/rGA;EACC,kBAAA;AFksGD;AEjsGC;EACC,WAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,kCAAA;AFmsGF;;AGpyHA,mBAAA;AACA;EACC,6DAAA;AHuyHD;;AGryHA;EACC,+DAAA;AHwyHD;;AGtyHA;EACC,6DAAA;AHyyHD;AGxyHC;EACC,6DAAA;AH0yHF;;AIpzHA,iBAAA;AAGA;;;;;;IAAA;AAOA;;;;;;IAAA;AAOA,sBAAA;AACA,cAAA;AACA;EACC;IACC,oCAAA;EJqzHA;EInzHD;IACC,wCAAA;EJqzHA;AACF;AInzHA;EACC;IACC,qBAAA;EJqzHA;EInzHD;IACC,yBAAA;EJqzHA;AACF;AI9yHA;EACC;IACC,UAAA;EJqzHA;AACF;AItyHA;EACC;IACC,UAAA;EJqzHA;EInzHD;IACC,UAAA;EJqzHA;EInzHD;IACC,WAAA;IACA,YAAA;IACA,UAAA;EJqzHA;AACF;AIzyHA;EACC;IAEC,6CAAA;EJqzHA;EInzHD;IAEC,0CAAA;EJqzHA;AACF;AInzHA;EACC;IACC,wBAAA;EJqzHA;EInzHD;IACC,6BAAA;EJqzHA;AACF;AI1yHA;EACC,WAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;AJozHD;;AIlzHA;EACC,eAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kCAAA;EACA,sBAAA;EACA,4BAAA;EACA,+BAAA;EACA,mCAAA;AJqzHD;;AInzHA;EACC,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;AJszHD;;AIpzHA;EACC,gBAAA;EACA,cAAA;AJuzHD;;AIrzHA;EACC,kBAAA;EACA,cAAA;EACA,2BAAA;EACA,WAAA;EACA,gBAAA;AJwzHD;;AItzHA;EACC,WAAA;EACA,qBAAA;EACA,0BAAA;EACA,+BAAA;EACA,kCAAA;EACA,8BAAA;EACA,6BAAA;AJyzHD;AIxzHC;EACC,cAAA;EACA,qBAAA;EACA,aAAA;AJ0zHF;;AIvzHA;EACC,kCAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,0BAAA;AJ0zHD;AIzzHC;EACC,aAAA;EACA,gBAAA;EACA,0BAAA;AJ2zHF;;AIxzHA;EACC,kCAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;AJ2zHD;AI1zHC;EACC,aAAA;EACA,gBAAA;EACA,0BAAA;AJ4zHF;;AIzzHA;EACC,kCAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;AJ4zHD;;AI1zHA;EACC,kCAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;AJ6zHD;AI5zHC;EACC,aAAA;EACA,gBAAA;EACA,0BAAA;AJ8zHF;;AI3zHA;EACC,cAAA;AJ8zHD;;AI5zHA;EACC,cAAA;AJ+zHD;;AI7zHA;EACC,cAAA;AJg0HD;;AI9zHA;EACC,gBAAA;EACA,YAAA;EACA,WAAA;AJi0HD;;AI/zHA;EACC,gBAAA;EACA,YAAA;EACA,WAAA;AJk0HD;;AIh0HA;EACC,kBAAA;EACA,kCAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,0BAAA;AJm0HD;AIl0HC;EACC,kBAAA;AJo0HF;;AIj0HA;EACC,kBAAA;EACA,gCAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,WAAA;EACA,0BAAA;EACA,eAAA;EACA,iBAAA;AJo0HD;;AIl0HA;EACC,kBAAA;EACA,gCAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,WAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AJq0HD;;AIn0HA;EACC,kBAAA;EACA,gCAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,WAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AJs0HD;;AIp0HA;EACC,kBAAA;EACA,gCAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,WAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AJu0HD;;AIr0HA;EACC,kBAAA;EACA,gCAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,WAAA;EACA,0BAAA;AJw0HD;;AIt0HA;EACC,kBAAA;EACA,gCAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,WAAA;EACA,0BAAA;AJy0HD;;AIv0HA;EACC,gCAAA;AJ00HD;;AIx0HA;EACC,kCAAA;AJ20HD;;AIz0HA;EACC,aAAA;EACA,WAAA;EACA,YAAA;EACA,6DAAA;EACA,eAAA;AJ40HD;;AI10HA;EACC,aAAA;EACA,oCAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,4BAAA;AJ60HD;;AI30HA;EACC,4BAAA;EACA,oCAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AJ80HD;AI70HC;EACC,4BAAA;AJ+0HF;;AI50HA;EACC,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,yBAAA;EACA,4BAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AJ+0HD;AI70HE;EACC,qBAAA;EACA,WAAA;EACA,YAAA;EACA,8EAAA;EACA,WAAA;AJ+0HH;;AI30HA;EACC,WAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AJ80HD;;AI50HA;EACC,kBAAA;AJ+0HD;;AI70HA;EACC,WAAA;AJg1HD;;AI90HA;EACC,YAAA;AJi1HD;;AI/0HA;EACC,WAAA;AJk1HD;;AIh1HA;EACC,qBAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;EACA,uCAAA;EACA,yBAAA;EACA,wBAAA;AJm1HD;;AIj1HA;EACC,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,gCAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,UAAA;EAGA,iDAAA;EACA,mBAAA;EACA,SAAA;AJo1HD;AIn1HC;EACC,kBAAA;EACA,eAAA;AJq1HF;;AIj1HC;EACC,kBAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,0BAAA;AJo1HF;AIj1HE;EACC,WAAA;AJm1HH;;AI/0HA;EACC,gBAAA;EACA,4BAAA;AJk1HD;AIj1HC;EACC,4BAAA;AJm1HF;AIj1HG;EAGC,6CAAA;EACA,UAAA;AJm1HJ;AIj1HG;EAGC,yCAAA;EACA,UAAA;AJm1HJ;AIh1HE;EAGC,qCAAA;EACA,WAAA;AJk1HH;AI/0HC;EACC,kBAAA;EACA,kBAAA;AJi1HF;AIh1HE;EACC,wBAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EAGA,yCAAA;EACA,WAAA;EAGA,iDAAA;EACA,cAAA;AJk1HH;AIh1HE;EACC,wBAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EAGA,yCAAA;EACA,WAAA;EAGA,iDAAA;EACA,cAAA;EACA,UAAA;AJk1HH;AI/0HC;EACC,WAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EAGA,qCAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,0BAAA;EAGA,uBAAA;EACA,0BAAA;EACA,+BAAA;EACA,kCAAA;EACA,8BAAA;EACA,6BAAA;AJi1HF;AI/0HC;EACC,WAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,+BAAA;EACA,6BAAA;EAGA,yCAAA;EACA,0BAAA;EACA,+BAAA;EACA,kCAAA;EACA,8BAAA;EACA,6BAAA;AJi1HF;;AI90HA;EACC,4BAAA;AJi1HD;AIh1HC;EACC,4BAAA;AJk1HF;AIh1HG;EAGC,6CAAA;EACA,UAAA;AJk1HJ;AIh1HG;EAGC,yCAAA;EACA,UAAA;AJk1HJ;AI/0HE;EAGC,qCAAA;EACA,WAAA;AJi1HH;AI90HC;EACC,kBAAA;EACA,kBAAA;AJg1HF;AI/0HE;EACC,wBAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EAGA,yCAAA;EACA,WAAA;EACA,0BAAA;EACA,WAAA;AJi1HH;AI/0HE;EACC,wBAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EAGA,yCAAA;EACA,WAAA;EACA,0BAAA;EACA,cAAA;EACA,UAAA;AJi1HH;AI90HC;EACC,WAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EAGA,qCAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,0BAAA;EAGA,uBAAA;AJg1HF;AI90HC;EACC,WAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,4BAAA;EACA,0BAAA;EAGA,yCAAA;EACA,0BAAA;AJg1HF;;AI70HA;EACC,mBAAA;EACA,mBAAA;AJg1HD;AI/0HC;EACC,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,4CAAA;EACA,0BAAA;EACA,mCAAA;EACA,sBAAA;EACA,WAAA;AJi1HF;AI90HE;EACC,0BAAA;AJg1HH;;AI50HA;EACC,mBAAA;EACA,kBAAA;AJ+0HD;AI90HC;EACC,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,0BAAA;AJg1HF;AI70HE;EACC,WAAA;AJ+0HH;;AI30HA;EACC,yBAAA;EACA,kBAAA;EACA,yBAAA;AJ80HD;AI70HC;EACC,sBAAA;EACA,qBAAA;AJ+0HF;AI90HE;EACC,WAAA;AJg1HH;AI70HC;EACC,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,0BAAA;AJ+0HF;;AI50HA;EACC,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,kBAAA;EACA,mBAAA;AJ+0HD;AI90HC;EACC,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,QAAA;EACA,UAAA;EACA,mBAAA;EACA,WAAA;EACA,0BAAA;AJg1HF;AI70HE;EACC,WAAA;EACA,SAAA;AJ+0HH;;AI30HA;EACC,gBAAA;EACA,kCAAA;EACA,kBAAA;EACA,4BAAA;EACA,mBAAA;AJ80HD;AI70HC;EACC,iCAAA;EACA,0BAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,yBAAA;EAEA,2BAAA;EACA,kBAAA;EACA,WAAA;AJ+0HF;AI50HE;EACC,YAAA;AJ80HH;;AI10HA;EACC,kBAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AJ60HD;AI50HC;EACC,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,0BAAA;AJ80HF;AI50HC;EAKC,sBAAA;AJ00HF;AI90HE;EACC,QAAA;EACA,YAAA;AJg1HH;;AI30HA;EACC,eAAA;EACG,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AJ80HJ;AI70HC;EACC,WAAA;EACA,8BAAA;EACA,qBAAA;EAIA,aAAA;EAIA,mBAAA;EAGA,iDAAA;AJ+0HF;AI70HC;EACC,WAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;AJ+0HF;AI90HE;EACC,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;AJg1HH;AI90HE;EACC,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,8BAAA;AJg1HH;AI70HC;EACC,eAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;AJ+0HF;AI90HE;EACC,qBAAA;AJg1HH;;AI50HA;EACC,2BAAA;EACA,sBAAA;EACA,mCAAA;EACA,iCAAA;EACA,mCAAA;EACA,8BAAA;EACA,2CAAA;EACA,yCAAA;EACA,gCAAA;EACA,2BAAA;EACA,wCAAA;EACA,sCAAA;EACA,+BAAA;EACA,0BAAA;EACA,uCAAA;EACA,qCAAA;EACA,8BAAA;EACA,yBAAA;EACA,sCAAA;EACA,oCAAA;AJ+0HD;;AI70HA;EACC,2BAAA;EACA,uBAAA;EACA,mCAAA;EACA,iCAAA;EACA,mCAAA;EACA,+BAAA;EACA,2CAAA;EACA,yCAAA;EACA,gCAAA;EACA,4BAAA;EACA,wCAAA;EACA,sCAAA;EACA,+BAAA;EACA,2BAAA;EACA,uCAAA;EACA,qCAAA;EACA,8BAAA;EACA,0BAAA;EACA,sCAAA;EACA,oCAAA;AJg1HD;;AI90HA;EACC,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,0BAAA;EACA,+BAAA;EACA,kCAAA;EACA,8BAAA;EACA,6BAAA;AJi1HD;AIh1HC;EACC,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;AJk1HF;;AI/0HA;EACC,eAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,0BAAA;EACA,yBAAA;EACA,+BAAA;EACA,kCAAA;EACA,8BAAA;EACA,6BAAA;AJk1HD;AIj1HC;EACC,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;AJm1HF;;AIh1HA;EACC,eAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EACA,mDAAA;EACA,0BAAA;EACA,+BAAA;EACA,kCAAA;EACA,8BAAA;EACA,6BAAA;EACA,4BAAA;EACA,kCAAA;AJm1HD;AI/0HI;EACC,SAAA;AJi1HL;AI90HG;EACC,mBAAA;AJg1HJ;AI50HK;EACC,aAAA;AJ80HN;AI30HI;EACC,iBAAA;AJ60HL;AIx0HC;EACC,iBAAA;AJ00HF;AIx0HC;EACC,iBAAA;AJ00HF;;AIt0HC;EACC,YAAA;EACA,UAAA;EACA,mBAAA;EAGA,8BAAA;EAEA,0BAAA;EAGA,6BAAA;EAEA,yBAAA;EAGA,qCAAA;EAEA,iCAAA;EAGA,gCAAA;EAEA,4BAAA;EACA,yBAAA;AJy0HF;;AIr0HC;EACC,YAAA;EACA,yBAAA;AJw0HF;AIt0HC;EACC,WAAA;AJw0HF;AIv0HE;EACC,kBAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EAKA,0BAAA;AJy0HH;AIx0HG;EACC,4BAAA;AJ00HJ;AIx0HG;EACC,2BAAA;AJ00HJ;AIx0HG;EACC,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,gCAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;EAKA,0BAAA;AJ00HJ;AIx0HG;EACC,kBAAA;EACA,aAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,2CAAA;EACA,iDAAA;EACA,0BAAA;EACA,+BAAA;EACA,kCAAA;EACA,8BAAA;EACA,6BAAA;EACA,kBAAA;AJ00HJ;AIz0HI;EAMC,kBAAA;EACA,WAAA;AJs0HL;AI30HM;EACC,yBAAA;AJ60HP;AIx0HK;EACC,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,gCAAA;EACA,0BAAA;EACA,WAAA;EACA,gBAAA;EACA,0BAAA;EACA,+BAAA;EACA,kCAAA;EACA,8BAAA;EACA,6BAAA;EACA,sBAAA;EACA,kDAAA;AJ00HN;AIv0HM;EACC,mBAAA;AJy0HP;AIt0HK;EACC,kBAAA;EACA,WAAA;EACA,OAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,2CAAA;EACA,iDAAA;EACA,0BAAA;EACA,+BAAA;EACA,kCAAA;EACA,8BAAA;EACA,6BAAA;AJw0HN;AIv0HM;EACC,kBAAA;EACA,WAAA;AJy0HP;AIx0HO;EACC,mBAAA;AJ00HR;AIz0HQ;EACC,mBAAA;AJ20HT;AIx0HO;EACC,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kDAAA;EACA,eAAA;EACA,gCAAA;EACA,0BAAA;EACA,sBAAA;EACA,gBAAA;EACA,0BAAA;EACA,+BAAA;EACA,kCAAA;EACA,8BAAA;EACA,6BAAA;AJ00HR;AIr0HQ;EACC,iCAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;AJu0HT;AIl0HK;EACC,UAAA;EACA,UAAA;AJo0HN;AI/zHM;EACC,iCAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;AJi0HP;AI5zHG;EACC,kBAAA;EACA,aAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,2CAAA;EACA,iDAAA;EACA,0BAAA;EACA,+BAAA;EACA,kCAAA;EACA,8BAAA;EACA,6BAAA;AJ8zHJ;AI5zHK;EACC,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,gCAAA;EACA,0BAAA;EACA,WAAA;EACA,gBAAA;EACA,0BAAA;EACA,+BAAA;EACA,kCAAA;EACA,8BAAA;EACA,6BAAA;EACA,gBAAA;EACA,qBAAA;AJ8zHN;AI7zHM;EACC,kBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,0BAAA;AJ+zHP;AI7zHM;EAKC,kBAAA;AJ2zHP;AI/zHO;EACC,wBAAA;EACA,UAAA;AJi0HR;AI3zHM;EACC,mBAAA;AJ6zHP;AIvzHI;EACC,cAAA;AJyzHL;AIvzHI;EACC,yBAAA;AJyzHL;AIvzHI;EACC,WAAA;AJyzHL;AItzHG;EACC,cAAA;AJwzHJ;AItzHG;EACC,UAAA;EACA,UAAA;AJwzHJ;AItzHG;EACC,WAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,OAAA;EACA,YAAA;EACA,0BAAA;AJwzHJ;AItzHG;EACC,gCAAA;AJwzHJ;AIpzHG;EACC,yBAAA;AJszHJ;AIjzHI;EACC,mBAAA;EACA,UAAA;EACA,eAAA;EACA,SAAA;AJmzHL;AIjzHI;EACC,mBAAA;EACA,UAAA;EACA,eAAA;EACA,SAAA;AJmzHL;AIhzHG;EACC,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;AJkzHJ;AI3yHM;EACC,mBAAA;EACA,UAAA;EACA,OAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AJ6yHP;AItyHG;EACC,kBAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,0BAAA;AJwyHJ;AIpyHK;EACC,aAAA;AJsyHN;AIhyHK;EACC,kBAAA;EACA,cAAA;EACA,gCAAA;EACA,oBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;AJkyHN;;AI1xHC;EACC,kDAAA;AJ6xHF;AI1xHE;EACC,mBAAA;AJ4xHH;;AIvxHC;EACC,kBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;AJ0xHF;AIzxHE;EACC,kBAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EAKA,0BAAA;AJ2xHH;AI1xHG;EACC,kBAAA;AJ4xHJ;;AItxHC;EACC,kBAAA;AJyxHF;AItxHE;EACC,iBAAA;AJwxHH;AIvxHG;EACC,gBAAA;AJyxHJ;AIxxHI;EACC,WAAA;AJ0xHL;;AInxHC;EACC,kBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;AJsxHF;;AInxHA;EACC,eAAA;EACA,QAAA;EACA,MAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;EACA,0BAAA;AJsxHD;AIrxHC;EACC,yBAAA;AJuxHF;AIrxHC;EACC,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;AJuxHF;AIrxHC;EACC,eAAA;EACA,QAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,0BAAA;EACA,sBAAA;AJuxHF;AIrxHC;EACC,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EAGA,2BAAA;EACA,qCAAA;AJuxHF;AIrxHC;EACC,kBAAA;EACA,WAAA;EACA,SAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;EAKA,yBAAA;AJuxHF;AItxHE;EAGC,wBAAA;AJwxHH;AIrxHC;EACC,kBAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;AJuxHF;AItxHE;EACC,kBAAA;EACA,cAAA;AJwxHH;AItxHG;EASC,aAAA;AJgxHJ;AIvxHK;EACC,8CAAA;AJyxHN;AIvxHK;EACC,aAAA;AJyxHN;AIpxHG;EACC,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EAKA,0BAAA;AJsxHJ;AIrxHI;EACC,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,2BAAA;EAKA,0BAAA;AJuxHL;AIpxHG;EACC,yBAAA;AJsxHJ;AIlxHK;EACC,eAAA;EACA,iBAAA;EACA,0BAAA;AJoxHN;AI1wHI;EACC,YAAA;AJ4wHL;AIvwHG;EACC,kBAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,oCAAA;EACA,eAAA;EACA,kBAAA;EAKA,0BAAA;EACA,UAAA;AJywHJ;AIvwHG;EACC,cAAA;EAGA,wBAAA;AJywHJ;AIrwHG;EACC,aAAA;AJuwHJ;AInwHC;EACC,kBAAA;EACA,iBAAA;AJqwHF;AIpwHE;EACC,kBAAA;EACA,qBAAA;EACA,qBAAA;AJswHH;AIrwHG;EACC,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EAKA,0BAAA;AJuwHJ;AInwHC;EACC,kBAAA;EACA,6BAAA;AJqwHF;AIpwHE;EACC,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AJswHH;AInwHG;EACC,kBAAA;EACA,cAAA;EACA,eAAA;EACA,+BAAA;EACA,kBAAA;AJqwHJ;AIpwHI;EACC,+BAAA;AJswHL;AIrwHK;EACC,0BAAA;AJuwHN;AIpwHI;EACC,kBAAA;AJswHL;;AIhwHA;EACC,gBAAA;AJmwHD;AIlwHC;EACC,UAAA;EACA,mBAAA;AJowHF;AInwHE;EACC,YAAA;EACA,mBAAA;EACA,WAAA;EACA,wCAAA;EACA,mCAAA;AJqwHH;AInwHE;EACC,UAAA;EACA,mBAAA;EAGA,yBAAA;EAGA,yBAAA;AJqwHH;AInwHE;EAGC,yBAAA;AJqwHH;;AIjwHA;EACC,mBAAA;AJowHD;;AIjwHC;EACC,gCAAA;EACA,iDAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AJowHF;;AIhwHC;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AJmwHF;AIjwHC;EAIC,eAAA;AJgwHF;AInwHE;EACC,cAAA;AJqwHH;AIlwHE;EACC,WAAA;AJowHH;;AI/vHC;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AJkwHF;AIhwHG;EACC,yBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;AJkwHJ;AIjwHI;EACC,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,0BAAA;EACA,+BAAA;EACA,kCAAA;EACA,8BAAA;EACA,6BAAA;EACA,kBAAA;EACA,WAAA;AJmwHL;AIhwHK;EACC,qBAAA;AJkwHN;;AI3vHA;EACC,eAAA;EACA,QAAA;EACA,YAAA;EAGA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EAEA,sBAAA;EACA,aAAA;EAGA,8CAAA;EAGA,yBAAA;EAGA,8DAAA;EACA,kBAAA;EACA,6DAAA;EACA,gBAAA;AJ8vHD;AI7vHC;EACC,WAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EAGA,iCAAA;EACA,UAAA;EAGA,oDAAA;AJ+vHF;AI9vHE;EACC,eAAA;AJgwHH;;AI5vHA;EACC,aAAA;AJ+vHD;;AI5vHC;EACC,QAAA;EACA,SAAA;AJ+vHF;;AI5vHA;EACC,WAAA;EACA,YAAA;EACA,2CAAA;EAEA,2CAAA;EACA,yBAAA;AJ+vHD;;AI7vHA;EACC,mBAAA;AJgwHD;;AI9vHA;EAEC,4CAAA;AJiwHD;;AI/vHA;EACC,mBAAA;AJkwHD;;AIhwHA;EAEC,4CAAA;AJmwHD;;AIjwHA;EACC,mBAAA;AJowHD;;AIlwHA;EAEC,6CAAA;AJqwHD;;AInwHA;EACC,mBAAA;AJswHD;;AIpwHA;EAEC,2CAAA;AJuwHD;;AIrwHA;EACC,mBAAA;AJwwHD;;AItwHA;EAEC,2CAAA;AJywHD;;AIvwHA;EACC,mBAAA;AJ0wHD;;AIxwHA;EAEC,4CAAA;AJ2wHD;;AIzwHA;EACC,mBAAA;AJ4wHD;;AI1wHA;EAEC,4CAAA;AJ6wHD;;AI3wHA;EACC,mBAAA;AJ8wHD;;AI5wHA;EAEC,6CAAA;AJ+wHD;;AI7wHA;EACC,mBAAA;AJgxHD;;AI9wHA;EAEC,2CAAA;AJixHD;;AI/wHA;EACC,mBAAA;AJkxHD;;AIhxHA;EAEC,2CAAA;AJmxHD;;AIjxHA;EACC,mBAAA;AJoxHD;;AIlxHA;EAEC,2CAAA;AJqxHD;;AInxHA;EACC,mBAAA;AJsxHD;;AIpxHA;EAEC,4CAAA;AJuxHD;;AIrxHA;EACC,mBAAA;AJwxHD;;AItxHA;EAEC,4CAAA;AJyxHD;;AIvxHA;EACC,WAAA;EACA,YAAA;EACA,gCAAA;EAEA,4BAAA;AJ0xHD;;AIxxHA;EACC,WAAA;EACA,YAAA;EACA,2BAAA;AJ2xHD;AI1xHC;EACC,UAAA;EAGA,gCAAA;EAGA,sBAAA;AJ4xHF;;AIzxHA;EAIC,kCAAA;AJyxHD;AI5xHC;EACC,UAAA;AJ8xHF;;AI1xHA;EACC,WAAA;EACA,YAAA;EACA,gCAAA;EACA,yBAAA;AJ6xHD;;AI3xHA;EACC,WAAA;EACA,YAAA;EACA,gCAAA;EACA,yBAAA;AJ8xHD;;AI5xHA;EACC,gBAAA;AJ+xHD;;AI7xHA;EACC,8BAAA;EAEA,uCAAA;AJgyHD;;AI9xHA;EACC,8BAAA;EAEA,uCAAA;AJiyHD;;AI/xHA;EACC,4BAAA;EACA,sBAAA;AJkyHD;;AIhyHA;EACC,4BAAA;EACA,sBAAA;AJmyHD;;AIjyHA;EACC,4BAAA;EACA,sBAAA;AJoyHD;;AIjyHC;EACC,aAAA;AJoyHF;;AIjyHA;EACC,aAAA;EACA,0BAAA;AJoyHD;;AIjyHC;EAEC,wEAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AJmyHF;AIjyHC;EACC,gBAAA;EACA,0BAAA;AJmyHF;AI/xHK;EACC,YAAA;EACA,qBAAA;AJiyHN;AI3xHC;EACC,gBAAA;EACA,kBAAA;AJ6xHF;AI5xHE;EACC,WAAA;EACA,0BAAA;AJ8xHH;AI3xHG;EACC,WAAA;EACA,gEAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,0BAAA;AJ6xHJ;;AIvxHC;EACC,gBAAA;AJ0xHF;;AIvxHA;EACC,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AJ0xHD;;AItxHE;EACC,WAAA;AJyxHH;AItxHC;EACC,oBAAA;EACA,kBAAA;AJwxHF;AIvxHE;EACC,WAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;AJyxHH;AItxHC;EACC,aAAA;AJwxHF;;AInxHE;EACC,sBAAA;AJsxHH;;AIjxHC;EAeC,iBAAA;EACA,kBAAA;AJswHF;AIrxHE;EACC,kBAAA;EACA,2CAAA;EACA,gCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,yBAAA;EACA,WAAA;EACA,aAAA;AJuxHH;AInxHE;EACC,kBAAA;EACA,UAAA;EACA,SAAA;AJqxHH;;AIhxHC;EACC,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;AJmxHF;;AIhxHA;EACC,kBAAA;AJmxHD;AIlxHC;EAQC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;AJ6wHF;AIxxHE;EACC,kBAAA;EACA,WAAA;AJ0xHH;AIzxHG;EACC,cAAA;AJ2xHJ;;AIjxHA;EACC,kBAAA;EACA,oBAAA;EACA,UAAA;AJoxHD;;AIlxHA;EACC,iBAAA;AJqxHD;;AInxHA;EACC,6BAAA;AJsxHD;;AIpxHA;EACC,6BAAA;AJuxHD;;AIrxHA;EACC,0BAAA;AJwxHD;;AItxHA;EACC,2BAAA;AJyxHD;;AIvxHA;EACC,2BAAA;AJ0xHD;;AIxxHA;EACC,2BAAA;AJ2xHD;;AIzxHA;EACC,2BAAA;AJ4xHD;;AI1xHA;EACC,2BAAA;AJ6xHD;;AI3xHA;EACC,2BAAA;AJ8xHD;;AI5xHA;EACC,2BAAA;AJ+xHD;;AI7xHA;EACC,2BAAA;AJgyHD;;AI9xHA;EACC,2BAAA;AJiyHD;;AI/xHA;EACC,2BAAA;AJkyHD;;AIhyHA;EACC,2BAAA;AJmyHD;;AIjyHA;EACC,2BAAA;AJoyHD;;AIlyHA;EACC,2BAAA;AJqyHD;;AInyHA;EACC,2BAAA;AJsyHD;;AIpyHA;EACC,2BAAA;AJuyHD;;AIryHA;EACC,6BAAA;EACA,6BAAA;AJwyHD;;AItyHA;EACC,8BAAA;AJyyHD;;AIvyHA;EACC,8BAAA;AJ0yHD;;AIxyHA;EACC,8BAAA;AJ2yHD;;AIzyHA;EACC,8BAAA;AJ4yHD;;AI1yHA;EACC,8BAAA;AJ6yHD;;AI3yHA;EACC,8BAAA;AJ8yHD;;AI5yHA;EACC,8BAAA;AJ+yHD;;AI7yHA;EACC,8BAAA;AJgzHD;;AI9yHA;EACC,8BAAA;AJizHD;;AI/yHA;EACC,8BAAA;AJkzHD;;AIhzHA;EACC,8BAAA;AJmzHD;;AIjzHA;EACC,8BAAA;AJozHD;;AIlzHA;EACC,8BAAA;AJqzHD;;AInzHA;EACC,8BAAA;AJszHD;;AIpzHA;EACC,8BAAA;AJuzHD;;AIrzHA;EACC,2BAAA;EACA,2BAAA;AJwzHD;;AItzHA;EACC,4BAAA;EACA,4BAAA;AJyzHD;;AIvzHA;EACC,6BAAA;AJ0zHD;;AIxzHA;EACC,2BAAA;AJ2zHD;;AIzzHA;EACC,4BAAA;AJ4zHD;;AI1zHA;EACC,4BAAA;AJ6zHD;;AI3zHA;EACC,4BAAA;AJ8zHD;;AI5zHA;EACC,4BAAA;AJ+zHD;;AI7zHA;EACC,4BAAA;AJg0HD;;AI9zHA;EACC,4BAAA;AJi0HD;;AI/zHA;EACC,4BAAA;AJk0HD;;AIh0HA;EACC,4BAAA;AJm0HD;;AIj0HA;EACC,4BAAA;AJo0HD;;AIl0HA;EACC,4BAAA;AJq0HD;;AIn0HA;EACC,4BAAA;AJs0HD;;AIp0HA;EACC,4BAAA;AJu0HD;;AIr0HA;EACC,4BAAA;AJw0HD;;AIt0HA;EACC,4BAAA;AJy0HD;;AIv0HA;EACC,4BAAA;AJ00HD;;AIx0HA;EACC,4BAAA;AJ20HD;;AIz0HA;EACC,6BAAA;AJ40HD;;AI10HA;EACC,6BAAA;AJ60HD;;AI30HA;EACC,6BAAA;AJ80HD;;AI50HA;EACC,6BAAA;AJ+0HD;;AI70HA;EACC,6BAAA;AJg1HD;;AI90HA;EACC,6BAAA;AJi1HD;;AI/0HA;EACC,6BAAA;AJk1HD;;AIh1HA;EACC,6BAAA;AJm1HD;;AIj1HA;EACC,6BAAA;AJo1HD;;AIl1HA;EACC,6BAAA;AJq1HD;;AIn1HA;EACC,6BAAA;AJs1HD;;AIp1HA;EACC,6BAAA;AJu1HD;;AIr1HA;EACC,6BAAA;AJw1HD;;AIt1HA;EACC,6BAAA;AJy1HD;;AIv1HA;EACC,6BAAA;AJ01HD;;AIx1HA;EACC,2BAAA;AJ21HD;;AIz1HA;EACC,4BAAA;AJ41HD;;AI11HA;EACC,6BAAA;AJ61HD;;AI31HA;EACC,8BAAA;EACA,8BAAA;AJ81HD;;AI51HA;EACC,0BAAA;AJ+1HD;;AI71HA;EACC,4BAAA;AJg2HD;;AI91HA;EACC,4BAAA;AJi2HD;;AI/1HA;EACC,4BAAA;AJk2HD;;AIh2HA;EACC,4BAAA;AJm2HD;;AIj2HA;EACC,4BAAA;AJo2HD;;AIl2HA;EACC,4BAAA;AJq2HD;;AIn2HA;EACC,4BAAA;AJs2HD;;AIp2HA;EACC,4BAAA;AJu2HD;;AIr2HA;EACC,4BAAA;AJw2HD;;AIt2HA;EACC,4BAAA;AJy2HD;;AIv2HA;EACC,4BAAA;AJ02HD;;AIx2HA;EACC,4BAAA;AJ22HD;;AIz2HA;EACC,4BAAA;AJ42HD;;AI12HA;EACC,4BAAA;AJ62HD;;AI32HA;EACC,4BAAA;AJ82HD;;AI52HA;EACC,6BAAA;AJ+2HD;;AI72HA;EACC,kBAAA;AJg3HD;;AI92HA;EACC,+BAAA;AJi3HD;;AI/2HA;EACC,+BAAA;AJk3HD;;AIh3HA;EACC,+BAAA;AJm3HD;;AIj3HA;EACC,+BAAA;AJo3HD;;AIl3HA;EACC,+BAAA;AJq3HD;;AIn3HA;EACC,+BAAA;AJs3HD;;AIp3HA;EACC,+BAAA;AJu3HD;;AIr3HA;EACC,+BAAA;AJw3HD;;AIt3HA;EACC,+BAAA;AJy3HD;;AIv3HA;EACC,+BAAA;AJ03HD;;AIx3HA;EACC,+BAAA;AJ23HD;;AIz3HA;EACC,+BAAA;AJ43HD;;AI13HA;EACC,+BAAA;AJ63HD;;AI33HA;EACC,+BAAA;AJ83HD;;AI53HA;EACC,+BAAA;AJ+3HD;;AI73HA;EACC,+BAAA;AJg4HD;;AI93HA;EACC,gCAAA;AJi4HD;;AI/3HA;EACC,qBAAA;AJk4HD;;AIh4HA;EACC,4BAAA;AJm4HD;;AIj4HA;EACC,6BAAA;AJo4HD;;AIl4HA;EACC,6BAAA;AJq4HD;;AIn4HA;EACC,6BAAA;AJs4HD;;AIp4HA;EACC,6BAAA;AJu4HD;;AIr4HA;EACC,6BAAA;AJw4HD;;AIt4HA;EACC,6BAAA;AJy4HD;;AIv4HA;EACC,6BAAA;AJ04HD;;AIx4HA;EACC,6BAAA;AJ24HD;;AIz4HA;EACC,6BAAA;AJ44HD;;AI14HA;EACC,6BAAA;AJ64HD;;AI34HA;EACC,6BAAA;AJ84HD;;AI54HA;EACC,6BAAA;AJ+4HD;;AI74HA;EACC,6BAAA;AJg5HD;;AI94HA;EACC,6BAAA;AJi5HD;;AI/4HA;EACC,6BAAA;AJk5HD;;AIh5HA;EACC,6BAAA;AJm5HD;;AIj5HA;EACC,8BAAA;AJo5HD;;AIl5HA;EACC,8BAAA;AJq5HD;;AIn5HA;EACC,8BAAA;AJs5HD;;AIp5HA;EACC,8BAAA;AJu5HD;;AIr5HA;EACC,8BAAA;AJw5HD;;AIt5HA;EACC,8BAAA;AJy5HD;;AIv5HA;EACC,8BAAA;AJ05HD;;AIx5HA;EACC,8BAAA;AJ25HD;;AIz5HA;EACC,8BAAA;AJ45HD;;AI15HA;EACC,8BAAA;AJ65HD;;AI35HA;EACC,8BAAA;AJ85HD;;AI55HA;EACC,8BAAA;AJ+5HD;;AI75HA;EACC,8BAAA;AJg6HD;;AI95HA;EACC,8BAAA;AJi6HD;;AI/5HA;EACC,8BAAA;AJk6HD;;AI/5HC;EACC,cAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;AJk6HF;;AI/5HA;EACC,kBAAA;EAEA,oBAAA;AJi6HD;;AIp5HA;EACC,iBAAA;AJu5HD;;AIr5HA;EACC,aAAA;AJw5HD;;AIt5HA;EACC,aAAA;AJy5HD;;AIv5HA;EACC;IACC,iBAAA;IACA,iBAAA;EJ05HA;AACF;AIv5HA;EACC;IACC,iCAAA;EJy5HA;AACF;AK95MA,mBAAA;AACA;EAEI;IACE,aAAA;EL+5MJ;EK35ME;IACE,SAAA;EL65MJ;AACF;AK15MA;EAGM;IACE,aAAA;EL05MN;EKr5ME;IACE,OAAA;ELu5MJ;EKp5MA;IACE,kBAAA;IACA,WAAA;IACA,OAAA;IACA,kBAAA;IACA,OAAA;ELs5MF;EKp5MA;IACE,gBAAA;IACA,gBAAA;ELs5MF;EKp5MA;IACE,mBAAA;ELs5MF;EKp5MA;IACE,wBAAA;ELs5MF;AACF;AKp5MA;EACE;IACE,aAAA;ELs5MF;AACF;AKp5MA;EACE;IACE,aAAA;ELs5MF;AACF;AKp5MA;EACE;IACE,aAAA;ELs5MF;AACF;AKp5MA;EAEI;IACE,aAAA;ELq5MJ;EKj5ME;IACE,OAAA;ELm5MJ;EK74MM;IACE,eAAA;EL+4MR;EK14MA;IACE,iBAAA;EL44MF;EK14MA;IACE,aAAA;EL44MF;EKz4ME;IACE,aAAA;EL24MJ;EKx4MA;IACE,iBAAA;EL04MF;EKx4MA;IACE,eAAA;EL04MF;EKx4MA;IACE,aAAA;EL04MF;EKx4MA;IACE,mBAAA;EL04MF;EKv4ME;IACE,SAAA;ELy4MJ;EKt4MA;IACE,eAAA;ELw4MF;EKr4ME;IACE,WAAA;ELu4MJ;EKp4MA;IACE,kBAAA;ELs4MF;EKr4ME;IACE,eAAA;IACA,iBAAA;ELu4MJ;EKn4ME;IACE,eAAA;IACA,iBAAA;IACA,iBAAA;ELq4MJ;EK/3MM;IACE,eAAA;ELi4MR;EK53MA;IACE,mBAAA;EL83MF;EKt3MA;IACE,cAAA;ELw3MF;EKt3MA;IACE,aAAA;ELw3MF;EKr3ME;IACE,aAAA;ELu3MJ;EKp3MA;IACE,iBAAA;ELs3MF;EKp3MA;IACE,kBAAA;ELs3MF;EKp3MA;IACE,qBAAA;ELs3MF;EKp3MA;IACE,kBAAA;IACA,WAAA;ELs3MF;EKn3ME;IACE,wBAAA;IACA,YAAA;IACA,8BAAA;IACA,iBAAA;ELq3MJ;EKn3ME;IACE,kBAAA;IACA,kBAAA;IACA,4BAAA;IACA,8BAAA;IACA,MAAA;ELq3MJ;EKn3ME;IACE,kBAAA;IACA,OAAA;IACA,MAAA;IACA,8BAAA;ELq3MJ;EKn3ME;IACE,aAAA;ELq3MJ;EKl3MA;IACE,iBAAA;ELo3MF;EKl3MA;IACE,mBAAA;ELo3MF;EKj3ME;IACE,gBAAA;ELm3MJ;EKh3MA;IACE,aAAA;ELk3MF;AACF;AKh3MA;EAIQ;IACE,yBAAA;IACA,kBAAA;IACA,UAAA;EL+2MR;EK72MU;IACE,yBAAA;IACA,kBAAA;IACA,UAAA;EL+2MZ;EK32MM;IACE,yBAAA;IACA,kBAAA;IACA,UAAA;EL62MR;AACF;AKx2MA;EACE;IACE,aAAA;EL02MF;EKx2MA;IACE,iBAAA;EL02MF;AACF;AKx2MA;EACE;IACE,iBAAA;EL02MF;EKx2MA;IACE,iBAAA;EL02MF;AACF;AKx2MA;EACE;IACE,wBAAA;EL02MF;EKx2MA;IACE,wBAAA;EL02MF;EKt2MI;IACE,wBAAA;ELw2MN;EKn2ME;IACE,cAAA;IACA,aAAA;ELq2MJ;EK/1MM;IACE,aAAA;ELi2MR;EK51MA;IACE,aAAA;EL81MF;EK31ME;IACE,aAAA;EL61MJ;EKx1MI;IACE,eAAA;EL01MN;EKr1ME;IACE,iBAAA;ELu1MJ;EKp1MA;IACE,kBAAA;IACA,SAAA;IACA,aAAA;IACA,8BAAA;ELs1MF;EKp1MA;IACE,kBAAA;ELs1MF;EKp1MI;IACE,WAAA;ELs1MN;EKl1MA;IACE,aAAA;ELo1MF;EKl1MA;IAIE,mBAAA;ELi1MF;EKp1ME;IACE,YAAA;ELs1MJ;EKl1MA;IACE,oBAAA;ELo1MF;EKl1MA;IACE,YAAA;ELo1MF;EKl1MA;IACE,qBAAA;ELo1MF;EKl1MA;IACE,mBAAA;ELo1MF;EKl1MA;IACE,sBAAA;IACA,iBAAA;ELo1MF;EKl1MA;IACE,qCAAA;IACA,UAAA;ELo1MF;EKl1MA;IACE,qCAAA;IACA,WAAA;IACA,SAAA;ELo1MF;EKl1MA;IACE,aAAA;ELo1MF;EKl1MA;IACE,sBAAA;IACA,SAAA;IACA,eAAA;ELo1MF;EKl1MA;IACE,mBAAA;ELo1MF;EKl1MA;IACE,cAAA;ELo1MF;EKj1ME;IACE,eAAA;IACA,oBAAA;ELm1MJ;EK/0ME;IACE,cAAA;ELi1MJ;EKh1MI;IACE,iBAAA;ELk1MN;EK90MA;IACE,oBAAA;ELg1MF;EK90MA;IACE,SAAA;ELg1MF;EK50MI;IACE,WAAA;EL80MN;EK30ME;IACE,WAAA;EL60MJ;EK10MA;IACE,oBAAA;IACA,sBAAA;EL40MF;EKz0ME;IACE,WAAA;EL20MJ;EKx0MA;IACE,iBAAA;EL00MF;EKx0MA;IACE,UAAA;EL00MF;EKx0MA;IACE,uBAAA;EL00MF;EKx0MA;IACE,mBAAA;EL00MF;EKx0MA;IACE,UAAA;EL00MF;EKx0MA;IACE,kBAAA;EL00MF;EKx0MA;IACE,kBAAA;IACA,iBAAA;EL00MF;EKx0MA;IACE,cAAA;EL00MF;EKx0MA;IACE,aAAA;EL00MF;EKx0MA;IACE,aAAA;EL00MF;EKx0MA;IACE,iBAAA;EL00MF;EKx0MA;IACE,kBAAA;EL00MF;EKv0ME;IACE,WAAA;ELy0MJ;EKt0MA;IACE,aAAA;ELw0MF;EKp0MI;IACE,oBAAA;ELs0MN;EKl0MA;IACE,oBAAA;IACA,WAAA;IACA,eAAA;ELo0MF;EKl0MA;IACE,WAAA;ELo0MF;EKh0MI;IACE,aAAA;ELk0MN;EK5zMI;IACE,aAAA;EL8zMN;EKzzME;IACE,sBAAA;IACA,uBAAA;EL2zMJ;EKxzMA;IACE,eAAA;EL0zMF;EKxzMA;IACE,iBAAA;EL0zMF;EKxzMA;IACE,YAAA;EL0zMF;EKxzMA;IACE,YAAA;IACA,aAAA;EL0zMF;EKzzME;IACE,YAAA;IACA,aAAA;EL2zMJ;EKzzME;IACE,YAAA;EL2zMJ;EKvzME;IACE,eAAA;ELyzMJ;EKrzME;IACE,8BAAA;ELuzMJ;EKpzMA;IACE,mBAAA;ELszMF;AACF;AKpzMA;EACE;IACE,iBAAA;ELszMF;EKpzMA;IACE,iBAAA;ELszMF;AACF;AKpzMA;EAEI;IACE,eAAA;IACA,iBAAA;ELqzMJ;EKjzME;IACE,eAAA;IACA,qBAAA;ELmzMJ;EKhzMA;IACE,eAAA;IACA,gBAAA;IACA,iBAAA;ELkzMF;EKhzMA;IAIE,cAAA;EL+yMF;EKlzME;IACE,oBAAA;ELozMJ;EKhzMA;IACE,qBAAA;ELkzMF;EKhzMA;IACE,aAAA;ELkzMF;EK/yME;IACE,mBAAA;ELizMJ;EK9yMA;IACE,oBAAA;IACA,WAAA;IACA,eAAA;ELgzMF;EK/yME;IACE,cAAA;ELizMJ;EKhzMI;IACE,mBAAA;ELkzMN;EK9yMA;IACE,iBAAA;ELgzMF;EK9yMA;IACE,iBAAA;ELgzMF;AACF;AK9yMA;EACE;IACE,eAAA;ELgzMF;EK9yMA;IACE,iBAAA;ELgzMF;AACF;AK9yMA;EACE;IACE,qBAAA;ELgzMF;EK9yMA;IACE,qBAAA;ELgzMF;EK9yMA;IACE,qBAAA;ELgzMF;EK9yMA;IACE,uBAAA;ELgzMF;EK9yMA;IACE,sBAAA;ELgzMF;EK9yMA;IACE,uBAAA;ELgzMF;EK9yMA;IACE,cAAA;ELgzMF;EK7yME;IACE,aAAA;EL+yMJ;EK5yMI;IACE,eAAA;IACA,iBAAA;EL8yMN;EKxyMI;IACE,eAAA;IACA,iBAAA;EL0yMN;EKtyMA;IACE,kBAAA;ELwyMF;EKtyMA;IACE,cAAA;ELwyMF;EKryME;IACE,eAAA;IACA,iBAAA;IACA,iBAAA;ELuyMJ;EKnyME;IACE,mBAAA;ELqyMJ;EKlyMA;IACE,aAAA;ELoyMF;EKlyMA;IACE,iBAAA;ELoyMF;AACF;AKlyMA;EACE;IACE,WAAA;ELoyMF;EKjyME;IACE,aAAA;ELmyMJ;EKhyMI;IACE,YAAA;ELkyMN;EK9xMA;IACE,uBAAA;ELgyMF;EK9xMA;IACE,qCAAA;IACA,UAAA;ELgyMF;EK9xMA;IACE,qCAAA;IACA,WAAA;IACA,SAAA;ELgyMF;EK9xMA;IACE,aAAA;ELgyMF;EK9xMA;IACE,sBAAA;IACA,SAAA;IACA,eAAA;ELgyMF;EK5xMI;IACE,eAAA;EL8xMN;EKzxME;IACE,kBAAA;EL2xMJ;EKtxMI;IACE,eAAA;IACA,iBAAA;ELwxMN;EKpxMA;IACE,wBAAA;ELsxMF;EKjxMM;IACE,eAAA;ELmxMR;EK7wME;IACE,eAAA;IACA,iBAAA;IACA,iBAAA;EL+wMJ;EK1wMI;IACE,eAAA;IACA,2BAAA;EL4wMN;EKxwMA;IACE,mBAAA;EL0wMF;EKvwME;IACE,gBAAA;ELywMJ;EKtwMA;IACE,WAAA;ELwwMF;EKpwMI;IACE,aAAA;ELswMN;EKhwMI;IACE,aAAA;ELkwMN;EK9vMA;IACE,aAAA;ELgwMF;EK9vMA;IACE,aAAA;ELgwMF;AACF;AK9vMA;EAGM;IACE,aAAA;EL8vMN;EK1vMA;IACE,iBAAA;EL4vMF;EK1vMA;IACE,eAAA;IACA,uBAAA;EL4vMF;EK1vMA;IACE,UAAA;EL4vMF;EK1vMA;IACE,kBAAA;EL4vMF;EK1vMA;IACE,aAAA;EL4vMF;AACF;AM9gOA;EACE,sBAAA;EACA,4CAAA;EACA,mPAAA;EAIA,mBAAA;EACA,kBAAA;EACA,mBAAA;AN6gOF;AM1gOA;EACE,+EAAA;EACA,iCAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EAEA,sCAAA;EACA,mCAAA;EACA,kCAAA;AN2gOF;;AMxgOA;EACE,gBAAA;AN2gOF;;AMzgOA;EACE,gBAAA;AN4gOF;;AM1gOA;EACE,gBAAA;AN6gOF;;AM3gOA;EACE,gBAAA;AN8gOF;;AM5gOA;EACE,gBAAA;AN+gOF;;AM7gOA;EACE,gBAAA;ANghOF;;AM9gOA;EACE,gBAAA;ANihOF;;AM/gOA;EACE,gBAAA;ANkhOF;;AMhhOA;EACE,gBAAA;ANmhOF;;AMjhOA;EACE,gBAAA;ANohOF;;AMlhOA;EACE,gBAAA;ANqhOF;;AMnhOA;EACE,gBAAA;ANshOF;;AMphOA;EACE,gBAAA;ANuhOF;;AMrhOA;EACE,gBAAA;ANwhOF;;AMthOA;EACE,gBAAA;ANyhOF;;AMvhOA;EACE,gBAAA;AN0hOF;;AMxhOA;EACE,gBAAA;AN2hOF;;AMzhOA;EACE,gBAAA;AN4hOF;;AM1hOA;EACE,gBAAA;AN6hOF;;AM3hOA;EACE,gBAAA;AN8hOF;;AM5hOA;EACE,gBAAA;AN+hOF","sourcesContent":["$primary_color: #ff8c2e;\n$shade_color: #7e2100;\n$secondary_color: #0d0d0d;\n$color_1: #00061a;\n$color_2: #fff;\n$color_3: #000;\n$color_4: #ff0e75;\n$color_5: transparent;\n$color_6: #800599;\n$color_7: #f6ec4f;\n$color_8: rgba(0, 6, 26, 1);\n$color_9: rgba(246, 236, 79, 1);\n$color_10: #666;\n$color_11: rgba(255, 255, 255, 0.1);\n$color_12: rgba(255, 255, 255, 0.5);\n$color_13: rgba(255, 255, 255, 0.25);\n$color_14: rgba(255, 255, 255, 1);\n$font-family_1: Archivo;\n$font-family_2: Rubik;\n\n@keyframes anim {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n@keyframes heroShapeFour {\n  0%,\n  100% {\n    border-radius: 42% 58% 70% 30% / 45% 45% 55% 55%;\n    transform: translate3d(0, 0, 0) rotateZ(0.02deg);\n  }\n  35% {\n    border-radius: 70% 30% 46% 54% / 30% 29% 71% 70%;\n    transform: translate3d(0, 10px, 0) rotateZ(0.02deg);\n  }\n  50% {\n    transform: translate3d(0, 0, 0) rotateZ(0.02deg);\n  }\n  65% {\n    border-radius: 100% 60% 60% 100% / 100% 100% 60% 60%;\n    transform: translate3d(0, 20px, 0) rotateZ(0.03deg);\n  }\n}\n/* banner__section  end */\n/* service__section */\n/* service__section  end */\n/* about-section  */\n/* about-section  end */\n/* choose__us-section */\n/* choose__us-section  end */\n/* team-section   */\n/* team-section end*/\n/* accomplised-section   */\n/* accomplised-section  end */\n/* testimonial -section */\n/* testimonial-section  end */\n/* brand__section  */\n/* brand__section end */\n/* blog__section  */\n/* blog__section end */\n/*** \n\n====================================================================\n                        Home-Page-Two\n====================================================================\n\n***/\n/** header-two **/\n/** header-two **/\n/** banner-section **/\n/* slider text animation */\n/* slider text animation end */\n/* accomplised-section */\n/* accomplised-section-end */\n/* brand-section */\n/* brand-section-end */\n/* progress-section */\n/* progress-section-end */\n/* about-section */\n/* about-section-end */\n/* service__two-section */\n/* service__two-section-end */\n/* choose___two-section-end */\n/* choose___two-section-end */\n/* price-section */\n/* price-section-end */\n/* portfolio-section */\n/* portfolio-section-end */\n/* portfolio-section-end */\n/* portfolio-section-end */\n/* About Page */\n/* About Page End*/\n/* Service Page */\n/* Service Page End*/\n/* testimonial page */\n/* testimonial page end */\n/* blog-details */\n/* blog-details end */\n/* contact page */\n/* contact page */\n/* service page */\n/* service page */\n/* brand new */\n@keyframes aspro-scroller {\n  0% {\n    transform: translate(0, 0);\n  }\n  100% {\n    transform: translate(-100%, 0);\n  }\n}\n@keyframes aspro-scroller-reverse {\n  0% {\n    transform: translate(0, 0);\n  }\n  100% {\n    transform: translate(100%, 0);\n  }\n}\n/* brand new end */\n/*** \n\n====================================================================\n                        Home-Page-Three\n====================================================================\n\n***/\n/* header__three */\n/* header__three end */\n/* about__three  */\n/* about__three end */\n/* banner__three */\n/* banner__three end*/\n/* choose__three */\n/* choose__three end*/\n/* portfolio three */\n/* portfolio three end*/\n/* accomplised */\n/* accomplised end */\n/* consultation  */\n/* consultation end */\n/*** \n\n====================================================================\n                        Service Details\n====================================================================\n\n***/\n/*** \n\n====================================================================\n                        404 Page\n====================================================================\n\n***/\n/*** \n\n====================================================================\n                        Project Details\n====================================================================\n\n***/\n.circle-main {\n  text-align: center;\n  height: 230px;\n  width: 230px;\n  display: block;\n  background: #f6ec4f;\n  border-radius: 50%;\n  position: relative;\n  .circle {\n    h1 {\n      font-size: 100px;\n      font-weight: 600;\n      line-height: 1.8em;\n      padding-top: 20px;\n      color: $color_1;\n    }\n    img {\n      position: absolute;\n      left: 50%;\n      top: 50%;\n      transform: translate(-50%, -50%);\n    }\n  }\n  &:before {\n    content: \"\";\n    position: absolute;\n    height: 210px;\n    width: 210px;\n    border-radius: 50%;\n    border: 1px dashed #00061a;\n    top: 10px;\n    right: 10px;\n  }\n}\n.round-text {\n  position: relative;\n  width: 200px;\n  height: 200px;\n  border-radius: 50%;\n  .text_1 {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    animation: anim 20s linear infinite;\n    top: 14px;\n    right: -14px;\n  }\n}\n.text_1 {\n  span {\n    position: absolute;\n    left: 50%;\n    transform-origin: 0 100px;\n  }\n  .text_2 {\n    font-size: 16px;\n    font-weight: 400;\n    text-transform: uppercase;\n    color: $color_1;\n  }\n}\n.banner__one {\n  .banner__bg {\n    left: 0;\n    top: -14px;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    background-repeat: no-repeat;\n    will-change: border-radius, transform, opacity;\n    animation: heroShapeFour 3s linear infinite;\n  }\n}\n.banner__right {\n  figure.image-box {\n    img {\n      border-radius: 20px 20px 213px 213px;\n    }\n  }\n}\n.icon__image__banner {\n  position: absolute;\n  left: -109px;\n  bottom: -61px;\n}\n.banner__title {\n  h1 {\n    color: $color_2;\n    font-family: $font-family_1;\n    font-size: 80px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 90px;\n    padding: 20px 0px;\n    span {\n      font-weight: 400;\n    }\n  }\n}\n.text {\n  p {\n    padding: 0px 31px 30px 0px;\n  }\n}\n.btn-box {\n  display: flex;\n}\n.banner__left {\n  padding-top: 26px;\n}\n.banner__icon {\n  background-repeat: no-repeat;\n  right: 0;\n  top: 22px;\n  width: 370px;\n  height: 469px;\n}\n.banner__data {\n  padding: 90px 0px 140px;\n  &:before {\n    content: \"\";\n    border-radius: 679.189px;\n    background: linear-gradient(\n      192deg,\n      rgba(246, 236, 79, 0.32) 0%,\n      rgba(150, 6, 147, 0.6) 100%\n    );\n    filter: blur(150px);\n    width: 460.256px;\n    height: 679.189px;\n    transform: rotate(21.269deg);\n    flex-shrink: 0;\n    position: absolute;\n    z-index: -1;\n    left: 40%;\n  }\n}\nsection.banner__one {\n  overflow: hidden;\n}\n.product__block__wrapper {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 40px;\n  flex-wrap: wrap;\n  height: max-content;\n  padding-bottom: 10px;\n}\n.new__service__block__wrapper {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 30px;\n  flex-wrap: wrap;\n  height: max-content;\n  padding: 0;\n}\n.product__block {\n  width: 200px;\n  height: max-content;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n\n  cursor: pointer;\n  &:hover {\n    .product__text {\n      h4 {\n        color: $primary_color;\n      }\n    }\n  }\n}\n.product__icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 200px;\n  height: 220px;\n  background: linear-gradient(192deg, $primary_color 0%, $shade_color 100%);\n  clip-path: polygon(50% 0, 100% 27%, 100% 73%, 50% 100%, 0 73%, 0 27%);\n  i {\n    width: 200px;\n    height: 220px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-style: normal;\n    font-size: 100px;\n    font-weight: 500;\n    color: $color_2;\n  }\n  img {\n    width: 150px;\n    padding: 40px 32px;\n    margin: 0 auto;\n    font-size: 50px;\n    position: relative;\n    z-index: 1;\n  }\n}\n.product__text {\n  button h4 {\n    color: $color_2;\n  }\n}\n.industry__block__wrapper {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 30px;\n  flex-wrap: wrap;\n  height: max-content;\n  padding-bottom: 10px;\n}\n.industry__block {\n  width: 200px;\n  height: max-content;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n  cursor: pointer;\n  &:hover {\n    .industry__text {\n      h4 {\n        color: $primary_color;\n      }\n    }\n  }\n}\n.industry__icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100px;\n  height: 110px;\n  background: linear-gradient(192deg, $primary_color 0%, $shade_color 100%);\n  clip-path: polygon(50% 0, 100% 27%, 100% 73%, 50% 100%, 0 73%, 0 27%);\n  i {\n    width: 100px;\n    height: 110px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-style: normal;\n    font-size: 60px;\n    font-weight: 500;\n    color: $color_2;\n  }\n  img {\n    width: 150px;\n    padding: 40px 32px;\n    margin: 0 auto;\n    font-size: 50px;\n    position: relative;\n    z-index: 1;\n  }\n}\n.industry__text {\n  button h4 {\n    color: $color_2;\n  }\n}\n.service__block {\n  position: relative;\n  padding: 36px 42px;\n  text-align: center;\n  border-bottom: none;\n  &:hover {\n    .service__icon__two {\n      &:after {\n        background: $primary_color;\n      }\n      &:before {\n        background: $primary_color;\n      }\n    }\n    .service__button {\n      a {\n        transform: scale(1.1);\n        color: $color_3;\n      }\n    }\n  }\n  // &:before {\n  // \tcontent: \"\";\n  // \tposition: absolute;\n  // \tinset: 0;\n  // \tpadding: 1px 1px 0px;\n  // \tborder-radius: 194.5px 194.5px 0px 0px;\n  // \tbackground: linear-gradient(180deg, $primary_color, $color_1);\n  // \t-webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);\n  // \t-webkit-mask-composite: xor;\n  // \tmask-composite: exclude;\n  // }\n}\n.service__icon {\n  i {\n    width: 110px;\n    height: 126px;\n    background: linear-gradient(192deg, $primary_color 0%, $shade_color 100%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0 auto;\n    font-size: 50px;\n    clip-path: polygon(50% 0, 100% 27%, 100% 73%, 50% 100%, 0 73%, 0 27%);\n    position: relative;\n    margin-top: 10px;\n    z-index: 1;\n  }\n  img {\n    // width: 110px;\n    // height: 126px;\n    padding: 40px 32px;\n    background: linear-gradient(192deg, $primary_color 0%, $shade_color 100%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0 auto;\n    font-size: 50px;\n    clip-path: polygon(50% 0, 100% 27%, 100% 73%, 50% 100%, 0 73%, 0 27%);\n    position: relative;\n    // margin-top: 10px;\n    z-index: 1;\n  }\n  &:before {\n    content: \"\";\n    width: 110px;\n    height: 126px;\n    position: absolute;\n    background: rgba(128, 5, 153, 0.3);\n    top: -11px;\n    left: 50%;\n    z-index: -1;\n    clip-path: polygon(50% 0, 100% 27%, 100% 73%, 50% 100%, 0 73%, 0 27%);\n    transform: translate(-50%, 0%);\n  }\n  position: relative;\n  padding-bottom: 70px;\n}\n.service__icon__two {\n  &:after {\n    width: 15px;\n    content: \"\";\n    height: 18px;\n    background: #800599;\n    clip-path: polygon(50% 0, 100% 25%, 100% 85%, 50% 100%, 0 85%, 0 25%);\n    margin: 0 auto;\n    position: absolute;\n    left: 50%;\n    transform: translate(-50%, 0%);\n    bottom: 20px;\n    transition: all 500ms ease;\n  }\n  &:before {\n    content: \"\";\n    width: 1px;\n    height: 34px;\n    background: rgba(255, 255, 255, 0.2);\n    position: absolute;\n    bottom: 37px;\n    left: 50%;\n    transform: translate(-50%, 0%);\n    transition: all 500ms ease;\n  }\n}\n.service__button {\n  a {\n    width: 40px;\n    height: 40px;\n    background: $primary_color;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    transform: scale(0);\n    transition: all 500ms ease;\n  }\n  position: absolute;\n  left: 50%;\n  bottom: 28px;\n  transform: translate(-50%, 0%);\n}\n.service__data {\n  // border: 1px solid;\n  border-radius: 5px;\n  background: #060e26;\n  padding: 56px;\n  // border-image: linear-gradient(180deg, #ff8c2e, #00061A) 1;\n}\n.funfact__content.about {\n  background-repeat: no-repeat;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: 196px;\n  height: 201px;\n  padding: 66px 36px 40px;\n  h1.count-text {\n    color: $color_1;\n    font-size: 40px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 50px;\n  }\n  .count-outer.count-box.counted {\n    span {\n      color: $color_1;\n      font-size: 38px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: 49px;\n    }\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  p {\n    color: $color_1;\n  }\n}\n.title.two {\n  h2 {\n    span {\n      color: $color_4;\n    }\n  }\n}\n.about__text__block {\n  .texts {\n    padding: 35px 0px;\n  }\n}\n.boild__text {\n  h1 {\n    font-family: $font-family_2;\n    font-size: 300px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    text-transform: uppercase;\n    position: absolute;\n    left: 50%;\n    -webkit-text-stroke-width: 1px;\n    -webkit-text-stroke-color: #00061a;\n    color: $color_5;\n    top: 50%;\n    margin-top: -17px;\n    transform: translate(-50%, -50%);\n    text-align: center;\n    width: 100%;\n  }\n}\n.about__section {\n  .pattern-2 {\n    left: 0;\n    width: 299px;\n    height: 300px;\n    background-repeat: no-repeat;\n    top: -90px;\n  }\n  &:before {\n    content: \"\";\n    width: 412.862px;\n    height: 609.251px;\n    transform: rotate(21.269deg);\n    position: absolute;\n    border-radius: 609.251px;\n    background: linear-gradient(\n      192deg,\n      rgba(246, 236, 79, 0.21) 0%,\n      rgba(150, 6, 147, 0.4) 100%\n    );\n    filter: blur(150px);\n    left: 50%;\n    transform: translate(-50%, 0%);\n    bottom: 0;\n  }\n}\n.choose__us__data {\n  &:before {\n    content: \"\";\n    background: #00061a;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    left: 300px;\n    top: 0;\n  }\n  padding: 100px 0px;\n}\n.choose__us {\n  &:before {\n    content: \"\";\n    width: 574.366px;\n    height: 847.578px;\n    transform: rotate(21.269deg);\n    border-radius: 847.578px;\n    background: linear-gradient(\n      192deg,\n      rgba(246, 236, 79, 0.21) 0%,\n      rgba(150, 6, 147, 0.4) 100%\n    );\n    filter: blur(150px);\n    position: absolute;\n    left: 80px;\n    bottom: -325px;\n  }\n}\n.choose__block {\n  position: relative;\n  padding-top: 130px;\n  &:before {\n    content: \"\";\n    width: 349.864px;\n    height: 516.286px;\n    transform: rotate(21.269deg);\n    border-radius: 516.286px;\n    background: linear-gradient(\n      192deg,\n      rgba(246, 236, 79, 0.32) 0%,\n      rgba(150, 6, 147, 0.6) 100%\n    );\n    filter: blur(150px);\n    position: absolute;\n    left: 0;\n  }\n}\n.team__data {\n  display: flex;\n  gap: 30px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.15);\n  padding: 30px 0px;\n  &:nth-child(2) {\n    padding-top: 0px;\n  }\n  &:nth-child(4) {\n    padding-bottom: 0;\n    border-bottom: none;\n  }\n}\n.team__data__left {\n  img {\n    width: 80px;\n    padding-top: 8px;\n  }\n}\n.team__data__right {\n  h3 {\n    font-size: 26px;\n    line-height: 36px;\n    padding-bottom: 10px;\n  }\n}\n.team__img {\n  img {\n    width: 100%;\n    clip-path: polygon(50% 0, 100% 25%, 100% 75%, 50% 100%, 0 75%, 0 25%);\n  }\n  position: relative;\n  &:before {\n    content: \"\";\n    background: rgba(128, 5, 153, 0.3);\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    left: 0;\n    clip-path: polygon(50% 0, 100% 25%, 100% 75%, 50% 100%, 0 75%, 0 25%);\n    transition: all 500ms ease;\n    top: -30px;\n  }\n}\n.team__block {\n  &:hover {\n    .team__img {\n      &:before {\n        background: $primary_color;\n        opacity: 0.3;\n      }\n    }\n  }\n  text-align: center;\n}\n.team__name {\n  padding: 20px 0px 10px;\n}\n.team__media {\n  ul {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    a {\n      color: $color_6;\n      font-weight: 600;\n      font-size: 20px;\n      font-family: $font-family_2;\n      line-height: 30px;\n      &:hover {\n        color: $primary_color;\n      }\n    }\n  }\n}\n.team__section {\n  .pattern-3 {\n    width: 100%;\n    height: 100%;\n    left: 0;\n    top: 0;\n    z-index: -1;\n    background-repeat: no-repeat;\n  }\n  &:before {\n    content: \"\";\n    width: 574.366px;\n    height: 847.578px;\n    transform: rotate(21.269deg);\n    border-radius: 847.578px;\n    background: linear-gradient(\n      192deg,\n      rgba(246, 236, 79, 0.21) 0%,\n      rgba(150, 6, 147, 0.4) 100%\n    );\n    filter: blur(150px);\n    position: absolute;\n    right: -44px;\n    top: -200px;\n  }\n  &:after {\n    content: \"\";\n    width: 358.308px;\n    height: 528.747px;\n    transform: rotate(21.269deg);\n    border-radius: 528.747px;\n    background: linear-gradient(\n      192deg,\n      rgba(246, 236, 79, 0.26) 0%,\n      rgba(150, 6, 147, 0.5) 100%\n    );\n    filter: blur(150px);\n    position: absolute;\n    bottom: -30px;\n    left: 5%;\n    z-index: -1;\n  }\n}\n.accomplised__section {\n  padding-top: 140px;\n}\n.accomplised__data {\n  border-radius: 10px;\n  background: #060e26;\n  padding: 120px 90px 120px 70px;\n  .pattern-4 {\n    width: 100%;\n    height: 100%;\n    top: 0;\n    background-repeat: no-repeat;\n    left: 15%;\n  }\n  &:before {\n    width: 358.308px;\n    height: 528.747px;\n    transform: rotate(21.269deg);\n    border-radius: 528.747px;\n    background: linear-gradient(\n      192deg,\n      rgba(246, 236, 79, 0.16) 0%,\n      rgba(150, 6, 147, 0.3) 100%\n    );\n    filter: blur(150px);\n    content: \"\";\n    position: absolute;\n    left: 50%;\n    transform: translate(-50%, 0%);\n    bottom: -100px;\n  }\n}\n.funfact__data {\n  .count-outer {\n    span {\n      color: $color_2;\n      font-family: $font-family_2;\n      font-size: 32px;\n      font-style: normal;\n      font-weight: 300;\n      line-height: 42px;\n    }\n    h1.count-text {\n      color: $color_2;\n      font-family: $font-family_2;\n      font-size: 40px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 42px;\n    }\n    span.two {\n      font-weight: 600 !important;\n    }\n  }\n  .funfact__content {\n    width: 150px;\n    height: 170px;\n    text-align: center;\n    clip-path: polygon(50% 0, 100% 27%, 100% 73%, 50% 100%, 0 73%, 0 27%);\n    padding: 45px 27px;\n    .count-outer {\n      display: flex;\n    }\n    p {\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 18px;\n    }\n  }\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  gap: 27px;\n}\n.funfact__content.one {\n  background: #ff0e75;\n}\n.funfact__content.two {\n  background: linear-gradient(\n    192deg,\n    rgba(246, 236, 79, 0.32) 0%,\n    rgba(150, 6, 147, 0.6) 100%\n  );\n}\n.funfact__content.three {\n  background: #800599;\n  margin-top: -48px;\n}\n.vision_mission_wrapper {\n  margin: 80px auto;\n  gap: 96px;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n}\n.core_value_wrapper {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  gap: 27px;\n  width: 100%;\n}\n.core_value_content {\n  width: 200px;\n  height: 220px;\n  text-align: center;\n  clip-path: polygon(50% 0, 100% 27%, 100% 73%, 50% 100%, 0 73%, 0 27%);\n  padding: 45px 27px;\n  p {\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 18px;\n  }\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n.core_value_content.one {\n  background: linear-gradient(\n    192deg,\n    $primary_color 0%,\n    rgba(150, 6, 147, 0.6) 100%\n  );\n}\n.core_value_content.two {\n  background: linear-gradient(192deg, #ffc34e 0%, rgba(150, 6, 147, 0.6) 100%);\n}\n.core_value_content.remove_gap_core_value_1,\n.core_value_content.remove_gap_core_value_2 {\n  margin-top: -65px;\n}\n.partner_client_item_wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 24px;\n  h6 {\n    text-align: center;\n  }\n  .img__box {\n    display: flex;\n    flex-shrink: 0;\n  }\n}\n.swiper__button {\n  .button_prev {\n    background: #fff;\n    width: 40px;\n    height: 40px;\n    color: $color_8;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 50%;\n    cursor: pointer;\n    position: relative;\n    overflow: hidden;\n    &:before {\n      content: \"\";\n      background: #f6ec4f;\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      display: inline-block;\n      border-radius: 50%;\n      transform: scale(0);\n      transition: all 500ms ease;\n    }\n    &:hover {\n      &:before {\n        transform: scale(1.1);\n      }\n    }\n  }\n  .button_next {\n    background: #fff;\n    width: 40px;\n    height: 40px;\n    color: $color_8;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 50%;\n    cursor: pointer;\n    position: relative;\n    overflow: hidden;\n    &:before {\n      content: \"\";\n      background: #f6ec4f;\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      display: inline-block;\n      border-radius: 50%;\n      transform: scale(0);\n      transition: all 500ms ease;\n    }\n    &:hover {\n      &:before {\n        transform: scale(1.1);\n      }\n    }\n  }\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  padding-bottom: 20px;\n  i {\n    position: relative;\n  }\n}\n.testimonial__top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.testimonials__info {\n  background: rgba(6, 14, 38, 1);\n  text-align: center;\n  padding: 40px 49px 80px;\n  clip-path: polygon(50% 0, 100% 25%, 100% 75%, 50% 100%, 0 75%, 0 25%);\n}\n.testimonial__section {\n  padding-bottom: 55px;\n  &:before {\n    content: \"\";\n    width: 790px;\n    height: 790px;\n    position: absolute;\n    border-radius: 50%;\n    background: linear-gradient(\n      192deg,\n      rgba(246, 236, 79, 0.32) 0%,\n      rgba(150, 6, 147, 0.6) 100%\n    );\n    filter: blur(300px);\n    left: 50%;\n    transform: translate(-50%, 0%);\n  }\n  .swiper-wrapper {\n    > * {\n      &:nth-child(even) {\n        margin-top: 200px;\n      }\n    }\n  }\n}\n.authore__rating {\n  ul {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 5px;\n    padding: 15px 0px 5px;\n    li {\n      color: $color_9;\n    }\n  }\n}\n.authore__info {\n  h5 {\n    color: $color_2;\n    text-align: center;\n    font-size: 26px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 36px;\n  }\n  p {\n    color: $color_10;\n    text-align: center;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 29px;\n  }\n}\n.testimonials__block__one {\n  .quote {\n    position: absolute;\n    bottom: 11px;\n    left: 50%;\n    width: 53px;\n    height: 62px;\n    transform: translate(-50%, 0%);\n    background: #666;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    clip-path: polygon(50% 0, 100% 27%, 100% 73%, 50% 100%, 0 73%, 0 27%);\n    transition: all 500ms ease;\n    span {\n      font-size: 25px;\n    }\n  }\n  &:hover {\n    .quote {\n      background: #f6ec4f;\n    }\n    .test__bg {\n      opacity: 1;\n    }\n  }\n  padding: 20px 20px;\n}\n.test__bg {\n  background: linear-gradient(\n    175deg,\n    rgba(246, 236, 79, 0.53) 0%,\n    rgba(150, 6, 147, 1) 100%\n  );\n  width: 400px;\n  height: 487px;\n  position: absolute;\n  left: 20px;\n  clip-path: polygon(50% 0, 100% 25%, 100% 75%, 50% 100%, 0 75%, 0 25%);\n  top: 20px;\n  transform: rotate(12deg);\n  opacity: 0;\n  transition: all 500ms ease;\n}\n.authore__img {\n  img {\n    width: 121px;\n    height: 138px;\n    clip-path: polygon(50% 0, 100% 25%, 100% 75%, 50% 100%, 0 75%, 0 25%);\n  }\n}\n.brand__section {\n  .owl-dots.disabled {\n    display: none;\n  }\n  .brand-carousel {\n    position: relative;\n    transform: rotate(-10deg);\n    padding: 35px 0px;\n    &:before {\n      content: \"\";\n      background: #f6ec4f;\n      position: absolute;\n      width: calc(100% - -5em);\n      height: 126px;\n      left: -3em;\n      top: 0px;\n    }\n  }\n  .pattern-3 {\n    width: 100%;\n    height: 100%;\n    left: 0;\n    top: 0;\n  }\n}\n.brand__content {\n  .brand__name {\n    h1 {\n      font-family: $font-family_2;\n      font-size: 50px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: normal;\n      letter-spacing: 5px;\n      text-transform: uppercase;\n      -webkit-text-stroke-width: 1px;\n      -webkit-text-stroke-color: #191f31;\n      color: $color_5;\n    }\n  }\n}\n.inner-box {\n  .image-box {\n    display: block;\n    overflow: hidden;\n    // background: linear-gradient(219deg, #FB0E76 0%, #910694 100%);\n    background: transparent;\n    border-radius: 5px 5px 0px 0px;\n    img {\n      width: 100%;\n      height: 400px;\n      transition: all 500ms ease;\n      object-fit: cover;\n    }\n  }\n  &:hover {\n    .image-box {\n      img {\n        transform: scale(1.05);\n        // opacity: 0.3;\n      }\n    }\n    .theme__btn__two {\n      i {\n        transform: rotate(0deg);\n      }\n    }\n    a.theme__btn__two {\n      // background: #800599;\n      background: linear-gradient(219deg, #ff8c2e 0%, #7e2100 100%);\n    }\n    div.theme__btn__two {\n      // background: #800599;\n      background: linear-gradient(219deg, #ff8c2e 0%, #7e2100 100%);\n    }\n  }\n}\n//\n.post__date {\n  position: absolute;\n  bottom: 0px;\n  width: 100%;\n  ul {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    padding: 20px 30px;\n    // margin: 0px 30px;\n    border-radius: 5px 5px 0px 0px;\n    background: #060e26;\n    li {\n      i {\n        width: 29px;\n        height: 35px;\n        // background: #00061A;\n        background: linear-gradient(219deg, #ff8c2e 0%, #7e2100 100%);\n        display: flex;\n        font-size: 15px;\n        align-items: center;\n        justify-content: center;\n        clip-path: polygon(50% 0, 100% 27%, 100% 73%, 50% 100%, 0 73%, 0 27%);\n        transition: all 500ms ease;\n        color: $color_2;\n      }\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      color: $color_2;\n      font-size: 15px;\n    }\n    li.two {\n      width: 6px;\n      height: 6px;\n      background: linear-gradient(219deg, #ff8c2e 0%, #7e2100 100%);\n      border-radius: 50%;\n    }\n  }\n}\n.detail__post__date {\n  position: absolute;\n  bottom: 0px;\n  width: 100%;\n  ul {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 24px;\n    padding: 20px 30px;\n    border-radius: 5px 5px 0px 0px;\n    background: #060e26;\n    li {\n      i {\n        width: 29px;\n        height: 35px;\n        background: linear-gradient(219deg, #ff8c2e 0%, #7e2100 100%);\n        display: flex;\n        font-size: 15px;\n        align-items: center;\n        justify-content: center;\n        clip-path: polygon(50% 0, 100% 27%, 100% 73%, 50% 100%, 0 73%, 0 27%);\n        transition: all 500ms ease;\n        color: $color_2;\n      }\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      color: $color_2;\n      font-size: 15px;\n    }\n    li.two {\n      width: 6px;\n      height: 6px;\n      background: linear-gradient(219deg, #ff8c2e 0%, #7e2100 100%);\n      border-radius: 50%;\n    }\n  }\n}\n.lower___content {\n  h4 {\n    margin-bottom: 12px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    text-align: start;\n  }\n  p {\n    margin-bottom: 20px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    -webkit-box-orient: vertical;\n    text-align: start;\n  }\n}\n.news___block {\n  .lower___content {\n    background: #060e26;\n    padding: 25px 30px 20px;\n  }\n  margin-bottom: 30px;\n  width: auto;\n  max-width: 400px;\n}\n.btn__box__two {\n  a.theme__btn__two {\n    width: 29px;\n    height: 35px;\n    // background: #FF0E75;\n    background: linear-gradient(219deg, #ff8c2e 0%, #7e2100 100%);\n    display: flex;\n    font-size: 15px;\n    align-items: center;\n    justify-content: center;\n    clip-path: polygon(50% 0, 100% 27%, 100% 73%, 50% 100%, 0 73%, 0 27%);\n    transition: all 500ms ease;\n    color: $color_2;\n    margin: 0 0 0 auto;\n    i {\n      transform: rotate(45deg);\n      transition: all 500ms ease;\n    }\n  }\n  div.theme__btn__two {\n    width: 29px;\n    height: 35px;\n    // background: #FF0E75;\n    background: linear-gradient(219deg, #ff8c2e 0%, #7e2100 100%);\n    display: flex;\n    font-size: 15px;\n    align-items: center;\n    justify-content: center;\n    clip-path: polygon(50% 0, 100% 27%, 100% 73%, 50% 100%, 0 73%, 0 27%);\n    transition: all 500ms ease;\n    color: $color_2;\n    margin: 0 0 0 auto;\n    i {\n      transform: rotate(45deg);\n      transition: all 500ms ease;\n    }\n  }\n}\n.blog__section {\n  &:before {\n    content: \"\";\n    width: 574.366px;\n    height: 847.578px;\n    border-radius: 847.578px;\n    background: linear-gradient(\n      192deg,\n      rgba(246, 236, 79, 0.21) 0%,\n      rgba(150, 6, 147, 0.4) 100%\n    );\n    filter: blur(150px);\n    position: absolute;\n    right: 0;\n    transform: rotate(21.269deg);\n    bottom: -300px;\n  }\n  .normaol__text {\n    padding-left: 65px;\n  }\n}\n.home__two {\n  background: #fff;\n  h1 {\n    color: $color_1;\n  }\n  h2 {\n    color: $color_1;\n  }\n}\n.footer-top.two {\n  .top-inner {\n    background: linear-gradient(238deg, #f6ec4f 0%, #00061a 100%) !important;\n  }\n}\n.blog__section.two {\n  .normaol__text {\n    p {\n      color: $color_10;\n    }\n  }\n}\n.accomplised__section__two {\n  h2 {\n    color: $color_2 !important;\n  }\n  .btn-box {\n    padding-left: 60px;\n  }\n  background: #060e26;\n}\n.main-header.two {\n  position: absolute;\n  top: 48px;\n  left: 0;\n  .header-lower {\n    .outer-box {\n      border-radius: 5px;\n      border: 1px solid rgba(255, 255, 255, 0.1);\n      background: #00061a;\n      padding: 0px 20px;\n    }\n  }\n  .outer-box {\n    .logo-box {\n      padding: 20px 0px;\n    }\n    .main-menu {\n      .navigation {\n        > li {\n          > a {\n            padding: 36px 0px;\n          }\n        }\n      }\n      .dropdown-btn {\n        top: 40px;\n      }\n    }\n  }\n}\n.slider-two {\n  position: relative;\n  overflow: hidden;\n  .pattern-1 {\n    width: 506px;\n    height: 469px;\n    left: 0;\n    bottom: 0;\n    background-repeat: no-repeat;\n    z-index: 1;\n  }\n}\n.banner-carousel {\n  .slide-item {\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: cover;\n  }\n  .content-box {\n    position: relative;\n    width: 100%;\n    h2 {\n      color: $color_2;\n      opacity: 0;\n      -webkit-transition: all 1000ms ease;\n      -moz-transition: all 1000ms ease;\n      -ms-transition: all 1000ms ease;\n      -o-transition: all 1000ms ease;\n      transition: all 1000ms ease;\n      transform: scaleX(0);\n    }\n    h4 {\n      color: $color_2;\n      opacity: 0;\n      -webkit-transition: all 1000ms ease;\n      -moz-transition: all 1000ms ease;\n      -ms-transition: all 1000ms ease;\n      -o-transition: all 1000ms ease;\n      transition: all 1000ms ease;\n      transform: scaleX(0);\n    }\n    p {\n      line-height: 28px;\n      color: $color_2;\n      opacity: 0;\n      -webkit-transform: translateY(100px);\n      -moz-transform: translateY(100px);\n      -ms-transform: translateY(100px);\n      -o-transform: translateY(100px);\n      transform: translateY(100px);\n      -webkit-transition: all 1000ms ease;\n      -moz-transition: all 1000ms ease;\n      -ms-transition: all 1000ms ease;\n      -o-transition: all 1000ms ease;\n      transition: all 1000ms ease;\n    }\n    .btn-box {\n      position: relative;\n      opacity: 0;\n      -webkit-transform: translateY(50px);\n      -moz-transform: translateY(50px);\n      -ms-transform: translateY(50px);\n      -o-transform: translateY(50px);\n      transform: translateY(50px);\n      -webkit-transition: all 1000ms ease;\n      -moz-transition: all 1000ms ease;\n      -ms-transition: all 1000ms ease;\n      -o-transition: all 1000ms ease;\n      transition: all 1000ms ease;\n    }\n  }\n  .active {\n    .content-box {\n      h2 {\n        opacity: 1;\n        transform: scaleX(1);\n      }\n      h4 {\n        opacity: 1;\n        transform: scaleX(1);\n      }\n      p {\n        opacity: 1;\n        -webkit-transform: translateY(0);\n        -moz-transform: translateY(0);\n        -ms-transform: translateY(0);\n        -o-transform: translateY(0);\n        transform: translateY(0);\n        -webkit-transition-delay: 1000ms;\n        -moz-transition-delay: 1000ms;\n        -ms-transition-delay: 1000ms;\n        -o-transition-delay: 1000ms;\n        transition-delay: 1000ms;\n      }\n      .btn-box {\n        opacity: 1;\n        -webkit-transform: translateY(0);\n        -moz-transform: translateY(0);\n        -ms-transform: translateY(0);\n        -o-transform: translateY(0);\n        transform: translateY(0);\n        -webkit-transition-delay: 1300ms;\n        -moz-transition-delay: 1300ms;\n        -ms-transition-delay: 1300ms;\n        -o-transition-delay: 1300ms;\n        transition-delay: 1300ms;\n      }\n    }\n  }\n}\n.banner__two {\n  .image-layer {\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: cover;\n  }\n  .content-box {\n    padding-bottom: 83px;\n    h2 {\n      font-family: $font-family_1;\n      font-size: 80px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: 90px;\n    }\n    p {\n      padding-bottom: 40px;\n      padding-right: 30px;\n    }\n  }\n}\nsection.banner__two {\n  padding-top: 313px;\n  &:before {\n    content: \"\";\n    width: 460.256px;\n    height: 679.189px;\n    transform: rotate(21.269deg);\n    position: absolute;\n    border-radius: 679.189px;\n    background: linear-gradient(\n      192deg,\n      rgba(246, 236, 79, 0.32) 0%,\n      rgba(150, 6, 147, 0.6) 100%\n    );\n    filter: blur(150px);\n    left: 0;\n    top: -100px;\n    z-index: 1;\n  }\n}\n.mission__block {\n  padding: 50px 60px;\n  border-right: 1px solid rgba(255, 255, 255, 0.1);\n}\n.banner__mission__block {\n  border-radius: 10px 0px 0px 0px;\n  background: rgba(255, 255, 255, 0.05);\n  backdrop-filter: blur(15px);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.slider-text-anim.title__last {\n  font-weight: 400;\n  letter-spacing: 16px;\n  span {\n    color: $color_7;\n  }\n}\n.slider-text-anim {\n  display: inline-block;\n  overflow: hidden;\n  position: relative;\n  padding-bottom: 5px;\n  &:before {\n    content: \"\";\n    width: 101%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 100%;\n    background: #fff;\n    -webkit-transition: 1s cubic-bezier(0.858, 0.01, 0.068, 0.99);\n    -o-transition: 1s cubic-bezier(0.858, 0.01, 0.068, 0.99);\n    transition: 1s cubic-bezier(0.858, 0.01, 0.068, 0.99);\n    z-index: 3;\n    -webkit-transform: translateX(-100%);\n    -ms-transform: translateX(-100%);\n    transform: translateX(-100%);\n    -webkit-transition-delay: 1s;\n    -o-transition-delay: 1s;\n    transition-delay: 1s;\n  }\n}\n.slider-text-anim.black-bg {\n  &:before {\n    background: #222;\n  }\n}\n.active {\n  .slider-text-anim {\n    &:before {\n      -webkit-transform: translateX(1%);\n      -ms-transform: translateX(1%);\n      transform: translateX(1%);\n    }\n  }\n}\n.slider-text-anim.two {\n  &:before {\n    background: #f6ec4f;\n  }\n}\n.accomplised__data.two {\n  padding: 0px 90px 0px 70px;\n  background: inherit;\n}\n.brand__section_two {\n  .brand__content {\n    .brand__name {\n      h1 {\n        font-size: 60px;\n      }\n    }\n  }\n  padding-bottom: 100px;\n  margin: 0px 20px;\n}\n.progress-box {\n  .bar-inner {\n    background: #f6ec4f;\n    position: relative;\n    display: block;\n    width: 0px;\n    height: 6px;\n    -webkit-transition: all 1500ms ease;\n    -ms-transition: all 1500ms ease;\n    -o-transition: all 1500ms ease;\n    -moz-transition: all 1500ms ease;\n    transition: all 1500ms ease;\n    &:before {\n      content: \"\";\n      width: 5px;\n      height: 9px;\n      background: #f6ec4f;\n      position: absolute;\n      top: 50%;\n      transform: translate(0%, -50%);\n      right: 0;\n    }\n  }\n  .bar {\n    position: relative;\n    width: 100%;\n    height: 6px;\n    background: #ebebeb;\n    margin-bottom: 30px;\n  }\n}\n.about__two__img__block {\n  .about__two__circle {\n    position: absolute;\n    top: 0px;\n    right: -20px;\n  }\n  padding-top: 60px;\n}\n.about__two__circle {\n  .circle-main {\n    width: 182px;\n    height: 182px;\n    &:before {\n      height: 166px;\n      width: 166px;\n      top: 8px;\n      right: 8px;\n    }\n    .round-text {\n      width: 156px;\n      height: 156px;\n      .text_1 {\n        top: 12px;\n        right: -12px;\n        span {\n          transform-origin: 0 80px;\n        }\n      }\n    }\n    .circle {\n      height: 100px;\n    }\n  }\n  .pattern-2 {\n    width: 58.18px;\n    height: 313.33px;\n    right: 36px;\n    top: 157px;\n  }\n}\n.about__text__two {\n  h4 {\n    color: $color_1;\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    letter-spacing: 2.88px;\n    span {\n      color: $color_7;\n    }\n  }\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  padding-top: 20px;\n  justify-content: center;\n  img {\n    width: 25px;\n  }\n}\n.about___two {\n  .about__text__block {\n    .texts {\n      p {\n        color: $color_10;\n      }\n      padding: 25px 0px;\n    }\n  }\n  .pattern-1 {\n    width: 486px;\n    height: 486px;\n    left: 0;\n    bottom: 0;\n    background-repeat: no-repeat;\n  }\n}\n.content_block_three {\n  h6 {\n    color: $color_1;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    padding-bottom: 22px;\n  }\n}\n.service__two {\n  background: #00061a;\n  .pattern-1 {\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 30%;\n    background-repeat: no-repeat;\n  }\n  .pattern-2 {\n    width: 100%;\n    height: 100%;\n    left: 40%;\n    top: 0;\n    background-repeat: no-repeat;\n  }\n  &:before {\n    content: \"\";\n    width: 392.703px;\n    height: 579.502px;\n    border-radius: 579.502px;\n    background: linear-gradient(\n      192deg,\n      rgba(246, 236, 79, 0.26) 0%,\n      rgba(150, 6, 147, 0.5) 100%\n    );\n    filter: blur(150px);\n    left: 50%;\n    bottom: 0;\n    z-index: 1;\n    position: absolute;\n    transform: translate(-50%, 0%);\n  }\n}\n.service__block__two {\n  padding: 163px 80px 50px;\n  overflow: hidden;\n  .service__image {\n    position: absolute;\n    top: 0;\n    left: 0;\n    transform: translateX(1000px);\n    opacity: 0;\n    transition: all 500ms ease;\n    background-repeat: no-repeat;\n    background-size: cover;\n    width: 100%;\n    height: 100%;\n  }\n  &:hover {\n    .service__image {\n      opacity: 1;\n      transform: translate(0px);\n    }\n  }\n  .service__icon {\n    padding-bottom: 22px;\n    &:before {\n      left: 0%;\n      transform: translate(0%, 0%);\n    }\n    i {\n      margin: 0;\n    }\n  }\n  .service__text {\n    p {\n      padding: 20px 0px 160px;\n    }\n  }\n}\n.service__number {\n  h1 {\n    color: $color_11 !important;\n    font-size: 100px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 90px;\n    position: absolute;\n    top: -70px;\n    left: -4px;\n  }\n}\n.service__button__two {\n  a {\n    color: $color_4;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 800;\n    line-height: 29px;\n    letter-spacing: 3.2px;\n    text-transform: uppercase;\n    &:hover {\n      letter-spacing: 4.2px;\n      color: $color_7;\n    }\n  }\n  position: relative;\n}\n.choose__text__block {\n  padding-top: 130px;\n  .normal__text {\n    p {\n      color: $color_10;\n    }\n    padding: 20px 0px 43px;\n    border-bottom: 1px solid rgba(128, 5, 153, 0.4);\n    position: relative;\n    &:before {\n      content: \"\";\n      background: #f6ec4f;\n      position: absolute;\n      width: 14px;\n      height: 15px;\n      left: 0;\n      bottom: -8px;\n      clip-path: polygon(50% 0, 100% 25%, 100% 75%, 50% 100%, 0 75%, 0 25%);\n    }\n    &:after {\n      content: \"\";\n      background: #f6ec4f;\n      position: absolute;\n      width: 14px;\n      height: 15px;\n      left: 50%;\n      bottom: -8px;\n      clip-path: polygon(50% 0, 100% 25%, 100% 75%, 50% 100%, 0 75%, 0 25%);\n      transform: translate(-50%, 0%);\n    }\n  }\n}\n.customaize__solution {\n  h5 {\n    color: $color_1;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 36px;\n  }\n  p {\n    color: $color_1;\n  }\n  display: flex;\n  align-items: center;\n  gap: 32px;\n  padding-top: 23px;\n}\n.choose_img__block {\n  img {\n    clip-path: polygon(50% 0, 100% 25%, 100% 75%, 50% 100%, 0 75%, 0 25%);\n  }\n}\n.choose___two {\n  .pattern-1 {\n    width: 433px;\n    height: 526px;\n    top: 140px;\n    right: 0px;\n  }\n}\n.choose_img__two {\n  .pattern-3 {\n    width: 268px;\n    height: 216px;\n    z-index: 1;\n    right: 10px;\n    top: 0;\n  }\n  .pattern-4 {\n    width: 275px;\n    height: 222px;\n    z-index: 1;\n    bottom: 0;\n    left: 0;\n  }\n}\n.price__block {\n  background: rgba(6, 14, 38, 1);\n  text-align: center;\n  padding: 180px 0px 18px;\n  margin-top: 50px;\n  clip-path: polygon(50% 0, 100% 25%, 100% 75%, 50% 100%, 0 75%, 0 25%);\n}\n.price__data {\n  background: #f6ec4f;\n  width: 183px;\n  height: 203px;\n  position: absolute;\n  top: -50px;\n  padding: 60px 25px;\n  left: 50%;\n  transform: translate(-50%, 0%);\n  clip-path: polygon(50% 0, 100% 25%, 100% 75%, 50% 100%, 0 75%, 0 25%);\n  z-index: 1;\n  text-align: center;\n  transition: all 500ms ease;\n  h5 {\n    color: $color_1;\n    font-size: 26px;\n    font-style: normal;\n    font-weight: 500;\n    text-align: center;\n    transition: all 500ms ease;\n  }\n  h4 {\n    font-size: 32px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 42px;\n    color: $color_1;\n    transition: all 500ms ease;\n    span {\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n    }\n  }\n}\n.price__list {\n  li {\n    padding-bottom: 18px;\n    &:last-child {\n      padding-bottom: 50px;\n    }\n  }\n}\n.price__icon {\n  background: #800599;\n  width: 40px;\n  height: 49px;\n  position: absolute;\n  left: 50%;\n  transform: translate(-50%, 0%);\n  bottom: -23px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  clip-path: polygon(50% 0, 100% 25%, 100% 75%, 50% 100%, 0 75%, 0 25%);\n  transition: all 500ms ease;\n}\n.price__content {\n  &:hover {\n    .price__data {\n      background: #800599;\n      h5 {\n        color: $color_2;\n      }\n      h4 {\n        color: $color_2;\n      }\n    }\n    .price__icon {\n      background: #f6ec4f;\n      color: $color_8;\n    }\n  }\n}\n.pricing__section {\n  .pattern-1 {\n    width: 100%;\n    height: 900px;\n    background-repeat: no-repeat;\n    top: 0;\n  }\n  .pattern-4 {\n    width: 100%;\n    height: 100%;\n    top: 0;\n    background-repeat: no-repeat;\n    left: 20%;\n  }\n}\n.portfolio-layer {\n  width: 100%;\n  height: 100%;\n  top: 0;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n.portfolio {\n  padding: 119px 0px 0px;\n  h2 {\n    color: $color_2 !important;\n  }\n}\n.protfolio__inner {\n  position: relative;\n  margin-right: -445px;\n  overflow: hidden;\n}\n.portfolio__block {\n  .lower__content {\n    background: linear-gradient(\n      180deg,\n      rgba(255, 14, 117, 0.6) 0%,\n      rgba(146, 6, 148, 0.6) 100%\n    );\n    width: 100%;\n    height: 100%;\n    z-index: 1;\n    top: 0;\n    left: 0;\n    opacity: 0;\n    transition: all 500ms ease;\n    padding: 30px;\n    transform: translateX(-100%);\n  }\n  &:hover {\n    .lower__content {\n      transform: translateX(0%);\n      opacity: 1;\n    }\n  }\n  overflow: hidden;\n}\n.protfolio__text {\n  display: flex;\n  justify-content: space-between;\n}\n.text__block {\n  h4 {\n    font-weight: 600;\n  }\n}\n.text__block_two {\n  h5 {\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 28px;\n  }\n}\n.protfolio__button {\n  position: absolute;\n  bottom: 30px;\n  left: 30px;\n  width: 86%;\n  a.theme-btn.theme-btn-one {\n    background: #f6ec4f;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 29px;\n    color: $color_1 !important;\n    text-transform: capitalize;\n  }\n}\n.page__title {\n  margin-top: 30px;\n  padding: 232px 0px;\n  text-align: center;\n  .bg-layer {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    left: -1px;\n    top: 0;\n    background-repeat: no-repeat;\n    background-size: cover;\n  }\n  .title {\n    font-family: $font-family_1;\n    font-size: 80px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 90px;\n  }\n}\n.bread__crumb {\n  li {\n    text-align: center;\n    font-family: $font-family_1;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    letter-spacing: 2px;\n    color: $color_2;\n    text-transform: uppercase;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding-bottom: 24px;\n\n    button {\n      text-align: center;\n      font-family: $font-family_1;\n      font-size: 20px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: normal;\n      letter-spacing: 2px;\n      color: $color_2;\n      text-transform: uppercase;\n      display: flex;\n      align-items: center;\n      gap: 8px;\n\n      &:hover {\n        color: $primary_color !important;\n      }\n    }\n  }\n  display: flex;\n  justify-content: flex-start;\n  padding: 64px 0 0;\n  gap: 8px;\n  white-space: nowrap;\n  flex: 1;\n  overflow-y: auto;\n}\n.about__section.about__page {\n  .pattern-2 {\n    top: 0 !important;\n  }\n}\n.pride__layer {\n  width: 100%;\n  height: 100%;\n  background-repeat: no-repeat;\n  position: absolute;\n  top: 0;\n  background-size: cover;\n}\n.pride__block {\n  figure {\n    img {\n      position: relative;\n    }\n  }\n  text-align: center;\n  h1 {\n    font-size: 80px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 90px;\n    padding: 0px 175px;\n  }\n}\n.service__page {\n  .service__block {\n    margin-bottom: 20px;\n    &:before {\n      padding: 1px;\n    }\n  }\n}\n.project__page {\n  .portfolio__block {\n    margin-bottom: 24px;\n  }\n  margin: 0px 120px;\n  img {\n    width: 100%;\n  }\n}\n.team__page {\n  .team__block {\n    margin-bottom: 50px;\n  }\n}\n.testimonial___data {\n  .row {\n    > div {\n      &:nth-child(even) {\n        margin-top: 150px;\n      }\n    }\n  }\n}\n.testimonials__block__one.page {\n  padding: 0px 20px;\n  position: relative;\n  .testimonials__info {\n    background: transparent;\n    padding: 0px 49px 80px;\n  }\n  .quote {\n    bottom: -10px;\n  }\n}\n.blog__details__content {\n  .blog__image {\n    img {\n      width: 100%;\n      height: 720px;\n      border-radius: 5px 5px 0px 0px;\n    }\n  }\n  .post__date, .detail__post__date {\n    ul {\n      padding: 32px 40px;\n    }\n  }\n}\nh3.blog__title {\n  font-size: 26px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 36px;\n  padding-bottom: 24px;\n}\n.blog__inner__box {\n  // padding: 60px;\n  padding: 20px 40px 52px;\n  background: #060e26;\n}\n.blog__details__text {\n  p {\n    padding-bottom: 20px;\n    white-space: pre-wrap;\n  }\n  ul {\n    li {\n      list-style: disc;\n    }\n  }\n  a {\n    color: $primary_color;\n    text-decoration: underline;\n    transition: all 500ms ease;\n    -moz-transition: all 500ms ease;\n    -webkit-transition: all 500ms ease;\n    -ms-transition: all 500ms ease;\n    -o-transition: all 500ms ease;\n    &:hover {\n      color: $primary_color;\n      opacity: 0.9;\n      text-decoration: underline;\n      outline: none;\n    }\n  }\n}\n.blog__tags__box {\n  padding: 25px;\n  background: #060e26;\n  margin: 50px 0px;\n}\n.tags__left {\n  display: flex;\n  align-items: flex-start;\n  gap: 20px;\n  flex-direction: column;\n  h3 {\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 36px;\n  }\n}\n.tags-list-1 {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  flex-wrap: wrap;\n  li {\n    a {\n      color: $color_1;\n      background: $color_12;\n      padding: 8px;\n      border-radius: 4px;\n      text-transform: capitalize;\n    }\n  }\n}\n.blog__comments__area {\n  padding: 40px;\n  background: #060e26;\n}\nh3.comments__title {\n  font-size: 26px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 36px;\n  padding-bottom: 30px;\n}\n.comments__box {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-bottom: 60px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.15);\n  margin-top: 60px;\n  gap: 26px;\n  .image__box {\n    img {\n      width: 117px;\n      height: 117px;\n      border-radius: 50%;\n    }\n    flex-shrink: 0;\n    display: flex;\n  }\n  &:nth-last-child(-n + 2) {\n    border: none;\n  }\n}\n.comments__content {\n  .upper {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding-bottom: 20px;\n    h4 {\n      font-size: 20px;\n      font-style: normal;\n      font-weight: 400;\n    }\n    .reply-btn {\n      background: #ff0e75;\n      padding: 5px 20px;\n    }\n  }\n}\n.comments__form.contact__section {\n  padding: 40px;\n  background: #060e26;\n  margin-top: 60px;\n}\n.form__inner {\n  input {\n    border-radius: 5px;\n    border: 1px solid rgba(255, 255, 255, 0.15);\n    width: 100%;\n    color: $color_13;\n    font-family: $font-family_2;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n    letter-spacing: 2.4px;\n    // text-transform: uppercase;\n    padding: 22px;\n  }\n  textarea {\n    border-radius: 5px;\n    border: 1px solid rgba(255, 255, 255, 0.15);\n    width: 100%;\n    color: $color_13;\n    font-family: $font-family_2;\n    font-size: 12px;\n    font-style: normal;\n    height: 164px;\n    font-weight: 400;\n    line-height: 24px;\n    letter-spacing: 2.4px;\n    // text-transform: uppercase;\n    padding: 22px;\n  }\n}\n.sidebar__search__box {\n  input {\n    border-radius: 5px;\n    color: $color_13;\n    font-family: $font-family_2;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n    letter-spacing: 2.4px;\n    text-transform: uppercase;\n    border: 1px solid rgba(255, 255, 255, 0.25);\n    padding: 20px;\n    width: 100%;\n  }\n  button {\n    position: absolute;\n    right: 22px;\n    color: $color_14;\n    top: 50%;\n    transform: translate(0%, -50%);\n  }\n}\n.single__sidebar__box {\n  background: #060e26;\n  padding: 30px;\n  margin-bottom: 40px;\n  h3 {\n    font-size: 26px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 36px;\n    padding-bottom: 40px;\n  }\n}\n.sidebar__blog__post {\n  .inner {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    .img__box {\n      display: flex;\n      flex-shrink: 0;\n      img {\n        width: 150px;\n        aspect-ratio: 4/3;\n      }\n    }\n  }\n  .title__box {\n    h4 {\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: 26px;\n    }\n  }\n  li {\n    margin-bottom: 20px;\n    cursor: pointer;\n    transition: all 500ms ease;\n\n    &:hover {\n      border-radius: 4px;\n      // background: rgba(255, 140, 46, 0.1);\n      background: rgba(255, 255, 255, 0.1);\n      backdrop-filter: 1px;\n    }\n  }\n  .date {\n    color: $primary_color;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    i {\n      color: $primary_color;\n    }\n  }\n}\n.sidebar-categories-box {\n  li {\n    a {\n      font-family: $font-family_2;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: 26px;\n      display: flex;\n      align-items: center;\n      gap: 16px;\n      padding-bottom: 20px;\n      i {\n        color: $color_9;\n      }\n    }\n  }\n}\n.contact__right {\n  background: #060e26;\n  padding: 80px;\n}\n.form-inner {\n  input {\n    color: $color_2;\n    font-family: $font-family_2;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n    letter-spacing: 2.4px;\n    border-radius: 5px;\n    border: 1px solid rgba(255, 255, 255, 0.15);\n    // text-transform: uppercase;\n    padding: 22px;\n    width: 100%;\n  }\n  select {\n    color: $color_2;\n    font-family: $font-family_2;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n    letter-spacing: 2.4px;\n    border-radius: 5px;\n    border: 1px solid rgba(255, 255, 255, 0.15);\n    padding: 22px;\n    width: 100%;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    background-image: linear-gradient(45deg, transparent 50%, $color_13 50%),\n      linear-gradient(135deg, $color_13 50%, transparent 50%);\n    background-position: calc(100% - 20px) 50%, calc(100% - 15px) 50%;\n    background-size: 5px 5px, 5px 5px;\n    background-repeat: no-repeat;\n  }\n  select:invalid {\n    color: $color_13;\n  }\n  select:focus {\n    color: $primary_color;\n    border-color: $primary_color;\n  }\n  input:focus,\n  textarea:focus {\n    color: $primary_color;\n    border-color: $primary_color;\n  }\n  input::placeholder {\n    color: $color_13;\n  }\n  input::-webkit-input-placeholder {\n    color: $color_13;\n  }\n  input:-moz-placeholder {\n    color: $color_13;\n  }\n  input::-moz-placeholder {\n    color: $color_13;\n  }\n  input:-ms-input-placeholder {\n    color: $color_13;\n  }\n  textarea {\n    border-radius: 5px;\n    border: 1px solid rgba(255, 255, 255, 0.15);\n    color: $color_2;\n    font-family: $font-family_2;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n    letter-spacing: 2.4px;\n    // text-transform: uppercase;\n    width: 100%;\n    padding: 22px;\n    height: 235px;\n  }\n  textarea::placeholder {\n    color: $color_13;\n  }\n  textarea::-webkit-input-placeholder {\n    color: $color_13;\n  }\n  textarea:-moz-placeholder {\n    color: $color_13;\n  }\n  textarea::-moz-placeholder {\n    color: $color_13;\n  }\n  textarea:-ms-input-placeholder {\n    color: $color_13;\n  }\n}\n.contact__left {\n  h4 {\n    font-size: 38px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 50px;\n    padding: 30px 0px;\n  }\n}\n.contact__block {\n  i {\n    border-radius: 2px;\n    background: #f6ec4f;\n    width: 48px;\n    height: 48px;\n    display: flex;\n    align-items: center;\n    font-size: 30px;\n    color: $color_8;\n    justify-content: center;\n  }\n  display: flex;\n  align-items: center;\n  gap: 27px;\n  padding-bottom: 40px;\n  .two {\n    i {\n      background: #ff0e75;\n      color: $color_2;\n    }\n  }\n}\n.google__map {\n  img {\n    width: 100%;\n  }\n  width: 100%;\n  height: 780px;\n}\n.service__contact__block {\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: #060e26;\n}\n.service__form__data {\n  padding: 90px 0px 160px 90px;\n}\n.service__contact__img {\n  position: absolute;\n  bottom: 0;\n  right: 12px;\n}\n.feature-three__wrap {\n  position: relative;\n  display: block;\n  animation: aspro-scroller 27s linear infinite;\n  will-change: transform;\n  white-space: nowrap;\n  &:hover {\n    animation-play-state: paused;\n  }\n}\n.feature-three__list {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: nowrap;\n  min-width: 100vw;\n  li {\n    position: relative;\n    display: block;\n  }\n  li + li {\n    margin-left: 30px;\n  }\n}\n.feature-three__title-box {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n.feature-three__title {\n  font-family: $font-family_2;\n  font-size: 60px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  letter-spacing: 5px;\n  text-transform: uppercase;\n  -webkit-text-stroke-width: 1px;\n  -webkit-text-stroke-color: #191f31;\n  color: $color_5 !important;\n  span {\n    font-family: $font-family_2;\n    font-size: 60px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    letter-spacing: 5px;\n    text-transform: uppercase;\n    -webkit-text-stroke-width: 1px;\n    -webkit-text-stroke-color: #191f31;\n    color: $color_5;\n  }\n}\n.feature-three--four {\n  padding: 0 0 108px;\n}\n.header__three {\n  .logo-box {\n    img {\n      width: 42px;\n      height: 58px;\n    }\n    position: absolute;\n    top: 25px;\n    padding: 0 !important;\n    left: 50%;\n    transform: translate(-50%, 0%);\n  }\n  .menu-area {\n    nav {\n      display: none;\n    }\n    .mobile-nav-toggler {\n      display: block !important;\n      float: left;\n    }\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, 50%);\n  }\n  .outer-box {\n    display: block !important;\n    height: 100vh;\n  }\n  figure.logo {\n    min-width: 0px !important;\n    display: flex;\n    justify-content: center;\n  }\n  .banner__media_two {\n    position: absolute;\n    left: 50%;\n    bottom: 30px;\n    transform: translate(-50%, 0%);\n  }\n}\n.main-header.header__three {\n  position: fixed;\n  background: #060e26;\n  width: 100px;\n}\n.banner__media_two {\n  li {\n    a {\n      font-weight: 600;\n      line-height: 46.5px;\n    }\n  }\n}\n.home__three {\n  .pattern-4 {\n    width: 506px;\n    height: 469px;\n    right: 0;\n    bottom: -140px;\n  }\n  .about__block {\n    margin-top: -140px;\n  }\n  .about__section {\n    &:before {\n      content: \"\";\n      width: 412.862px;\n      height: 609.251px;\n      transform: rotate(21.269deg);\n      position: absolute;\n      border-radius: 847.578px;\n      background: linear-gradient(\n        192deg,\n        rgba(246, 236, 79, 0.21) 0%,\n        rgba(150, 6, 147, 0.4) 100%\n      );\n      filter: blur(150px);\n      filter: blur(150px);\n      left: inherit;\n      transform: translate(-50%, 0%);\n      bottom: inherit;\n      right: -100px;\n      top: -100px;\n    }\n  }\n}\n.home__three__banner {\n  position: relative;\n  .image-layer {\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: cover;\n  }\n  .banner__data {\n    padding: 0;\n  }\n  h1 {\n    span {\n      font-weight: 700;\n    }\n    span.color {\n      color: $color_7;\n    }\n  }\n  .btn-box {\n    padding-bottom: 120px;\n  }\n  .banner__mission__block {\n    border-radius: 0;\n  }\n  .banner__bottom {\n    border-radius: 0px 10px 0px 0px;\n  }\n  .pattern-3 {\n    width: 299px;\n    height: 411px;\n    left: 233px;\n    bottom: 240px;\n  }\n}\n.banner__media {\n  padding: 54px 0px 100px;\n  ul {\n    display: flex;\n    align-items: center;\n    gap: 65px;\n    justify-content: flex-end;\n  }\n}\n.choose__us.three {\n  .pattern-2 {\n    width: 299px;\n    height: 300px;\n    background-repeat: no-repeat;\n    left: 100px;\n    top: -80px;\n    width: 299px;\n    height: 300px;\n    background-repeat: no-repeat;\n    left: 100px;\n    top: -80px;\n  }\n  &:before {\n    display: none;\n  }\n}\n.choose_us_block {\n  h2 {\n    padding-bottom: 30px;\n  }\n  li {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    font-family: $font-family_2;\n    font-size: 26px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 36px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n    padding: 20px 0px;\n    &:nth-child(1) {\n      padding-top: 0;\n    }\n    &:nth-child(4) {\n      border: none;\n    }\n  }\n}\n.portfolio.home__three__p {\n  border-radius: 5px;\n  background: #060e26;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  margin-top: 140px;\n  padding: 140px 0px 120px;\n}\n.accomplised__data.two.three {\n  background: #060e26 !important;\n  border-radius: 10px;\n  padding: 120px 90px 120px 70px;\n}\nsection.accomplised__section__two.see__pad.three {\n  &:before {\n    content: \"\";\n    position: absolute;\n    border-radius: 528.747px;\n    background: linear-gradient(\n      192deg,\n      rgba(246, 236, 79, 0.26) 0%,\n      rgba(150, 6, 147, 0.5) 100%\n    );\n    filter: blur(150px);\n    width: 358.308px;\n    height: 528.747px;\n    transform: rotate(21.269deg);\n    flex-shrink: 0;\n    left: 100px;\n    bottom: -104px;\n  }\n}\n.accomplised__section__two.see__pad.three {\n  background: #00061a;\n  position: relative;\n}\n.consultation__list {\n  padding-top: 41px;\n  li {\n    a {\n      width: 100%;\n      font-family: $font-family_2;\n      font-size: 26px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 36px;\n      padding: 35px 0px 35px 85px;\n      border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n      display: flex;\n      align-items: center;\n      position: relative;\n      span {\n        height: 100%;\n        padding: 0px 16px;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: normal;\n        position: absolute;\n        display: flex;\n        align-items: center;\n        border-right: 1px solid rgba(255, 255, 255, 0.2);\n        width: 52px;\n        left: 0;\n      }\n    }\n  }\n}\n.consultation__img {\n  margin-top: -50px;\n}\n.consultation__text {\n  position: absolute;\n  width: 460px;\n  left: 80px;\n  top: 50%;\n  transform: translate(0%, -50%);\n  h3 {\n    padding-bottom: 30px;\n  }\n  p {\n    padding-bottom: 20px;\n  }\n}\n.consultation__button {\n  padding-top: 20px;\n  a {\n    &:hover {\n      letter-spacing: 3px;\n    }\n  }\n}\n.pricing__section.three {\n  &:before {\n    content: \"\";\n    width: 790px;\n    height: 790px;\n    flex-shrink: 0;\n    border-radius: 790px;\n    background: var(\n      --shadow,\n      linear-gradient(\n        192deg,\n        rgba(246, 236, 79, 0.32) 0%,\n        rgba(150, 6, 147, 0.6) 100%\n      )\n    );\n    filter: blur(300px);\n    position: absolute;\n    top: -27%;\n    left: 34%;\n  }\n}\n.service__contact.three {\n  &:after {\n    content: \"\";\n    width: 574.366px;\n    height: 847.578px;\n    transform: rotate(21.269deg);\n    flex-shrink: 0;\n    border-radius: 847.578px;\n    background: var(\n      --shadow-2,\n      linear-gradient(\n        180deg,\n        rgba(246, 236, 79, 0.32) 0%,\n        rgba(150, 6, 147, 0.14) 90.86%\n      )\n    );\n    filter: blur(150px);\n    position: absolute;\n    right: 0;\n  }\n  padding-bottom: 140px;\n}\n.service__details {\n  padding: 140px 0px 0px;\n}\n.all__service {\n  h3 {\n    background: $primary_color;\n    padding: 14px 30px;\n  }\n}\n.sidebar__widget {\n  position: relative;\n  padding: 24px;\n\n  &:before {\n    content: \"\";\n    position: absolute;\n    inset: 0;\n    padding: 1px;\n    background: linear-gradient(\n      180deg,\n      rgb(246 236 79 / 8%),\n      rgba(150, 6, 147, 0.23)\n    );\n    -webkit-mask: linear-gradient(#fff 0 0) content-box,\n      linear-gradient(#fff 0 0);\n    -webkit-mask-composite: xor;\n    mask-composite: exclude;\n    z-index: -1;\n    border-radius: 4px;\n  }\n}\nul.service__details__1__cat {\n  padding: 30px 0px;\n}\n.service__details__1__cat {\n  a {\n    padding: 10px 30px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    font-family: $font-family_1;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 29px;\n    cursor: pointer;\n    position: relative;\n    margin-bottom: 10px;\n    transition: all 150ms ease-in-out;\n    &:before {\n      content: \"\";\n      position: absolute;\n      inset: 0;\n      padding: 1px;\n      // background: linear-gradient(180deg, rgba(246, 236, 79, 0.53), rgba(150, 6, 147, 0.23));\n      background: linear-gradient(\n        192deg,\n        #ff8c2e 0%,\n        rgba(150, 6, 147, 0.6) 100%\n      );\n      -webkit-mask: linear-gradient(#fff 0 0) content-box,\n        linear-gradient(#fff 0 0);\n      -webkit-mask-composite: xor;\n      mask-composite: exclude;\n      z-index: -1;\n      border-radius: 4px;\n    }\n    &:hover {\n      color: $color_2;\n      font-weight: 600;\n    }\n  }\n  a.active {\n    color: $color_2;\n    font-weight: 600;\n    background: linear-gradient(\n      192deg,\n      #ff8c2e 0%,\n      rgba(150, 6, 147, 0.6) 100%\n    );\n    border-radius: 4px;\n  }\n}\n.sidebar__widget_network {\n  margin-top: 40px;\n  padding: 120px 60px;\n  text-align: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  .services__icon {\n    i {\n      width: 90px;\n      height: 90px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background: linear-gradient(192deg, $primary_color 0%, $shade_color 100%);\n      margin: 20px auto;\n      font-size: 40px;\n      border-radius: 50%;\n    }\n  }\n}\n.service__right {\n  h2 {\n    padding: 40px 0px 35px;\n    span {\n      color: $color_4;\n    }\n  }\n  h3 {\n    margin: 0 0 24px;\n  }\n  .row {\n    padding: 30px 0px 0px;\n  }\n  li {\n    a {\n      position: relative;\n      font-family: $font-family_2;\n      font-size: 22px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 36px;\n      padding: 10px 20px;\n      width: 100%;\n      align-items: center;\n      display: flex;\n      gap: 18px;\n      margin-bottom: 40px;\n      &:before {\n        content: \"\";\n        position: absolute;\n        inset: 0;\n        padding: 1px;\n        // background: linear-gradient(180deg, rgba(246, 236, 79, 0.53), rgba(150, 6, 147, 0.23));\n        background: linear-gradient(\n          192deg,\n          #ff8c2e 0%,\n          rgba(150, 6, 147, 0.23) 100%\n        );\n        -webkit-mask: linear-gradient(#fff 0 0) content-box,\n          linear-gradient(#fff 0 0);\n        -webkit-mask-composite: xor;\n        mask-composite: exclude;\n        z-index: -1;\n        border-radius: 4px;\n      }\n      i {\n        width: 70px;\n        height: 70px;\n        background: #666;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border-radius: 5px;\n        font-size: 40px;\n        transition: all 500ms ease;\n      }\n      &:hover {\n        i {\n          background: $primary_color;\n          color: $color_2;\n        }\n      }\n    }\n  }\n  position: relative;\n  &:before {\n    width: 412.862px;\n    height: 609.251px;\n    transform: rotate(21.269deg);\n    flex-shrink: 0;\n    border-radius: 609.251px;\n    background: linear-gradient(\n      192deg,\n      rgba(246, 236, 79, 0.21) 0%,\n      rgba(150, 6, 147, 0.4) 100%\n    );\n    filter: blur(150px);\n    position: absolute;\n    content: \"\";\n    left: -16%;\n    top: 4%;\n  }\n}\n.error__page {\n  h1.title {\n    text-align: center;\n    font-family: $font-family_2;\n    font-size: 400px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    span {\n      color: $primary_color;\n    }\n  }\n}\n.page__title.error__page {\n  margin-top: 0;\n  padding: 0;\n  width: 100%;\n  height: 100dvh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  .btn-box {\n    justify-content: center;\n    padding-top: 40px;\n  }\n}\n.project__details {\n  padding-top: 140px;\n  .image {\n    img {\n      border-radius: 5px;\n    }\n  }\n  .data {\n    h4 {\n      font-size: 32px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 42px;\n      padding: 50px 0px 35px;\n    }\n  }\n  .data__list {\n    li {\n      font-family: $font-family_1;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: 29px;\n      display: flex;\n      align-items: center;\n      margin-bottom: 15px;\n      gap: 15px;\n      i {\n        width: 20px;\n        height: 20px;\n        background: #666;\n        border-radius: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n    }\n    padding: 40px 0px 100px;\n  }\n  .project__button {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 30px 50px;\n    border-top: 1px solid rgba(234, 234, 234, 0.1);\n    border-bottom: 1px solid rgba(234, 234, 234, 0.1);\n  }\n  .button__one {\n    a {\n      font-family: $font-family_2;\n      font-size: 26px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 36px;\n    }\n  }\n}\n.pro__info {\n  background: #ff0e75;\n  border-radius: 10px;\n  padding: 60px;\n  max-width: 800px;\n  margin: -94px auto 0;\n  position: relative;\n  ul {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n  .name__two {\n    h4 {\n      font-size: 30px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 40px;\n    }\n  }\n}\n@media (min-width: 768px) {\n  .feature-three__list {\n    li + li {\n      margin-left: 50px;\n    }\n  }\n}\n@media (min-width: 1200px) {\n  .feature-three__list {\n    li + li {\n      margin-left: 70px;\n    }\n  }\n}\n\n@media (min-width: 768px) {\n  .feature-three__list {\n    li + li {\n      margin-left: 50px;\n    }\n  }\n}\n@media (min-width: 1200px) {\n  .feature-three__list {\n    li + li {\n      margin-left: 70px;\n    }\n  }\n}\n.mobile-menu {\n  .navigation {\n    li {\n      .dropdown-btn.open + ul {\n        display: block;\n      }\n    }\n  }\n}\n.form-inner {\n  .form-group {\n    margin-bottom: 1rem;\n  }\n}\n\n.account-info-wrapper {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  transition: all 500ms ease;\n\n  svg {\n    fill: $color_2;\n  }\n  svg path,\n  a {\n    transition: all 500ms ease;\n    fill: $color_2;\n    color: $color_2;\n  }\n}\n\n.account-info-wrapper:hover svg path,\n.account-info-wrapper:hover a {\n  fill: $primary_color;\n  color: $primary_color !important;\n}\n\n.map-popup {\n  .leaflet-popup-content-wrapper {\n    border-radius: 6px;\n    padding: 8px 12px;\n  }\n  .leaflet-popup-tip-container {\n    display: none;\n  }\n  .leaflet-popup-content,\n  .leaflet-popup-content p {\n    padding: 0;\n    margin: 0;\n    color: $color_1;\n    font-family: $font-family_1;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    text-align: center;\n  }\n  .leaflet-popup-close-button {\n    display: none;\n  }\n}\n\n.office-wrapper {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 8px;\n}\n\n.office-map-wrapper {\n  width: 100%;\n  height: 780px;\n}\n\n.news-articles-wrapper {\n  margin-top: 32px;\n  width: 100%;\n  gap: 32px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.editorial-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  gap: 12px;\n  a {\n    color: #ff8c2e;\n    transition: all 500ms ease;\n    -moz-transition: all 500ms ease;\n    -webkit-transition: all 500ms ease;\n    -ms-transition: all 500ms ease;\n    -o-transition: all 500ms ease;\n    &:hover {\n      color: #ff8c2e;\n      opacity: 0.9;\n      outline: none;\n    }\n  }\n  p {\n    text-align: center;\n  }\n}\n\n.social-media-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n  div {\n    display: inherit;\n    gap: 8px;\n  }\n\n  div > div {\n    display: inherit;\n\n    svg {\n      fill: #ffffff;\n    }\n    svg path,\n    a {\n      transition: all 500ms ease;\n      fill: #ffffff;\n      color: #ffffff;\n    }\n  }\n  div > div:hover svg path,\n  div > div:hover a {\n    fill: #ff8c2e;\n    color: #ff8c2e !important;\n  }\n}\n\n.content-markdown {\n  p {\n    &:has(img) {\n      display: grid;\n      grid-template-columns: repeat(2, 1fr);\n      gap: 20px;\n\n      @media (max-width: 768px) {\n        grid-template-columns: 1fr;\n      }\n    }\n  }\n}\n\n.image-content-markdown {\n  max-width: 100%;\n  height: auto;\n  display: block;\n  margin: 20px auto;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);\n  border-radius: 4px;\n}\n","@import \"https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap\";\n@import \"https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\";\n@keyframes anim {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n@keyframes heroShapeFour {\n  0%, 100% {\n    border-radius: 42% 58% 70% 30%/45% 45% 55% 55%;\n    transform: translate3d(0, 0, 0) rotateZ(0.02deg);\n  }\n  35% {\n    border-radius: 70% 30% 46% 54%/30% 29% 71% 70%;\n    transform: translate3d(0, 10px, 0) rotateZ(0.02deg);\n  }\n  50% {\n    transform: translate3d(0, 0, 0) rotateZ(0.02deg);\n  }\n  65% {\n    border-radius: 100% 60% 60% 100%/100% 100% 60% 60%;\n    transform: translate3d(0, 20px, 0) rotateZ(0.03deg);\n  }\n}\n/* banner__section  end */\n/* service__section */\n/* service__section  end */\n/* about-section  */\n/* about-section  end */\n/* choose__us-section */\n/* choose__us-section  end */\n/* team-section   */\n/* team-section end*/\n/* accomplised-section   */\n/* accomplised-section  end */\n/* testimonial -section */\n/* testimonial-section  end */\n/* brand__section  */\n/* brand__section end */\n/* blog__section  */\n/* blog__section end */\n/*** \n\n====================================================================\n                        Home-Page-Two\n====================================================================\n\n***/\n/** header-two **/\n/** header-two **/\n/** banner-section **/\n/* slider text animation */\n/* slider text animation end */\n/* accomplised-section */\n/* accomplised-section-end */\n/* brand-section */\n/* brand-section-end */\n/* progress-section */\n/* progress-section-end */\n/* about-section */\n/* about-section-end */\n/* service__two-section */\n/* service__two-section-end */\n/* choose___two-section-end */\n/* choose___two-section-end */\n/* price-section */\n/* price-section-end */\n/* portfolio-section */\n/* portfolio-section-end */\n/* portfolio-section-end */\n/* portfolio-section-end */\n/* About Page */\n/* About Page End*/\n/* Service Page */\n/* Service Page End*/\n/* testimonial page */\n/* testimonial page end */\n/* blog-details */\n/* blog-details end */\n/* contact page */\n/* contact page */\n/* service page */\n/* service page */\n/* brand new */\n@keyframes aspro-scroller {\n  0% {\n    transform: translate(0, 0);\n  }\n  100% {\n    transform: translate(-100%, 0);\n  }\n}\n@keyframes aspro-scroller-reverse {\n  0% {\n    transform: translate(0, 0);\n  }\n  100% {\n    transform: translate(100%, 0);\n  }\n}\n/* brand new end */\n/*** \n\n====================================================================\n                        Home-Page-Three\n====================================================================\n\n***/\n/* header__three */\n/* header__three end */\n/* about__three  */\n/* about__three end */\n/* banner__three */\n/* banner__three end*/\n/* choose__three */\n/* choose__three end*/\n/* portfolio three */\n/* portfolio three end*/\n/* accomplised */\n/* accomplised end */\n/* consultation  */\n/* consultation end */\n/*** \n\n====================================================================\n                        Service Details\n====================================================================\n\n***/\n/*** \n\n====================================================================\n                        404 Page\n====================================================================\n\n***/\n/*** \n\n====================================================================\n                        Project Details\n====================================================================\n\n***/\n.circle-main {\n  text-align: center;\n  height: 230px;\n  width: 230px;\n  display: block;\n  background: #f6ec4f;\n  border-radius: 50%;\n  position: relative;\n}\n.circle-main .circle h1 {\n  font-size: 100px;\n  font-weight: 600;\n  line-height: 1.8em;\n  padding-top: 20px;\n  color: #00061a;\n}\n.circle-main .circle img {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n}\n.circle-main:before {\n  content: \"\";\n  position: absolute;\n  height: 210px;\n  width: 210px;\n  border-radius: 50%;\n  border: 1px dashed #00061a;\n  top: 10px;\n  right: 10px;\n}\n\n.round-text {\n  position: relative;\n  width: 200px;\n  height: 200px;\n  border-radius: 50%;\n}\n.round-text .text_1 {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  animation: anim 20s linear infinite;\n  top: 14px;\n  right: -14px;\n}\n\n.text_1 span {\n  position: absolute;\n  left: 50%;\n  transform-origin: 0 100px;\n}\n.text_1 .text_2 {\n  font-size: 16px;\n  font-weight: 400;\n  text-transform: uppercase;\n  color: #00061a;\n}\n\n.banner__one .banner__bg {\n  left: 0;\n  top: -14px;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  background-repeat: no-repeat;\n  will-change: border-radius, transform, opacity;\n  animation: heroShapeFour 3s linear infinite;\n}\n\n.banner__right figure.image-box img {\n  border-radius: 20px 20px 213px 213px;\n}\n\n.icon__image__banner {\n  position: absolute;\n  left: -109px;\n  bottom: -61px;\n}\n\n.banner__title h1 {\n  color: #fff;\n  font-family: Archivo;\n  font-size: 80px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 90px;\n  padding: 20px 0px;\n}\n.banner__title h1 span {\n  font-weight: 400;\n}\n\n.text p {\n  padding: 0px 31px 30px 0px;\n}\n\n.btn-box {\n  display: flex;\n}\n\n.banner__left {\n  padding-top: 26px;\n}\n\n.banner__icon {\n  background-repeat: no-repeat;\n  right: 0;\n  top: 22px;\n  width: 370px;\n  height: 469px;\n}\n\n.banner__data {\n  padding: 90px 0px 140px;\n}\n.banner__data:before {\n  content: \"\";\n  border-radius: 679.189px;\n  background: linear-gradient(192deg, rgba(246, 236, 79, 0.32) 0%, rgba(150, 6, 147, 0.6) 100%);\n  filter: blur(150px);\n  width: 460.256px;\n  height: 679.189px;\n  transform: rotate(21.269deg);\n  flex-shrink: 0;\n  position: absolute;\n  z-index: -1;\n  left: 40%;\n}\n\nsection.banner__one {\n  overflow: hidden;\n}\n\n.product__block__wrapper {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 40px;\n  flex-wrap: wrap;\n  height: max-content;\n  padding-bottom: 10px;\n}\n\n.new__service__block__wrapper {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 30px;\n  flex-wrap: wrap;\n  height: max-content;\n  padding: 0;\n}\n\n.product__block {\n  width: 200px;\n  height: max-content;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n  cursor: pointer;\n}\n.product__block:hover .product__text h4 {\n  color: #ff8c2e;\n}\n\n.product__icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 200px;\n  height: 220px;\n  background: linear-gradient(192deg, #ff8c2e 0%, #7e2100 100%);\n  clip-path: polygon(50% 0, 100% 27%, 100% 73%, 50% 100%, 0 73%, 0 27%);\n}\n.product__icon i {\n  width: 200px;\n  height: 220px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-style: normal;\n  font-size: 100px;\n  font-weight: 500;\n  color: #fff;\n}\n.product__icon img {\n  width: 150px;\n  padding: 40px 32px;\n  margin: 0 auto;\n  font-size: 50px;\n  position: relative;\n  z-index: 1;\n}\n\n.product__text button h4 {\n  color: #fff;\n}\n\n.industry__block__wrapper {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 30px;\n  flex-wrap: wrap;\n  height: max-content;\n  padding-bottom: 10px;\n}\n\n.industry__block {\n  width: 200px;\n  height: max-content;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n  cursor: pointer;\n}\n.industry__block:hover .industry__text h4 {\n  color: #ff8c2e;\n}\n\n.industry__icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100px;\n  height: 110px;\n  background: linear-gradient(192deg, #ff8c2e 0%, #7e2100 100%);\n  clip-path: polygon(50% 0, 100% 27%, 100% 73%, 50% 100%, 0 73%, 0 27%);\n}\n.industry__icon i {\n  width: 100px;\n  height: 110px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-style: normal;\n  font-size: 60px;\n  font-weight: 500;\n  color: #fff;\n}\n.industry__icon img {\n  width: 150px;\n  padding: 40px 32px;\n  margin: 0 auto;\n  font-size: 50px;\n  position: relative;\n  z-index: 1;\n}\n\n.industry__text button h4 {\n  color: #fff;\n}\n\n.service__block {\n  position: relative;\n  padding: 36px 42px;\n  text-align: center;\n  border-bottom: none;\n}\n.service__block:hover .service__icon__two:after {\n  background: #ff8c2e;\n}\n.service__block:hover .service__icon__two:before {\n  background: #ff8c2e;\n}\n.service__block:hover .service__button a {\n  transform: scale(1.1);\n  color: #000;\n}\n\n.service__icon {\n  position: relative;\n  padding-bottom: 70px;\n}\n.service__icon i {\n  width: 110px;\n  height: 126px;\n  background: linear-gradient(192deg, #ff8c2e 0%, #7e2100 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto;\n  font-size: 50px;\n  clip-path: polygon(50% 0, 100% 27%, 100% 73%, 50% 100%, 0 73%, 0 27%);\n  position: relative;\n  margin-top: 10px;\n  z-index: 1;\n}\n.service__icon img {\n  padding: 40px 32px;\n  background: linear-gradient(192deg, #ff8c2e 0%, #7e2100 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto;\n  font-size: 50px;\n  clip-path: polygon(50% 0, 100% 27%, 100% 73%, 50% 100%, 0 73%, 0 27%);\n  position: relative;\n  z-index: 1;\n}\n.service__icon:before {\n  content: \"\";\n  width: 110px;\n  height: 126px;\n  position: absolute;\n  background: rgba(128, 5, 153, 0.3);\n  top: -11px;\n  left: 50%;\n  z-index: -1;\n  clip-path: polygon(50% 0, 100% 27%, 100% 73%, 50% 100%, 0 73%, 0 27%);\n  transform: translate(-50%, 0%);\n}\n\n.service__icon__two:after {\n  width: 15px;\n  content: \"\";\n  height: 18px;\n  background: #800599;\n  clip-path: polygon(50% 0, 100% 25%, 100% 85%, 50% 100%, 0 85%, 0 25%);\n  margin: 0 auto;\n  position: absolute;\n  left: 50%;\n  transform: translate(-50%, 0%);\n  bottom: 20px;\n  transition: all 500ms ease;\n}\n.service__icon__two:before {\n  content: \"\";\n  width: 1px;\n  height: 34px;\n  background: rgba(255, 255, 255, 0.2);\n  position: absolute;\n  bottom: 37px;\n  left: 50%;\n  transform: translate(-50%, 0%);\n  transition: all 500ms ease;\n}\n\n.service__button {\n  position: absolute;\n  left: 50%;\n  bottom: 28px;\n  transform: translate(-50%, 0%);\n}\n.service__button a {\n  width: 40px;\n  height: 40px;\n  background: #ff8c2e;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transform: scale(0);\n  transition: all 500ms ease;\n}\n\n.service__data {\n  border-radius: 5px;\n  background: #060e26;\n  padding: 56px;\n}\n\n.funfact__content.about {\n  background-repeat: no-repeat;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: 196px;\n  height: 201px;\n  padding: 66px 36px 40px;\n}\n.funfact__content.about h1.count-text {\n  color: #00061a;\n  font-size: 40px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 50px;\n}\n.funfact__content.about .count-outer.count-box.counted {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.funfact__content.about .count-outer.count-box.counted span {\n  color: #00061a;\n  font-size: 38px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 49px;\n}\n.funfact__content.about p {\n  color: #00061a;\n}\n\n.title.two h2 span {\n  color: #ff0e75;\n}\n\n.about__text__block .texts {\n  padding: 35px 0px;\n}\n\n.boild__text h1 {\n  font-family: Rubik;\n  font-size: 300px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  text-transform: uppercase;\n  position: absolute;\n  left: 50%;\n  -webkit-text-stroke-width: 1px;\n  -webkit-text-stroke-color: #00061a;\n  color: transparent;\n  top: 50%;\n  margin-top: -17px;\n  transform: translate(-50%, -50%);\n  text-align: center;\n  width: 100%;\n}\n\n.about__section .pattern-2 {\n  left: 0;\n  width: 299px;\n  height: 300px;\n  background-repeat: no-repeat;\n  top: -90px;\n}\n.about__section:before {\n  content: \"\";\n  width: 412.862px;\n  height: 609.251px;\n  transform: rotate(21.269deg);\n  position: absolute;\n  border-radius: 609.251px;\n  background: linear-gradient(192deg, rgba(246, 236, 79, 0.21) 0%, rgba(150, 6, 147, 0.4) 100%);\n  filter: blur(150px);\n  left: 50%;\n  transform: translate(-50%, 0%);\n  bottom: 0;\n}\n\n.choose__us__data {\n  padding: 100px 0px;\n}\n.choose__us__data:before {\n  content: \"\";\n  background: #00061a;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  left: 300px;\n  top: 0;\n}\n\n.choose__us:before {\n  content: \"\";\n  width: 574.366px;\n  height: 847.578px;\n  transform: rotate(21.269deg);\n  border-radius: 847.578px;\n  background: linear-gradient(192deg, rgba(246, 236, 79, 0.21) 0%, rgba(150, 6, 147, 0.4) 100%);\n  filter: blur(150px);\n  position: absolute;\n  left: 80px;\n  bottom: -325px;\n}\n\n.choose__block {\n  position: relative;\n  padding-top: 130px;\n}\n.choose__block:before {\n  content: \"\";\n  width: 349.864px;\n  height: 516.286px;\n  transform: rotate(21.269deg);\n  border-radius: 516.286px;\n  background: linear-gradient(192deg, rgba(246, 236, 79, 0.32) 0%, rgba(150, 6, 147, 0.6) 100%);\n  filter: blur(150px);\n  position: absolute;\n  left: 0;\n}\n\n.team__data {\n  display: flex;\n  gap: 30px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.15);\n  padding: 30px 0px;\n}\n.team__data:nth-child(2) {\n  padding-top: 0px;\n}\n.team__data:nth-child(4) {\n  padding-bottom: 0;\n  border-bottom: none;\n}\n\n.team__data__left img {\n  width: 80px;\n  padding-top: 8px;\n}\n\n.team__data__right h3 {\n  font-size: 26px;\n  line-height: 36px;\n  padding-bottom: 10px;\n}\n\n.team__img {\n  position: relative;\n}\n.team__img img {\n  width: 100%;\n  clip-path: polygon(50% 0, 100% 25%, 100% 75%, 50% 100%, 0 75%, 0 25%);\n}\n.team__img:before {\n  content: \"\";\n  background: rgba(128, 5, 153, 0.3);\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  clip-path: polygon(50% 0, 100% 25%, 100% 75%, 50% 100%, 0 75%, 0 25%);\n  transition: all 500ms ease;\n  top: -30px;\n}\n\n.team__block {\n  text-align: center;\n}\n.team__block:hover .team__img:before {\n  background: #ff8c2e;\n  opacity: 0.3;\n}\n\n.team__name {\n  padding: 20px 0px 10px;\n}\n\n.team__media ul {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n.team__media ul a {\n  color: #800599;\n  font-weight: 600;\n  font-size: 20px;\n  font-family: Rubik;\n  line-height: 30px;\n}\n.team__media ul a:hover {\n  color: #ff8c2e;\n}\n\n.team__section .pattern-3 {\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  z-index: -1;\n  background-repeat: no-repeat;\n}\n.team__section:before {\n  content: \"\";\n  width: 574.366px;\n  height: 847.578px;\n  transform: rotate(21.269deg);\n  border-radius: 847.578px;\n  background: linear-gradient(192deg, rgba(246, 236, 79, 0.21) 0%, rgba(150, 6, 147, 0.4) 100%);\n  filter: blur(150px);\n  position: absolute;\n  right: -44px;\n  top: -200px;\n}\n.team__section:after {\n  content: \"\";\n  width: 358.308px;\n  height: 528.747px;\n  transform: rotate(21.269deg);\n  border-radius: 528.747px;\n  background: linear-gradient(192deg, rgba(246, 236, 79, 0.26) 0%, rgba(150, 6, 147, 0.5) 100%);\n  filter: blur(150px);\n  position: absolute;\n  bottom: -30px;\n  left: 5%;\n  z-index: -1;\n}\n\n.accomplised__section {\n  padding-top: 140px;\n}\n\n.accomplised__data {\n  border-radius: 10px;\n  background: #060e26;\n  padding: 120px 90px 120px 70px;\n}\n.accomplised__data .pattern-4 {\n  width: 100%;\n  height: 100%;\n  top: 0;\n  background-repeat: no-repeat;\n  left: 15%;\n}\n.accomplised__data:before {\n  width: 358.308px;\n  height: 528.747px;\n  transform: rotate(21.269deg);\n  border-radius: 528.747px;\n  background: linear-gradient(192deg, rgba(246, 236, 79, 0.16) 0%, rgba(150, 6, 147, 0.3) 100%);\n  filter: blur(150px);\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  transform: translate(-50%, 0%);\n  bottom: -100px;\n}\n\n.funfact__data {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  gap: 27px;\n}\n.funfact__data .count-outer span {\n  color: #fff;\n  font-family: Rubik;\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 300;\n  line-height: 42px;\n}\n.funfact__data .count-outer h1.count-text {\n  color: #fff;\n  font-family: Rubik;\n  font-size: 40px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 42px;\n}\n.funfact__data .count-outer span.two {\n  font-weight: 600 !important;\n}\n.funfact__data .funfact__content {\n  width: 150px;\n  height: 170px;\n  text-align: center;\n  clip-path: polygon(50% 0, 100% 27%, 100% 73%, 50% 100%, 0 73%, 0 27%);\n  padding: 45px 27px;\n}\n.funfact__data .funfact__content .count-outer {\n  display: flex;\n}\n.funfact__data .funfact__content p {\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n}\n\n.funfact__content.one {\n  background: #ff0e75;\n}\n\n.funfact__content.two {\n  background: linear-gradient(192deg, rgba(246, 236, 79, 0.32) 0%, rgba(150, 6, 147, 0.6) 100%);\n}\n\n.funfact__content.three {\n  background: #800599;\n  margin-top: -48px;\n}\n\n.vision_mission_wrapper {\n  margin: 80px auto;\n  gap: 96px;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n}\n\n.core_value_wrapper {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  gap: 27px;\n  width: 100%;\n}\n\n.core_value_content {\n  width: 200px;\n  height: 220px;\n  text-align: center;\n  clip-path: polygon(50% 0, 100% 27%, 100% 73%, 50% 100%, 0 73%, 0 27%);\n  padding: 45px 27px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n.core_value_content p {\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n}\n\n.core_value_content.one {\n  background: linear-gradient(192deg, #ff8c2e 0%, rgba(150, 6, 147, 0.6) 100%);\n}\n\n.core_value_content.two {\n  background: linear-gradient(192deg, #ffc34e 0%, rgba(150, 6, 147, 0.6) 100%);\n}\n\n.core_value_content.remove_gap_core_value_1,\n.core_value_content.remove_gap_core_value_2 {\n  margin-top: -65px;\n}\n\n.partner_client_item_wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 24px;\n}\n.partner_client_item_wrapper h6 {\n  text-align: center;\n}\n.partner_client_item_wrapper .img__box {\n  display: flex;\n  flex-shrink: 0;\n}\n\n.swiper__button {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  padding-bottom: 20px;\n}\n.swiper__button .button_prev {\n  background: #fff;\n  width: 40px;\n  height: 40px;\n  color: rgb(0, 6, 26);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n}\n.swiper__button .button_prev:before {\n  content: \"\";\n  background: #f6ec4f;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: inline-block;\n  border-radius: 50%;\n  transform: scale(0);\n  transition: all 500ms ease;\n}\n.swiper__button .button_prev:hover:before {\n  transform: scale(1.1);\n}\n.swiper__button .button_next {\n  background: #fff;\n  width: 40px;\n  height: 40px;\n  color: rgb(0, 6, 26);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n}\n.swiper__button .button_next:before {\n  content: \"\";\n  background: #f6ec4f;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: inline-block;\n  border-radius: 50%;\n  transform: scale(0);\n  transition: all 500ms ease;\n}\n.swiper__button .button_next:hover:before {\n  transform: scale(1.1);\n}\n.swiper__button i {\n  position: relative;\n}\n\n.testimonial__top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.testimonials__info {\n  background: rgb(6, 14, 38);\n  text-align: center;\n  padding: 40px 49px 80px;\n  clip-path: polygon(50% 0, 100% 25%, 100% 75%, 50% 100%, 0 75%, 0 25%);\n}\n\n.testimonial__section {\n  padding-bottom: 55px;\n}\n.testimonial__section:before {\n  content: \"\";\n  width: 790px;\n  height: 790px;\n  position: absolute;\n  border-radius: 50%;\n  background: linear-gradient(192deg, rgba(246, 236, 79, 0.32) 0%, rgba(150, 6, 147, 0.6) 100%);\n  filter: blur(300px);\n  left: 50%;\n  transform: translate(-50%, 0%);\n}\n.testimonial__section .swiper-wrapper > *:nth-child(even) {\n  margin-top: 200px;\n}\n\n.authore__rating ul {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  padding: 15px 0px 5px;\n}\n.authore__rating ul li {\n  color: rgb(246, 236, 79);\n}\n\n.authore__info h5 {\n  color: #fff;\n  text-align: center;\n  font-size: 26px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 36px;\n}\n.authore__info p {\n  color: #666;\n  text-align: center;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 29px;\n}\n\n.testimonials__block__one {\n  padding: 20px 20px;\n}\n.testimonials__block__one .quote {\n  position: absolute;\n  bottom: 11px;\n  left: 50%;\n  width: 53px;\n  height: 62px;\n  transform: translate(-50%, 0%);\n  background: #666;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  clip-path: polygon(50% 0, 100% 27%, 100% 73%, 50% 100%, 0 73%, 0 27%);\n  transition: all 500ms ease;\n}\n.testimonials__block__one .quote span {\n  font-size: 25px;\n}\n.testimonials__block__one:hover .quote {\n  background: #f6ec4f;\n}\n.testimonials__block__one:hover .test__bg {\n  opacity: 1;\n}\n\n.test__bg {\n  background: linear-gradient(175deg, rgba(246, 236, 79, 0.53) 0%, rgb(150, 6, 147) 100%);\n  width: 400px;\n  height: 487px;\n  position: absolute;\n  left: 20px;\n  clip-path: polygon(50% 0, 100% 25%, 100% 75%, 50% 100%, 0 75%, 0 25%);\n  top: 20px;\n  transform: rotate(12deg);\n  opacity: 0;\n  transition: all 500ms ease;\n}\n\n.authore__img img {\n  width: 121px;\n  height: 138px;\n  clip-path: polygon(50% 0, 100% 25%, 100% 75%, 50% 100%, 0 75%, 0 25%);\n}\n\n.brand__section .owl-dots.disabled {\n  display: none;\n}\n.brand__section .brand-carousel {\n  position: relative;\n  transform: rotate(-10deg);\n  padding: 35px 0px;\n}\n.brand__section .brand-carousel:before {\n  content: \"\";\n  background: #f6ec4f;\n  position: absolute;\n  width: calc(100% + 5em);\n  height: 126px;\n  left: -3em;\n  top: 0px;\n}\n.brand__section .pattern-3 {\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n}\n\n.brand__content .brand__name h1 {\n  font-family: Rubik;\n  font-size: 50px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  letter-spacing: 5px;\n  text-transform: uppercase;\n  -webkit-text-stroke-width: 1px;\n  -webkit-text-stroke-color: #191f31;\n  color: transparent;\n}\n\n.inner-box .image-box {\n  display: block;\n  overflow: hidden;\n  background: transparent;\n  border-radius: 5px 5px 0px 0px;\n}\n.inner-box .image-box img {\n  width: 100%;\n  height: 400px;\n  transition: all 500ms ease;\n  object-fit: cover;\n}\n.inner-box:hover .image-box img {\n  transform: scale(1.05);\n}\n.inner-box:hover .theme__btn__two i {\n  transform: rotate(0deg);\n}\n.inner-box:hover a.theme__btn__two {\n  background: linear-gradient(219deg, #ff8c2e 0%, #7e2100 100%);\n}\n.inner-box:hover div.theme__btn__two {\n  background: linear-gradient(219deg, #ff8c2e 0%, #7e2100 100%);\n}\n\n.post__date {\n  position: absolute;\n  bottom: 0px;\n  width: 100%;\n}\n.post__date ul {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 20px 30px;\n  border-radius: 5px 5px 0px 0px;\n  background: #060e26;\n}\n.post__date ul li {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #fff;\n  font-size: 15px;\n}\n.post__date ul li i {\n  width: 29px;\n  height: 35px;\n  background: linear-gradient(219deg, #ff8c2e 0%, #7e2100 100%);\n  display: flex;\n  font-size: 15px;\n  align-items: center;\n  justify-content: center;\n  clip-path: polygon(50% 0, 100% 27%, 100% 73%, 50% 100%, 0 73%, 0 27%);\n  transition: all 500ms ease;\n  color: #fff;\n}\n.post__date ul li.two {\n  width: 6px;\n  height: 6px;\n  background: linear-gradient(219deg, #ff8c2e 0%, #7e2100 100%);\n  border-radius: 50%;\n}\n\n.detail__post__date {\n  position: absolute;\n  bottom: 0px;\n  width: 100%;\n}\n.detail__post__date ul {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 24px;\n  padding: 20px 30px;\n  border-radius: 5px 5px 0px 0px;\n  background: #060e26;\n}\n.detail__post__date ul li {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #fff;\n  font-size: 15px;\n}\n.detail__post__date ul li i {\n  width: 29px;\n  height: 35px;\n  background: linear-gradient(219deg, #ff8c2e 0%, #7e2100 100%);\n  display: flex;\n  font-size: 15px;\n  align-items: center;\n  justify-content: center;\n  clip-path: polygon(50% 0, 100% 27%, 100% 73%, 50% 100%, 0 73%, 0 27%);\n  transition: all 500ms ease;\n  color: #fff;\n}\n.detail__post__date ul li.two {\n  width: 6px;\n  height: 6px;\n  background: linear-gradient(219deg, #ff8c2e 0%, #7e2100 100%);\n  border-radius: 50%;\n}\n\n.lower___content h4 {\n  margin-bottom: 12px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  text-align: start;\n}\n.lower___content p {\n  margin-bottom: 20px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  text-align: start;\n}\n\n.news___block {\n  margin-bottom: 30px;\n  width: auto;\n  max-width: 400px;\n}\n.news___block .lower___content {\n  background: #060e26;\n  padding: 25px 30px 20px;\n}\n\n.btn__box__two a.theme__btn__two {\n  width: 29px;\n  height: 35px;\n  background: linear-gradient(219deg, #ff8c2e 0%, #7e2100 100%);\n  display: flex;\n  font-size: 15px;\n  align-items: center;\n  justify-content: center;\n  clip-path: polygon(50% 0, 100% 27%, 100% 73%, 50% 100%, 0 73%, 0 27%);\n  transition: all 500ms ease;\n  color: #fff;\n  margin: 0 0 0 auto;\n}\n.btn__box__two a.theme__btn__two i {\n  transform: rotate(45deg);\n  transition: all 500ms ease;\n}\n.btn__box__two div.theme__btn__two {\n  width: 29px;\n  height: 35px;\n  background: linear-gradient(219deg, #ff8c2e 0%, #7e2100 100%);\n  display: flex;\n  font-size: 15px;\n  align-items: center;\n  justify-content: center;\n  clip-path: polygon(50% 0, 100% 27%, 100% 73%, 50% 100%, 0 73%, 0 27%);\n  transition: all 500ms ease;\n  color: #fff;\n  margin: 0 0 0 auto;\n}\n.btn__box__two div.theme__btn__two i {\n  transform: rotate(45deg);\n  transition: all 500ms ease;\n}\n\n.blog__section:before {\n  content: \"\";\n  width: 574.366px;\n  height: 847.578px;\n  border-radius: 847.578px;\n  background: linear-gradient(192deg, rgba(246, 236, 79, 0.21) 0%, rgba(150, 6, 147, 0.4) 100%);\n  filter: blur(150px);\n  position: absolute;\n  right: 0;\n  transform: rotate(21.269deg);\n  bottom: -300px;\n}\n.blog__section .normaol__text {\n  padding-left: 65px;\n}\n\n.home__two {\n  background: #fff;\n}\n.home__two h1 {\n  color: #00061a;\n}\n.home__two h2 {\n  color: #00061a;\n}\n\n.footer-top.two .top-inner {\n  background: linear-gradient(238deg, #f6ec4f 0%, #00061a 100%) !important;\n}\n\n.blog__section.two .normaol__text p {\n  color: #666;\n}\n\n.accomplised__section__two {\n  background: #060e26;\n}\n.accomplised__section__two h2 {\n  color: #fff !important;\n}\n.accomplised__section__two .btn-box {\n  padding-left: 60px;\n}\n\n.main-header.two {\n  position: absolute;\n  top: 48px;\n  left: 0;\n}\n.main-header.two .header-lower .outer-box {\n  border-radius: 5px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: #00061a;\n  padding: 0px 20px;\n}\n.main-header.two .outer-box .logo-box {\n  padding: 20px 0px;\n}\n.main-header.two .outer-box .main-menu .navigation > li > a {\n  padding: 36px 0px;\n}\n.main-header.two .outer-box .main-menu .dropdown-btn {\n  top: 40px;\n}\n\n.slider-two {\n  position: relative;\n  overflow: hidden;\n}\n.slider-two .pattern-1 {\n  width: 506px;\n  height: 469px;\n  left: 0;\n  bottom: 0;\n  background-repeat: no-repeat;\n  z-index: 1;\n}\n\n.banner-carousel .slide-item {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n}\n.banner-carousel .content-box {\n  position: relative;\n  width: 100%;\n}\n.banner-carousel .content-box h2 {\n  color: #fff;\n  opacity: 0;\n  -webkit-transition: all 1000ms ease;\n  -moz-transition: all 1000ms ease;\n  -ms-transition: all 1000ms ease;\n  -o-transition: all 1000ms ease;\n  transition: all 1000ms ease;\n  transform: scaleX(0);\n}\n.banner-carousel .content-box h4 {\n  color: #fff;\n  opacity: 0;\n  -webkit-transition: all 1000ms ease;\n  -moz-transition: all 1000ms ease;\n  -ms-transition: all 1000ms ease;\n  -o-transition: all 1000ms ease;\n  transition: all 1000ms ease;\n  transform: scaleX(0);\n}\n.banner-carousel .content-box p {\n  line-height: 28px;\n  color: #fff;\n  opacity: 0;\n  -webkit-transform: translateY(100px);\n  -moz-transform: translateY(100px);\n  -ms-transform: translateY(100px);\n  -o-transform: translateY(100px);\n  transform: translateY(100px);\n  -webkit-transition: all 1000ms ease;\n  -moz-transition: all 1000ms ease;\n  -ms-transition: all 1000ms ease;\n  -o-transition: all 1000ms ease;\n  transition: all 1000ms ease;\n}\n.banner-carousel .content-box .btn-box {\n  position: relative;\n  opacity: 0;\n  -webkit-transform: translateY(50px);\n  -moz-transform: translateY(50px);\n  -ms-transform: translateY(50px);\n  -o-transform: translateY(50px);\n  transform: translateY(50px);\n  -webkit-transition: all 1000ms ease;\n  -moz-transition: all 1000ms ease;\n  -ms-transition: all 1000ms ease;\n  -o-transition: all 1000ms ease;\n  transition: all 1000ms ease;\n}\n.banner-carousel .active .content-box h2 {\n  opacity: 1;\n  transform: scaleX(1);\n}\n.banner-carousel .active .content-box h4 {\n  opacity: 1;\n  transform: scaleX(1);\n}\n.banner-carousel .active .content-box p {\n  opacity: 1;\n  -webkit-transform: translateY(0);\n  -moz-transform: translateY(0);\n  -ms-transform: translateY(0);\n  -o-transform: translateY(0);\n  transform: translateY(0);\n  -webkit-transition-delay: 1000ms;\n  -moz-transition-delay: 1000ms;\n  -ms-transition-delay: 1000ms;\n  -o-transition-delay: 1000ms;\n  transition-delay: 1000ms;\n}\n.banner-carousel .active .content-box .btn-box {\n  opacity: 1;\n  -webkit-transform: translateY(0);\n  -moz-transform: translateY(0);\n  -ms-transform: translateY(0);\n  -o-transform: translateY(0);\n  transform: translateY(0);\n  -webkit-transition-delay: 1300ms;\n  -moz-transition-delay: 1300ms;\n  -ms-transition-delay: 1300ms;\n  -o-transition-delay: 1300ms;\n  transition-delay: 1300ms;\n}\n\n.banner__two .image-layer {\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n}\n.banner__two .content-box {\n  padding-bottom: 83px;\n}\n.banner__two .content-box h2 {\n  font-family: Archivo;\n  font-size: 80px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 90px;\n}\n.banner__two .content-box p {\n  padding-bottom: 40px;\n  padding-right: 30px;\n}\n\nsection.banner__two {\n  padding-top: 313px;\n}\nsection.banner__two:before {\n  content: \"\";\n  width: 460.256px;\n  height: 679.189px;\n  transform: rotate(21.269deg);\n  position: absolute;\n  border-radius: 679.189px;\n  background: linear-gradient(192deg, rgba(246, 236, 79, 0.32) 0%, rgba(150, 6, 147, 0.6) 100%);\n  filter: blur(150px);\n  left: 0;\n  top: -100px;\n  z-index: 1;\n}\n\n.mission__block {\n  padding: 50px 60px;\n  border-right: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.banner__mission__block {\n  border-radius: 10px 0px 0px 0px;\n  background: rgba(255, 255, 255, 0.05);\n  backdrop-filter: blur(15px);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.slider-text-anim.title__last {\n  font-weight: 400;\n  letter-spacing: 16px;\n}\n.slider-text-anim.title__last span {\n  color: #f6ec4f;\n}\n\n.slider-text-anim {\n  display: inline-block;\n  overflow: hidden;\n  position: relative;\n  padding-bottom: 5px;\n}\n.slider-text-anim:before {\n  content: \"\";\n  width: 101%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 100%;\n  background: #fff;\n  -webkit-transition: 1s cubic-bezier(0.858, 0.01, 0.068, 0.99);\n  -o-transition: 1s cubic-bezier(0.858, 0.01, 0.068, 0.99);\n  transition: 1s cubic-bezier(0.858, 0.01, 0.068, 0.99);\n  z-index: 3;\n  -webkit-transform: translateX(-100%);\n  -ms-transform: translateX(-100%);\n  transform: translateX(-100%);\n  -webkit-transition-delay: 1s;\n  -o-transition-delay: 1s;\n  transition-delay: 1s;\n}\n\n.slider-text-anim.black-bg:before {\n  background: #222;\n}\n\n.active .slider-text-anim:before {\n  -webkit-transform: translateX(1%);\n  -ms-transform: translateX(1%);\n  transform: translateX(1%);\n}\n\n.slider-text-anim.two:before {\n  background: #f6ec4f;\n}\n\n.accomplised__data.two {\n  padding: 0px 90px 0px 70px;\n  background: inherit;\n}\n\n.brand__section_two {\n  padding-bottom: 100px;\n  margin: 0px 20px;\n}\n.brand__section_two .brand__content .brand__name h1 {\n  font-size: 60px;\n}\n\n.progress-box .bar-inner {\n  background: #f6ec4f;\n  position: relative;\n  display: block;\n  width: 0px;\n  height: 6px;\n  -webkit-transition: all 1500ms ease;\n  -ms-transition: all 1500ms ease;\n  -o-transition: all 1500ms ease;\n  -moz-transition: all 1500ms ease;\n  transition: all 1500ms ease;\n}\n.progress-box .bar-inner:before {\n  content: \"\";\n  width: 5px;\n  height: 9px;\n  background: #f6ec4f;\n  position: absolute;\n  top: 50%;\n  transform: translate(0%, -50%);\n  right: 0;\n}\n.progress-box .bar {\n  position: relative;\n  width: 100%;\n  height: 6px;\n  background: #ebebeb;\n  margin-bottom: 30px;\n}\n\n.about__two__img__block {\n  padding-top: 60px;\n}\n.about__two__img__block .about__two__circle {\n  position: absolute;\n  top: 0px;\n  right: -20px;\n}\n\n.about__two__circle .circle-main {\n  width: 182px;\n  height: 182px;\n}\n.about__two__circle .circle-main:before {\n  height: 166px;\n  width: 166px;\n  top: 8px;\n  right: 8px;\n}\n.about__two__circle .circle-main .round-text {\n  width: 156px;\n  height: 156px;\n}\n.about__two__circle .circle-main .round-text .text_1 {\n  top: 12px;\n  right: -12px;\n}\n.about__two__circle .circle-main .round-text .text_1 span {\n  transform-origin: 0 80px;\n}\n.about__two__circle .circle-main .circle {\n  height: 100px;\n}\n.about__two__circle .pattern-2 {\n  width: 58.18px;\n  height: 313.33px;\n  right: 36px;\n  top: 157px;\n}\n\n.about__text__two {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  padding-top: 20px;\n  justify-content: center;\n}\n.about__text__two h4 {\n  color: #00061a;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  letter-spacing: 2.88px;\n}\n.about__text__two h4 span {\n  color: #f6ec4f;\n}\n.about__text__two img {\n  width: 25px;\n}\n\n.about___two .about__text__block .texts {\n  padding: 25px 0px;\n}\n.about___two .about__text__block .texts p {\n  color: #666;\n}\n.about___two .pattern-1 {\n  width: 486px;\n  height: 486px;\n  left: 0;\n  bottom: 0;\n  background-repeat: no-repeat;\n}\n\n.content_block_three h6 {\n  color: #00061a;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  padding-bottom: 22px;\n}\n\n.service__two {\n  background: #00061a;\n}\n.service__two .pattern-1 {\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 30%;\n  background-repeat: no-repeat;\n}\n.service__two .pattern-2 {\n  width: 100%;\n  height: 100%;\n  left: 40%;\n  top: 0;\n  background-repeat: no-repeat;\n}\n.service__two:before {\n  content: \"\";\n  width: 392.703px;\n  height: 579.502px;\n  border-radius: 579.502px;\n  background: linear-gradient(192deg, rgba(246, 236, 79, 0.26) 0%, rgba(150, 6, 147, 0.5) 100%);\n  filter: blur(150px);\n  left: 50%;\n  bottom: 0;\n  z-index: 1;\n  position: absolute;\n  transform: translate(-50%, 0%);\n}\n\n.service__block__two {\n  padding: 163px 80px 50px;\n  overflow: hidden;\n}\n.service__block__two .service__image {\n  position: absolute;\n  top: 0;\n  left: 0;\n  transform: translateX(1000px);\n  opacity: 0;\n  transition: all 500ms ease;\n  background-repeat: no-repeat;\n  background-size: cover;\n  width: 100%;\n  height: 100%;\n}\n.service__block__two:hover .service__image {\n  opacity: 1;\n  transform: translate(0px);\n}\n.service__block__two .service__icon {\n  padding-bottom: 22px;\n}\n.service__block__two .service__icon:before {\n  left: 0%;\n  transform: translate(0%, 0%);\n}\n.service__block__two .service__icon i {\n  margin: 0;\n}\n.service__block__two .service__text p {\n  padding: 20px 0px 160px;\n}\n\n.service__number h1 {\n  color: rgba(255, 255, 255, 0.1) !important;\n  font-size: 100px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 90px;\n  position: absolute;\n  top: -70px;\n  left: -4px;\n}\n\n.service__button__two {\n  position: relative;\n}\n.service__button__two a {\n  color: #ff0e75;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 800;\n  line-height: 29px;\n  letter-spacing: 3.2px;\n  text-transform: uppercase;\n}\n.service__button__two a:hover {\n  letter-spacing: 4.2px;\n  color: #f6ec4f;\n}\n\n.choose__text__block {\n  padding-top: 130px;\n}\n.choose__text__block .normal__text {\n  padding: 20px 0px 43px;\n  border-bottom: 1px solid rgba(128, 5, 153, 0.4);\n  position: relative;\n}\n.choose__text__block .normal__text p {\n  color: #666;\n}\n.choose__text__block .normal__text:before {\n  content: \"\";\n  background: #f6ec4f;\n  position: absolute;\n  width: 14px;\n  height: 15px;\n  left: 0;\n  bottom: -8px;\n  clip-path: polygon(50% 0, 100% 25%, 100% 75%, 50% 100%, 0 75%, 0 25%);\n}\n.choose__text__block .normal__text:after {\n  content: \"\";\n  background: #f6ec4f;\n  position: absolute;\n  width: 14px;\n  height: 15px;\n  left: 50%;\n  bottom: -8px;\n  clip-path: polygon(50% 0, 100% 25%, 100% 75%, 50% 100%, 0 75%, 0 25%);\n  transform: translate(-50%, 0%);\n}\n\n.customaize__solution {\n  display: flex;\n  align-items: center;\n  gap: 32px;\n  padding-top: 23px;\n}\n.customaize__solution h5 {\n  color: #00061a;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 36px;\n}\n.customaize__solution p {\n  color: #00061a;\n}\n\n.choose_img__block img {\n  clip-path: polygon(50% 0, 100% 25%, 100% 75%, 50% 100%, 0 75%, 0 25%);\n}\n\n.choose___two .pattern-1 {\n  width: 433px;\n  height: 526px;\n  top: 140px;\n  right: 0px;\n}\n\n.choose_img__two .pattern-3 {\n  width: 268px;\n  height: 216px;\n  z-index: 1;\n  right: 10px;\n  top: 0;\n}\n.choose_img__two .pattern-4 {\n  width: 275px;\n  height: 222px;\n  z-index: 1;\n  bottom: 0;\n  left: 0;\n}\n\n.price__block {\n  background: rgb(6, 14, 38);\n  text-align: center;\n  padding: 180px 0px 18px;\n  margin-top: 50px;\n  clip-path: polygon(50% 0, 100% 25%, 100% 75%, 50% 100%, 0 75%, 0 25%);\n}\n\n.price__data {\n  background: #f6ec4f;\n  width: 183px;\n  height: 203px;\n  position: absolute;\n  top: -50px;\n  padding: 60px 25px;\n  left: 50%;\n  transform: translate(-50%, 0%);\n  clip-path: polygon(50% 0, 100% 25%, 100% 75%, 50% 100%, 0 75%, 0 25%);\n  z-index: 1;\n  text-align: center;\n  transition: all 500ms ease;\n}\n.price__data h5 {\n  color: #00061a;\n  font-size: 26px;\n  font-style: normal;\n  font-weight: 500;\n  text-align: center;\n  transition: all 500ms ease;\n}\n.price__data h4 {\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 42px;\n  color: #00061a;\n  transition: all 500ms ease;\n}\n.price__data h4 span {\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n}\n\n.price__list li {\n  padding-bottom: 18px;\n}\n.price__list li:last-child {\n  padding-bottom: 50px;\n}\n\n.price__icon {\n  background: #800599;\n  width: 40px;\n  height: 49px;\n  position: absolute;\n  left: 50%;\n  transform: translate(-50%, 0%);\n  bottom: -23px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  clip-path: polygon(50% 0, 100% 25%, 100% 75%, 50% 100%, 0 75%, 0 25%);\n  transition: all 500ms ease;\n}\n\n.price__content:hover .price__data {\n  background: #800599;\n}\n.price__content:hover .price__data h5 {\n  color: #fff;\n}\n.price__content:hover .price__data h4 {\n  color: #fff;\n}\n.price__content:hover .price__icon {\n  background: #f6ec4f;\n  color: rgb(0, 6, 26);\n}\n\n.pricing__section .pattern-1 {\n  width: 100%;\n  height: 900px;\n  background-repeat: no-repeat;\n  top: 0;\n}\n.pricing__section .pattern-4 {\n  width: 100%;\n  height: 100%;\n  top: 0;\n  background-repeat: no-repeat;\n  left: 20%;\n}\n\n.portfolio-layer {\n  width: 100%;\n  height: 100%;\n  top: 0;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.portfolio {\n  padding: 119px 0px 0px;\n}\n.portfolio h2 {\n  color: #fff !important;\n}\n\n.protfolio__inner {\n  position: relative;\n  margin-right: -445px;\n  overflow: hidden;\n}\n\n.portfolio__block {\n  overflow: hidden;\n}\n.portfolio__block .lower__content {\n  background: linear-gradient(180deg, rgba(255, 14, 117, 0.6) 0%, rgba(146, 6, 148, 0.6) 100%);\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  transition: all 500ms ease;\n  padding: 30px;\n  transform: translateX(-100%);\n}\n.portfolio__block:hover .lower__content {\n  transform: translateX(0%);\n  opacity: 1;\n}\n\n.protfolio__text {\n  display: flex;\n  justify-content: space-between;\n}\n\n.text__block h4 {\n  font-weight: 600;\n}\n\n.text__block_two h5 {\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 28px;\n}\n\n.protfolio__button {\n  position: absolute;\n  bottom: 30px;\n  left: 30px;\n  width: 86%;\n}\n.protfolio__button a.theme-btn.theme-btn-one {\n  background: #f6ec4f;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 29px;\n  color: #00061a !important;\n  text-transform: capitalize;\n}\n\n.page__title {\n  margin-top: 30px;\n  padding: 232px 0px;\n  text-align: center;\n}\n.page__title .bg-layer {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: -1px;\n  top: 0;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n.page__title .title {\n  font-family: Archivo;\n  font-size: 80px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 90px;\n}\n\n.bread__crumb {\n  display: flex;\n  justify-content: flex-start;\n  padding: 64px 0 0;\n  gap: 8px;\n  white-space: nowrap;\n  flex: 1;\n  overflow-y: auto;\n}\n.bread__crumb li {\n  text-align: center;\n  font-family: Archivo;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: 2px;\n  color: #fff;\n  text-transform: uppercase;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding-bottom: 24px;\n}\n.bread__crumb li button {\n  text-align: center;\n  font-family: Archivo;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: 2px;\n  color: #fff;\n  text-transform: uppercase;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.bread__crumb li button:hover {\n  color: #ff8c2e !important;\n}\n\n.about__section.about__page .pattern-2 {\n  top: 0 !important;\n}\n\n.pride__layer {\n  width: 100%;\n  height: 100%;\n  background-repeat: no-repeat;\n  position: absolute;\n  top: 0;\n  background-size: cover;\n}\n\n.pride__block {\n  text-align: center;\n}\n.pride__block figure img {\n  position: relative;\n}\n.pride__block h1 {\n  font-size: 80px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 90px;\n  padding: 0px 175px;\n}\n\n.service__page .service__block {\n  margin-bottom: 20px;\n}\n.service__page .service__block:before {\n  padding: 1px;\n}\n\n.project__page {\n  margin: 0px 120px;\n}\n.project__page .portfolio__block {\n  margin-bottom: 24px;\n}\n.project__page img {\n  width: 100%;\n}\n\n.team__page .team__block {\n  margin-bottom: 50px;\n}\n\n.testimonial___data .row > div:nth-child(even) {\n  margin-top: 150px;\n}\n\n.testimonials__block__one.page {\n  padding: 0px 20px;\n  position: relative;\n}\n.testimonials__block__one.page .testimonials__info {\n  background: transparent;\n  padding: 0px 49px 80px;\n}\n.testimonials__block__one.page .quote {\n  bottom: -10px;\n}\n\n.blog__details__content .blog__image img {\n  width: 100%;\n  height: 720px;\n  border-radius: 5px 5px 0px 0px;\n}\n.blog__details__content .post__date ul, .blog__details__content .detail__post__date ul {\n  padding: 32px 40px;\n}\n\nh3.blog__title {\n  font-size: 26px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 36px;\n  padding-bottom: 24px;\n}\n\n.blog__inner__box {\n  padding: 20px 40px 52px;\n  background: #060e26;\n}\n\n.blog__details__text p {\n  padding-bottom: 20px;\n  white-space: pre-wrap;\n}\n.blog__details__text ul li {\n  list-style: disc;\n}\n.blog__details__text a {\n  color: #ff8c2e;\n  text-decoration: underline;\n  transition: all 500ms ease;\n  -moz-transition: all 500ms ease;\n  -webkit-transition: all 500ms ease;\n  -ms-transition: all 500ms ease;\n  -o-transition: all 500ms ease;\n}\n.blog__details__text a:hover {\n  color: #ff8c2e;\n  opacity: 0.9;\n  text-decoration: underline;\n  outline: none;\n}\n\n.blog__tags__box {\n  padding: 25px;\n  background: #060e26;\n  margin: 50px 0px;\n}\n\n.tags__left {\n  display: flex;\n  align-items: flex-start;\n  gap: 20px;\n  flex-direction: column;\n}\n.tags__left h3 {\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 36px;\n}\n\n.tags-list-1 {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  flex-wrap: wrap;\n}\n.tags-list-1 li a {\n  color: #00061a;\n  background: rgba(255, 255, 255, 0.5);\n  padding: 8px;\n  border-radius: 4px;\n  text-transform: capitalize;\n}\n\n.blog__comments__area {\n  padding: 40px;\n  background: #060e26;\n}\n\nh3.comments__title {\n  font-size: 26px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 36px;\n  padding-bottom: 30px;\n}\n\n.comments__box {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-bottom: 60px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.15);\n  margin-top: 60px;\n  gap: 26px;\n}\n.comments__box .image__box {\n  flex-shrink: 0;\n  display: flex;\n}\n.comments__box .image__box img {\n  width: 117px;\n  height: 117px;\n  border-radius: 50%;\n}\n.comments__box:nth-last-child(-n+2) {\n  border: none;\n}\n\n.comments__content .upper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-bottom: 20px;\n}\n.comments__content .upper h4 {\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 400;\n}\n.comments__content .upper .reply-btn {\n  background: #ff0e75;\n  padding: 5px 20px;\n}\n\n.comments__form.contact__section {\n  padding: 40px;\n  background: #060e26;\n  margin-top: 60px;\n}\n\n.form__inner input {\n  border-radius: 5px;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  width: 100%;\n  color: rgba(255, 255, 255, 0.25);\n  font-family: Rubik;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  letter-spacing: 2.4px;\n  padding: 22px;\n}\n.form__inner textarea {\n  border-radius: 5px;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  width: 100%;\n  color: rgba(255, 255, 255, 0.25);\n  font-family: Rubik;\n  font-size: 12px;\n  font-style: normal;\n  height: 164px;\n  font-weight: 400;\n  line-height: 24px;\n  letter-spacing: 2.4px;\n  padding: 22px;\n}\n\n.sidebar__search__box input {\n  border-radius: 5px;\n  color: rgba(255, 255, 255, 0.25);\n  font-family: Rubik;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  letter-spacing: 2.4px;\n  text-transform: uppercase;\n  border: 1px solid rgba(255, 255, 255, 0.25);\n  padding: 20px;\n  width: 100%;\n}\n.sidebar__search__box button {\n  position: absolute;\n  right: 22px;\n  color: rgb(255, 255, 255);\n  top: 50%;\n  transform: translate(0%, -50%);\n}\n\n.single__sidebar__box {\n  background: #060e26;\n  padding: 30px;\n  margin-bottom: 40px;\n}\n.single__sidebar__box h3 {\n  font-size: 26px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 36px;\n  padding-bottom: 40px;\n}\n\n.sidebar__blog__post .inner {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n.sidebar__blog__post .inner .img__box {\n  display: flex;\n  flex-shrink: 0;\n}\n.sidebar__blog__post .inner .img__box img {\n  width: 150px;\n  aspect-ratio: 4/3;\n}\n.sidebar__blog__post .title__box h4 {\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 26px;\n}\n.sidebar__blog__post li {\n  margin-bottom: 20px;\n  cursor: pointer;\n  transition: all 500ms ease;\n}\n.sidebar__blog__post li:hover {\n  border-radius: 4px;\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: 1px;\n}\n.sidebar__blog__post .date {\n  color: #ff8c2e;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.sidebar__blog__post .date i {\n  color: #ff8c2e;\n}\n\n.sidebar-categories-box li a {\n  font-family: Rubik;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 26px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding-bottom: 20px;\n}\n.sidebar-categories-box li a i {\n  color: rgb(246, 236, 79);\n}\n\n.contact__right {\n  background: #060e26;\n  padding: 80px;\n}\n\n.form-inner input {\n  color: #fff;\n  font-family: Rubik;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  letter-spacing: 2.4px;\n  border-radius: 5px;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  padding: 22px;\n  width: 100%;\n}\n.form-inner select {\n  color: #fff;\n  font-family: Rubik;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  letter-spacing: 2.4px;\n  border-radius: 5px;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  padding: 22px;\n  width: 100%;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: linear-gradient(45deg, transparent 50%, rgba(255, 255, 255, 0.25) 50%), linear-gradient(135deg, rgba(255, 255, 255, 0.25) 50%, transparent 50%);\n  background-position: calc(100% - 20px) 50%, calc(100% - 15px) 50%;\n  background-size: 5px 5px, 5px 5px;\n  background-repeat: no-repeat;\n}\n.form-inner select:invalid {\n  color: rgba(255, 255, 255, 0.25);\n}\n.form-inner select:focus {\n  color: #ff8c2e;\n  border-color: #ff8c2e;\n}\n.form-inner input:focus,\n.form-inner textarea:focus {\n  color: #ff8c2e;\n  border-color: #ff8c2e;\n}\n.form-inner input::placeholder {\n  color: rgba(255, 255, 255, 0.25);\n}\n.form-inner input::-webkit-input-placeholder {\n  color: rgba(255, 255, 255, 0.25);\n}\n.form-inner input:-moz-placeholder {\n  color: rgba(255, 255, 255, 0.25);\n}\n.form-inner input::-moz-placeholder {\n  color: rgba(255, 255, 255, 0.25);\n}\n.form-inner input:-ms-input-placeholder {\n  color: rgba(255, 255, 255, 0.25);\n}\n.form-inner textarea {\n  border-radius: 5px;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  color: #fff;\n  font-family: Rubik;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  letter-spacing: 2.4px;\n  width: 100%;\n  padding: 22px;\n  height: 235px;\n}\n.form-inner textarea::placeholder {\n  color: rgba(255, 255, 255, 0.25);\n}\n.form-inner textarea::-webkit-input-placeholder {\n  color: rgba(255, 255, 255, 0.25);\n}\n.form-inner textarea:-moz-placeholder {\n  color: rgba(255, 255, 255, 0.25);\n}\n.form-inner textarea::-moz-placeholder {\n  color: rgba(255, 255, 255, 0.25);\n}\n.form-inner textarea:-ms-input-placeholder {\n  color: rgba(255, 255, 255, 0.25);\n}\n\n.contact__left h4 {\n  font-size: 38px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 50px;\n  padding: 30px 0px;\n}\n\n.contact__block {\n  display: flex;\n  align-items: center;\n  gap: 27px;\n  padding-bottom: 40px;\n}\n.contact__block i {\n  border-radius: 2px;\n  background: #f6ec4f;\n  width: 48px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  font-size: 30px;\n  color: rgb(0, 6, 26);\n  justify-content: center;\n}\n.contact__block .two i {\n  background: #ff0e75;\n  color: #fff;\n}\n\n.google__map {\n  width: 100%;\n  height: 780px;\n}\n.google__map img {\n  width: 100%;\n}\n\n.service__contact__block {\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: #060e26;\n}\n\n.service__form__data {\n  padding: 90px 0px 160px 90px;\n}\n\n.service__contact__img {\n  position: absolute;\n  bottom: 0;\n  right: 12px;\n}\n\n.feature-three__wrap {\n  position: relative;\n  display: block;\n  animation: aspro-scroller 27s linear infinite;\n  will-change: transform;\n  white-space: nowrap;\n}\n.feature-three__wrap:hover {\n  animation-play-state: paused;\n}\n\n.feature-three__list {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: nowrap;\n  min-width: 100vw;\n}\n.feature-three__list li {\n  position: relative;\n  display: block;\n}\n.feature-three__list li + li {\n  margin-left: 30px;\n}\n\n.feature-three__title-box {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.feature-three__title {\n  font-family: Rubik;\n  font-size: 60px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  letter-spacing: 5px;\n  text-transform: uppercase;\n  -webkit-text-stroke-width: 1px;\n  -webkit-text-stroke-color: #191f31;\n  color: transparent !important;\n}\n.feature-three__title span {\n  font-family: Rubik;\n  font-size: 60px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  letter-spacing: 5px;\n  text-transform: uppercase;\n  -webkit-text-stroke-width: 1px;\n  -webkit-text-stroke-color: #191f31;\n  color: transparent;\n}\n\n.feature-three--four {\n  padding: 0 0 108px;\n}\n\n.header__three .logo-box {\n  position: absolute;\n  top: 25px;\n  padding: 0 !important;\n  left: 50%;\n  transform: translate(-50%, 0%);\n}\n.header__three .logo-box img {\n  width: 42px;\n  height: 58px;\n}\n.header__three .menu-area {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, 50%);\n}\n.header__three .menu-area nav {\n  display: none;\n}\n.header__three .menu-area .mobile-nav-toggler {\n  display: block !important;\n  float: left;\n}\n.header__three .outer-box {\n  display: block !important;\n  height: 100vh;\n}\n.header__three figure.logo {\n  min-width: 0px !important;\n  display: flex;\n  justify-content: center;\n}\n.header__three .banner__media_two {\n  position: absolute;\n  left: 50%;\n  bottom: 30px;\n  transform: translate(-50%, 0%);\n}\n\n.main-header.header__three {\n  position: fixed;\n  background: #060e26;\n  width: 100px;\n}\n\n.banner__media_two li a {\n  font-weight: 600;\n  line-height: 46.5px;\n}\n\n.home__three .pattern-4 {\n  width: 506px;\n  height: 469px;\n  right: 0;\n  bottom: -140px;\n}\n.home__three .about__block {\n  margin-top: -140px;\n}\n.home__three .about__section:before {\n  content: \"\";\n  width: 412.862px;\n  height: 609.251px;\n  transform: rotate(21.269deg);\n  position: absolute;\n  border-radius: 847.578px;\n  background: linear-gradient(192deg, rgba(246, 236, 79, 0.21) 0%, rgba(150, 6, 147, 0.4) 100%);\n  filter: blur(150px);\n  filter: blur(150px);\n  left: inherit;\n  transform: translate(-50%, 0%);\n  bottom: inherit;\n  right: -100px;\n  top: -100px;\n}\n\n.home__three__banner {\n  position: relative;\n}\n.home__three__banner .image-layer {\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n}\n.home__three__banner .banner__data {\n  padding: 0;\n}\n.home__three__banner h1 span {\n  font-weight: 700;\n}\n.home__three__banner h1 span.color {\n  color: #f6ec4f;\n}\n.home__three__banner .btn-box {\n  padding-bottom: 120px;\n}\n.home__three__banner .banner__mission__block {\n  border-radius: 0;\n}\n.home__three__banner .banner__bottom {\n  border-radius: 0px 10px 0px 0px;\n}\n.home__three__banner .pattern-3 {\n  width: 299px;\n  height: 411px;\n  left: 233px;\n  bottom: 240px;\n}\n\n.banner__media {\n  padding: 54px 0px 100px;\n}\n.banner__media ul {\n  display: flex;\n  align-items: center;\n  gap: 65px;\n  justify-content: flex-end;\n}\n\n.choose__us.three .pattern-2 {\n  width: 299px;\n  height: 300px;\n  background-repeat: no-repeat;\n  left: 100px;\n  top: -80px;\n  width: 299px;\n  height: 300px;\n  background-repeat: no-repeat;\n  left: 100px;\n  top: -80px;\n}\n.choose__us.three:before {\n  display: none;\n}\n\n.choose_us_block h2 {\n  padding-bottom: 30px;\n}\n.choose_us_block li {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-family: Rubik;\n  font-size: 26px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 36px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n  padding: 20px 0px;\n}\n.choose_us_block li:nth-child(1) {\n  padding-top: 0;\n}\n.choose_us_block li:nth-child(4) {\n  border: none;\n}\n\n.portfolio.home__three__p {\n  border-radius: 5px;\n  background: #060e26;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  margin-top: 140px;\n  padding: 140px 0px 120px;\n}\n\n.accomplised__data.two.three {\n  background: #060e26 !important;\n  border-radius: 10px;\n  padding: 120px 90px 120px 70px;\n}\n\nsection.accomplised__section__two.see__pad.three:before {\n  content: \"\";\n  position: absolute;\n  border-radius: 528.747px;\n  background: linear-gradient(192deg, rgba(246, 236, 79, 0.26) 0%, rgba(150, 6, 147, 0.5) 100%);\n  filter: blur(150px);\n  width: 358.308px;\n  height: 528.747px;\n  transform: rotate(21.269deg);\n  flex-shrink: 0;\n  left: 100px;\n  bottom: -104px;\n}\n\n.accomplised__section__two.see__pad.three {\n  background: #00061a;\n  position: relative;\n}\n\n.consultation__list {\n  padding-top: 41px;\n}\n.consultation__list li a {\n  width: 100%;\n  font-family: Rubik;\n  font-size: 26px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 36px;\n  padding: 35px 0px 35px 85px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n.consultation__list li a span {\n  height: 100%;\n  padding: 0px 16px;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  position: absolute;\n  display: flex;\n  align-items: center;\n  border-right: 1px solid rgba(255, 255, 255, 0.2);\n  width: 52px;\n  left: 0;\n}\n\n.consultation__img {\n  margin-top: -50px;\n}\n\n.consultation__text {\n  position: absolute;\n  width: 460px;\n  left: 80px;\n  top: 50%;\n  transform: translate(0%, -50%);\n}\n.consultation__text h3 {\n  padding-bottom: 30px;\n}\n.consultation__text p {\n  padding-bottom: 20px;\n}\n\n.consultation__button {\n  padding-top: 20px;\n}\n.consultation__button a:hover {\n  letter-spacing: 3px;\n}\n\n.pricing__section.three:before {\n  content: \"\";\n  width: 790px;\n  height: 790px;\n  flex-shrink: 0;\n  border-radius: 790px;\n  background: var(--shadow, linear-gradient(192deg, rgba(246, 236, 79, 0.32) 0%, rgba(150, 6, 147, 0.6) 100%));\n  filter: blur(300px);\n  position: absolute;\n  top: -27%;\n  left: 34%;\n}\n\n.service__contact.three {\n  padding-bottom: 140px;\n}\n.service__contact.three:after {\n  content: \"\";\n  width: 574.366px;\n  height: 847.578px;\n  transform: rotate(21.269deg);\n  flex-shrink: 0;\n  border-radius: 847.578px;\n  background: var(--shadow-2, linear-gradient(180deg, rgba(246, 236, 79, 0.32) 0%, rgba(150, 6, 147, 0.14) 90.86%));\n  filter: blur(150px);\n  position: absolute;\n  right: 0;\n}\n\n.service__details {\n  padding: 140px 0px 0px;\n}\n\n.all__service h3 {\n  background: #ff8c2e;\n  padding: 14px 30px;\n}\n\n.sidebar__widget {\n  position: relative;\n  padding: 24px;\n}\n.sidebar__widget:before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  padding: 1px;\n  background: linear-gradient(180deg, rgba(246, 236, 79, 0.08), rgba(150, 6, 147, 0.23));\n  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);\n  -webkit-mask-composite: xor;\n  mask-composite: exclude;\n  z-index: -1;\n  border-radius: 4px;\n}\n\nul.service__details__1__cat {\n  padding: 30px 0px;\n}\n\n.service__details__1__cat a {\n  padding: 10px 30px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-family: Archivo;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 29px;\n  cursor: pointer;\n  position: relative;\n  margin-bottom: 10px;\n  transition: all 150ms ease-in-out;\n}\n.service__details__1__cat a:before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  padding: 1px;\n  background: linear-gradient(192deg, #ff8c2e 0%, rgba(150, 6, 147, 0.6) 100%);\n  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);\n  -webkit-mask-composite: xor;\n  mask-composite: exclude;\n  z-index: -1;\n  border-radius: 4px;\n}\n.service__details__1__cat a:hover {\n  color: #fff;\n  font-weight: 600;\n}\n.service__details__1__cat a.active {\n  color: #fff;\n  font-weight: 600;\n  background: linear-gradient(192deg, #ff8c2e 0%, rgba(150, 6, 147, 0.6) 100%);\n  border-radius: 4px;\n}\n\n.sidebar__widget_network {\n  margin-top: 40px;\n  padding: 120px 60px;\n  text-align: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n.sidebar__widget_network .services__icon i {\n  width: 90px;\n  height: 90px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(192deg, #ff8c2e 0%, #7e2100 100%);\n  margin: 20px auto;\n  font-size: 40px;\n  border-radius: 50%;\n}\n\n.service__right {\n  position: relative;\n}\n.service__right h2 {\n  padding: 40px 0px 35px;\n}\n.service__right h2 span {\n  color: #ff0e75;\n}\n.service__right h3 {\n  margin: 0 0 24px;\n}\n.service__right .row {\n  padding: 30px 0px 0px;\n}\n.service__right li a {\n  position: relative;\n  font-family: Rubik;\n  font-size: 22px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 36px;\n  padding: 10px 20px;\n  width: 100%;\n  align-items: center;\n  display: flex;\n  gap: 18px;\n  margin-bottom: 40px;\n}\n.service__right li a:before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  padding: 1px;\n  background: linear-gradient(192deg, #ff8c2e 0%, rgba(150, 6, 147, 0.23) 100%);\n  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);\n  -webkit-mask-composite: xor;\n  mask-composite: exclude;\n  z-index: -1;\n  border-radius: 4px;\n}\n.service__right li a i {\n  width: 70px;\n  height: 70px;\n  background: #666;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 5px;\n  font-size: 40px;\n  transition: all 500ms ease;\n}\n.service__right li a:hover i {\n  background: #ff8c2e;\n  color: #fff;\n}\n.service__right:before {\n  width: 412.862px;\n  height: 609.251px;\n  transform: rotate(21.269deg);\n  flex-shrink: 0;\n  border-radius: 609.251px;\n  background: linear-gradient(192deg, rgba(246, 236, 79, 0.21) 0%, rgba(150, 6, 147, 0.4) 100%);\n  filter: blur(150px);\n  position: absolute;\n  content: \"\";\n  left: -16%;\n  top: 4%;\n}\n\n.error__page h1.title {\n  text-align: center;\n  font-family: Rubik;\n  font-size: 400px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n.error__page h1.title span {\n  color: #ff8c2e;\n}\n\n.page__title.error__page {\n  margin-top: 0;\n  padding: 0;\n  width: 100%;\n  height: 100dvh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.page__title.error__page .btn-box {\n  justify-content: center;\n  padding-top: 40px;\n}\n\n.project__details {\n  padding-top: 140px;\n}\n.project__details .image img {\n  border-radius: 5px;\n}\n.project__details .data h4 {\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 42px;\n  padding: 50px 0px 35px;\n}\n.project__details .data__list {\n  padding: 40px 0px 100px;\n}\n.project__details .data__list li {\n  font-family: Archivo;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 29px;\n  display: flex;\n  align-items: center;\n  margin-bottom: 15px;\n  gap: 15px;\n}\n.project__details .data__list li i {\n  width: 20px;\n  height: 20px;\n  background: #666;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.project__details .project__button {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 30px 50px;\n  border-top: 1px solid rgba(234, 234, 234, 0.1);\n  border-bottom: 1px solid rgba(234, 234, 234, 0.1);\n}\n.project__details .button__one a {\n  font-family: Rubik;\n  font-size: 26px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 36px;\n}\n\n.pro__info {\n  background: #ff0e75;\n  border-radius: 10px;\n  padding: 60px;\n  max-width: 800px;\n  margin: -94px auto 0;\n  position: relative;\n}\n.pro__info ul {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.pro__info .name__two h4 {\n  font-size: 30px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 40px;\n}\n\n@media (min-width: 768px) {\n  .feature-three__list li + li {\n    margin-left: 50px;\n  }\n}\n@media (min-width: 1200px) {\n  .feature-three__list li + li {\n    margin-left: 70px;\n  }\n}\n@media (min-width: 768px) {\n  .feature-three__list li + li {\n    margin-left: 50px;\n  }\n}\n@media (min-width: 1200px) {\n  .feature-three__list li + li {\n    margin-left: 70px;\n  }\n}\n.mobile-menu .navigation li .dropdown-btn.open + ul {\n  display: block;\n}\n\n.form-inner .form-group {\n  margin-bottom: 1rem;\n}\n\n.account-info-wrapper {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  transition: all 500ms ease;\n}\n.account-info-wrapper svg {\n  fill: #fff;\n}\n.account-info-wrapper svg path,\n.account-info-wrapper a {\n  transition: all 500ms ease;\n  fill: #fff;\n  color: #fff;\n}\n\n.account-info-wrapper:hover svg path,\n.account-info-wrapper:hover a {\n  fill: #ff8c2e;\n  color: #ff8c2e !important;\n}\n\n.map-popup .leaflet-popup-content-wrapper {\n  border-radius: 6px;\n  padding: 8px 12px;\n}\n.map-popup .leaflet-popup-tip-container {\n  display: none;\n}\n.map-popup .leaflet-popup-content,\n.map-popup .leaflet-popup-content p {\n  padding: 0;\n  margin: 0;\n  color: #00061a;\n  font-family: Archivo;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  text-align: center;\n}\n.map-popup .leaflet-popup-close-button {\n  display: none;\n}\n\n.office-wrapper {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 8px;\n}\n\n.office-map-wrapper {\n  width: 100%;\n  height: 780px;\n}\n\n.news-articles-wrapper {\n  margin-top: 32px;\n  width: 100%;\n  gap: 32px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.editorial-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  gap: 12px;\n}\n.editorial-wrapper a {\n  color: #ff8c2e;\n  transition: all 500ms ease;\n  -moz-transition: all 500ms ease;\n  -webkit-transition: all 500ms ease;\n  -ms-transition: all 500ms ease;\n  -o-transition: all 500ms ease;\n}\n.editorial-wrapper a:hover {\n  color: #ff8c2e;\n  opacity: 0.9;\n  outline: none;\n}\n.editorial-wrapper p {\n  text-align: center;\n}\n\n.social-media-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n}\n.social-media-wrapper div {\n  display: inherit;\n  gap: 8px;\n}\n.social-media-wrapper div > div {\n  display: inherit;\n}\n.social-media-wrapper div > div svg {\n  fill: #ffffff;\n}\n.social-media-wrapper div > div svg path,\n.social-media-wrapper div > div a {\n  transition: all 500ms ease;\n  fill: #ffffff;\n  color: #ffffff;\n}\n.social-media-wrapper div > div:hover svg path,\n.social-media-wrapper div > div:hover a {\n  fill: #ff8c2e;\n  color: #ff8c2e !important;\n}\n\n.content-markdown p:has(img) {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px;\n}\n@media (max-width: 768px) {\n  .content-markdown p:has(img) {\n    grid-template-columns: 1fr;\n  }\n}\n\n.image-content-markdown {\n  max-width: 100%;\n  height: auto;\n  display: block;\n  margin: 20px auto;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);\n  border-radius: 4px;\n}\n\n/*!\nAnimate.css - http://daneden.me/animate\nLicensed under the MIT license - http://opensource.org/licenses/MIT\n\nCopyright (c) 2023 Daniel Eden\n*/\n@keyframes \"zoomInOut\" {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(0.8);\n  }\n  to {\n    transform: scale(1);\n  }\n}\n@keyframes \"moveLeftBounce\" {\n  0% {\n    transform: translateX(0);\n  }\n  50% {\n    transform: translateX(50px) translateY(20px);\n  }\n  to {\n    transform: translateX(0);\n  }\n}\n@keyframes \"animationFramesOne\" {\n  0% {\n    transform: translate(0) rotate(0deg);\n  }\n  20% {\n    transform: translate(73px, -1px) rotate(36deg);\n  }\n  40% {\n    transform: translate(141px, 72px) rotate(72deg);\n  }\n  60% {\n    transform: translate(83px, 122px) rotate(108deg);\n  }\n  80% {\n    transform: translate(-40px, 72px) rotate(144deg);\n  }\n  to {\n    transform: translate(0) rotate(0deg);\n  }\n}\n@keyframes \"rotateme\" {\n  0% {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(1turn);\n  }\n}\n@keyframes \"float-bob-y\" {\n  0% {\n    -webkit-transform: translateY(-20px);\n    transform: translateY(-20px);\n  }\n  50% {\n    -webkit-transform: translateY(-10px);\n    transform: translateY(-10px);\n  }\n  100% {\n    -webkit-transform: translateY(-20px);\n    transform: translateY(-20px);\n  }\n}\n.animation-moveLeftBounce {\n  animation: moveLeftBounce 3s linear infinite;\n}\n\n.animation-zoomInOut {\n  animation: zoomInOut 3s linear infinite;\n}\n\n.animation-animationFramesOne {\n  animation: animationFramesOne 20s linear infinite;\n}\n\n.animation-rotateme {\n  animation-name: rotateme;\n  animation-duration: 20s;\n  animation-iteration-count: infinite;\n  animation-timing-function: linear;\n}\n\n.float-bob-y {\n  animation-name: float-bob-y;\n  animation-duration: 2s;\n  animation-iteration-count: infinite;\n  animation-timing-function: linear;\n  -webkit-animation-name: float-bob-y;\n  -webkit-animation-duration: 2s;\n  -webkit-animation-iteration-count: infinite;\n  -webkit-animation-timing-function: linear;\n  -moz-animation-name: float-bob-y;\n  -moz-animation-duration: 2s;\n  -moz-animation-iteration-count: infinite;\n  -moz-animation-timing-function: linear;\n  -ms-animation-name: float-bob-y;\n  -ms-animation-duration: 2s;\n  -ms-animation-iteration-count: infinite;\n  -ms-animation-timing-function: linear;\n  -o-animation-name: float-bob-y;\n  -o-animation-duration: 2s;\n  -o-animation-iteration-count: infinite;\n  -o-animation-timing-function: linear;\n}\n\n.blog-standard-content .news-block-one .lower-content .category a:hover {\n  text-decoration: underline;\n}\n.blog-standard-content .news-block-one .inner-box {\n  border-bottom: 1px solid #e5e5e5;\n}\n\n.news-block-one.video-block .image-box .video-btn {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n}\n.news-block-one.video-block .image-box .video-btn a {\n  background: #fff;\n}\n.news-block-one.video-block .image-box .video-btn a:before {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  background: transparent;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  -webkit-animation-delay: 0.9s;\n  animation-delay: 0.9s;\n  content: \"\";\n  position: absolute;\n  -webkit-box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.9);\n  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.9);\n  -webkit-animation: ripple 3s infinite;\n  animation: ripple 3s infinite;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.news-block-one.video-block .image-box .video-btn a:after {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  background: transparent;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  -webkit-animation-delay: 0.9s;\n  animation-delay: 0.9s;\n  content: \"\";\n  position: absolute;\n  -webkit-box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.9);\n  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.9);\n  -webkit-animation: ripple 3s infinite;\n  animation: ripple 3s infinite;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n  -webkit-animation-delay: 0.6s;\n  animation-delay: 0.6s;\n}\n.news-block-one.video-block .image-box img {\n  opacity: 1 !important;\n  border-radius: 5px;\n}\n.news-block-one.video-block .image-box .image:before {\n  position: absolute;\n  content: \"\";\n  background: #000;\n  width: 100%;\n  height: 100%;\n  left: 0px;\n  top: 0px;\n  opacity: 0.3;\n  z-index: 1;\n  border-radius: 5px;\n}\n\n.news-block-one.carousel-block .inner-box .image img {\n  opacity: 1 !important;\n  border-radius: 5px;\n}\n.news-block-one.carousel-block .owl-nav {\n  position: absolute;\n  left: 0px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 100%;\n}\n.news-block-one.carousel-block .owl-nav button {\n  position: absolute;\n  display: inline-block;\n  width: 50px;\n  height: 50px;\n  line-height: 50px;\n  background: #fff;\n  font-size: 20px;\n  color: #141417;\n  text-align: center;\n  border-radius: 50%;\n  transition: all 500ms ease;\n}\n.news-block-one.carousel-block .owl-nav button:hover {\n  color: #fff;\n}\n.news-block-one.carousel-block .owl-nav button.owl-prev {\n  left: 30px;\n}\n.news-block-one.carousel-block .owl-nav button.owl-next {\n  right: 30px;\n}\n\n.news-block-one .inner-box blockquote .icon-box {\n  color: #fceee7;\n}\n.news-block-one .inner-box blockquote h5.name:before {\n  position: absolute;\n  content: \"\";\n  background: #141417;\n  width: 15px;\n  height: 2px;\n  left: 0px;\n  top: 12px;\n}\n\n.news-block-one.quote-block .inner-box {\n  overflow: visible;\n}\n\n.sidebar-page-container .pagination li {\n  border-radius: 5px;\n}\n.sidebar-page-container .pagination li a {\n  border-radius: 5px;\n}\n.sidebar-page-container .inner-container {\n  background: #fff;\n}\n.sidebar-page-container .inner-container:before {\n  position: absolute;\n  content: \"\";\n  background: #fff;\n  width: calc(100% + 140px);\n  height: 100%;\n  left: -70px;\n  top: 0px;\n}\n.sidebar-page-container .theme-btn {\n  border: 1px solid #e7e7e7;\n  color: #141417 !important;\n  padding: 11px 32px;\n}\n.sidebar-page-container .theme-btn:hover {\n  color: #fff !important;\n  border-color: #e45712;\n}\n\n.blog-sidebar .sidebar-widget {\n  background: #f7f7f7;\n}\n.blog-sidebar .search-widget .search-form .form-group input[type=search] {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: 60px;\n  border: 1px solid #e5e5e5;\n  border-radius: 5px;\n  font-size: 16px;\n  color: #808080;\n  font-family: \"Poppins\", sans-serif;\n  padding: 10px 20px 10px 60px;\n  transition: all 500ms ease;\n  background: #f7f7f7;\n}\n.blog-sidebar .search-widget .search-form .form-group button {\n  position: absolute;\n  left: 28px;\n  top: 18px;\n  font-size: 18px;\n  color: #808080;\n  cursor: pointer;\n  transition: all 500ms ease;\n}\n.blog-sidebar .post-widget .post {\n  border-bottom: 1px solid #e5e5e5;\n  min-height: 104px;\n}\n.blog-sidebar .post-widget .post:last-child {\n  border-bottom: none;\n}\n.blog-sidebar .post-widget .post .post-thumb img {\n  width: 100%;\n  border-radius: 5px;\n}\n.blog-sidebar .post-widget .post:hover .post-thumb img {\n  opacity: 0.2;\n}\n.blog-sidebar .post-widget .post h5 {\n  line-height: 24px;\n}\n.blog-sidebar .tags-widget .tags-list {\n  margin: 0px -5px;\n}\n.blog-sidebar .tags-widget .tags-list li a {\n  padding: 5px 14px;\n  border: 1px solid #e5e5e5;\n}\n.blog-sidebar .tags-widget .tags-list li a:hover {\n  color: #fff;\n}\n\n.blog-standard-2 .blog-standard-content .news-block-one .inner-box {\n  border-bottom: none;\n}\n.blog-standard-2 .news-block-one .inner-box blockquote {\n  border-left: none;\n  background: #302f2f;\n}\n.blog-standard-2 .news-block-one .inner-box blockquote .icon-box {\n  color: #454444;\n  left: 50%;\n  transform: translateX(-50%);\n}\n.blog-standard-2 .news-block-one .inner-box blockquote h5 {\n  color: #fff;\n}\n.blog-standard-2 .news-block-one .inner-box blockquote h5:before {\n  display: none;\n}\n.blog-standard-2 .blog-sidebar .sidebar-widget {\n  background: transparent;\n}\n\n.blog-grid-one .news-block-one .inner-box .post-date-two {\n  background: #fff;\n}\n.blog-grid-one .news-block-one .inner-box .post-date-two h4 {\n  color: #141417;\n}\n.blog-grid-one .news-block-one .inner-box .theme-btn {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 500;\n  border-radius: 0px;\n  padding: 11px 32px;\n}\n\n.blog-grid-two .news-block-one .inner-box .theme-btn {\n  font-size: 16px;\n  border-radius: 30px;\n  padding-top: 11px;\n  padding-bottom: 11px;\n}\n.blog-grid-two .news-block-one .inner-box .theme-btn:hover {\n  border-color: #e45712;\n  background: #e45712;\n}\n.blog-grid-two .pagination li a {\n  border-radius: 50%;\n}\n\n.blog-masonry-two .more-btn .theme-btn {\n  background: #e45712;\n  padding: 12px 40px;\n}\n.blog-masonry-two .news-block-one .inner-box blockquote {\n  border-left: none;\n  background: #302f2f;\n}\n.blog-masonry-two .news-block-one .inner-box blockquote .icon-box {\n  color: #454444;\n  left: 50%;\n  transform: translateX(-50%);\n}\n.blog-masonry-two .news-block-one .inner-box blockquote h5 {\n  color: #fff;\n}\n.blog-masonry-two .news-block-one .inner-box blockquote h5:before {\n  display: none;\n}\n.blog-masonry-two .news-block-one.carousel-block .inner-box .image img {\n  border-radius: 0px;\n}\n\n.blog-list-content .news-block-one .inner-box {\n  padding-left: 370px;\n}\n.blog-list-content .news-block-one .inner-box .image-box {\n  width: 370px;\n  height: 370px;\n}\n.blog-list-content .news-block-one .inner-box .post-date-two {\n  background: #fff;\n}\n.blog-list-content .news-block-one .inner-box .post-date-two h4 {\n  color: #141417;\n}\n.blog-list-content .news-block-one .inner-box .theme-btn {\n  border-radius: 0px;\n}\n\n.blog-details-content .blog-post .content-one .post-title .post-info li:before {\n  position: absolute;\n  content: \"\";\n  background: #e5e5e5;\n  width: 6px;\n  height: 6px;\n  top: 12px;\n  right: -19px;\n  border-radius: 50%;\n}\n.blog-details-content .blog-post .content-one .post-title .post-info li:last-child:before {\n  display: none;\n}\n.blog-details-content .blog-post .image-box img {\n  border-radius: 5px;\n  width: 100%;\n}\n.blog-details-content blockquote .icon-box {\n  color: #fceee7;\n}\n.blog-details-content blockquote h5.name:before {\n  position: absolute;\n  content: \"\";\n  background: #141417;\n  width: 15px;\n  height: 2px;\n  left: 0px;\n  top: 12px;\n}\n.blog-details-content .list li:before {\n  position: absolute;\n  content: \"\";\n  left: 0px;\n  top: 6px;\n  width: 12px;\n  height: 12px;\n  border: 2px solid #141417;\n  border-radius: 50%;\n}\n.blog-details-content .post-share-option {\n  border-top: 1px solid #e5e5e5;\n  border-bottom: 1px solid #e5e5e5;\n}\n.blog-details-content .post-share-option .tags-list li a {\n  padding: 9px 14px;\n  border: 1px solid #e5e5e5;\n}\n.blog-details-content .post-share-option .tags-list li a:hover {\n  color: #fff;\n}\n.blog-details-content .post-share-option .social-list li a {\n  border: 1px solid #e6e6e6;\n  color: #808080;\n}\n.blog-details-content .post-share-option .social-list li a:hover {\n  color: #fff;\n}\n.blog-details-content .nav-btn .single-btn {\n  border: 1px solid #e7e7e7;\n}\n.blog-details-content .nav-btn .single-btn:hover {\n  border-color: transparent;\n  box-shadow: 0px 5px 30px 0px rgba(0, 0, 0, 0.07);\n}\n.blog-details-content .nav-btn .single-btn h6 i {\n  position: relative;\n  font-size: 22px;\n  top: 3px;\n}\n.blog-details-content .nav-btn .single-btn.prev-btn h6 i {\n  margin-right: 8px;\n}\n.blog-details-content .nav-btn .single-btn.next-btn h6 i {\n  margin-left: 8px;\n}\n.blog-details-content .author-box {\n  box-shadow: 0px 5px 30px 0px rgba(0, 0, 0, 0.07);\n}\n.blog-details-content .author-box .author-thumb img {\n  width: 100%;\n  border-radius: 50%;\n}\n.blog-details-content .comments-form-area .form-group {\n  margin-bottom: 20px;\n}\n.blog-details-content .comments-form-area .form-group:last-child {\n  margin-bottom: 0px;\n}\n.blog-details-content .comments-form-area .form-group input[type=text] {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: 50px;\n  font-size: 16px;\n  font-family: \"Poppins\", sans-serif;\n  color: #808080;\n  border-bottom: 1px solid #e5e5e5;\n  transition: all 500ms ease;\n}\n.blog-details-content .comments-form-area .form-group input[type=email] {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: 50px;\n  font-size: 16px;\n  font-family: \"Poppins\", sans-serif;\n  color: #808080;\n  border-bottom: 1px solid #e5e5e5;\n  transition: all 500ms ease;\n}\n.blog-details-content .comments-form-area .form-group textarea {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: 50px;\n  font-size: 16px;\n  font-family: \"Poppins\", sans-serif;\n  color: #808080;\n  border-bottom: 1px solid #e5e5e5;\n  transition: all 500ms ease;\n  height: 60px;\n  resize: none;\n}\n.blog-details-content .comments-form-area .check-box label {\n  color: #808080;\n}\n.blog-details-content .comments-form-area .theme-btn {\n  padding: 13px 31px;\n  background: #e35712;\n  color: #fff !important;\n  border: none;\n}\n\n.page-title .post-title h2 {\n  color: #fff;\n}\n.page-title .post-title .post-info li {\n  color: #fff;\n}\n.page-title .post-title .post-info li:before {\n  position: absolute;\n  content: \"\";\n  background: #e5e5e5;\n  width: 6px;\n  height: 6px;\n  top: 12px;\n  right: -19px;\n  border-radius: 50%;\n}\n.page-title .post-title .post-info li:last-child:before {\n  display: none;\n}\n\n.page-title.blog-details {\n  padding-top: 237px;\n  padding-bottom: 182px;\n}\n\n.sidebar-page-container.blog-details-3 {\n  padding-top: 420px;\n}\n.sidebar-page-container.blog-details-3 .bg-image {\n  width: 100%;\n  height: 722px;\n  background-size: cover;\n  border-radius: inherit;\n  background-position: bottom center;\n}\n\n/* template-color */\n.handle-preloader {\n  background: linear-gradient(224deg, #800599 0%, #FF0E75 100%);\n}\n\n.handle-preloader.home-2 {\n  background: -webkit-linear-gradient(0deg, #41a0ea, #f18e95 75%);\n}\n\n.theme-btn-one {\n  background: linear-gradient(219deg, #ff8c2e 0%, #7E2100 100%);\n}\n.theme-btn-one:before {\n  background: linear-gradient(219deg, #ff8c2e 0%, #7E2100 100%);\n}\n\n/*** use-font ***/\n/*** \n\n====================================================================\n  Reset\n====================================================================\n\n ***/\n/*** \n\n====================================================================\n  Global Settings\n====================================================================\n\n ***/\n/** use-font-family **/\n/* Preloader */\n@keyframes spin-1 {\n  from {\n    transform: rotateY(0) rotateX(30deg);\n  }\n  to {\n    transform: rotateY(1turn) rotateX(30deg);\n  }\n}\n@keyframes spin-2 {\n  from {\n    transform: rotateY(0);\n  }\n  to {\n    transform: rotateY(1turn);\n  }\n}\n@-webkit-keyframes shine {\n  100% {\n    left: 125%;\n  }\n}\n@keyframes shine {\n  100% {\n    left: 125%;\n  }\n}\n@-webkit-keyframes circle {\n  0% {\n    opacity: 1;\n  }\n  40% {\n    opacity: 1;\n  }\n  100% {\n    width: 200%;\n    height: 200%;\n    opacity: 0;\n  }\n}\n@keyframes circle {\n  0% {\n    opacity: 1;\n  }\n  40% {\n    opacity: 1;\n  }\n  100% {\n    width: 200%;\n    height: 200%;\n    opacity: 0;\n  }\n}\n@-webkit-keyframes ripple {\n  70% {\n    -webkit-box-shadow: 0 0 0 40px rgba(255, 255, 255, 0);\n    box-shadow: 0 0 0 40px rgba(255, 255, 255, 0);\n  }\n  100% {\n    -webkit-box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);\n    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);\n  }\n}\n@keyframes ripple {\n  70% {\n    -webkit-box-shadow: 0 0 0 40px rgba(255, 255, 255, 0);\n    box-shadow: 0 0 0 40px rgba(255, 255, 255, 0);\n  }\n  100% {\n    -webkit-box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);\n    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);\n  }\n}\n@keyframes slide {\n  from {\n    background-position: 0 0;\n  }\n  to {\n    background-position: 1920px 0;\n  }\n}\n@-webkit-keyframes slide {\n  from {\n    background-position: 0 0;\n  }\n  to {\n    background-position: 1920px 0;\n  }\n}\n* {\n  margin: 0px;\n  padding: 0px;\n  border: none;\n  outline: none;\n}\n\nbody {\n  font-size: 16px;\n  color: #fff;\n  line-height: 28px;\n  font-weight: 400;\n  background: #00061A;\n  font-family: \"Archivo\", sans-serif;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center top;\n  -webkit-font-smoothing: antialiased;\n}\n\n.auto-container {\n  position: static;\n  max-width: 1296px;\n  padding: 0px 15px;\n  margin: 0 auto;\n}\n\n.small-container {\n  max-width: 680px;\n  margin: 0 auto;\n}\n\n.boxed_wrapper {\n  position: relative;\n  margin: 0 auto;\n  overflow: hidden !important;\n  width: 100%;\n  min-width: 300px;\n}\n\na {\n  color: #fff;\n  text-decoration: none;\n  transition: all 500ms ease;\n  -moz-transition: all 500ms ease;\n  -webkit-transition: all 500ms ease;\n  -ms-transition: all 500ms ease;\n  -o-transition: all 500ms ease;\n}\na:hover {\n  color: #ff8c2e;\n  text-decoration: none;\n  outline: none;\n}\n\ninput {\n  font-family: \"Archivo\", sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  background: transparent;\n  transition: all 500ms ease;\n}\ninput:focus {\n  outline: none;\n  box-shadow: none;\n  transition: all 500ms ease;\n}\n\nbutton {\n  font-family: \"Archivo\", sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  background: transparent;\n}\nbutton:focus {\n  outline: none;\n  box-shadow: none;\n  transition: all 500ms ease;\n}\n\nselect {\n  font-family: \"Archivo\", sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  background: transparent;\n}\n\ntextarea {\n  font-family: \"Archivo\", sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  background: transparent;\n}\ntextarea:focus {\n  outline: none;\n  box-shadow: none;\n  transition: all 500ms ease;\n}\n\n::-webkit-input-placeholder {\n  color: inherit;\n}\n\n::-moz-input-placeholder {\n  color: inherit;\n}\n\n::-ms-input-placeholder {\n  color: inherit;\n}\n\nul {\n  list-style: none;\n  padding: 0px;\n  margin: 0px;\n}\n\nli {\n  list-style: none;\n  padding: 0px;\n  margin: 0px;\n}\n\np {\n  position: relative;\n  font-family: \"Archivo\", sans-serif;\n  color: #fff;\n  font-size: 16px;\n  line-height: 29px;\n  margin-bottom: 0px;\n  font-weight: 400;\n  transition: all 500ms ease;\n}\np:last-child {\n  margin-bottom: 0px;\n}\n\nh1 {\n  position: relative;\n  font-family: \"Rubik\", sans-serif;\n  font-weight: 400;\n  color: #fff;\n  line-height: 29px;\n  margin: 0px;\n  transition: all 500ms ease;\n  font-size: 50px;\n  line-height: 60px;\n}\n\nh2 {\n  position: relative;\n  font-family: \"Rubik\", sans-serif;\n  font-weight: 400;\n  color: #fff;\n  line-height: 29px;\n  margin: 0px;\n  transition: all 500ms ease;\n  font-size: 40px;\n  font-weight: 700;\n  line-height: 50px;\n}\n\nh3 {\n  position: relative;\n  font-family: \"Rubik\", sans-serif;\n  font-weight: 400;\n  color: #fff;\n  line-height: 29px;\n  margin: 0px;\n  transition: all 500ms ease;\n  font-size: 32px;\n  font-weight: 600;\n  line-height: 42px;\n}\n\nh4 {\n  position: relative;\n  font-family: \"Rubik\", sans-serif;\n  font-weight: 400;\n  color: #fff;\n  line-height: 29px;\n  margin: 0px;\n  transition: all 500ms ease;\n  font-size: 26px;\n  font-weight: 500;\n  line-height: 36px;\n}\n\nh5 {\n  position: relative;\n  font-family: \"Rubik\", sans-serif;\n  font-weight: 400;\n  color: #fff;\n  line-height: 29px;\n  margin: 0px;\n  transition: all 500ms ease;\n}\n\nh6 {\n  position: relative;\n  font-family: \"Rubik\", sans-serif;\n  font-weight: 400;\n  color: #fff;\n  line-height: 29px;\n  margin: 0px;\n  transition: all 500ms ease;\n}\n\n.font_family_rubik {\n  font-family: \"Rubik\", sans-serif;\n}\n\n.font_family_archivo {\n  font-family: \"Archivo\", sans-serif;\n}\n\n.loader-wrap {\n  z-index: 9999;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(219deg, #00061A 0%, #00061A 100%);\n  position: fixed;\n}\n\n.preloader {\n  display: flex;\n  animation: spin-1 8s linear infinite;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin: auto;\n  width: 300px;\n  height: 300px;\n  color: #ff8c2e;\n  transform-style: preserve-3d;\n}\n\n.preloader-ring {\n  transform-style: preserve-3d;\n  animation: spin-2 4s linear infinite;\n  position: relative;\n  height: 60px;\n  width: 20px;\n}\n.preloader-ring:nth-child(even) {\n  animation-direction: reverse;\n}\n\n.preloader-sector {\n  font-size: 40px;\n  line-height: 60px;\n  font-weight: 600;\n  text-align: center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  text-transform: uppercase;\n  transform: translateZ(160px);\n  display: inline-block;\n  width: 100%;\n  height: 100%;\n}\n.preloader-sector:empty:before {\n  display: inline-block;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(transparent 50%, #ff8c2e 50% 55%, transparent 55%);\n  content: \"\";\n}\n\n.hendel__preloder {\n  width: 100%;\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.centred {\n  text-align: center;\n}\n\n.pull-left {\n  float: left;\n}\n\n.pull-right {\n  float: right;\n}\n\nfigure {\n  margin: 0px;\n}\n\nimg {\n  display: inline-block;\n  max-width: 100%;\n  height: auto;\n  transition-delay: 0.1s;\n  transition-timing-function: ease-in-out;\n  transition-duration: 0.7s;\n  transition-property: all;\n}\n\n.theme-btn {\n  position: relative;\n  display: flex;\n  overflow: hidden;\n  vertical-align: middle;\n  font-size: 12px;\n  line-height: 24px;\n  font-weight: 500;\n  font-family: \"Rubik\", sans-serif;\n  color: #fff !important;\n  text-align: center;\n  padding: 15px 20px;\n  border-radius: 5px;\n  letter-spacing: 2.4px;\n  text-transform: uppercase;\n  z-index: 1;\n  -webkit-transition: all cubic-bezier(0.4, 0, 0.2, 1) 0.4s;\n  -o-transition: all cubic-bezier(0.4, 0, 0.2, 1) 0.4s;\n  transition: all cubic-bezier(0.4, 0, 0.2, 1) 0.4s;\n  align-items: center;\n  gap: 10px;\n}\n.theme-btn i {\n  position: relative;\n  font-size: 15px;\n}\n\n.theme-btn-one:before {\n  position: absolute;\n  content: \"\";\n  width: 0%;\n  height: 100%;\n  left: 0px;\n  top: 0px;\n  z-index: -1;\n  transition: all 500ms ease;\n}\n.theme-btn-one:hover:before {\n  width: 100%;\n}\n\n.theme-btn-two {\n  background: #fff;\n  padding: 12px 62px 12px 30px;\n}\n.theme-btn-two:hover {\n  padding: 12px 69px 12px 30px;\n}\n.theme-btn-two:hover span:before {\n  -webkit-transform: translateY(-50%) translateX(-30px);\n  -ms-transform: translateY(-50%) translateX(-30px);\n  transform: translateY(-50%) translateX(-30px);\n  opacity: 0;\n}\n.theme-btn-two:hover span:after {\n  -webkit-transform: translateY(-50%) translateX(0);\n  -ms-transform: translateY(-50%) translateX(0);\n  transform: translateY(-50%) translateX(0);\n  opacity: 1;\n}\n.theme-btn-two:hover:before {\n  -webkit-transform: translateY(-50%) scaleX(1);\n  -ms-transform: translateY(-50%) scaleX(1);\n  transform: translateY(-50%) scaleX(1);\n  width: 25px;\n}\n.theme-btn-two span {\n  position: relative;\n  color: transparent;\n}\n.theme-btn-two span:before {\n  content: attr(data-text);\n  position: absolute;\n  top: 50%;\n  left: 0;\n  -webkit-transform: translateY(-50%) translateX(0);\n  -ms-transform: translateY(-50%) translateX(0);\n  transform: translateY(-50%) translateX(0);\n  width: 100%;\n  -webkit-transition: all cubic-bezier(0.4, 0, 0.2, 1) 0.4s;\n  -o-transition: all cubic-bezier(0.4, 0, 0.2, 1) 0.4s;\n  transition: all cubic-bezier(0.4, 0, 0.2, 1) 0.4s;\n  color: #141417;\n}\n.theme-btn-two span:after {\n  content: attr(data-text);\n  position: absolute;\n  top: 50%;\n  left: 0;\n  -webkit-transform: translateY(-50%) translateX(0);\n  -ms-transform: translateY(-50%) translateX(0);\n  transform: translateY(-50%) translateX(0);\n  width: 100%;\n  -webkit-transition: all cubic-bezier(0.4, 0, 0.2, 1) 0.4s;\n  -o-transition: all cubic-bezier(0.4, 0, 0.2, 1) 0.4s;\n  transition: all cubic-bezier(0.4, 0, 0.2, 1) 0.4s;\n  color: #f4244f;\n  opacity: 0;\n}\n.theme-btn-two:before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  right: 32px;\n  -webkit-transform: translateY(-50%) scaleX(1);\n  -ms-transform: translateY(-50%) scaleX(1);\n  transform: translateY(-50%) scaleX(1);\n  width: 18px;\n  height: 2px;\n  background: #141417;\n  transition: all 500ms ease;\n  -webkit-transform-origin: right;\n  -ms-transform-origin: right;\n  transform-origin: right;\n  transition: all 500ms ease;\n  -moz-transition: all 500ms ease;\n  -webkit-transition: all 500ms ease;\n  -ms-transition: all 500ms ease;\n  -o-transition: all 500ms ease;\n}\n.theme-btn-two:after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  right: 32px;\n  width: 9px;\n  height: 9px;\n  border-right: 2px solid #141417;\n  border-top: 2px solid #141417;\n  -webkit-transform: translateY(-50%) rotate(45deg);\n  -ms-transform: translateY(-50%) rotate(45deg);\n  transform: translateY(-50%) rotate(45deg);\n  transition: all 500ms ease;\n  -moz-transition: all 500ms ease;\n  -webkit-transition: all 500ms ease;\n  -ms-transition: all 500ms ease;\n  -o-transition: all 500ms ease;\n}\n\n.theme-btn-three {\n  padding: 12px 62px 12px 30px;\n}\n.theme-btn-three:hover {\n  padding: 12px 69px 12px 30px;\n}\n.theme-btn-three:hover span:before {\n  -webkit-transform: translateY(-50%) translateX(-30px);\n  -ms-transform: translateY(-50%) translateX(-30px);\n  transform: translateY(-50%) translateX(-30px);\n  opacity: 0;\n}\n.theme-btn-three:hover span:after {\n  -webkit-transform: translateY(-50%) translateX(0);\n  -ms-transform: translateY(-50%) translateX(0);\n  transform: translateY(-50%) translateX(0);\n  opacity: 1;\n}\n.theme-btn-three:hover:before {\n  -webkit-transform: translateY(-50%) scaleX(1);\n  -ms-transform: translateY(-50%) scaleX(1);\n  transform: translateY(-50%) scaleX(1);\n  width: 25px;\n}\n.theme-btn-three span {\n  position: relative;\n  color: transparent;\n}\n.theme-btn-three span:before {\n  content: attr(data-text);\n  position: absolute;\n  top: 50%;\n  left: 0;\n  -webkit-transform: translateY(-50%) translateX(0);\n  -ms-transform: translateY(-50%) translateX(0);\n  transform: translateY(-50%) translateX(0);\n  width: 100%;\n  transition: all 500ms ease;\n  color: #fff;\n}\n.theme-btn-three span:after {\n  content: attr(data-text);\n  position: absolute;\n  top: 50%;\n  left: 0;\n  -webkit-transform: translateY(-50%) translateX(0);\n  -ms-transform: translateY(-50%) translateX(0);\n  transform: translateY(-50%) translateX(0);\n  width: 100%;\n  transition: all 500ms ease;\n  color: #141417;\n  opacity: 0;\n}\n.theme-btn-three:before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  right: 32px;\n  -webkit-transform: translateY(-50%) scaleX(1);\n  -ms-transform: translateY(-50%) scaleX(1);\n  transform: translateY(-50%) scaleX(1);\n  width: 18px;\n  height: 2px;\n  background: #fff;\n  transition: all 500ms ease;\n  -webkit-transform-origin: right;\n  -ms-transform-origin: right;\n  transform-origin: right;\n}\n.theme-btn-three:after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  right: 32px;\n  width: 9px;\n  height: 9px;\n  border-right: 2px solid #fff;\n  border-top: 2px solid #fff;\n  -webkit-transform: translateY(-50%) rotate(45deg);\n  -ms-transform: translateY(-50%) rotate(45deg);\n  transform: translateY(-50%) rotate(45deg);\n  transition: all 500ms ease;\n}\n\n.theme-btn-four {\n  border-radius: 30px;\n  background: #6a36ff;\n}\n.theme-btn-four:before {\n  background-color: #141417;\n  border-radius: 30px;\n  content: \"\";\n  display: block;\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n  transform: translate(-100%, 0) rotate(10deg);\n  transform-origin: top left;\n  transition: 0.3s transform ease-out;\n  will-change: transform;\n  z-index: -1;\n}\n.theme-btn-four:hover:before {\n  transform: translate(0, 0);\n}\n\n.theme-btn-five {\n  background: #612ade;\n  padding: 17px 40px;\n}\n.theme-btn-five:before {\n  position: absolute;\n  content: \"\";\n  background: #141417;\n  width: 0%;\n  height: 100%;\n  left: 0px;\n  top: 0px;\n  z-index: -1;\n  transition: all 500ms ease;\n}\n.theme-btn-five:hover:before {\n  width: 100%;\n}\n\n.theme-btn-six {\n  border: 1px solid #e7e7e7;\n  padding: 16px 40px;\n  color: #141417 !important;\n}\n.theme-btn-six:hover {\n  color: #fff !important;\n  border-color: #612ade;\n}\n.theme-btn-six:hover:before {\n  width: 100%;\n}\n.theme-btn-six:before {\n  position: absolute;\n  content: \"\";\n  background: #612ade;\n  width: 0%;\n  height: 100%;\n  left: 0px;\n  top: 0px;\n  z-index: -1;\n  transition: all 500ms ease;\n}\n\n.theme-btn-seven {\n  background: #f1592a;\n  border-radius: 30px;\n  font-size: 17px;\n  font-weight: 500;\n  font-family: \"Muli\", sans-serif;\n  padding: 17px 35px;\n  letter-spacing: 1px;\n}\n.theme-btn-seven:before {\n  position: absolute;\n  content: \"\";\n  background: #141417;\n  width: 0%;\n  height: 100%;\n  top: 0px;\n  right: 0px;\n  border-radius: 30px;\n  z-index: -1;\n  transition: all 500ms ease;\n}\n.theme-btn-seven:hover:before {\n  width: 100%;\n  left: 0px;\n}\n\n.theme-btn-eight {\n  font-weight: 500;\n  font-family: \"Spartan\", sans-serif;\n  border-radius: 0px;\n  padding: 13px 26px 11px 26px;\n  background: #ff7f4c;\n}\n.theme-btn-eight:before {\n  webkit-transition-duration: 800ms;\n  transition-duration: 800ms;\n  position: absolute;\n  width: 200%;\n  height: 200%;\n  content: \"\";\n  bottom: 110%;\n  left: 50%;\n  background-color: #141417;\n  -webkit-transform: translateX(-50%);\n  transform: translateX(-50%);\n  border-radius: 50%;\n  z-index: -1;\n}\n.theme-btn-eight:hover:before {\n  bottom: -40%;\n}\n\n.theme-btn-nine {\n  border-radius: 0px;\n  font-family: \"Jost\", sans-serif;\n  padding: 17px 40px;\n  font-size: 17px;\n  background: #fff;\n  color: #141417 !important;\n}\n.theme-btn-nine:before {\n  position: absolute;\n  content: \"\";\n  background: #141417;\n  width: 100%;\n  height: 0%;\n  left: 0px;\n  bottom: 0px;\n  z-index: -1;\n  transition: all 500ms ease;\n}\n.theme-btn-nine:hover {\n  color: #fff !important;\n}\n.theme-btn-nine:hover:before {\n  top: 0px;\n  height: 100%;\n}\n\n.scroll-to-top {\n  position: fixed;\n  right: 15px;\n  bottom: 20px;\n  z-index: 99;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.scroll-to-top svg {\n  width: 20px;\n  visibility: visible !important;\n  opacity: 1 !important;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-transition: all cubic-bezier(0.4, 0, 0.2, 1) 0.4s;\n  -o-transition: all cubic-bezier(0.4, 0, 0.2, 1) 0.4s;\n  transition: all cubic-bezier(0.4, 0, 0.2, 1) 0.4s;\n}\n.scroll-to-top .scroll-bar {\n  width: 50px;\n  height: 2px;\n  margin-right: 10px;\n  position: relative;\n}\n.scroll-to-top .scroll-bar:before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n  width: 100%;\n  background-color: #f4244f;\n  opacity: 0.3;\n}\n.scroll-to-top .scroll-bar .bar-inner {\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 100%;\n  background-color: currentColor;\n}\n.scroll-to-top .scroll-bar-text {\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 500ms ease;\n}\n.scroll-to-top .scroll-bar-text:hover {\n  transform: scale(1.1);\n}\n\n.float-bob-y {\n  animation-name: float-bob-y;\n  animation-duration: 2s;\n  animation-iteration-count: infinite;\n  animation-timing-function: linear;\n  -webkit-animation-name: float-bob-y;\n  -webkit-animation-duration: 2s;\n  -webkit-animation-iteration-count: infinite;\n  -webkit-animation-timing-function: linear;\n  -moz-animation-name: float-bob-y;\n  -moz-animation-duration: 2s;\n  -moz-animation-iteration-count: infinite;\n  -moz-animation-timing-function: linear;\n  -ms-animation-name: float-bob-y;\n  -ms-animation-duration: 2s;\n  -ms-animation-iteration-count: infinite;\n  -ms-animation-timing-function: linear;\n  -o-animation-name: float-bob-y;\n  -o-animation-duration: 2s;\n  -o-animation-iteration-count: infinite;\n  -o-animation-timing-function: linear;\n}\n\n.float-bob-x {\n  animation-name: float-bob-x;\n  animation-duration: 15s;\n  animation-iteration-count: infinite;\n  animation-timing-function: linear;\n  -webkit-animation-name: float-bob-x;\n  -webkit-animation-duration: 15s;\n  -webkit-animation-iteration-count: infinite;\n  -webkit-animation-timing-function: linear;\n  -moz-animation-name: float-bob-x;\n  -moz-animation-duration: 15s;\n  -moz-animation-iteration-count: infinite;\n  -moz-animation-timing-function: linear;\n  -ms-animation-name: float-bob-x;\n  -ms-animation-duration: 15s;\n  -ms-animation-iteration-count: infinite;\n  -ms-animation-timing-function: linear;\n  -o-animation-name: float-bob-x;\n  -o-animation-duration: 15s;\n  -o-animation-iteration-count: infinite;\n  -o-animation-timing-function: linear;\n}\n\n.main-header {\n  position: relative;\n  left: 0px;\n  top: 0px;\n  right: 0px;\n  z-index: 999;\n  width: 100%;\n  transition: all 500ms ease;\n  -moz-transition: all 500ms ease;\n  -webkit-transition: all 500ms ease;\n  -ms-transition: all 500ms ease;\n  -o-transition: all 500ms ease;\n}\n.main-header .outer-box {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.main-header-mobile {\n  position: fixed;\n  left: 0px;\n  top: 0px;\n  right: 0px;\n  z-index: 999;\n  width: 100%;\n  transition: all 500ms ease;\n  background-color: #00061A;\n  -moz-transition: all 500ms ease;\n  -webkit-transition: all 500ms ease;\n  -ms-transition: all 500ms ease;\n  -o-transition: all 500ms ease;\n}\n.main-header-mobile .outer-box {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.sticky-header {\n  position: fixed;\n  opacity: 0;\n  visibility: hidden;\n  left: 0px;\n  top: 0px;\n  width: 100%;\n  z-index: 0;\n  background-color: #00061A;\n  box-shadow: 0px 10px 20px 0px rgba(27, 24, 47, 0.1);\n  transition: all 500ms ease;\n  -moz-transition: all 500ms ease;\n  -webkit-transition: all 500ms ease;\n  -ms-transition: all 500ms ease;\n  -o-transition: all 500ms ease;\n  transform: translateY(-100%);\n  border-bottom: 0.5px solid #ff8c2e;\n}\n.sticky-header .main-menu .navigation li.dropdown .dropdown-btn {\n  top: 33px;\n}\n.sticky-header .main-menu .navigation > li.current {\n  border-bottom: none;\n}\n.sticky-header .main-menu .navigation > li a:before {\n  display: none;\n}\n.sticky-header .main-menu .navigation > li > a {\n  padding: 30px 0px;\n}\n.sticky-header .logo-box {\n  padding: 14px 0px;\n}\n.sticky-header .nav-right {\n  margin-left: 30px;\n}\n\n.fixed-header .sticky-header {\n  z-index: 999;\n  opacity: 1;\n  visibility: visible;\n  -ms-animation-name: fadeInDown;\n  -moz-animation-name: fadeInDown;\n  -op-animation-name: fadeInDown;\n  -webkit-animation-name: fadeInDown;\n  animation-name: fadeInDown;\n  -ms-animation-duration: 500ms;\n  -moz-animation-duration: 500ms;\n  -op-animation-duration: 500ms;\n  -webkit-animation-duration: 500ms;\n  animation-duration: 500ms;\n  -ms-animation-timing-function: linear;\n  -moz-animation-timing-function: linear;\n  -op-animation-timing-function: linear;\n  -webkit-animation-timing-function: linear;\n  animation-timing-function: linear;\n  -ms-animation-iteration-count: 1;\n  -moz-animation-iteration-count: 1;\n  -op-animation-iteration-count: 1;\n  -webkit-animation-iteration-count: 1;\n  animation-iteration-count: 1;\n  transform: translateY(0%);\n}\n\n.main-menu .navbar-collapse {\n  padding: 0px;\n  display: block !important;\n}\n.main-menu .navigation {\n  margin: 0px;\n}\n.main-menu .navigation > li {\n  position: relative;\n  float: left;\n  z-index: 2;\n  margin: 0px 16px;\n  -webkit-transition: all 300ms ease;\n  -moz-transition: all 300ms ease;\n  -ms-transition: all 300ms ease;\n  -o-transition: all 300ms ease;\n  transition: all 300ms ease;\n}\n.main-menu .navigation > li:last-child {\n  margin-right: 0px !important;\n}\n.main-menu .navigation > li:first-child {\n  margin-left: 0px !important;\n}\n.main-menu .navigation > li > a {\n  position: relative;\n  display: block;\n  text-align: center;\n  font-size: 18px;\n  line-height: normal;\n  font-family: \"Rubik\", sans-serif;\n  padding: 50px 0px;\n  font-weight: 500;\n  opacity: 1;\n  color: #fff;\n  overflow: hidden;\n  z-index: 1;\n  -webkit-transition: all 500ms ease;\n  -moz-transition: all 500ms ease;\n  -ms-transition: all 500ms ease;\n  -o-transition: all 500ms ease;\n  transition: all 500ms ease;\n}\n.main-menu .navigation > li > ul {\n  position: absolute;\n  left: inherit;\n  top: 100%;\n  width: 230px;\n  margin-top: 15px;\n  z-index: 100;\n  display: none;\n  opacity: 0;\n  padding-top: 0px;\n  padding-bottom: 0px;\n  visibility: hidden;\n  background: rgb(0, 6, 26);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.07);\n  transition: all 500ms ease;\n  -moz-transition: all 500ms ease;\n  -webkit-transition: all 500ms ease;\n  -ms-transition: all 500ms ease;\n  -o-transition: all 500ms ease;\n  padding: 15px 24px;\n}\n.main-menu .navigation > li > ul > li {\n  position: relative;\n  width: 100%;\n}\n.main-menu .navigation > li > ul > li:hover > a {\n  color: #ff8c2e !important;\n}\n.main-menu .navigation > li > ul > li > a {\n  position: relative;\n  display: block;\n  padding: 10px 0px;\n  line-height: 24px;\n  font-weight: 400;\n  font-size: 16px;\n  font-family: \"Rubik\", sans-serif;\n  text-transform: capitalize;\n  color: #fff;\n  text-align: left;\n  transition: all 500ms ease;\n  -moz-transition: all 500ms ease;\n  -webkit-transition: all 500ms ease;\n  -ms-transition: all 500ms ease;\n  -o-transition: all 500ms ease;\n  color: #fff !important;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.15);\n}\n.main-menu .navigation > li > ul > li:last-child > a {\n  border-bottom: none;\n}\n.main-menu .navigation > li > ul > li > ul {\n  position: absolute;\n  right: 100%;\n  top: 0%;\n  margin-top: 15px;\n  width: 230px;\n  z-index: 100;\n  display: none;\n  background: rgb(0, 6, 26);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.07);\n  transition: all 500ms ease;\n  -moz-transition: all 500ms ease;\n  -webkit-transition: all 500ms ease;\n  -ms-transition: all 500ms ease;\n  -o-transition: all 500ms ease;\n}\n.main-menu .navigation > li > ul > li > ul > li {\n  position: relative;\n  width: 100%;\n}\n.main-menu .navigation > li > ul > li > ul > li:last-child {\n  border-bottom: none;\n}\n.main-menu .navigation > li > ul > li > ul > li:last-child > a {\n  border-bottom: none;\n}\n.main-menu .navigation > li > ul > li > ul > li > a {\n  position: relative;\n  display: block;\n  padding: 8px 0px;\n  line-height: 24px;\n  font-weight: 500;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.15);\n  font-size: 16px;\n  font-family: \"Rubik\", sans-serif;\n  text-transform: capitalize;\n  color: #fff !important;\n  text-align: left;\n  transition: all 500ms ease;\n  -moz-transition: all 500ms ease;\n  -webkit-transition: all 500ms ease;\n  -ms-transition: all 500ms ease;\n  -o-transition: all 500ms ease;\n}\n.main-menu .navigation > li > ul > li > ul > li.dropdown > a:after {\n  font-family: \"Font Awesome 5 Pro\";\n  content: \"\\f105\";\n  position: absolute;\n  right: 20px;\n  top: 12px;\n  display: block;\n  line-height: 24px;\n  font-size: 16px;\n  font-weight: 900;\n  z-index: 5;\n}\n.main-menu .navigation > li > ul > li > ul.from-right {\n  left: auto;\n  right: 0px;\n}\n.main-menu .navigation > li > ul > li.dropdown > a:after {\n  font-family: \"icomoon\" !important;\n  content: \"\\e906\";\n  position: absolute;\n  right: 20px;\n  top: 8px;\n  display: block;\n  line-height: 24px;\n  font-size: 16px;\n  font-weight: 800;\n  text-align: center;\n  z-index: 5;\n}\n.main-menu .navigation > li > .megamenu {\n  position: absolute;\n  left: inherit;\n  top: 100%;\n  width: 230px;\n  margin-top: 15px;\n  z-index: 100;\n  display: none;\n  opacity: 0;\n  padding-top: 0px;\n  padding-bottom: 0px;\n  visibility: hidden;\n  background: rgb(0, 6, 26);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.07);\n  transition: all 500ms ease;\n  -moz-transition: all 500ms ease;\n  -webkit-transition: all 500ms ease;\n  -ms-transition: all 500ms ease;\n  -o-transition: all 500ms ease;\n}\n.main-menu .navigation > li > .megamenu li > a {\n  position: relative;\n  display: block;\n  padding: 10px 0px;\n  line-height: 24px;\n  font-weight: 400;\n  font-size: 16px;\n  font-family: \"Rubik\", sans-serif;\n  text-transform: capitalize;\n  color: #fff;\n  text-align: left;\n  transition: all 500ms ease;\n  -moz-transition: all 500ms ease;\n  -webkit-transition: all 500ms ease;\n  -ms-transition: all 500ms ease;\n  -o-transition: all 500ms ease;\n  padding: 6px 0px;\n  display: inline-block;\n}\n.main-menu .navigation > li > .megamenu li > a:before {\n  position: absolute;\n  content: \"\";\n  width: 0%;\n  height: 1px;\n  left: 0px;\n  bottom: 8px;\n  transition: all 500ms ease;\n}\n.main-menu .navigation > li > .megamenu li > a:hover {\n  padding-left: 15px;\n}\n.main-menu .navigation > li > .megamenu li > a:hover:before {\n  width: calc(100% - 15px);\n  left: 15px;\n}\n.main-menu .navigation > li > .megamenu li:last-child > a {\n  border-bottom: none;\n}\n.main-menu .navigation > li:hover a {\n  color: #ff8c2e;\n}\n.main-menu .navigation > li:hover .dropdown-btn {\n  color: #ff8c2e !important;\n}\n.main-menu .navigation > li:hover:before {\n  width: 100%;\n}\n.main-menu .navigation > li a.active {\n  color: #ff8c2e;\n}\n.main-menu .navigation > li > ul.from-right {\n  left: auto;\n  right: 0px;\n}\n.main-menu .navigation > li:before {\n  content: \"\";\n  background: #ff8c2e;\n  width: 0%;\n  height: 3px;\n  position: absolute;\n  left: 0;\n  bottom: -3px;\n  transition: all 500ms ease;\n}\n.main-menu .navigation > li .active {\n  border-bottom: 3px solid #ff8c2e;\n}\n.main-menu .navigation > li.current .dropdown-btn {\n  color: #ff8c2e !important;\n}\n.main-menu .navigation > li.dropdown:hover > ul {\n  visibility: visible;\n  opacity: 1;\n  margin-top: 6px;\n  top: 100%;\n}\n.main-menu .navigation > li.dropdown:hover > .megamenu {\n  visibility: visible;\n  opacity: 1;\n  margin-top: 6px;\n  top: 100%;\n}\n.main-menu .navigation > li.dropdown > .megamenu {\n  position: absolute;\n  width: 100%;\n  padding: 30px 50px;\n  left: 0px;\n}\n.main-menu .navigation li > ul > li.dropdown:hover > ul {\n  visibility: visible;\n  opacity: 1;\n  top: 0%;\n  margin-top: 0px;\n  margin-right: 34px;\n  padding: 15px 10px;\n}\n.main-menu .navigation li.dropdown .dropdown-btn {\n  position: absolute;\n  right: -23px;\n  top: 53px;\n  width: 15px;\n  height: 15px;\n  text-align: center;\n  font-size: 14px;\n  line-height: 26px;\n  color: #fff;\n  cursor: pointer;\n  z-index: 5;\n  transition: all 500ms ease;\n}\n.main-menu .navigation li.dropdown ul li.dropdown .dropdown-btn {\n  display: none;\n}\n.main-menu .navigation li.dropdown .megamenu li h6 {\n  position: relative;\n  display: block;\n  border-bottom: 1px solid #e5e5e5;\n  padding-bottom: 13px;\n  padding-top: 13px;\n  font-size: 16px;\n  line-height: 26px;\n  font-weight: 700;\n  text-transform: uppercase;\n  color: #141417;\n  margin-bottom: 7px;\n}\n\n.header__style__one .outer-box {\n  border-bottom: 1px solid rgba(255, 255, 255, 0.15);\n}\n.header__style__one .sticky-header .outer-box {\n  border-bottom: none;\n}\n\n.menu-area .mobile-nav-toggler {\n  position: relative;\n  float: right;\n  font-size: 40px;\n  line-height: 50px;\n  cursor: pointer;\n  color: #3786ff;\n  display: none;\n}\n.menu-area .mobile-nav-toggler .icon-bar {\n  position: relative;\n  height: 2px;\n  width: 30px;\n  display: block;\n  margin-bottom: 5px;\n  background-color: #ff8c2e;\n  -webkit-transition: all 300ms ease;\n  -moz-transition: all 300ms ease;\n  -ms-transition: all 300ms ease;\n  -o-transition: all 300ms ease;\n  transition: all 300ms ease;\n}\n.menu-area .mobile-nav-toggler .icon-bar:last-child {\n  margin-bottom: 0px;\n}\n\n.header-lower .theme-btn {\n  padding: 15px 30px;\n}\n.header-lower .outer-box .logo-box {\n  padding: 30px 0px;\n}\n.header-lower .outer-box .logo-box .logo {\n  min-width: 200px;\n}\n.header-lower .outer-box .logo-box .logo img {\n  width: 100%;\n}\n\n.nav-outer .mobile-nav-toggler {\n  position: relative;\n  float: right;\n  font-size: 40px;\n  line-height: 50px;\n  cursor: pointer;\n  color: #3786ff;\n  display: none;\n}\n\n.mobile-menu {\n  position: fixed;\n  right: 0;\n  top: 0;\n  width: 300px;\n  padding-right: 30px;\n  max-width: 100%;\n  height: 100%;\n  opacity: 0;\n  visibility: hidden;\n  z-index: 999999;\n  transition: all 900ms ease;\n}\n.mobile-menu .navbar-collapse {\n  display: block !important;\n}\n.mobile-menu .nav-logo {\n  position: relative;\n  padding: 50px 25px;\n  text-align: left;\n  padding-bottom: 50px;\n}\n.mobile-menu .menu-backdrop {\n  position: fixed;\n  left: 0%;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  transition: all 900ms ease;\n  background-color: #000;\n}\n.mobile-menu .menu-box {\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  width: 100%;\n  height: 100%;\n  max-height: 100%;\n  overflow-y: auto;\n  background: #00061A;\n  padding: 0px 0px;\n  z-index: 5;\n  opacity: 0;\n  visibility: hidden;\n  border-radius: 0px;\n  -webkit-transform: translateX(100%);\n  -ms-transform: translateX(100%);\n  transform: translateX(100%);\n  transition: all 900ms ease !important;\n}\n.mobile-menu .close-btn {\n  position: absolute;\n  right: 25px;\n  top: 10px;\n  line-height: 30px;\n  width: 24px;\n  text-align: center;\n  font-size: 16px;\n  color: #ffffff;\n  cursor: pointer;\n  z-index: 10;\n  -webkit-transition: all 0.9s ease;\n  -moz-transition: all 0.9s ease;\n  -ms-transition: all 0.9s ease;\n  -o-transition: all 0.9s ease;\n  transition: all 0.9s ease;\n}\n.mobile-menu .close-btn:hover {\n  -webkit-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n.mobile-menu .navigation {\n  position: relative;\n  display: block;\n  width: 100%;\n  float: none;\n}\n.mobile-menu .navigation li {\n  position: relative;\n  display: block;\n}\n.mobile-menu .navigation li > ul {\n  display: none;\n}\n.mobile-menu .navigation li > ul > li:first-child {\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n.mobile-menu .navigation li > ul > li > ul {\n  display: none;\n}\n.mobile-menu .navigation li > a {\n  position: relative;\n  display: block;\n  line-height: 24px;\n  padding: 10px 25px;\n  font-size: 15px;\n  font-weight: 500;\n  color: #ffffff;\n  text-transform: uppercase;\n  -webkit-transition: all 500ms ease;\n  -moz-transition: all 500ms ease;\n  -ms-transition: all 500ms ease;\n  -o-transition: all 500ms ease;\n  transition: all 500ms ease;\n}\n.mobile-menu .navigation li > a:before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 0;\n  border-left: 5px solid #fff;\n  -webkit-transition: all 500ms ease;\n  -moz-transition: all 500ms ease;\n  -ms-transition: all 500ms ease;\n  -o-transition: all 500ms ease;\n  transition: all 500ms ease;\n}\n.mobile-menu .navigation li > a.active {\n  color: #ff8c2e !important;\n}\n.mobile-menu .navigation li ul li > a {\n  font-size: 16px;\n  margin-left: 20px;\n  text-transform: capitalize;\n}\n.mobile-menu .navigation li.current > a:before {\n  height: 100%;\n}\n.mobile-menu .navigation li.dropdown .dropdown-btn {\n  position: absolute;\n  right: 6px;\n  top: 6px;\n  width: 32px;\n  height: 32px;\n  text-align: center;\n  font-size: 16px;\n  line-height: 32px;\n  color: #ffffff;\n  background: rgba(255, 255, 255, 0.1);\n  cursor: pointer;\n  border-radius: 2px;\n  -webkit-transition: all 500ms ease;\n  -moz-transition: all 500ms ease;\n  -ms-transition: all 500ms ease;\n  -o-transition: all 500ms ease;\n  transition: all 500ms ease;\n  z-index: 5;\n}\n.mobile-menu .navigation li.dropdown .dropdown-btn.open {\n  color: #ffffff;\n  -webkit-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n.mobile-menu .navigation > li.dropdown > .megamenu {\n  display: none;\n}\n.mobile-menu .social-links {\n  position: relative;\n  padding: 0px 25px;\n}\n.mobile-menu .social-links li {\n  position: relative;\n  display: inline-block;\n  margin: 0px 10px 10px;\n}\n.mobile-menu .social-links li a {\n  position: relative;\n  line-height: 32px;\n  font-size: 16px;\n  color: #ffffff;\n  -webkit-transition: all 500ms ease;\n  -moz-transition: all 500ms ease;\n  -ms-transition: all 500ms ease;\n  -o-transition: all 500ms ease;\n  transition: all 500ms ease;\n}\n.mobile-menu .contact-info {\n  position: relative;\n  padding: 120px 30px 20px 30px;\n}\n.mobile-menu .contact-info h4 {\n  position: relative;\n  font-size: 20px;\n  color: #ffffff;\n  font-weight: 700;\n  margin-bottom: 20px;\n}\n.mobile-menu .contact-info ul li {\n  position: relative;\n  display: block;\n  font-size: 15px;\n  color: rgba(255, 255, 255, 0.8);\n  margin-bottom: 3px;\n}\n.mobile-menu .contact-info ul li a {\n  color: rgba(255, 255, 255, 0.8);\n}\n.mobile-menu .contact-info ul li a:hover {\n  text-decoration: underline;\n}\n.mobile-menu .contact-info ul li:last-child {\n  margin-bottom: 0px;\n}\n\n.mobile-menu-visible {\n  overflow: hidden;\n}\n.mobile-menu-visible .mobile-menu {\n  opacity: 1;\n  visibility: visible;\n}\n.mobile-menu-visible .mobile-menu .menu-backdrop {\n  opacity: 0.7;\n  visibility: visible;\n  right: 100%;\n  -webkit-transition: all 0.8s ease-out 0s;\n  -o-transition: all 0.8s ease-out 0s;\n}\n.mobile-menu-visible .mobile-menu .menu-box {\n  opacity: 1;\n  visibility: visible;\n  -webkit-transition: all 0.7s ease;\n  -o-transition: all 0.7s ease;\n  transition: all 0.7s ease;\n  -webkit-transform: translateX(0%);\n  -ms-transform: translateX(0%);\n  transform: translateX(0%);\n}\n.mobile-menu-visible .mobile-menu .close-btn {\n  -webkit-transform: rotate(360deg);\n  -ms-transform: rotate(360deg);\n  transform: rotate(360deg);\n}\n\ndiv#mCSB_1_container {\n  top: 0px !important;\n}\n\n.header-top-one .top__inner {\n  border-radius: 0px 0px 25px 25px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(255, 255, 255, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 30px;\n}\n\n.top__hrader__left ul {\n  display: flex;\n  align-items: center;\n  gap: 22px;\n}\n.top__hrader__left li {\n  font-size: 14px;\n}\n.top__hrader__left li span {\n  color: #ff8c2e;\n}\n.top__hrader__left li a {\n  color: #fff;\n}\n\n.top__hrader__right ul {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.top__hrader__right ul li a {\n  border: 1px solid #272D40;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  font-size: 12px;\n  position: relative;\n  z-index: 1;\n  color: #fff;\n}\n.top__hrader__right ul li a:before {\n  position: absolute;\n  content: \"\";\n  width: 100%;\n  height: 100%;\n  background-color: #800599;\n  border: 1px solid #800599;\n  transform: scale(0);\n  transition: all 500ms ease;\n  -moz-transition: all 500ms ease;\n  -webkit-transition: all 500ms ease;\n  -ms-transition: all 500ms ease;\n  -o-transition: all 500ms ease;\n  border-radius: 50%;\n  z-index: -1;\n}\n.top__hrader__right ul li a:hover:before {\n  transform: scale(1.1);\n}\n\n.mouse-pointer {\n  position: fixed;\n  top: 50%;\n  left: -100px;\n  -webkit-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  width: 10px;\n  height: 10px;\n  pointer-events: none;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  z-index: 9999;\n  -webkit-transition-property: width, height, background;\n  -o-transition-property: width, height, background;\n  transition-property: width, height, background;\n  -webkit-transition-duration: 0.9s;\n  -o-transition-duration: 0.9s;\n  transition-duration: 0.9s;\n  -webkit-transition-timing-function: cubic-bezier(0.19, 0.94, 0.336, 1);\n  -o-transition-timing-function: cubic-bezier(0.19, 0.94, 0.336, 1);\n  transition-timing-function: cubic-bezier(0.19, 0.94, 0.336, 1);\n  border-radius: 50%;\n  background: linear-gradient(224deg, #ff8c2e 0%, #7E2100 100%);\n  overflow: hidden;\n}\n.mouse-pointer .icon {\n  color: #fff;\n  font-size: 14px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-100%, -50%);\n  -ms-transform: translate(-100%, -50%);\n  transform: translate(-100%, -50%);\n  opacity: 0;\n  -webkit-transition: 0.4s cubic-bezier(0.225, 1, 0.316, 0.99);\n  -o-transition: 0.4s cubic-bezier(0.225, 1, 0.316, 0.99);\n  transition: 0.4s cubic-bezier(0.225, 1, 0.316, 0.99);\n}\n.mouse-pointer .icon i {\n  margin: 0px 3px;\n}\n\n.mouse-pointer.display_none {\n  display: none;\n}\n\nbody.out .mouse-pointer {\n  width: 0;\n  height: 0;\n}\n\n.mouse-pointer.large {\n  width: 65px;\n  height: 65px;\n  background: rgba(224, 36, 79, 0) !important;\n  -webkit-box-shadow: 0 0 30px rgba(224, 36, 79, 0.4);\n  box-shadow: 0 0 30px rgba(224, 36, 79, 0.4);\n  display: block !important;\n}\n\n.mouse-pointer.style-two {\n  background: #41a0ea;\n}\n\n.mouse-pointer.style-two.large {\n  -webkit-box-shadow: 0 0 30px rgba(65, 160, 234, 0.4);\n  box-shadow: 0 0 30px rgba(65, 160, 234, 0.4);\n}\n\n.mouse-pointer.style-three {\n  background: #6a36ff;\n}\n\n.mouse-pointer.style-three.large {\n  -webkit-box-shadow: 0 0 30px rgba(106, 54, 255, 0.4);\n  box-shadow: 0 0 30px rgba(106, 54, 255, 0.4);\n}\n\n.mouse-pointer.style-four {\n  background: #bc8664;\n}\n\n.mouse-pointer.style-four.large {\n  -webkit-box-shadow: 0 0 30px rgba(188, 134, 100, 0.4);\n  box-shadow: 0 0 30px rgba(188, 134, 100, 0.4);\n}\n\n.mouse-pointer.style-five {\n  background: #f1592a;\n}\n\n.mouse-pointer.style-five.large {\n  -webkit-box-shadow: 0 0 30px rgba(241, 89, 42, 0.4);\n  box-shadow: 0 0 30px rgba(241, 89, 42, 0.4);\n}\n\n.mouse-pointer.style-six {\n  background: #e93421;\n}\n\n.mouse-pointer.style-six.large {\n  -webkit-box-shadow: 0 0 30px rgba(233, 52, 33, 0.4);\n  box-shadow: 0 0 30px rgba(233, 52, 33, 0.4);\n}\n\n.mouse-pointer.style-seven {\n  background: #f38836;\n}\n\n.mouse-pointer.style-seven.large {\n  -webkit-box-shadow: 0 0 30px rgba(243, 136, 54, 0.4);\n  box-shadow: 0 0 30px rgba(243, 136, 54, 0.4);\n}\n\n.mouse-pointer.style-eight {\n  background: #ff7f4c;\n}\n\n.mouse-pointer.style-eight.large {\n  -webkit-box-shadow: 0 0 30px rgba(255, 127, 76, 0.4);\n  box-shadow: 0 0 30px rgba(255, 127, 76, 0.4);\n}\n\n.mouse-pointer.style-nine {\n  background: #ae8c64;\n}\n\n.mouse-pointer.style-nine.large {\n  -webkit-box-shadow: 0 0 30px rgba(174, 140, 100, 0.4);\n  box-shadow: 0 0 30px rgba(174, 140, 100, 0.4);\n}\n\n.mouse-pointer.style-ten {\n  background: #ff5e14;\n}\n\n.mouse-pointer.style-ten.large {\n  -webkit-box-shadow: 0 0 30px rgba(255, 94, 20, 0.4);\n  box-shadow: 0 0 30px rgba(255, 94, 20, 0.4);\n}\n\n.mouse-pointer.style-11 {\n  background: #fb4754;\n}\n\n.mouse-pointer.style-11.large {\n  -webkit-box-shadow: 0 0 30px rgba(251, 71, 84, 0.4);\n  box-shadow: 0 0 30px rgba(251, 71, 84, 0.4);\n}\n\n.mouse-pointer.style-12 {\n  background: #00d0f5;\n}\n\n.mouse-pointer.style-12.large {\n  -webkit-box-shadow: 0 0 30px rgba(0, 208, 245, 0.4);\n  box-shadow: 0 0 30px rgba(0, 208, 245, 0.4);\n}\n\n.mouse-pointer.style-13 {\n  background: #a44ac5;\n}\n\n.mouse-pointer.style-13.large {\n  -webkit-box-shadow: 0 0 30px rgba(164, 74, 197, 0.4);\n  box-shadow: 0 0 30px rgba(164, 74, 197, 0.4);\n}\n\n.mouse-pointer.style-14 {\n  background: #17be74;\n}\n\n.mouse-pointer.style-14.large {\n  -webkit-box-shadow: 0 0 30px rgba(23, 190, 116, 0.4);\n  box-shadow: 0 0 30px rgba(23, 190, 116, 0.4);\n}\n\n.mouse-pointer.small {\n  width: 25px;\n  height: 25px;\n  background: rgba(227, 87, 18, 0);\n  -webkit-box-shadow: 0 0 30px #e35712;\n  box-shadow: 0 0 30px #e35712;\n}\n\n.mouse-pointer.right {\n  width: 50px;\n  height: 50px;\n  background: #000 !important;\n}\n.mouse-pointer.right .icon {\n  opacity: 1;\n  -webkit-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  -webkit-transition-delay: 0.2s;\n  -o-transition-delay: 0.2s;\n  transition-delay: 0.2s;\n}\n\n.mouse-pointer.right.large {\n  background: transparent !important;\n}\n.mouse-pointer.right.large .icon {\n  opacity: 0;\n}\n\n.mouse-pointer.zoom {\n  width: 80px;\n  height: 80px;\n  background: rgba(227, 87, 18, 0);\n  border: 2px solid #e35712;\n}\n\n.mouse-pointer.open {\n  width: 80px;\n  height: 80px;\n  background: rgba(227, 87, 18, 0);\n  border: 2px solid #e35712;\n}\n\n.mouse-pointer.black {\n  background: #000;\n}\n\n.mouse-pointer.black.large {\n  background: rgba(0, 0, 0, 0.4);\n  -webkit-box-shadow: 0 0 30px rgba(0, 0, 0, 0.2);\n  box-shadow: 0 0 30px rgba(0, 0, 0, 0.2);\n}\n\n.mouse-pointer.black.small {\n  background: rgba(0, 0, 0, 0.5);\n  -webkit-box-shadow: 0 0 30px rgba(0, 0, 0, 0.2);\n  box-shadow: 0 0 30px rgba(0, 0, 0, 0.2);\n}\n\n.mouse-pointer.black.right {\n  background: rgba(0, 0, 0, 0);\n  border: 2px solid #000;\n}\n\n.mouse-pointer.black.zoom {\n  background: rgba(0, 0, 0, 0);\n  border: 2px solid #000;\n}\n\n.mouse-pointer.black.open {\n  background: rgba(0, 0, 0, 0);\n  border: 2px solid #000;\n}\n\n.touch .mouse-pointer {\n  display: none;\n}\n\n.mouse-pointer.transparent {\n  display: none;\n  transition: all 500ms ease;\n}\n\n.main__footer .top-inner {\n  background: linear-gradient(238deg, #00061A 0%, #060E26 100%) !important;\n  padding: 23px 50px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-radius: 4px;\n}\n.main__footer .inner__box {\n  overflow: hidden;\n  transition: all 500ms ease;\n}\n.main__footer .inner__box:hover .image__box a:before {\n  opacity: 0.2;\n  transform: scale(1.1);\n}\n.main__footer .image__box {\n  overflow: hidden;\n  position: relative;\n}\n.main__footer .image__box img {\n  width: 100%;\n  transition: all 500ms ease;\n}\n.main__footer .image__box a:before {\n  content: \"\";\n  background: -webkit-linear-gradient(0deg, #c335da, #fc2643 100%);\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  transform: scale(0);\n  transition: all 500ms ease;\n}\n\n.left__top h3 {\n  font-weight: 400;\n}\n\n.footer__one {\n  background: #00061A;\n  padding: 150px 0px 30px;\n  position: relative;\n  overflow: hidden;\n}\n\n.footer-widget .text p {\n  color: #fff;\n}\n.footer-widget .widget-title {\n  padding-bottom: 40px;\n  position: relative;\n}\n.footer-widget .widget-title:after {\n  content: \"\";\n  background: #ff8c2e;\n  width: 37px;\n  height: 2px;\n  position: absolute;\n  left: 0;\n  top: 37px;\n}\n.footer-widget .btn-box {\n  display: flex;\n}\n\n.footer-logo-widget .text p {\n  padding: 30px 0px 20px;\n}\n\n.news-letter-widget .form-group {\n  padding-top: 22px;\n  position: relative;\n}\n.news-letter-widget .form-group input {\n  border-radius: 5px;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  color: rgba(255, 255, 255, 0.25);\n  font-family: Rubik;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  letter-spacing: 2.4px;\n  text-transform: uppercase;\n  width: 100%;\n  padding: 22px;\n}\n.news-letter-widget .form-group .btn-box {\n  position: absolute;\n  right: 8px;\n  top: 30px;\n}\n\n.widget_content ul.instagram_list {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 5px;\n}\n\n.footer-bottom {\n  padding-top: 120px;\n}\n.footer-bottom .copyright {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 32px;\n  width: 100%;\n}\n.footer-bottom .copyright p {\n  text-align: center;\n  color: #fff;\n}\n.footer-bottom .copyright p a {\n  color: #ff8c2e;\n}\n\n.footer-top {\n  position: relative;\n  margin-bottom: -60px;\n  z-index: 9;\n}\n\n.see__pad {\n  padding: 60px 0px;\n}\n\n.p_relative {\n  position: relative !important;\n}\n\n.p_absolute {\n  position: absolute !important;\n}\n\n.mt-5 {\n  margin-top: 5px !important;\n}\n\n.mt-10 {\n  margin-top: 10px !important;\n}\n\n.mt-15 {\n  margin-top: 15px !important;\n}\n\n.mt-20 {\n  margin-top: 20px !important;\n}\n\n.mt-25 {\n  margin-top: 25px !important;\n}\n\n.mt-30 {\n  margin-top: 30px !important;\n}\n\n.mt-35 {\n  margin-top: 35px !important;\n}\n\n.mt-40 {\n  margin-top: 40px !important;\n}\n\n.mt-45 {\n  margin-top: 45px !important;\n}\n\n.mt-50 {\n  margin-top: 50px !important;\n}\n\n.mt-55 {\n  margin-top: 55px !important;\n}\n\n.mt-60 {\n  margin-top: 60px !important;\n}\n\n.mt-65 {\n  margin-top: 65px !important;\n}\n\n.mt-70 {\n  margin-top: 70px !important;\n}\n\n.mt-75 {\n  margin-top: 75px !important;\n}\n\n.mt-80 {\n  margin-top: 80px !important;\n}\n\n.mb-5 {\n  margin-bottom: 5px !important;\n  margin-bottom: 5px !important;\n}\n\n.mb-10 {\n  margin-bottom: 10px !important;\n}\n\n.mb-15 {\n  margin-bottom: 15px !important;\n}\n\n.mb-20 {\n  margin-bottom: 20px !important;\n}\n\n.mb-25 {\n  margin-bottom: 25px !important;\n}\n\n.mb-30 {\n  margin-bottom: 30px !important;\n}\n\n.mb-35 {\n  margin-bottom: 35px !important;\n}\n\n.mb-40 {\n  margin-bottom: 40px !important;\n}\n\n.mb-45 {\n  margin-bottom: 45px !important;\n}\n\n.mb-50 {\n  margin-bottom: 50px !important;\n}\n\n.mb-55 {\n  margin-bottom: 55px !important;\n}\n\n.mb-60 {\n  margin-bottom: 60px !important;\n}\n\n.mb-65 {\n  margin-bottom: 65px !important;\n}\n\n.mb-70 {\n  margin-bottom: 70px !important;\n}\n\n.mb-75 {\n  margin-bottom: 75px !important;\n}\n\n.mb-80 {\n  margin-bottom: 80px !important;\n}\n\n.ml-0 {\n  margin-left: 0px !important;\n  margin-left: 0px !important;\n}\n\n.mr-0 {\n  margin-right: 0px !important;\n  margin-right: 0px !important;\n}\n\n.mb-0 {\n  margin-bottom: 0px !important;\n}\n\n.ml-5 {\n  margin-left: 5px !important;\n}\n\n.ml-10 {\n  margin-left: 10px !important;\n}\n\n.ml-15 {\n  margin-left: 15px !important;\n}\n\n.ml-20 {\n  margin-left: 20px !important;\n}\n\n.ml-25 {\n  margin-left: 25px !important;\n}\n\n.ml-30 {\n  margin-left: 30px !important;\n}\n\n.ml-35 {\n  margin-left: 35px !important;\n}\n\n.ml-40 {\n  margin-left: 40px !important;\n}\n\n.ml-45 {\n  margin-left: 45px !important;\n}\n\n.ml-50 {\n  margin-left: 50px !important;\n}\n\n.ml-55 {\n  margin-left: 55px !important;\n}\n\n.ml-60 {\n  margin-left: 60px !important;\n}\n\n.ml-65 {\n  margin-left: 65px !important;\n}\n\n.ml-70 {\n  margin-left: 70px !important;\n}\n\n.ml-75 {\n  margin-left: 75px !important;\n}\n\n.ml-80 {\n  margin-left: 80px !important;\n}\n\n.mr-5 {\n  margin-right: 5px !important;\n}\n\n.mr-10 {\n  margin-right: 10px !important;\n}\n\n.mr-15 {\n  margin-right: 15px !important;\n}\n\n.mr-20 {\n  margin-right: 20px !important;\n}\n\n.mr-25 {\n  margin-right: 25px !important;\n}\n\n.mr-30 {\n  margin-right: 30px !important;\n}\n\n.mr-35 {\n  margin-right: 35px !important;\n}\n\n.mr-40 {\n  margin-right: 40px !important;\n}\n\n.mr-45 {\n  margin-right: 45px !important;\n}\n\n.mr-50 {\n  margin-right: 50px !important;\n}\n\n.mr-55 {\n  margin-right: 55px !important;\n}\n\n.mr-60 {\n  margin-right: 60px !important;\n}\n\n.mr-65 {\n  margin-right: 65px !important;\n}\n\n.mr-70 {\n  margin-right: 70px !important;\n}\n\n.mr-75 {\n  margin-right: 75px !important;\n}\n\n.mr-80 {\n  margin-right: 80px !important;\n}\n\n.pt-0 {\n  padding-top: 0px !important;\n}\n\n.pl-0 {\n  padding-left: 0px !important;\n}\n\n.pr-0 {\n  padding-right: 0px !important;\n}\n\n.pb-5 {\n  padding-bottom: 5px !important;\n  padding-bottom: 5px !important;\n}\n\n.mt-0 {\n  margin-top: 0px !important;\n}\n\n.pt-10 {\n  padding-top: 10px !important;\n}\n\n.pt-15 {\n  padding-top: 15px !important;\n}\n\n.pt-20 {\n  padding-top: 20px !important;\n}\n\n.pt-25 {\n  padding-top: 25px !important;\n}\n\n.pt-30 {\n  padding-top: 30px !important;\n}\n\n.pt-35 {\n  padding-top: 35px !important;\n}\n\n.pt-40 {\n  padding-top: 40px !important;\n}\n\n.pt-45 {\n  padding-top: 45px !important;\n}\n\n.pt-50 {\n  padding-top: 50px !important;\n}\n\n.pt-55 {\n  padding-top: 55px !important;\n}\n\n.pt-60 {\n  padding-top: 60px !important;\n}\n\n.pt-65 {\n  padding-top: 65px !important;\n}\n\n.pt-70 {\n  padding-top: 70px !important;\n}\n\n.pt-75 {\n  padding-top: 75px !important;\n}\n\n.pt-80 {\n  padding-top: 80px !important;\n}\n\n.pt-100 {\n  padding-top: 100px !important;\n}\n\n.pt-140 {\n  padding-top: 140px;\n}\n\n.pb-10 {\n  padding-bottom: 10px !important;\n}\n\n.pb-15 {\n  padding-bottom: 15px !important;\n}\n\n.pb-20 {\n  padding-bottom: 20px !important;\n}\n\n.pb-25 {\n  padding-bottom: 25px !important;\n}\n\n.pb-24 {\n  padding-bottom: 24px !important;\n}\n\n.pb-30 {\n  padding-bottom: 30px !important;\n}\n\n.pb-35 {\n  padding-bottom: 35px !important;\n}\n\n.pb-40 {\n  padding-bottom: 40px !important;\n}\n\n.pb-45 {\n  padding-bottom: 45px !important;\n}\n\n.pb-50 {\n  padding-bottom: 50px !important;\n}\n\n.pb-55 {\n  padding-bottom: 55px !important;\n}\n\n.pb-60 {\n  padding-bottom: 60px !important;\n}\n\n.pb-65 {\n  padding-bottom: 65px !important;\n}\n\n.pb-70 {\n  padding-bottom: 70px !important;\n}\n\n.pb-75 {\n  padding-bottom: 75px !important;\n}\n\n.pb-80 {\n  padding-bottom: 80px !important;\n}\n\n.pb-100 {\n  padding-bottom: 100px !important;\n}\n\n.pb-140 {\n  padding-bottom: 140px;\n}\n\n.pl-5 {\n  padding-left: 5px !important;\n}\n\n.pl-10 {\n  padding-left: 10px !important;\n}\n\n.pl-15 {\n  padding-left: 15px !important;\n}\n\n.pl-20 {\n  padding-left: 20px !important;\n}\n\n.pl-25 {\n  padding-left: 25px !important;\n}\n\n.pl-30 {\n  padding-left: 30px !important;\n}\n\n.pl-35 {\n  padding-left: 35px !important;\n}\n\n.pl-40 {\n  padding-left: 40px !important;\n}\n\n.pl-45 {\n  padding-left: 45px !important;\n}\n\n.pl-50 {\n  padding-left: 50px !important;\n}\n\n.pl-55 {\n  padding-left: 55px !important;\n}\n\n.pl-60 {\n  padding-left: 60px !important;\n}\n\n.pl-65 {\n  padding-left: 65px !important;\n}\n\n.pl-70 {\n  padding-left: 70px !important;\n}\n\n.pl-75 {\n  padding-left: 75px !important;\n}\n\n.pl-80 {\n  padding-left: 80px !important;\n}\n\n.pr-5 {\n  padding-right: 5px !important;\n}\n\n.pr-10 {\n  padding-right: 10px !important;\n}\n\n.pr-15 {\n  padding-right: 15px !important;\n}\n\n.pr-20 {\n  padding-right: 20px !important;\n}\n\n.pr-25 {\n  padding-right: 25px !important;\n}\n\n.pr-30 {\n  padding-right: 30px !important;\n}\n\n.pr-35 {\n  padding-right: 35px !important;\n}\n\n.pr-40 {\n  padding-right: 40px !important;\n}\n\n.pr-45 {\n  padding-right: 45px !important;\n}\n\n.pr-50 {\n  padding-right: 50px !important;\n}\n\n.pr-55 {\n  padding-right: 55px !important;\n}\n\n.pr-60 {\n  padding-right: 60px !important;\n}\n\n.pr-65 {\n  padding-right: 65px !important;\n}\n\n.pr-70 {\n  padding-right: 70px !important;\n}\n\n.pr-75 {\n  padding-right: 75px !important;\n}\n\n.pr-80 {\n  padding-right: 80px !important;\n}\n\n.sub__title h4 {\n  color: #ff8c2e;\n  font-family: Archivo;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: 13.2px;\n  text-transform: uppercase;\n}\n\n.title__data {\n  position: relative;\n  padding-bottom: 60px;\n}\n\n.title {\n  padding-top: 10px;\n}\n\n.owl-nav {\n  display: none;\n}\n\n.owl-dots {\n  display: none;\n}\n\n@media (min-width: 1296px) {\n  .container {\n    max-width: 1296px;\n    padding: 0px 15px;\n  }\n}\n@media only screen and (max-width: 991px) {\n  .see__pad {\n    margin: 120px 0px 60px !important;\n  }\n}\n/* Responsive Css */\n@media only screen and (max-width: 1800px) {\n  .choose___two .pattern-1 {\n    display: none;\n  }\n  .choose__us__data:before {\n    left: 0px;\n  }\n}\n@media only screen and (max-width: 1449px) {\n  .post__date ul li.two {\n    display: none;\n  }\n  .choose__us.three .pattern-2 {\n    left: 0;\n  }\n  .consultation__text {\n    position: relative;\n    width: auto;\n    left: 0;\n    position: relative;\n    left: 0;\n  }\n  .consultation__img {\n    margin-top: 50px;\n    margin-top: 50px;\n  }\n  .home__three {\n    padding-left: 100px;\n  }\n  .service__block__two {\n    padding: 155px 70px 50px;\n  }\n}\n@media only screen and (max-width: 1231px) {\n  .funfact__content.three {\n    margin-top: 0;\n  }\n}\n@media only screen and (max-width: 1231px) {\n  .funfact__content.three {\n    margin-top: 0;\n  }\n}\n@media only screen and (max-width: 1319px) {\n  .home__three .funfact__content.three {\n    margin-top: 0;\n  }\n}\n@media only screen and (max-width: 1200px) {\n  .main-header.header__style__one .btn-box {\n    display: none;\n  }\n  .choose__us__data:before {\n    left: 0;\n  }\n  .testimonial__section .swiper-wrapper > *:nth-child(even) {\n    margin-top: 0px;\n  }\n  .see__pad {\n    padding: 50px 0px;\n  }\n  br {\n    display: none;\n  }\n  .banner__one .banner__bg {\n    display: none;\n  }\n  .accomplised__section {\n    padding-top: 40px;\n  }\n  .funfact__content.three {\n    margin-top: 0px;\n  }\n  .test__bg {\n    display: none;\n  }\n  .news__block {\n    margin-bottom: 20px;\n  }\n  .post__date ul, .detail__post__date ul {\n    gap: 20px;\n  }\n  .protfolio__inner {\n    margin-right: 0;\n  }\n  .portfolio__block img {\n    width: 100%;\n  }\n  .page__title {\n    padding: 150px 0px;\n  }\n  .page__title .title {\n    font-size: 60px;\n    line-height: 70px;\n  }\n  .pride__block h1 {\n    font-size: 60px;\n    line-height: 70px;\n    padding: 0px 20px;\n  }\n  .testimonial___data .row > div:nth-child(even) {\n    margin-top: 0px;\n  }\n  .testimonials__block__one.page {\n    margin-bottom: 50px;\n  }\n  .comments__box {\n    display: block;\n  }\n  .blog__inner__box {\n    padding: 40px;\n  }\n  .home__three .about__block {\n    margin-top: 0;\n  }\n  .consultation__text {\n    padding-top: 50px;\n  }\n  .footer__one {\n    padding-top: 100px;\n  }\n  .service__contact.three {\n    padding-bottom: 100px;\n  }\n  .main-header.header__three {\n    position: relative;\n    width: auto;\n  }\n  .header__three .outer-box {\n    display: flex !important;\n    height: auto;\n    justify-content: space-between;\n    padding: 0px 20px;\n  }\n  .header__three .logo-box {\n    position: relative;\n    left: 0 !important;\n    padding: 30px 0px !important;\n    transform: translate(0px, 0px);\n    top: 0;\n  }\n  .header__three .menu-area {\n    position: relative;\n    left: 0;\n    top: 0;\n    transform: translate(0px, 0px);\n  }\n  .header__three .banner__media_two {\n    display: none;\n  }\n  .home__three {\n    padding-left: 0px;\n  }\n  .service__details__left {\n    margin-bottom: 50px;\n  }\n  .error__page h1.title {\n    font-size: 200px;\n  }\n  .core_value_content.remove_gap_core_value {\n    margin-top: 0;\n  }\n}\n@media only screen and (min-width: 768px) {\n  .main-menu .navigation > li > ul {\n    display: block !important;\n    visibility: hidden;\n    opacity: 0;\n  }\n  .main-menu .navigation > li > ul > li > ul {\n    display: block !important;\n    visibility: hidden;\n    opacity: 0;\n  }\n  .main-menu .navigation > li > .megamenu {\n    display: block !important;\n    visibility: hidden;\n    opacity: 0;\n  }\n}\n@media only screen and (max-width: 1199px) {\n  .core_value_content.remove_gap_core_value_1 {\n    margin-top: 0;\n  }\n  .core_value_content.remove_gap_core_value_2 {\n    margin-top: -65px;\n  }\n}\n@media only screen and (max-width: 1087px) {\n  .core_value_content.remove_gap_core_value_1 {\n    margin-top: -65px;\n  }\n  .core_value_content.remove_gap_core_value_2 {\n    margin-top: -65px;\n  }\n}\n@media only screen and (max-width: 991px) {\n  .main-menu {\n    display: none !important;\n  }\n  .sticky-header {\n    display: none !important;\n  }\n  .main-header.style-one .outer-container:before {\n    display: none !important;\n  }\n  .menu-area .mobile-nav-toggler {\n    display: block;\n    padding: 10px;\n  }\n  .megamenu ul li:first-child {\n    display: none;\n  }\n  .pattern-layer {\n    display: none;\n  }\n  .header-top-one .top__inner {\n    display: none;\n  }\n  .brand__content .brand__name h1 {\n    font-size: 40px;\n  }\n  .brand__section .brand-carousel {\n    padding: 40px 0px;\n  }\n  .icon__image__banner {\n    position: absolute;\n    left: 50%;\n    bottom: -61px;\n    transform: translate(-50%, 0%);\n  }\n  .banner__right {\n    padding-top: 100px;\n  }\n  .banner__right figure.image-box img {\n    width: 100%;\n  }\n  .scroll-to-top {\n    display: none;\n  }\n  .service__block {\n    margin-bottom: 20px;\n  }\n  .service__block:before {\n    padding: 1px;\n  }\n  .about__block {\n    padding-bottom: 50px;\n  }\n  .funfact__content.about {\n    bottom: 50px;\n  }\n  .choose__block {\n    padding: 0px 0px 50px;\n  }\n  .team__block {\n    margin-bottom: 60px;\n  }\n  .funfact__data {\n    justify-content: start;\n    padding-top: 50px;\n  }\n  .vision_mission_wrapper {\n    grid-template-columns: repeat(1, 1fr);\n    width: 80%;\n  }\n  .office-wrapper {\n    grid-template-columns: repeat(1, 1fr);\n    width: 100%;\n    gap: 32px;\n  }\n  .office-map-wrapper {\n    height: 480px;\n  }\n  .news-articles-wrapper {\n    flex-direction: column;\n    gap: 20px;\n    padding: 0 12px;\n  }\n  .accomplised__data {\n    padding: 100px 20px;\n  }\n  .testimonials__info {\n    padding: 100px;\n  }\n  .blog__section .normaol__text {\n    padding-left: 0;\n    padding-bottom: 50px;\n  }\n  .main__footer .top-inner {\n    display: block;\n  }\n  .main__footer .top-inner .right__top {\n    padding-top: 20px;\n  }\n  .footer-column {\n    padding-bottom: 20px;\n  }\n  .main-header.two {\n    top: 20px;\n  }\n  .about__two__img__block figure img {\n    width: 100%;\n  }\n  .about__two__img__block .about__two__circle {\n    right: 20px;\n  }\n  .about__text__two {\n    padding-bottom: 20px;\n    justify-content: start;\n  }\n  .choose_img__block img {\n    width: 100%;\n  }\n  .choose__text__block {\n    padding-top: 50px;\n  }\n  .accomplised__data.two {\n    padding: 0;\n  }\n  .brand__section_two {\n    padding: 0px 20px 100px;\n  }\n  .price__content {\n    margin-bottom: 60px;\n  }\n  .service__form__data {\n    padding: 0;\n  }\n  .service__contact__block {\n    padding: 80px 40px;\n  }\n  .service__contact__img {\n    position: relative;\n    padding-top: 50px;\n  }\n  .project__page {\n    margin: 0 20px;\n  }\n  .contact__right {\n    padding: 40px;\n  }\n  .banner__media {\n    display: none;\n  }\n  section.banner__one {\n    margin-top: 120px;\n  }\n  .banner__one.home__three__banner {\n    padding-top: 100px;\n  }\n  .consultation__img img {\n    width: 100%;\n  }\n  .accomplised__data.two.three {\n    padding: 20px;\n  }\n  .home__three__banner .banner__mission__block h3 {\n    padding-bottom: 10px;\n  }\n  .pro__info {\n    margin: 50px 0px 0px;\n    width: 100%;\n    max-width: 100%;\n  }\n  .news___block {\n    width: 100%;\n  }\n  .inner-box .image-box img {\n    height: 300px;\n  }\n  .blog__details__content .blog__image img {\n    height: 480px;\n  }\n  .post__date ul {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .core_value_content.remove_gap_core_value_1 {\n    margin-top: 0px;\n  }\n  .core_value_content.remove_gap_core_value_2 {\n    margin-top: -65px;\n  }\n  .industry__block {\n    width: 150px;\n  }\n  .industry__icon {\n    width: 100px;\n    height: 110px;\n  }\n  .industry__icon i {\n    width: 100px;\n    height: 110px;\n  }\n  .industry__icon img {\n    width: 150px;\n  }\n  .industry__text button h4 {\n    font-size: 16px;\n  }\n  .footer-bottom .copyright {\n    flex-direction: column-reverse;\n  }\n  .social-media-wrapper {\n    margin-bottom: 64px;\n  }\n}\n@media only screen and (max-width: 910px) {\n  .core_value_content.remove_gap_core_value_1 {\n    margin-top: -65px;\n  }\n  .core_value_content.remove_gap_core_value_2 {\n    margin-top: -65px;\n  }\n}\n@media only screen and (max-width: 767px) {\n  .banner__title h1 {\n    font-size: 50px;\n    line-height: 60px;\n  }\n  .sub__title h4 {\n    font-size: 16px;\n    letter-spacing: 5.2px;\n  }\n  h2 {\n    font-size: 30px;\n    font-weight: 700;\n    line-height: 40px;\n  }\n  .team__data {\n    display: block;\n  }\n  .team__data .team__data__left {\n    padding-bottom: 20px;\n  }\n  .brand__section.p_relative.see__pad {\n    padding: 50px 0px 0px;\n  }\n  .mission__block {\n    padding: 40px;\n  }\n  .home__three__banner .banner__mission__block {\n    margin-bottom: 20px;\n  }\n  .pro__info {\n    margin: 50px 0px 0px;\n    width: 100%;\n    max-width: 100%;\n  }\n  .pro__info ul {\n    display: block;\n  }\n  .pro__info ul li {\n    margin-bottom: 20px;\n  }\n  .core_value_content.remove_gap_core_value_1 {\n    margin-top: -65px;\n  }\n  .core_value_content.remove_gap_core_value_2 {\n    margin-top: -65px;\n  }\n}\n@media only screen and (max-width: 683px) {\n  .core_value_content.remove_gap_core_value_1 {\n    margin-top: 0px;\n  }\n  .core_value_content.remove_gap_core_value_2 {\n    margin-top: -65px;\n  }\n}\n@media only screen and (max-width: 599px) {\n  .product__block__wrapper {\n    padding: 0 40px 100px;\n  }\n  .industry__block__wrapper {\n    padding: 0 40px 100px;\n  }\n  .new__service__block__wrapper {\n    padding: 0 40px 100px;\n  }\n  .service__block {\n    padding: 40px 30px 80px;\n  }\n  .service__data {\n    padding: 90px 10px 0px;\n  }\n  .testimonials__info {\n    padding: 40px 49px 80px;\n  }\n  .testimonial__top {\n    display: block;\n  }\n  .main__footer .top-inner {\n    padding: 20px;\n  }\n  .main__footer .left__top h3 {\n    font-size: 25px;\n    line-height: 35px;\n  }\n  .banner__two .content-box h2 {\n    font-size: 50px;\n    line-height: 60px;\n  }\n  section.banner__two {\n    padding-top: 200px;\n  }\n  .banner__mission__block {\n    display: block;\n  }\n  .pride__block h1 {\n    font-size: 40px;\n    line-height: 50px;\n    padding: 0px 20px;\n  }\n  .bread__crumb li {\n    letter-spacing: 4px;\n  }\n  .core_value_content.remove_gap_core_value_1 {\n    margin-top: 0;\n  }\n  .core_value_content.remove_gap_core_value_2 {\n    margin-top: -65px;\n  }\n}\n@media only screen and (max-width: 499px) {\n  .mobile-menu {\n    width: 100%;\n  }\n  .main-header .btn-box {\n    display: none;\n  }\n  .main-header .search-box-outer .dropdown-menu {\n    width: 300px;\n  }\n  .funfact__data {\n    justify-content: center;\n  }\n  .vision_mission_wrapper {\n    grid-template-columns: repeat(1, 1fr);\n    width: 80%;\n  }\n  .office-wrapper {\n    grid-template-columns: repeat(1, 1fr);\n    width: 100%;\n    gap: 32px;\n  }\n  .office-map-wrapper {\n    height: 480px;\n  }\n  .news-articles-wrapper {\n    flex-direction: column;\n    gap: 20px;\n    padding: 0 12px;\n  }\n  .brand__content .brand__name h1 {\n    font-size: 30px;\n  }\n  .brand__section .brand-carousel {\n    padding: 45px 20px;\n  }\n  .banner__two .content-box h2 {\n    font-size: 40px;\n    line-height: 50px;\n  }\n  .service__block__two {\n    padding: 100px 40px 50px;\n  }\n  .brand__section_two .brand__content .brand__name h1 {\n    font-size: 35px;\n  }\n  .choose_us_block li {\n    font-size: 20px;\n    line-height: 30px;\n    padding: 15px 0px;\n  }\n  .consultation__list li a {\n    font-size: 20px;\n    padding: 20px 0px 20px 85px;\n  }\n  .sidebar__widget_network {\n    padding: 100px 20px;\n  }\n  .error__page h1.title {\n    font-size: 100px;\n  }\n  .news___block {\n    width: 100%;\n  }\n  .inner-box .image-box img {\n    height: 300px;\n  }\n  .blog__details__content .blog__image img {\n    height: 300px;\n  }\n  .core_value_content.remove_gap_core_value_1 {\n    margin-top: 0;\n  }\n  .core_value_content.remove_gap_core_value_2 {\n    margin-top: 0;\n  }\n}\n@media only screen and (max-width: 399px) {\n  .header-top-one .top-right li.search-box-outer {\n    display: none;\n  }\n  .banner__left {\n    padding-top: 26px;\n  }\n  .testimonials__info {\n    clip-path: none;\n    padding: 41px 30px 80px;\n  }\n  .protfolio__button {\n    width: 80%;\n  }\n  .contact__right {\n    padding: 40px 20px;\n  }\n  .pro__info {\n    padding: 40px;\n  }\n}\n@font-face {\n  font-family: \"icomoon\";\n  src: url(\"../fonts/icomoon.eot?buz9qd\");\n  src: url(\"../fonts/icomoon.eot?buz9qd#iefix\") format(\"embedded-opentype\"), url(\"../fonts/icomoon.ttf?buz9qd\") format(\"truetype\"), url(\"../fonts/icomoon.woff?buz9qd\") format(\"woff\"), url(\"../fonts/icomoon.svg?buz9qd#icomoon\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n[class^=icon-], [class*=\" icon-\"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: \"icomoon\" !important;\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-17:before {\n  content: \"\\e910\";\n}\n\n.icon-18:before {\n  content: \"\\e911\";\n}\n\n.icon-16:before {\n  content: \"\\e90f\";\n}\n\n.icon-01:before {\n  content: \"\\e900\";\n}\n\n.icon-02:before {\n  content: \"\\e901\";\n}\n\n.icon-03:before {\n  content: \"\\e902\";\n}\n\n.icon-04:before {\n  content: \"\\e903\";\n}\n\n.icon-05:before {\n  content: \"\\e904\";\n}\n\n.icon-06:before {\n  content: \"\\e905\";\n}\n\n.icon-07:before {\n  content: \"\\e906\";\n}\n\n.icon-08:before {\n  content: \"\\e907\";\n}\n\n.icon-09:before {\n  content: \"\\e908\";\n}\n\n.icon-10:before {\n  content: \"\\e909\";\n}\n\n.icon-11:before {\n  content: \"\\e90a\";\n}\n\n.icon-12:before {\n  content: \"\\e90b\";\n}\n\n.icon-13:before {\n  content: \"\\e90c\";\n}\n\n.icon-14:before {\n  content: \"\\e90d\";\n}\n\n.icon-15:before {\n  content: \"\\e90e\";\n}\n\n.icon-19:before {\n  content: \"\\e912\";\n}\n\n.icon-20:before {\n  content: \"\\e913\";\n}\n\n.icon-fa-times:before {\n  content: \"\\e914\";\n}","@charset \"UTF-8\";\n/*!\nAnimate.css - http://daneden.me/animate\nLicensed under the MIT license - http://opensource.org/licenses/MIT\n\nCopyright (c) 2023 Daniel Eden\n*/\n@keyframes \"zoomInOut\" {\n\t0% {\n\t\ttransform: scale(1);\n\t}\n\t50% {\n\t\ttransform: scale(.8);\n\t}\n\tto {\n\t\ttransform: scale(1);\n\t}\n}\n@keyframes \"moveLeftBounce\" {\n\t0% {\n\t\ttransform: translateX(0);\n\t}\n\t50% {\n\t\ttransform: translateX(50px) translateY(20px);\n\t}\n\tto {\n\t\ttransform: translateX(0);\n\t}\n}\n@keyframes \"animationFramesOne\" {\n\t0% {\n\t\ttransform: translate(0) rotate(0deg);\n\t}\n\t20% {\n\t\ttransform: translate(73px,-1px) rotate(36deg);\n\t}\n\t40% {\n\t\ttransform: translate(141px,72px) rotate(72deg);\n\t}\n\t60% {\n\t\ttransform: translate(83px,122px) rotate(108deg);\n\t}\n\t80% {\n\t\ttransform: translate(-40px,72px) rotate(144deg);\n\t}\n\tto {\n\t\ttransform: translate(0) rotate(0deg);\n\t}\n}\n@keyframes \"rotateme\" {\n\t0% {\n\t\ttransform: rotate(0deg);\n\t}\n\tto {\n\t\ttransform: rotate(1turn);\n\t}\n}\n@keyframes \"float-bob-y\" {\n\t0% {\n\t\t-webkit-transform: translateY(-20px);\n\t\ttransform: translateY(-20px);\n\t}\n\t50% {\n\t\t-webkit-transform: translateY(-10px);\n\t\ttransform: translateY(-10px);\n\t}\n\t100% {\n\t\t-webkit-transform: translateY(-20px);\n\t\ttransform: translateY(-20px);\n\t}\n}\n.animation-moveLeftBounce {\n\tanimation: moveLeftBounce 3s linear infinite;\n}\n.animation-zoomInOut {\n\tanimation: zoomInOut 3s linear infinite;\n}\n.animation-animationFramesOne {\n\tanimation: animationFramesOne 20s linear infinite;\n}\n.animation-rotateme {\n\tanimation-name: rotateme;\n\tanimation-duration: 20s;\n\tanimation-iteration-count: infinite;\n\tanimation-timing-function: linear;\n}\n.float-bob-y {\n\tanimation-name: float-bob-y;\n\tanimation-duration: 2s;\n\tanimation-iteration-count: infinite;\n\tanimation-timing-function: linear;\n\t-webkit-animation-name: float-bob-y;\n\t-webkit-animation-duration: 2s;\n\t-webkit-animation-iteration-count: infinite;\n\t-webkit-animation-timing-function: linear;\n\t-moz-animation-name: float-bob-y;\n\t-moz-animation-duration: 2s;\n\t-moz-animation-iteration-count: infinite;\n\t-moz-animation-timing-function: linear;\n\t-ms-animation-name: float-bob-y;\n\t-ms-animation-duration: 2s;\n\t-ms-animation-iteration-count: infinite;\n\t-ms-animation-timing-function: linear;\n\t-o-animation-name: float-bob-y;\n\t-o-animation-duration: 2s;\n\t-o-animation-iteration-count: infinite;\n\t-o-animation-timing-function: linear;\n}\n",".blog-standard-content {\n\t.news-block-one {\n\t\t.lower-content {\n\t\t\t.category {\n\t\t\t\ta {\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\ttext-decoration: underline;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.inner-box {\n\t\t\tborder-bottom: 1px solid #e5e5e5;\n\t\t}\n\t}\n}\n.news-block-one.video-block {\n\t.image-box {\n\t\t.video-btn {\n\t\t\tposition: absolute;\n\t\t\tleft: 50%;\n\t\t\ttop: 50%;\n\t\t\ttransform: translate(-50%,-50%);\n\t\t\ta {\n\t\t\t\tbackground: #fff;\n\t\t\t\t&:before {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\theight: 100%;\n\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\tbackground: transparent;\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: 50%;\n\t\t\t\t\tleft: 50%;\n\t\t\t\t\t-webkit-transform: translate(-50%, -50%);\n\t\t\t\t\ttransform: translate(-50%, -50%);\n\t\t\t\t\t-webkit-animation-delay: .9s;\n\t\t\t\t\tanimation-delay: .9s;\n\t\t\t\t\tcontent: \"\";\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\t-webkit-box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.9);\n\t\t\t\t\tbox-shadow: 0 0 0 0 rgba(255, 255, 255, 0.9);\n\t\t\t\t\t-webkit-animation: ripple 3s infinite;\n\t\t\t\t\tanimation: ripple 3s infinite;\n\t\t\t\t\t-webkit-transition: all .4s ease;\n\t\t\t\t\ttransition: all .4s ease;\n\t\t\t\t}\n\t\t\t\t&:after {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\theight: 100%;\n\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\tbackground: transparent;\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: 50%;\n\t\t\t\t\tleft: 50%;\n\t\t\t\t\t-webkit-transform: translate(-50%, -50%);\n\t\t\t\t\ttransform: translate(-50%, -50%);\n\t\t\t\t\t-webkit-animation-delay: .9s;\n\t\t\t\t\tanimation-delay: .9s;\n\t\t\t\t\tcontent: \"\";\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\t-webkit-box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.9);\n\t\t\t\t\tbox-shadow: 0 0 0 0 rgba(255, 255, 255, 0.9);\n\t\t\t\t\t-webkit-animation: ripple 3s infinite;\n\t\t\t\t\tanimation: ripple 3s infinite;\n\t\t\t\t\t-webkit-transition: all .4s ease;\n\t\t\t\t\ttransition: all .4s ease;\n\t\t\t\t\t-webkit-animation-delay: .6s;\n\t\t\t\t\tanimation-delay: .6s;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\timg {\n\t\t\topacity: 1 !important;\n\t\t\tborder-radius: 5px;\n\t\t}\n\t\t.image {\n\t\t\t&:before {\n\t\t\t\tposition: absolute;\n\t\t\t\tcontent: '';\n\t\t\t\tbackground: #000;\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t\tleft: 0px;\n\t\t\t\ttop: 0px;\n\t\t\t\topacity: 0.3;\n\t\t\t\tz-index: 1;\n\t\t\t\tborder-radius: 5px;\n\t\t\t}\n\t\t}\n\t}\n}\n.news-block-one.carousel-block {\n\t.inner-box {\n\t\t.image {\n\t\t\timg {\n\t\t\t\topacity: 1 !important;\n\t\t\t\tborder-radius: 5px;\n\t\t\t}\n\t\t}\n\t}\n\t.owl-nav {\n\t\tposition: absolute;\n\t\tleft: 0px;\n\t\ttop: 50%;\n\t\ttransform: translateY(-50%);\n\t\twidth: 100%;\n\t\tbutton {\n\t\t\tposition: absolute;\n\t\t\tdisplay: inline-block;\n\t\t\twidth: 50px;\n\t\t\theight: 50px;\n\t\t\tline-height: 50px;\n\t\t\tbackground: #fff;\n\t\t\tfont-size: 20px;\n\t\t\tcolor: #141417;\n\t\t\ttext-align: center;\n\t\t\tborder-radius: 50%;\n\t\t\ttransition: all 500ms ease;\n\t\t\t&:hover {\n\t\t\t\tcolor: #fff;\n\t\t\t}\n\t\t}\n\t\tbutton.owl-prev {\n\t\t\tleft: 30px;\n\t\t}\n\t\tbutton.owl-next {\n\t\t\tright: 30px;\n\t\t}\n\t}\n}\n.news-block-one {\n\t.inner-box {\n\t\tblockquote {\n\t\t\t.icon-box {\n\t\t\t\tcolor: #fceee7;\n\t\t\t}\n\t\t\th5.name {\n\t\t\t\t&:before {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tcontent: '';\n\t\t\t\t\tbackground: #141417;\n\t\t\t\t\twidth: 15px;\n\t\t\t\t\theight: 2px;\n\t\t\t\t\tleft: 0px;\n\t\t\t\t\ttop: 12px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.news-block-one.quote-block {\n\t.inner-box {\n\t\toverflow: visible;\n\t}\n}\n.sidebar-page-container {\n\t.pagination {\n\t\tli {\n\t\t\tborder-radius: 5px;\n\t\t\ta {\n\t\t\t\tborder-radius: 5px;\n\t\t\t}\n\t\t}\n\t}\n\t.inner-container {\n\t\tbackground: #fff;\n\t\t&:before {\n\t\t\tposition: absolute;\n\t\t\tcontent: '';\n\t\t\tbackground: #fff;\n\t\t\twidth: calc(100% + 140px);\n\t\t\theight: 100%;\n\t\t\tleft: -70px;\n\t\t\ttop: 0px;\n\t\t}\n\t}\n\t.theme-btn {\n\t\tborder: 1px solid #e7e7e7;\n\t\tcolor: #141417 !important;\n\t\tpadding: 11px 32px;\n\t\t&:hover {\n\t\t\tcolor: #fff !important;\n\t\t\tborder-color: #e45712;\n\t\t}\n\t}\n}\n.blog-sidebar {\n\t.sidebar-widget {\n\t\tbackground: #f7f7f7;\n\t}\n\t.search-widget {\n\t\t.search-form {\n\t\t\t.form-group {\n\t\t\t\tinput[type='search'] {\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\theight: 60px;\n\t\t\t\t\tborder: 1px solid #e5e5e5;\n\t\t\t\t\tborder-radius: 5px;\n\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\tcolor: #808080;\n\t\t\t\t\tfont-family: 'Poppins', sans-serif;\n\t\t\t\t\tpadding: 10px 20px 10px 60px;\n\t\t\t\t\ttransition: all 500ms ease;\n\t\t\t\t\tbackground: #f7f7f7;\n\t\t\t\t}\n\t\t\t\tbutton {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tleft: 28px;\n\t\t\t\t\ttop: 18px;\n\t\t\t\t\tfont-size: 18px;\n\t\t\t\t\tcolor: #808080;\n\t\t\t\t\tcursor: pointer;\n\t\t\t\t\ttransition: all 500ms ease;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.post-widget {\n\t\t.post {\n\t\t\tborder-bottom: 1px solid #e5e5e5;\n\t\t\tmin-height: 104px;\n\t\t\t&:last-child {\n\t\t\t\tborder-bottom: none;\n\t\t\t}\n\t\t\t.post-thumb {\n\t\t\t\timg {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tborder-radius: 5px;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&:hover {\n\t\t\t\t.post-thumb {\n\t\t\t\t\timg {\n\t\t\t\t\t\topacity: 0.2;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\th5 {\n\t\t\t\tline-height: 24px;\n\t\t\t}\n\t\t}\n\t}\n\t.tags-widget {\n\t\t.tags-list {\n\t\t\tmargin: 0px -5px;\n\t\t\tli {\n\t\t\t\ta {\n\t\t\t\t\tpadding: 5px 14px;\n\t\t\t\t\tborder: 1px solid #e5e5e5;\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\tcolor: #fff;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.blog-standard-2 {\n\t.blog-standard-content {\n\t\t.news-block-one {\n\t\t\t.inner-box {\n\t\t\t\tborder-bottom: none;\n\t\t\t}\n\t\t}\n\t}\n\t.news-block-one {\n\t\t.inner-box {\n\t\t\tblockquote {\n\t\t\t\tborder-left: none;\n\t\t\t\tbackground: #302f2f;\n\t\t\t\t.icon-box {\n\t\t\t\t\tcolor: #454444;\n\t\t\t\t\tleft: 50%;\n\t\t\t\t\ttransform: translateX(-50%);\n\t\t\t\t}\n\t\t\t\th5 {\n\t\t\t\t\tcolor: #fff;\n\t\t\t\t\t&:before {\n\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.blog-sidebar {\n\t\t.sidebar-widget {\n\t\t\tbackground: transparent;\n\t\t}\n\t}\n}\n.blog-grid-one {\n\t.news-block-one {\n\t\t.inner-box {\n\t\t\t.post-date-two {\n\t\t\t\tbackground: #fff;\n\t\t\t\th4 {\n\t\t\t\t\tcolor: #141417;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.theme-btn {\n\t\t\t\tfont-family: 'Poppins', sans-serif;\n\t\t\t\tfont-weight: 500;\n\t\t\t\tborder-radius: 0px;\n\t\t\t\tpadding: 11px 32px;\n\t\t\t}\n\t\t}\n\t}\n}\n.blog-grid-two {\n\t.news-block-one {\n\t\t.inner-box {\n\t\t\t.theme-btn {\n\t\t\t\tfont-size: 16px;\n\t\t\t\tborder-radius: 30px;\n\t\t\t\tpadding-top: 11px;\n\t\t\t\tpadding-bottom: 11px;\n\t\t\t\t&:hover {\n\t\t\t\t\tborder-color: #e45712;\n\t\t\t\t\tbackground: #e45712;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.pagination {\n\t\tli {\n\t\t\ta {\n\t\t\t\tborder-radius: 50%;\n\t\t\t}\n\t\t}\n\t}\n}\n.blog-masonry-two {\n\t.more-btn {\n\t\t.theme-btn {\n\t\t\tbackground: #e45712;\n\t\t\tpadding: 12px 40px;\n\t\t}\n\t}\n\t.news-block-one {\n\t\t.inner-box {\n\t\t\tblockquote {\n\t\t\t\tborder-left: none;\n\t\t\t\tbackground: #302f2f;\n\t\t\t\t.icon-box {\n\t\t\t\t\tcolor: #454444;\n\t\t\t\t\tleft: 50%;\n\t\t\t\t\ttransform: translateX(-50%);\n\t\t\t\t}\n\t\t\t\th5 {\n\t\t\t\t\tcolor: #fff;\n\t\t\t\t\t&:before {\n\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.news-block-one.carousel-block {\n\t\t.inner-box {\n\t\t\t.image {\n\t\t\t\timg {\n\t\t\t\t\tborder-radius: 0px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.blog-list-content {\n\t.news-block-one {\n\t\t.inner-box {\n\t\t\tpadding-left: 370px;\n\t\t\t.image-box {\n\t\t\t\twidth: 370px;\n\t\t\t\theight: 370px;\n\t\t\t}\n\t\t\t.post-date-two {\n\t\t\t\tbackground: #fff;\n\t\t\t\th4 {\n\t\t\t\t\tcolor: #141417;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.theme-btn {\n\t\t\t\tborder-radius: 0px;\n\t\t\t}\n\t\t}\n\t}\n}\n.blog-details-content {\n\t.blog-post {\n\t\t.content-one {\n\t\t\t.post-title {\n\t\t\t\t.post-info {\n\t\t\t\t\tli {\n\t\t\t\t\t\t&:before {\n\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\tcontent: '';\n\t\t\t\t\t\t\tbackground: #e5e5e5;\n\t\t\t\t\t\t\twidth: 6px;\n\t\t\t\t\t\t\theight: 6px;\n\t\t\t\t\t\t\ttop: 12px;\n\t\t\t\t\t\t\tright: -19px;\n\t\t\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\t&:before {\n\t\t\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.image-box {\n\t\t\timg {\n\t\t\t\tborder-radius: 5px;\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t}\n\t}\n\tblockquote {\n\t\t.icon-box {\n\t\t\tcolor: #fceee7;\n\t\t}\n\t\th5.name {\n\t\t\t&:before {\n\t\t\t\tposition: absolute;\n\t\t\t\tcontent: '';\n\t\t\t\tbackground: #141417;\n\t\t\t\twidth: 15px;\n\t\t\t\theight: 2px;\n\t\t\t\tleft: 0px;\n\t\t\t\ttop: 12px;\n\t\t\t}\n\t\t}\n\t}\n\t.list {\n\t\tli {\n\t\t\t&:before {\n\t\t\t\tposition: absolute;\n\t\t\t\tcontent: '';\n\t\t\t\tleft: 0px;\n\t\t\t\ttop: 6px;\n\t\t\t\twidth: 12px;\n\t\t\t\theight: 12px;\n\t\t\t\tborder: 2px solid #141417;\n\t\t\t\tborder-radius: 50%;\n\t\t\t}\n\t\t}\n\t}\n\t.post-share-option {\n\t\t.tags-list {\n\t\t\tli {\n\t\t\t\ta {\n\t\t\t\t\tpadding: 9px 14px;\n\t\t\t\t\tborder: 1px solid #e5e5e5;\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\tcolor: #fff;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\tborder-top: 1px solid #e5e5e5;\n\t\tborder-bottom: 1px solid #e5e5e5;\n\t\t.social-list {\n\t\t\tli {\n\t\t\t\ta {\n\t\t\t\t\tborder: 1px solid #e6e6e6;\n\t\t\t\t\tcolor: #808080;\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\tcolor: #fff;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.nav-btn {\n\t\t.single-btn {\n\t\t\tborder: 1px solid #e7e7e7;\n\t\t\t&:hover {\n\t\t\t\tborder-color: transparent;\n\t\t\t\tbox-shadow: 0px 5px 30px 0px rgba(0, 0, 0, 0.07);\n\t\t\t}\n\t\t\th6 {\n\t\t\t\ti {\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tfont-size: 22px;\n\t\t\t\t\ttop: 3px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.single-btn.prev-btn {\n\t\t\th6 {\n\t\t\t\ti {\n\t\t\t\t\tmargin-right: 8px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.single-btn.next-btn {\n\t\t\th6 {\n\t\t\t\ti {\n\t\t\t\t\tmargin-left: 8px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.author-box {\n\t\tbox-shadow: 0px 5px 30px 0px rgba(0, 0, 0, 0.07);\n\t\t.author-thumb {\n\t\t\timg {\n\t\t\t\twidth: 100%;\n\t\t\t\tborder-radius: 50%;\n\t\t\t}\n\t\t}\n\t}\n\t.comments-form-area {\n\t\t.form-group {\n\t\t\tmargin-bottom: 20px;\n\t\t\t&:last-child {\n\t\t\t\tmargin-bottom: 0px;\n\t\t\t}\n\t\t\tinput[type='text'] {\n\t\t\t\tposition: relative;\n\t\t\t\tdisplay: inline-block;\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 50px;\n\t\t\t\tfont-size: 16px;\n\t\t\t\tfont-family: 'Poppins', sans-serif;\n\t\t\t\tcolor: #808080;\n\t\t\t\tborder-bottom: 1px solid #e5e5e5;\n\t\t\t\ttransition: all 500ms ease;\n\t\t\t}\n\t\t\tinput[type='email'] {\n\t\t\t\tposition: relative;\n\t\t\t\tdisplay: inline-block;\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 50px;\n\t\t\t\tfont-size: 16px;\n\t\t\t\tfont-family: 'Poppins', sans-serif;\n\t\t\t\tcolor: #808080;\n\t\t\t\tborder-bottom: 1px solid #e5e5e5;\n\t\t\t\ttransition: all 500ms ease;\n\t\t\t}\n\t\t\ttextarea {\n\t\t\t\tposition: relative;\n\t\t\t\tdisplay: inline-block;\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 50px;\n\t\t\t\tfont-size: 16px;\n\t\t\t\tfont-family: 'Poppins', sans-serif;\n\t\t\t\tcolor: #808080;\n\t\t\t\tborder-bottom: 1px solid #e5e5e5;\n\t\t\t\ttransition: all 500ms ease;\n\t\t\t\theight: 60px;\n\t\t\t\tresize: none;\n\t\t\t}\n\t\t}\n\t\t.check-box {\n\t\t\tlabel {\n\t\t\t\tcolor: #808080;\n\t\t\t}\n\t\t}\n\t\t.theme-btn {\n\t\t\tpadding: 13px 31px;\n\t\t\tbackground: #e35712;\n\t\t\tcolor: #fff !important;\n\t\t\tborder: none;\n\t\t}\n\t}\n}\n.page-title {\n\t.post-title {\n\t\th2 {\n\t\t\tcolor: #fff;\n\t\t}\n\t\t.post-info {\n\t\t\tli {\n\t\t\t\tcolor: #fff;\n\t\t\t\t&:before {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tcontent: '';\n\t\t\t\t\tbackground: #e5e5e5;\n\t\t\t\t\twidth: 6px;\n\t\t\t\t\theight: 6px;\n\t\t\t\t\ttop: 12px;\n\t\t\t\t\tright: -19px;\n\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t}\n\t\t\t\t&:last-child {\n\t\t\t\t\t&:before {\n\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.page-title.blog-details {\n\tpadding-top: 237px;\n\tpadding-bottom: 182px;\n}\n.sidebar-page-container.blog-details-3 {\n\tpadding-top: 420px;\n\t.bg-image {\n\t\twidth: 100%;\n\t\theight: 722px;\n\t\tbackground-size: cover;\n\t\tborder-radius: inherit;\n\t\tbackground-position: bottom center;\n\t}\n}\n","/* template-color */\n.handle-preloader {\n\tbackground: linear-gradient(224deg, #800599 0%, #FF0E75 100%);\n}\n.handle-preloader.home-2 {\n\tbackground: -webkit-linear-gradient(0deg, #41a0ea, #f18e95 75%);\n}\n.theme-btn-one {\n\tbackground: linear-gradient(219deg, #ff8c2e 0%, #7E2100 100%);\n\t&:before {\n\t\tbackground: linear-gradient(219deg, #ff8c2e 0%, #7E2100 100%);\n\t}\n}\n","/*** use-font ***/\n@import \"https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap\";\n@import \"https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\";\n/*** \n\n====================================================================\n  Reset\n====================================================================\n\n ***/\n/*** \n\n====================================================================\n  Global Settings\n====================================================================\n\n ***/\n/** use-font-family **/\n/* Preloader */\n@keyframes spin-1 {\n\tfrom {\n\t\ttransform: rotateY(0) rotateX(30deg);\n\t}\n\tto {\n\t\ttransform: rotateY(1turn) rotateX(30deg);\n\t}\n}\n@keyframes spin-2{\n\tfrom {\n\t\ttransform: rotateY(0);\n\t}\n\tto {\n\t\ttransform: rotateY(1turn);\n\t}\n}\n@-webkit-keyframes shine {\n\t100% {\n\t\tleft: 125%;\n\t}\n}\n@keyframes shine {\n\t100% {\n\t\tleft: 125%;\n\t}\n}\n@-webkit-keyframes circle {\n\t0% {\n\t\topacity: 1;\n\t}\n\t40% {\n\t\topacity: 1;\n\t}\n\t100% {\n\t\twidth: 200%;\n\t\theight: 200%;\n\t\topacity: 0;\n\t}\n}\n@keyframes circle {\n\t0% {\n\t\topacity: 1;\n\t}\n\t40% {\n\t\topacity: 1;\n\t}\n\t100% {\n\t\twidth: 200%;\n\t\theight: 200%;\n\t\topacity: 0;\n\t}\n}\n@-webkit-keyframes ripple {\n\t70% {\n\t\t-webkit-box-shadow: 0 0 0 40px rgba(255, 255, 255, 0);\n\t\tbox-shadow: 0 0 0 40px rgba(255, 255, 255, 0);\n\t}\n\t100% {\n\t\t-webkit-box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);\n\t\tbox-shadow: 0 0 0 0 rgba(255, 255, 255, 0);\n\t}\n}\n@keyframes ripple {\n\t70% {\n\t\t-webkit-box-shadow: 0 0 0 40px rgba(255, 255, 255, 0);\n\t\tbox-shadow: 0 0 0 40px rgba(255, 255, 255, 0);\n\t}\n\t100% {\n\t\t-webkit-box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);\n\t\tbox-shadow: 0 0 0 0 rgba(255, 255, 255, 0);\n\t}\n}\n@keyframes slide {\n\tfrom {\n\t\tbackground-position: 0 0;\n\t}\n\tto {\n\t\tbackground-position: 1920px 0;\n\t}\n}\n@-webkit-keyframes slide {\n\tfrom {\n\t\tbackground-position: 0 0;\n\t}\n\tto {\n\t\tbackground-position: 1920px 0;\n\t}\n}\n\n* {\n\tmargin: 0px;\n\tpadding: 0px;\n\tborder: none;\n\toutline: none;\n}\nbody {\n\tfont-size: 16px;\n\tcolor: #fff;\n\tline-height: 28px;\n\tfont-weight: 400;\n\tbackground: #00061A;\n\tfont-family: 'Archivo', sans-serif;\n\tbackground-size: cover;\n\tbackground-repeat: no-repeat;\n\tbackground-position: center top;\n\t-webkit-font-smoothing: antialiased;\n}\n.auto-container {\n\tposition: static;\n\tmax-width: 1296px;\n\tpadding: 0px 15px;\n\tmargin: 0 auto;\n}\n.small-container {\n\tmax-width: 680px;\n\tmargin: 0 auto;\n}\n.boxed_wrapper {\n\tposition: relative;\n\tmargin: 0 auto;\n\toverflow: hidden !important;\n\twidth: 100%;\n\tmin-width: 300px;\n}\na {\n\tcolor: #fff;\n\ttext-decoration: none;\n\ttransition: all 500ms ease;\n\t-moz-transition: all 500ms ease;\n\t-webkit-transition: all 500ms ease;\n\t-ms-transition: all 500ms ease;\n\t-o-transition: all 500ms ease;\n\t&:hover {\n\t\tcolor: #ff8c2e;\n\t\ttext-decoration: none;\n\t\toutline: none;\n\t}\n}\ninput {\n\tfont-family: 'Archivo', sans-serif;\n\tfont-weight: 400;\n\tfont-size: 16px;\n\tbackground: transparent;\n\ttransition: all 500ms ease;\n\t&:focus {\n\t\toutline: none;\n\t\tbox-shadow: none;\n\t\ttransition: all 500ms ease;\n\t}\n}\nbutton {\n\tfont-family: 'Archivo', sans-serif;\n\tfont-weight: 400;\n\tfont-size: 16px;\n\tbackground: transparent;\n\t&:focus {\n\t\toutline: none;\n\t\tbox-shadow: none;\n\t\ttransition: all 500ms ease;\n\t}\n}\nselect {\n\tfont-family: 'Archivo', sans-serif;\n\tfont-weight: 400;\n\tfont-size: 16px;\n\tbackground: transparent;\n}\ntextarea {\n\tfont-family: 'Archivo', sans-serif;\n\tfont-weight: 400;\n\tfont-size: 16px;\n\tbackground: transparent;\n\t&:focus {\n\t\toutline: none;\n\t\tbox-shadow: none;\n\t\ttransition: all 500ms ease;\n\t}\n}\n::-webkit-input-placeholder {\n\tcolor: inherit;\n}\n::-moz-input-placeholder {\n\tcolor: inherit;\n}\n::-ms-input-placeholder {\n\tcolor: inherit;\n}\nul {\n\tlist-style: none;\n\tpadding: 0px;\n\tmargin: 0px;\n}\nli {\n\tlist-style: none;\n\tpadding: 0px;\n\tmargin: 0px;\n}\np {\n\tposition: relative;\n\tfont-family: 'Archivo', sans-serif;\n\tcolor: #fff;\n\tfont-size: 16px;\n\tline-height: 29px;\n\tmargin-bottom: 0px;\n\tfont-weight: 400;\n\ttransition: all 500ms ease;\n\t&:last-child {\n\t\tmargin-bottom: 0px;\n\t}\n}\nh1 {\n\tposition: relative;\n\tfont-family: 'Rubik', sans-serif;\n\tfont-weight: 400;\n\tcolor: #fff;\n\tline-height: 29px;\n\tmargin: 0px;\n\ttransition: all 500ms ease;\n\tfont-size: 50px;\n\tline-height: 60px;\n}\nh2 {\n\tposition: relative;\n\tfont-family: 'Rubik', sans-serif;\n\tfont-weight: 400;\n\tcolor: #fff;\n\tline-height: 29px;\n\tmargin: 0px;\n\ttransition: all 500ms ease;\n\tfont-size: 40px;\n\tfont-weight: 700;\n\tline-height: 50px;\n}\nh3 {\n\tposition: relative;\n\tfont-family: 'Rubik', sans-serif;\n\tfont-weight: 400;\n\tcolor: #fff;\n\tline-height: 29px;\n\tmargin: 0px;\n\ttransition: all 500ms ease;\n\tfont-size: 32px;\n\tfont-weight: 600;\n\tline-height: 42px;\n}\nh4 {\n\tposition: relative;\n\tfont-family: 'Rubik', sans-serif;\n\tfont-weight: 400;\n\tcolor: #fff;\n\tline-height: 29px;\n\tmargin: 0px;\n\ttransition: all 500ms ease;\n\tfont-size: 26px;\n\tfont-weight: 500;\n\tline-height: 36px;\n}\nh5 {\n\tposition: relative;\n\tfont-family: 'Rubik', sans-serif;\n\tfont-weight: 400;\n\tcolor: #fff;\n\tline-height: 29px;\n\tmargin: 0px;\n\ttransition: all 500ms ease;\n}\nh6 {\n\tposition: relative;\n\tfont-family: 'Rubik', sans-serif;\n\tfont-weight: 400;\n\tcolor: #fff;\n\tline-height: 29px;\n\tmargin: 0px;\n\ttransition: all 500ms ease;\n}\n.font_family_rubik {\n\tfont-family: 'Rubik', sans-serif;\n}\n.font_family_archivo {\n\tfont-family: 'Archivo', sans-serif;\n}\n.loader-wrap {\n\tz-index: 9999;\n\twidth: 100%;\n\theight: 100%;\n\tbackground: linear-gradient(219deg, #00061A 0%, #00061A 100%);\n\tposition: fixed;\n}\n.preloader {\n\tdisplay: flex;\n\tanimation: spin-1 8s linear infinite;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\tmargin: auto;\n\twidth: 300px;\n\theight: 300px;\n\tcolor: #ff8c2e;\n\ttransform-style: preserve-3d;\n}\n.preloader-ring {\n\ttransform-style: preserve-3d;\n\tanimation: spin-2 4s linear infinite;\n\tposition: relative;\n\theight: 60px;\n\twidth: 20px;\n\t&:nth-child(even) {\n\t\tanimation-direction: reverse;\n\t}\n}\n.preloader-sector {\n\tfont-size: 40px;\n\tline-height: 60px;\n\tfont-weight: 600;\n\ttext-align: center;\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\ttext-transform: uppercase;\n\ttransform: translateZ(160px);\n\tdisplay: inline-block;\n\twidth: 100%;\n\theight: 100%;\n\t&:empty {\n\t\t&:before {\n\t\t\tdisplay: inline-block;\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tbackground: linear-gradient(transparent 50%, #ff8c2e 50% 55%, transparent 55%);\n\t\t\tcontent: \"\";\n\t\t}\n\t}\n}\n.hendel__preloder {\n\twidth: 100%;\n\theight: 100vh;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n.centred {\n\ttext-align: center;\n}\n.pull-left {\n\tfloat: left;\n}\n.pull-right {\n\tfloat: right;\n}\nfigure {\n\tmargin: 0px;\n}\nimg {\n\tdisplay: inline-block;\n\tmax-width: 100%;\n\theight: auto;\n\ttransition-delay: .1s;\n\ttransition-timing-function: ease-in-out;\n\ttransition-duration: .7s;\n\ttransition-property: all;\n}\n.theme-btn {\n\tposition: relative;\n\tdisplay: flex;\n\toverflow: hidden;\n\tvertical-align: middle;\n\tfont-size: 12px;\n\tline-height: 24px;\n\tfont-weight: 500;\n\tfont-family: 'Rubik', sans-serif;\n\tcolor: #fff !important;\n\ttext-align: center;\n\tpadding: 15px 20px;\n\tborder-radius: 5px;\n\tletter-spacing: 2.4px;\n\ttext-transform: uppercase;\n\tz-index: 1;\n\t-webkit-transition: all cubic-bezier(.4,0,.2,1) .4s;\n\t-o-transition: all cubic-bezier(.4,0,.2,1) .4s;\n\ttransition: all cubic-bezier(.4,0,.2,1) .4s;\n\talign-items: center;\n\tgap: 10px;\n\ti {\n\t\tposition: relative;\n\t\tfont-size: 15px;\n\t}\n}\n.theme-btn-one {\n\t&:before {\n\t\tposition: absolute;\n\t\tcontent: '';\n\t\twidth: 0%;\n\t\theight: 100%;\n\t\tleft: 0px;\n\t\ttop: 0px;\n\t\tz-index: -1;\n\t\ttransition: all 500ms ease;\n\t}\n\t&:hover {\n\t\t&:before {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n}\n.theme-btn-two {\n\tbackground: #fff;\n\tpadding: 12px 62px 12px 30px;\n\t&:hover {\n\t\tpadding: 12px 69px 12px 30px;\n\t\tspan {\n\t\t\t&:before {\n\t\t\t\t-webkit-transform: translateY(-50%) translateX(-30px);\n\t\t\t\t-ms-transform: translateY(-50%) translateX(-30px);\n\t\t\t\ttransform: translateY(-50%) translateX(-30px);\n\t\t\t\topacity: 0;\n\t\t\t}\n\t\t\t&:after {\n\t\t\t\t-webkit-transform: translateY(-50%) translateX(0);\n\t\t\t\t-ms-transform: translateY(-50%) translateX(0);\n\t\t\t\ttransform: translateY(-50%) translateX(0);\n\t\t\t\topacity: 1;\n\t\t\t}\n\t\t}\n\t\t&:before {\n\t\t\t-webkit-transform: translateY(-50%) scaleX(1);\n\t\t\t-ms-transform: translateY(-50%) scaleX(1);\n\t\t\ttransform: translateY(-50%) scaleX(1);\n\t\t\twidth: 25px;\n\t\t}\n\t}\n\tspan {\n\t\tposition: relative;\n\t\tcolor: transparent;\n\t\t&:before {\n\t\t\tcontent: attr(data-text);\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\tleft: 0;\n\t\t\t-webkit-transform: translateY(-50%) translateX(0);\n\t\t\t-ms-transform: translateY(-50%) translateX(0);\n\t\t\ttransform: translateY(-50%) translateX(0);\n\t\t\twidth: 100%;\n\t\t\t-webkit-transition: all cubic-bezier(.4,0,.2,1) .4s;\n\t\t\t-o-transition: all cubic-bezier(.4,0,.2,1) .4s;\n\t\t\ttransition: all cubic-bezier(.4,0,.2,1) .4s;\n\t\t\tcolor: #141417;\n\t\t}\n\t\t&:after {\n\t\t\tcontent: attr(data-text);\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\tleft: 0;\n\t\t\t-webkit-transform: translateY(-50%) translateX(0);\n\t\t\t-ms-transform: translateY(-50%) translateX(0);\n\t\t\ttransform: translateY(-50%) translateX(0);\n\t\t\twidth: 100%;\n\t\t\t-webkit-transition: all cubic-bezier(.4,0,.2,1) .4s;\n\t\t\t-o-transition: all cubic-bezier(.4,0,.2,1) .4s;\n\t\t\ttransition: all cubic-bezier(.4,0,.2,1) .4s;\n\t\t\tcolor: #f4244f;\n\t\t\topacity: 0;\n\t\t}\n\t}\n\t&:before {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\tright: 32px;\n\t\t-webkit-transform: translateY(-50%) scaleX(1);\n\t\t-ms-transform: translateY(-50%) scaleX(1);\n\t\ttransform: translateY(-50%) scaleX(1);\n\t\twidth: 18px;\n\t\theight: 2px;\n\t\tbackground: #141417;\n\t\ttransition: all 500ms ease;\n\t\t-webkit-transform-origin: right;\n\t\t-ms-transform-origin: right;\n\t\ttransform-origin: right;\n\t\ttransition: all 500ms ease;\n\t\t-moz-transition: all 500ms ease;\n\t\t-webkit-transition: all 500ms ease;\n\t\t-ms-transition: all 500ms ease;\n\t\t-o-transition: all 500ms ease;\n\t}\n\t&:after {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\tright: 32px;\n\t\twidth: 9px;\n\t\theight: 9px;\n\t\tborder-right: 2px solid #141417;\n\t\tborder-top: 2px solid #141417;\n\t\t-webkit-transform: translateY(-50%) rotate(45deg);\n\t\t-ms-transform: translateY(-50%) rotate(45deg);\n\t\ttransform: translateY(-50%) rotate(45deg);\n\t\ttransition: all 500ms ease;\n\t\t-moz-transition: all 500ms ease;\n\t\t-webkit-transition: all 500ms ease;\n\t\t-ms-transition: all 500ms ease;\n\t\t-o-transition: all 500ms ease;\n\t}\n}\n.theme-btn-three {\n\tpadding: 12px 62px 12px 30px;\n\t&:hover {\n\t\tpadding: 12px 69px 12px 30px;\n\t\tspan {\n\t\t\t&:before {\n\t\t\t\t-webkit-transform: translateY(-50%) translateX(-30px);\n\t\t\t\t-ms-transform: translateY(-50%) translateX(-30px);\n\t\t\t\ttransform: translateY(-50%) translateX(-30px);\n\t\t\t\topacity: 0;\n\t\t\t}\n\t\t\t&:after {\n\t\t\t\t-webkit-transform: translateY(-50%) translateX(0);\n\t\t\t\t-ms-transform: translateY(-50%) translateX(0);\n\t\t\t\ttransform: translateY(-50%) translateX(0);\n\t\t\t\topacity: 1;\n\t\t\t}\n\t\t}\n\t\t&:before {\n\t\t\t-webkit-transform: translateY(-50%) scaleX(1);\n\t\t\t-ms-transform: translateY(-50%) scaleX(1);\n\t\t\ttransform: translateY(-50%) scaleX(1);\n\t\t\twidth: 25px;\n\t\t}\n\t}\n\tspan {\n\t\tposition: relative;\n\t\tcolor: transparent;\n\t\t&:before {\n\t\t\tcontent: attr(data-text);\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\tleft: 0;\n\t\t\t-webkit-transform: translateY(-50%) translateX(0);\n\t\t\t-ms-transform: translateY(-50%) translateX(0);\n\t\t\ttransform: translateY(-50%) translateX(0);\n\t\t\twidth: 100%;\n\t\t\ttransition: all 500ms ease;\n\t\t\tcolor: #fff;\n\t\t}\n\t\t&:after {\n\t\t\tcontent: attr(data-text);\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\tleft: 0;\n\t\t\t-webkit-transform: translateY(-50%) translateX(0);\n\t\t\t-ms-transform: translateY(-50%) translateX(0);\n\t\t\ttransform: translateY(-50%) translateX(0);\n\t\t\twidth: 100%;\n\t\t\ttransition: all 500ms ease;\n\t\t\tcolor: #141417;\n\t\t\topacity: 0;\n\t\t}\n\t}\n\t&:before {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\tright: 32px;\n\t\t-webkit-transform: translateY(-50%) scaleX(1);\n\t\t-ms-transform: translateY(-50%) scaleX(1);\n\t\ttransform: translateY(-50%) scaleX(1);\n\t\twidth: 18px;\n\t\theight: 2px;\n\t\tbackground: #fff;\n\t\ttransition: all 500ms ease;\n\t\t-webkit-transform-origin: right;\n\t\t-ms-transform-origin: right;\n\t\ttransform-origin: right;\n\t}\n\t&:after {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\tright: 32px;\n\t\twidth: 9px;\n\t\theight: 9px;\n\t\tborder-right: 2px solid #fff;\n\t\tborder-top: 2px solid #fff;\n\t\t-webkit-transform: translateY(-50%) rotate(45deg);\n\t\t-ms-transform: translateY(-50%) rotate(45deg);\n\t\ttransform: translateY(-50%) rotate(45deg);\n\t\ttransition: all 500ms ease;\n\t}\n}\n.theme-btn-four {\n\tborder-radius: 30px;\n\tbackground: #6a36ff;\n\t&:before {\n\t\tbackground-color: #141417;\n\t\tborder-radius: 30px;\n\t\tcontent: '';\n\t\tdisplay: block;\n\t\theight: 100%;\n\t\twidth: 100%;\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\ttop: 0;\n\t\ttransform: translate(-100%, 0) rotate(10deg);\n\t\ttransform-origin: top left;\n\t\ttransition: .3s transform ease-out;\n\t\twill-change: transform;\n\t\tz-index: -1;\n\t}\n\t&:hover {\n\t\t&:before {\n\t\t\ttransform: translate(0, 0);\n\t\t}\n\t}\n}\n.theme-btn-five {\n\tbackground: #612ade;\n\tpadding: 17px 40px;\n\t&:before {\n\t\tposition: absolute;\n\t\tcontent: '';\n\t\tbackground: #141417;\n\t\twidth: 0%;\n\t\theight: 100%;\n\t\tleft: 0px;\n\t\ttop: 0px;\n\t\tz-index: -1;\n\t\ttransition: all 500ms ease;\n\t}\n\t&:hover {\n\t\t&:before {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n}\n.theme-btn-six {\n\tborder: 1px solid #e7e7e7;\n\tpadding: 16px 40px;\n\tcolor: #141417 !important;\n\t&:hover {\n\t\tcolor: #fff !important;\n\t\tborder-color: #612ade;\n\t\t&:before {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\t&:before {\n\t\tposition: absolute;\n\t\tcontent: '';\n\t\tbackground: #612ade;\n\t\twidth: 0%;\n\t\theight: 100%;\n\t\tleft: 0px;\n\t\ttop: 0px;\n\t\tz-index: -1;\n\t\ttransition: all 500ms ease;\n\t}\n}\n.theme-btn-seven {\n\tbackground: #f1592a;\n\tborder-radius: 30px;\n\tfont-size: 17px;\n\tfont-weight: 500;\n\tfont-family: 'Muli', sans-serif;\n\tpadding: 17px 35px;\n\tletter-spacing: 1px;\n\t&:before {\n\t\tposition: absolute;\n\t\tcontent: '';\n\t\tbackground: #141417;\n\t\twidth: 0%;\n\t\theight: 100%;\n\t\ttop: 0px;\n\t\tright: 0px;\n\t\tborder-radius: 30px;\n\t\tz-index: -1;\n\t\ttransition: all 500ms ease;\n\t}\n\t&:hover {\n\t\t&:before {\n\t\t\twidth: 100%;\n\t\t\tleft: 0px;\n\t\t}\n\t}\n}\n.theme-btn-eight {\n\tfont-weight: 500;\n\tfont-family: 'Spartan', sans-serif;\n\tborder-radius: 0px;\n\tpadding: 13px 26px 11px 26px;\n\tbackground: #ff7f4c;\n\t&:before {\n\t\twebkit-transition-duration: 800ms;\n\t\ttransition-duration: 800ms;\n\t\tposition: absolute;\n\t\twidth: 200%;\n\t\theight: 200%;\n\t\tcontent: \"\";\n\t\tbottom: 110%;\n\t\tleft: 50%;\n\t\tbackground-color: #141417;\n\t\t-webkit-transform: translateX(-50%);\n\t\ttransform: translateX(-50%);\n\t\tborder-radius: 50%;\n\t\tz-index: -1;\n\t}\n\t&:hover {\n\t\t&:before {\n\t\t\tbottom: -40%;\n\t\t}\n\t}\n}\n.theme-btn-nine {\n\tborder-radius: 0px;\n\tfont-family: 'Jost', sans-serif;\n\tpadding: 17px 40px;\n\tfont-size: 17px;\n\tbackground: #fff;\n\tcolor: #141417 !important;\n\t&:before {\n\t\tposition: absolute;\n\t\tcontent: '';\n\t\tbackground: #141417;\n\t\twidth: 100%;\n\t\theight: 0%;\n\t\tleft: 0px;\n\t\tbottom: 0px;\n\t\tz-index: -1;\n\t\ttransition: all 500ms ease;\n\t}\n\t&:hover {\n\t\t&:before {\n\t\t\ttop: 0px;\n\t\t\theight: 100%;\n\t\t}\n\t\tcolor: #fff !important;\n\t}\n}\n.scroll-to-top {\n\tposition: fixed;\n    right: 15px;\n    bottom: 20px;\n    z-index: 99;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\tsvg {\n\t\twidth: 20px;\n\t\tvisibility: visible !important;\n\t\topacity: 1 !important;\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -webkit-flex;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-align: center;\n\t\t-webkit-align-items: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center;\n\t\t-webkit-transition: all cubic-bezier(.4,0,.2,1) .4s;\n\t\t-o-transition: all cubic-bezier(.4,0,.2,1) .4s;\n\t\ttransition: all cubic-bezier(.4,0,.2,1) .4s;\n\t}\n\t.scroll-bar {\n\t\twidth: 50px;\n\t\theight: 2px;\n\t\tmargin-right: 10px;\n\t\tposition: relative;\n\t\t&:before {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\tleft: 0;\n\t\t\ttop: 0;\n\t\t\theight: 100%;\n\t\t\twidth: 100%;\n\t\t\tbackground-color: #f4244f;\n\t\t\topacity: .3;\n\t\t}\n\t\t.bar-inner {\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\tright: 0;\n\t\t\theight: 100%;\n\t\t\tbackground-color: currentColor;\n\t\t}\n\t}\n\t.scroll-bar-text {\n\t\tfont-size: 14px;\n\t\tfont-weight: 600;\n\t\tcursor: pointer;\n\t\ttransition: all 500ms ease;\n\t\t&:hover {\n\t\t\ttransform: scale(1.1);\n\t\t}\n\t}\n}\n.float-bob-y {\n\tanimation-name: float-bob-y;\n\tanimation-duration: 2s;\n\tanimation-iteration-count: infinite;\n\tanimation-timing-function: linear;\n\t-webkit-animation-name: float-bob-y;\n\t-webkit-animation-duration: 2s;\n\t-webkit-animation-iteration-count: infinite;\n\t-webkit-animation-timing-function: linear;\n\t-moz-animation-name: float-bob-y;\n\t-moz-animation-duration: 2s;\n\t-moz-animation-iteration-count: infinite;\n\t-moz-animation-timing-function: linear;\n\t-ms-animation-name: float-bob-y;\n\t-ms-animation-duration: 2s;\n\t-ms-animation-iteration-count: infinite;\n\t-ms-animation-timing-function: linear;\n\t-o-animation-name: float-bob-y;\n\t-o-animation-duration: 2s;\n\t-o-animation-iteration-count: infinite;\n\t-o-animation-timing-function: linear;\n}\n.float-bob-x {\n\tanimation-name: float-bob-x;\n\tanimation-duration: 15s;\n\tanimation-iteration-count: infinite;\n\tanimation-timing-function: linear;\n\t-webkit-animation-name: float-bob-x;\n\t-webkit-animation-duration: 15s;\n\t-webkit-animation-iteration-count: infinite;\n\t-webkit-animation-timing-function: linear;\n\t-moz-animation-name: float-bob-x;\n\t-moz-animation-duration: 15s;\n\t-moz-animation-iteration-count: infinite;\n\t-moz-animation-timing-function: linear;\n\t-ms-animation-name: float-bob-x;\n\t-ms-animation-duration: 15s;\n\t-ms-animation-iteration-count: infinite;\n\t-ms-animation-timing-function: linear;\n\t-o-animation-name: float-bob-x;\n\t-o-animation-duration: 15s;\n\t-o-animation-iteration-count: infinite;\n\t-o-animation-timing-function: linear;\n}\n.main-header {\n\tposition: relative;\n\tleft: 0px;\n\ttop: 0px;\n\tright: 0px;\n\tz-index: 999;\n\twidth: 100%;\n\ttransition: all 500ms ease;\n\t-moz-transition: all 500ms ease;\n\t-webkit-transition: all 500ms ease;\n\t-ms-transition: all 500ms ease;\n\t-o-transition: all 500ms ease;\n\t.outer-box {\n\t\tposition: relative;\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t}\n}\n.main-header-mobile {\n\tposition: fixed;\n\tleft: 0px;\n\ttop: 0px;\n\tright: 0px;\n\tz-index: 999;\n\twidth: 100%;\n\ttransition: all 500ms ease;\n\tbackground-color: #00061A;\n\t-moz-transition: all 500ms ease;\n\t-webkit-transition: all 500ms ease;\n\t-ms-transition: all 500ms ease;\n\t-o-transition: all 500ms ease;\n\t.outer-box {\n\t\tposition: relative;\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t}\n}\n.sticky-header {\n\tposition: fixed;\n\topacity: 0;\n\tvisibility: hidden;\n\tleft: 0px;\n\ttop: 0px;\n\twidth: 100%;\n\tz-index: 0;\n\tbackground-color: #00061A;\n\tbox-shadow: 0px 10px 20px 0px rgba(27, 24, 47, 0.10);\n\ttransition: all 500ms ease;\n\t-moz-transition: all 500ms ease;\n\t-webkit-transition: all 500ms ease;\n\t-ms-transition: all 500ms ease;\n\t-o-transition: all 500ms ease;\n\ttransform: translateY(-100%);\n\tborder-bottom: 0.5px solid #ff8c2e;\n\t.main-menu {\n\t\t.navigation {\n\t\t\tli.dropdown {\n\t\t\t\t.dropdown-btn {\n\t\t\t\t\ttop: 33px;\n\t\t\t\t}\n\t\t\t}\n\t\t\t>li.current {\n\t\t\t\tborder-bottom: none;\n\t\t\t}\n\t\t\t>li {\n\t\t\t\ta {\n\t\t\t\t\t&:before {\n\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t>a {\n\t\t\t\t\tpadding: 30px 0px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.logo-box {\n\t\tpadding: 14px 0px;\n\t}\n\t.nav-right {\n\t\tmargin-left: 30px;\n\t}\n}\n.fixed-header {\n\t.sticky-header {\n\t\tz-index: 999;\n\t\topacity: 1;\n\t\tvisibility: visible;\n\t\t-ms-animation-name: fadeInDown;\n\t\t-moz-animation-name: fadeInDown;\n\t\t-op-animation-name: fadeInDown;\n\t\t-webkit-animation-name: fadeInDown;\n\t\tanimation-name: fadeInDown;\n\t\t-ms-animation-duration: 500ms;\n\t\t-moz-animation-duration: 500ms;\n\t\t-op-animation-duration: 500ms;\n\t\t-webkit-animation-duration: 500ms;\n\t\tanimation-duration: 500ms;\n\t\t-ms-animation-timing-function: linear;\n\t\t-moz-animation-timing-function: linear;\n\t\t-op-animation-timing-function: linear;\n\t\t-webkit-animation-timing-function: linear;\n\t\tanimation-timing-function: linear;\n\t\t-ms-animation-iteration-count: 1;\n\t\t-moz-animation-iteration-count: 1;\n\t\t-op-animation-iteration-count: 1;\n\t\t-webkit-animation-iteration-count: 1;\n\t\tanimation-iteration-count: 1;\n\t\ttransform: translateY(0%);\n\t}\n}\n.main-menu {\n\t.navbar-collapse {\n\t\tpadding: 0px;\n\t\tdisplay: block !important;\n\t}\n\t.navigation {\n\t\tmargin: 0px;\n\t\t>li {\n\t\t\tposition: relative;\n\t\t\tfloat: left;\n\t\t\tz-index: 2;\n\t\t\tmargin: 0px 16px;\n\t\t\t-webkit-transition: all 300ms ease;\n\t\t\t-moz-transition: all 300ms ease;\n\t\t\t-ms-transition: all 300ms ease;\n\t\t\t-o-transition: all 300ms ease;\n\t\t\ttransition: all 300ms ease;\n\t\t\t&:last-child {\n\t\t\t\tmargin-right: 0px !important;\n\t\t\t}\n\t\t\t&:first-child {\n\t\t\t\tmargin-left: 0px !important;\n\t\t\t}\n\t\t\t>a {\n\t\t\t\tposition: relative;\n\t\t\t\tdisplay: block;\n\t\t\t\ttext-align: center;\n\t\t\t\tfont-size: 18px;\n\t\t\t\tline-height: normal;\n\t\t\t\tfont-family: 'Rubik', sans-serif;\n\t\t\t\tpadding: 50px 0px;\n\t\t\t\tfont-weight: 500;\n\t\t\t\topacity: 1;\n\t\t\t\tcolor: #fff;\n\t\t\t\toverflow: hidden;\n\t\t\t\tz-index: 1;\n\t\t\t\t-webkit-transition: all 500ms ease;\n\t\t\t\t-moz-transition: all 500ms ease;\n\t\t\t\t-ms-transition: all 500ms ease;\n\t\t\t\t-o-transition: all 500ms ease;\n\t\t\t\ttransition: all 500ms ease;\n\t\t\t}\n\t\t\t>ul {\n\t\t\t\tposition: absolute;\n\t\t\t\tleft: inherit;\n\t\t\t\ttop: 100%;\n\t\t\t\twidth: 230px;\n\t\t\t\tmargin-top: 15px;\n\t\t\t\tz-index: 100;\n\t\t\t\tdisplay: none;\n\t\t\t\topacity: 0;\n\t\t\t\tpadding-top: 0px;\n\t\t\t\tpadding-bottom: 0px;\n\t\t\t\tvisibility: hidden;\n\t\t\t\tbackground: rgba(0, 6, 26, 1);\n\t\t\t\tborder: 1px solid rgba(255, 255, 255, 0.15);\n\t\t\t\tbox-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.07);\n\t\t\t\ttransition: all 500ms ease;\n\t\t\t\t-moz-transition: all 500ms ease;\n\t\t\t\t-webkit-transition: all 500ms ease;\n\t\t\t\t-ms-transition: all 500ms ease;\n\t\t\t\t-o-transition: all 500ms ease;\n\t\t\t\tpadding: 15px 24px;\n\t\t\t\t>li {\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\t>a {\n\t\t\t\t\t\t\tcolor: #ff8c2e !important;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\tposition: relative;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\t>a {\n\t\t\t\t\t\tposition: relative;\n\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\tpadding: 10px 0px;\n\t\t\t\t\t\tline-height: 24px;\n\t\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\t\tfont-family: 'Rubik', sans-serif;\n\t\t\t\t\t\ttext-transform: capitalize;\n\t\t\t\t\t\tcolor: #fff;\n\t\t\t\t\t\ttext-align: left;\n\t\t\t\t\t\ttransition: all 500ms ease;\n\t\t\t\t\t\t-moz-transition: all 500ms ease;\n\t\t\t\t\t\t-webkit-transition: all 500ms ease;\n\t\t\t\t\t\t-ms-transition: all 500ms ease;\n\t\t\t\t\t\t-o-transition: all 500ms ease;\n\t\t\t\t\t\tcolor: #fff !important;\n\t\t\t\t\t\tborder-bottom: 1px solid rgba(255, 255, 255, 0.15);\n\t\t\t\t\t}\n\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t>a {\n\t\t\t\t\t\t\tborder-bottom: none;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t>ul {\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\tright: 100%;\n\t\t\t\t\t\ttop: 0%;\n\t\t\t\t\t\tmargin-top: 15px;\n\t\t\t\t\t\twidth: 230px;\n\t\t\t\t\t\tz-index: 100;\n\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t\tbackground: rgba(0, 6, 26, 1);\n\t\t\t\t\t\tborder: 1px solid rgba(255, 255, 255, 0.15);\n\t\t\t\t\t\tbox-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.07);\n\t\t\t\t\t\ttransition: all 500ms ease;\n\t\t\t\t\t\t-moz-transition: all 500ms ease;\n\t\t\t\t\t\t-webkit-transition: all 500ms ease;\n\t\t\t\t\t\t-ms-transition: all 500ms ease;\n\t\t\t\t\t\t-o-transition: all 500ms ease;\n\t\t\t\t\t\t>li {\n\t\t\t\t\t\t\tposition: relative;\n\t\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\t\tborder-bottom: none;\n\t\t\t\t\t\t\t\t>a {\n\t\t\t\t\t\t\t\t\tborder-bottom: none;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t>a {\n\t\t\t\t\t\t\t\tposition: relative;\n\t\t\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\t\t\tpadding: 8px 0px;\n\t\t\t\t\t\t\t\tline-height: 24px;\n\t\t\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t\t\t\tborder-bottom: 1px solid rgba(255, 255, 255, 0.15);\n\t\t\t\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\t\t\t\tfont-family: 'Rubik', sans-serif;\n\t\t\t\t\t\t\t\ttext-transform: capitalize;\n\t\t\t\t\t\t\t\tcolor: #fff !important;\n\t\t\t\t\t\t\t\ttext-align: left;\n\t\t\t\t\t\t\t\ttransition: all 500ms ease;\n\t\t\t\t\t\t\t\t-moz-transition: all 500ms ease;\n\t\t\t\t\t\t\t\t-webkit-transition: all 500ms ease;\n\t\t\t\t\t\t\t\t-ms-transition: all 500ms ease;\n\t\t\t\t\t\t\t\t-o-transition: all 500ms ease;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t>li.dropdown {\n\t\t\t\t\t\t\t>a {\n\t\t\t\t\t\t\t\t&:after {\n\t\t\t\t\t\t\t\t\tfont-family: 'Font Awesome 5 Pro';\n\t\t\t\t\t\t\t\t\tcontent: \"\\f105\";\n\t\t\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\t\t\tright: 20px;\n\t\t\t\t\t\t\t\t\ttop: 12px;\n\t\t\t\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\t\t\t\tline-height: 24px;\n\t\t\t\t\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\t\t\t\t\tfont-weight: 900;\n\t\t\t\t\t\t\t\t\tz-index: 5;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t>ul.from-right {\n\t\t\t\t\t\tleft: auto;\n\t\t\t\t\t\tright: 0px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t>li.dropdown {\n\t\t\t\t\t>a {\n\t\t\t\t\t\t&:after {\n\t\t\t\t\t\t\tfont-family: 'icomoon' !important;\n\t\t\t\t\t\t\tcontent: \"\\e906\";\n\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\tright: 20px;\n\t\t\t\t\t\t\ttop: 8px;\n\t\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\t\tline-height: 24px;\n\t\t\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\t\t\tfont-weight: 800;\n\t\t\t\t\t\t\ttext-align: center;\n\t\t\t\t\t\t\tz-index: 5;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t>.megamenu {\n\t\t\t\tposition: absolute;\n\t\t\t\tleft: inherit;\n\t\t\t\ttop: 100%;\n\t\t\t\twidth: 230px;\n\t\t\t\tmargin-top: 15px;\n\t\t\t\tz-index: 100;\n\t\t\t\tdisplay: none;\n\t\t\t\topacity: 0;\n\t\t\t\tpadding-top: 0px;\n\t\t\t\tpadding-bottom: 0px;\n\t\t\t\tvisibility: hidden;\n\t\t\t\tbackground: rgba(0, 6, 26, 1);\n\t\t\t\tborder: 1px solid rgba(255, 255, 255, 0.15);\n\t\t\t\tbox-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.07);\n\t\t\t\ttransition: all 500ms ease;\n\t\t\t\t-moz-transition: all 500ms ease;\n\t\t\t\t-webkit-transition: all 500ms ease;\n\t\t\t\t-ms-transition: all 500ms ease;\n\t\t\t\t-o-transition: all 500ms ease;\n\t\t\t\tli {\n\t\t\t\t\t>a {\n\t\t\t\t\t\tposition: relative;\n\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\tpadding: 10px 0px;\n\t\t\t\t\t\tline-height: 24px;\n\t\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\t\tfont-family: 'Rubik', sans-serif;\n\t\t\t\t\t\ttext-transform: capitalize;\n\t\t\t\t\t\tcolor: #fff;\n\t\t\t\t\t\ttext-align: left;\n\t\t\t\t\t\ttransition: all 500ms ease;\n\t\t\t\t\t\t-moz-transition: all 500ms ease;\n\t\t\t\t\t\t-webkit-transition: all 500ms ease;\n\t\t\t\t\t\t-ms-transition: all 500ms ease;\n\t\t\t\t\t\t-o-transition: all 500ms ease;\n\t\t\t\t\t\tpadding: 6px 0px;\n\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\t&:before {\n\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\tcontent: '';\n\t\t\t\t\t\t\twidth: 0%;\n\t\t\t\t\t\t\theight: 1px;\n\t\t\t\t\t\t\tleft: 0px;\n\t\t\t\t\t\t\tbottom: 8px;\n\t\t\t\t\t\t\ttransition: all 500ms ease;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t&:before {\n\t\t\t\t\t\t\t\twidth: calc(100% - 15px);\n\t\t\t\t\t\t\t\tleft: 15px;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\tpadding-left: 15px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t>a {\n\t\t\t\t\t\t\tborder-bottom: none;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t&:hover {\n\t\t\t\ta {\n\t\t\t\t\tcolor: #ff8c2e;\n\t\t\t\t}\n\t\t\t\t.dropdown-btn {\n\t\t\t\t\tcolor: #ff8c2e !important;\n\t\t\t\t}\n\t\t\t\t&:before {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t}\n\t\t\t}\n\t\t\ta.active {\n\t\t\t\tcolor: #ff8c2e;\n\t\t\t}\n\t\t\t>ul.from-right {\n\t\t\t\tleft: auto;\n\t\t\t\tright: 0px;\n\t\t\t}\n\t\t\t&:before {\n\t\t\t\tcontent: \"\";\n\t\t\t\tbackground: #ff8c2e;\n\t\t\t\twidth: 0%;\n\t\t\t\theight: 3px;\n\t\t\t\tposition: absolute;\n\t\t\t\tleft: 0;\n\t\t\t\tbottom: -3px;\n\t\t\t\ttransition: all 500ms ease;\n\t\t\t}\n\t\t\t.active {\n\t\t\t\tborder-bottom: 3px solid #ff8c2e;\n\t\t\t}\n\t\t}\n\t\t>li.current {\n\t\t\t.dropdown-btn {\n\t\t\t\tcolor: #ff8c2e !important;\n\t\t\t}\n\t\t}\n\t\t>li.dropdown {\n\t\t\t&:hover {\n\t\t\t\t>ul {\n\t\t\t\t\tvisibility: visible;\n\t\t\t\t\topacity: 1;\n\t\t\t\t\tmargin-top: 6px;\n\t\t\t\t\ttop: 100%;\n\t\t\t\t}\n\t\t\t\t>.megamenu {\n\t\t\t\t\tvisibility: visible;\n\t\t\t\t\topacity: 1;\n\t\t\t\t\tmargin-top: 6px;\n\t\t\t\t\ttop: 100%;\n\t\t\t\t}\n\t\t\t}\n\t\t\t>.megamenu {\n\t\t\t\tposition: absolute;\n\t\t\t\twidth: 100%;\n\t\t\t\tpadding: 30px 50px;\n\t\t\t\tleft: 0px;\n\t\t\t}\n\t\t}\n\t\tli {\n\t\t\t>ul {\n\t\t\t\t>li.dropdown {\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\t>ul {\n\t\t\t\t\t\t\tvisibility: visible;\n\t\t\t\t\t\t\topacity: 1;\n\t\t\t\t\t\t\ttop: 0%;\n\t\t\t\t\t\t\tmargin-top: 0px;\n\t\t\t\t\t\t\tmargin-right: 34px;\n\t\t\t\t\t\t\tpadding: 15px 10px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\tli.dropdown {\n\t\t\t.dropdown-btn {\n\t\t\t\tposition: absolute;\n\t\t\t\tright: -23px;\n\t\t\t\ttop: 53px;\n\t\t\t\twidth: 15px;\n\t\t\t\theight: 15px;\n\t\t\t\ttext-align: center;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tline-height: 26px;\n\t\t\t\tcolor: #fff;\n\t\t\t\tcursor: pointer;\n\t\t\t\tz-index: 5;\n\t\t\t\ttransition: all 500ms ease;\n\t\t\t}\n\t\t\tul {\n\t\t\t\tli.dropdown {\n\t\t\t\t\t.dropdown-btn {\n\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.megamenu {\n\t\t\t\tli {\n\t\t\t\t\th6 {\n\t\t\t\t\t\tposition: relative;\n\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\tborder-bottom: 1px solid #e5e5e5;\n\t\t\t\t\t\tpadding-bottom: 13px;\n\t\t\t\t\t\tpadding-top: 13px;\n\t\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\t\tline-height: 26px;\n\t\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\t\ttext-transform: uppercase;\n\t\t\t\t\t\tcolor: #141417;\n\t\t\t\t\t\tmargin-bottom: 7px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.header__style__one {\n\t.outer-box {\n\t\tborder-bottom: 1px solid rgba(255, 255, 255, 0.15);\n\t}\n\t.sticky-header {\n\t\t.outer-box {\n\t\t\tborder-bottom: none;\n\t\t}\n\t}\n}\n.menu-area {\n\t.mobile-nav-toggler {\n\t\tposition: relative;\n\t\tfloat: right;\n\t\tfont-size: 40px;\n\t\tline-height: 50px;\n\t\tcursor: pointer;\n\t\tcolor: #3786ff;\n\t\tdisplay: none;\n\t\t.icon-bar {\n\t\t\tposition: relative;\n\t\t\theight: 2px;\n\t\t\twidth: 30px;\n\t\t\tdisplay: block;\n\t\t\tmargin-bottom: 5px;\n\t\t\tbackground-color: #ff8c2e;\n\t\t\t-webkit-transition: all 300ms ease;\n\t\t\t-moz-transition: all 300ms ease;\n\t\t\t-ms-transition: all 300ms ease;\n\t\t\t-o-transition: all 300ms ease;\n\t\t\ttransition: all 300ms ease;\n\t\t\t&:last-child {\n\t\t\t\tmargin-bottom: 0px;\n\t\t\t}\n\t\t}\n\t}\n}\n.header-lower {\n\t.theme-btn {\n\t\tpadding: 15px 30px;\n\t}\n\t.outer-box {\n\t\t.logo-box {\n\t\t\tpadding: 30px 0px;\n\t\t\t.logo {\n\t\t\t\tmin-width: 200px;\n\t\t\t\timg {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.nav-outer {\n\t.mobile-nav-toggler {\n\t\tposition: relative;\n\t\tfloat: right;\n\t\tfont-size: 40px;\n\t\tline-height: 50px;\n\t\tcursor: pointer;\n\t\tcolor: #3786ff;\n\t\tdisplay: none;\n\t}\n}\n.mobile-menu {\n\tposition: fixed;\n\tright: 0;\n\ttop: 0;\n\twidth: 300px;\n\tpadding-right: 30px;\n\tmax-width: 100%;\n\theight: 100%;\n\topacity: 0;\n\tvisibility: hidden;\n\tz-index: 999999;\n\ttransition: all 900ms ease;\n\t.navbar-collapse {\n\t\tdisplay: block !important;\n\t}\n\t.nav-logo {\n\t\tposition: relative;\n\t\tpadding: 50px 25px;\n\t\ttext-align: left;\n\t\tpadding-bottom: 50px;\n\t}\n\t.menu-backdrop {\n\t\tposition: fixed;\n\t\tleft: 0%;\n\t\ttop: 0;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tz-index: 1;\n\t\ttransition: all 900ms ease;\n\t\tbackground-color: #000;\n\t}\n\t.menu-box {\n\t\tposition: absolute;\n\t\tleft: 0px;\n\t\ttop: 0px;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tmax-height: 100%;\n\t\toverflow-y: auto;\n\t\tbackground: #00061A;\n\t\tpadding: 0px 0px;\n\t\tz-index: 5;\n\t\topacity: 0;\n\t\tvisibility: hidden;\n\t\tborder-radius: 0px;\n\t\t-webkit-transform: translateX(100%);\n\t\t-ms-transform: translateX(100%);\n\t\ttransform: translateX(100%);\n\t\ttransition: all 900ms ease !important;\n\t}\n\t.close-btn {\n\t\tposition: absolute;\n\t\tright: 25px;\n\t\ttop: 10px;\n\t\tline-height: 30px;\n\t\twidth: 24px;\n\t\ttext-align: center;\n\t\tfont-size: 16px;\n\t\tcolor: #ffffff;\n\t\tcursor: pointer;\n\t\tz-index: 10;\n\t\t-webkit-transition: all 0.9s ease;\n\t\t-moz-transition: all 0.9s ease;\n\t\t-ms-transition: all 0.9s ease;\n\t\t-o-transition: all 0.9s ease;\n\t\ttransition: all 0.9s ease;\n\t\t&:hover {\n\t\t\t-webkit-transform: rotate(90deg);\n\t\t\t-ms-transform: rotate(90deg);\n\t\t\ttransform: rotate(90deg);\n\t\t}\n\t}\n\t.navigation {\n\t\tposition: relative;\n\t\tdisplay: block;\n\t\twidth: 100%;\n\t\tfloat: none;\n\t\tli {\n\t\t\tposition: relative;\n\t\t\tdisplay: block;\n\t\t\t// border-top: 1px solid rgba(255,255,255,0.10);\n\t\t\t>ul {\n\t\t\t\t>li {\n\t\t\t\t\t&:first-child {\n\t\t\t\t\t\tborder-top: 1px solid rgba(255,255,255,0.10);\n\t\t\t\t\t}\n\t\t\t\t\t>ul {\n\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t\t>a {\n\t\t\t\tposition: relative;\n\t\t\t\tdisplay: block;\n\t\t\t\tline-height: 24px;\n\t\t\t\tpadding: 10px 25px;\n\t\t\t\tfont-size: 15px;\n\t\t\t\tfont-weight: 500;\n\t\t\t\tcolor: #ffffff;\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\t-webkit-transition: all 500ms ease;\n\t\t\t\t-moz-transition: all 500ms ease;\n\t\t\t\t-ms-transition: all 500ms ease;\n\t\t\t\t-o-transition: all 500ms ease;\n\t\t\t\ttransition: all 500ms ease;\n\t\t\t\t&:before {\n\t\t\t\t\tcontent: '';\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tleft: 0;\n\t\t\t\t\ttop: 0;\n\t\t\t\t\theight: 0;\n\t\t\t\t\tborder-left: 5px solid #fff;\n\t\t\t\t\t-webkit-transition: all 500ms ease;\n\t\t\t\t\t-moz-transition: all 500ms ease;\n\t\t\t\t\t-ms-transition: all 500ms ease;\n\t\t\t\t\t-o-transition: all 500ms ease;\n\t\t\t\t\ttransition: all 500ms ease;\n\t\t\t\t}\n\t\t\t}\n\t\t\t> a.active {\n\t\t\t\tcolor: #ff8c2e !important;\n\t\t\t}\n\t\t\tul {\n\t\t\t\tli {\n\t\t\t\t\t>a {\n\t\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\t\tmargin-left: 20px;\n\t\t\t\t\t\ttext-transform: capitalize;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&:last-child {\n\t\t\t// border-bottom: 1px solid rgba(255,255,255,0.10);\n\t\t}\n\t\tli.current {\n\t\t\t>a {\n\t\t\t\t&:before {\n\t\t\t\t\theight: 100%;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\tli.dropdown {\n\t\t\t.dropdown-btn {\n\t\t\t\tposition: absolute;\n\t\t\t\tright: 6px;\n\t\t\t\ttop: 6px;\n\t\t\t\twidth: 32px;\n\t\t\t\theight: 32px;\n\t\t\t\ttext-align: center;\n\t\t\t\tfont-size: 16px;\n\t\t\t\tline-height: 32px;\n\t\t\t\tcolor: #ffffff;\n\t\t\t\tbackground: rgba(255,255,255,0.10);\n\t\t\t\tcursor: pointer;\n\t\t\t\tborder-radius: 2px;\n\t\t\t\t-webkit-transition: all 500ms ease;\n\t\t\t\t-moz-transition: all 500ms ease;\n\t\t\t\t-ms-transition: all 500ms ease;\n\t\t\t\t-o-transition: all 500ms ease;\n\t\t\t\ttransition: all 500ms ease;\n\t\t\t\tz-index: 5;\n\t\t\t}\n\t\t\t.dropdown-btn.open {\n\t\t\t\tcolor: #ffffff;\n\t\t\t\t-webkit-transform: rotate(90deg);\n\t\t\t\t-ms-transform: rotate(90deg);\n\t\t\t\ttransform: rotate(90deg);\n\t\t\t}\n\t\t}\n\t\t>li.dropdown {\n\t\t\t>.megamenu {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t}\n\t.social-links {\n\t\tposition: relative;\n\t\tpadding: 0px 25px;\n\t\tli {\n\t\t\tposition: relative;\n\t\t\tdisplay: inline-block;\n\t\t\tmargin: 0px 10px 10px;\n\t\t\ta {\n\t\t\t\tposition: relative;\n\t\t\t\tline-height: 32px;\n\t\t\t\tfont-size: 16px;\n\t\t\t\tcolor: #ffffff;\n\t\t\t\t-webkit-transition: all 500ms ease;\n\t\t\t\t-moz-transition: all 500ms ease;\n\t\t\t\t-ms-transition: all 500ms ease;\n\t\t\t\t-o-transition: all 500ms ease;\n\t\t\t\ttransition: all 500ms ease;\n\t\t\t}\n\t\t}\n\t}\n\t.contact-info {\n\t\tposition: relative;\n\t\tpadding: 120px 30px 20px 30px;\n\t\th4 {\n\t\t\tposition: relative;\n\t\t\tfont-size: 20px;\n\t\t\tcolor: #ffffff;\n\t\t\tfont-weight: 700;\n\t\t\tmargin-bottom: 20px;\n\t\t}\n\t\tul {\n\t\t\tli {\n\t\t\t\tposition: relative;\n\t\t\t\tdisplay: block;\n\t\t\t\tfont-size: 15px;\n\t\t\t\tcolor: rgba(255,255,255,0.80);\n\t\t\t\tmargin-bottom: 3px;\n\t\t\t\ta {\n\t\t\t\t\tcolor: rgba(255,255,255,0.80);\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\ttext-decoration: underline;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&:last-child {\n\t\t\t\t\tmargin-bottom: 0px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.mobile-menu-visible {\n\toverflow: hidden;\n\t.mobile-menu {\n\t\topacity: 1;\n\t\tvisibility: visible;\n\t\t.menu-backdrop {\n\t\t\topacity: 0.70;\n\t\t\tvisibility: visible;\n\t\t\tright: 100%;\n\t\t\t-webkit-transition: all .8s ease-out 0s;\n\t\t\t-o-transition: all .8s ease-out 0s;\n\t\t}\n\t\t.menu-box {\n\t\t\topacity: 1;\n\t\t\tvisibility: visible;\n\t\t\t-webkit-transition: all 0.7s ease;\n\t\t\t-o-transition: all 0.7s ease;\n\t\t\ttransition: all 0.7s ease;\n\t\t\t-webkit-transform: translateX(0%);\n\t\t\t-ms-transform: translateX(0%);\n\t\t\ttransform: translateX(0%);\n\t\t}\n\t\t.close-btn {\n\t\t\t-webkit-transform: rotate(360deg);\n\t\t\t-ms-transform: rotate(360deg);\n\t\t\ttransform: rotate(360deg);\n\t\t}\n\t}\n}\ndiv#mCSB_1_container {\n\ttop: 0px !important;\n}\n.header-top-one {\n\t.top__inner {\n\t\tborder-radius: 0px 0px 25px 25px;\n\t\tborder-bottom: 1px solid rgba(255, 255, 255, 0.10);\n\t\tbackground: rgba(255, 255, 255, 0.10);\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t\tpadding: 10px 30px;\n\t}\n}\n.top__hrader__left {\n\tul {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 22px;\n\t}\n\tli {\n\t\tspan {\n\t\t\tcolor: #ff8c2e;\n\t\t}\n\t\tfont-size: 14px;\n\t\ta {\n\t\t\tcolor: #fff;\n\t\t}\n\t}\n}\n.top__hrader__right {\n\tul {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 10px;\n\t\tli {\n\t\t\ta {\n\t\t\t\tborder: 1px solid #272D40;\n\t\t\t\twidth: 30px;\n\t\t\t\theight: 30px;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t\tborder-radius: 50%;\n\t\t\t\tfont-size: 12px;\n\t\t\t\tposition: relative;\n\t\t\t\tz-index: 1;\n\t\t\t\tcolor: #fff;\n\t\t\t\t&:before {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tcontent: \"\";\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\theight: 100%;\n\t\t\t\t\tbackground-color: #800599;\n\t\t\t\t\tborder: 1px solid #800599;\n\t\t\t\t\ttransform: scale(0.0);\n\t\t\t\t\ttransition: all 500ms ease;\n\t\t\t\t\t-moz-transition: all 500ms ease;\n\t\t\t\t\t-webkit-transition: all 500ms ease;\n\t\t\t\t\t-ms-transition: all 500ms ease;\n\t\t\t\t\t-o-transition: all 500ms ease;\n\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\tz-index: -1;\n\t\t\t\t}\n\t\t\t\t&:hover {\n\t\t\t\t\t&:before {\n\t\t\t\t\t\ttransform: scale(1.1);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.mouse-pointer {\n\tposition: fixed;\n\ttop: 50%;\n\tleft: -100px;\n\t-webkit-transform: translate(-50%, -50%);\n\t-ms-transform: translate(-50%, -50%);\n\ttransform: translate(-50%, -50%);\n\twidth: 10px;\n\theight: 10px;\n\tpointer-events: none;\n\t-webkit-box-sizing: border-box;\n\tbox-sizing: border-box;\n\tz-index: 9999;\n\t-webkit-transition-property: width, height, background;\n\t-o-transition-property: width, height, background;\n\ttransition-property: width, height, background;\n\t-webkit-transition-duration: .9s;\n\t-o-transition-duration: .9s;\n\ttransition-duration: .9s;\n\t-webkit-transition-timing-function: cubic-bezier(.19, .94, .336, 1);\n\t-o-transition-timing-function: cubic-bezier(.19, .94, .336, 1);\n\ttransition-timing-function: cubic-bezier(.19, .94, .336, 1);\n\tborder-radius: 50%;\n\tbackground: linear-gradient(224deg, #ff8c2e 0%, #7E2100 100%);\n\toverflow: hidden;\n\t.icon {\n\t\tcolor: #fff;\n\t\tfont-size: 14px;\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\tleft: 50%;\n\t\t-webkit-transform: translate(-100%, -50%);\n\t\t-ms-transform: translate(-100%, -50%);\n\t\ttransform: translate(-100%, -50%);\n\t\topacity: 0;\n\t\t-webkit-transition: .4s cubic-bezier(.225, 1, .316, .99);\n\t\t-o-transition: .4s cubic-bezier(.225, 1, .316, .99);\n\t\ttransition: .4s cubic-bezier(.225, 1, .316, .99);\n\t\ti {\n\t\t\tmargin: 0px 3px;\n\t\t}\n\t}\n}\n.mouse-pointer.display_none {\n\tdisplay: none;\n}\nbody.out {\n\t.mouse-pointer {\n\t\twidth: 0;\n\t\theight: 0;\n\t}\n}\n.mouse-pointer.large {\n\twidth: 65px;\n\theight: 65px;\n\tbackground: rgba(224,36,79,.0) !important;\n\t-webkit-box-shadow: 0 0 30px rgba(224,36,79, 0.4);\n\tbox-shadow: 0 0 30px rgba(224,36,79, 0.4);\n\tdisplay: block !important;\n}\n.mouse-pointer.style-two {\n\tbackground: #41a0ea;\n}\n.mouse-pointer.style-two.large {\n\t-webkit-box-shadow: 0 0 30px rgba(65,160,234, 0.4);\n\tbox-shadow: 0 0 30px rgba(65,160,234, 0.4);\n}\n.mouse-pointer.style-three {\n\tbackground: #6a36ff;\n}\n.mouse-pointer.style-three.large {\n\t-webkit-box-shadow: 0 0 30px rgba(106,54,255, 0.4);\n\tbox-shadow: 0 0 30px rgba(106,54,255, 0.4);\n}\n.mouse-pointer.style-four {\n\tbackground: #bc8664;\n}\n.mouse-pointer.style-four.large {\n\t-webkit-box-shadow: 0 0 30px rgba(188,134,100, 0.4);\n\tbox-shadow: 0 0 30px rgba(188,134,100, 0.4);\n}\n.mouse-pointer.style-five {\n\tbackground: #f1592a;\n}\n.mouse-pointer.style-five.large {\n\t-webkit-box-shadow: 0 0 30px rgba(241,89,42, 0.4);\n\tbox-shadow: 0 0 30px rgba(241,89,42, 0.4);\n}\n.mouse-pointer.style-six {\n\tbackground: #e93421;\n}\n.mouse-pointer.style-six.large {\n\t-webkit-box-shadow: 0 0 30px rgba(233,52,33, 0.4);\n\tbox-shadow: 0 0 30px rgba(233,52,33, 0.4);\n}\n.mouse-pointer.style-seven {\n\tbackground: #f38836;\n}\n.mouse-pointer.style-seven.large {\n\t-webkit-box-shadow: 0 0 30px rgba(243,136,54, 0.4);\n\tbox-shadow: 0 0 30px rgba(243,136,54, 0.4);\n}\n.mouse-pointer.style-eight {\n\tbackground: #ff7f4c;\n}\n.mouse-pointer.style-eight.large {\n\t-webkit-box-shadow: 0 0 30px rgba(255,127,76, 0.4);\n\tbox-shadow: 0 0 30px rgba(255,127,76, 0.4);\n}\n.mouse-pointer.style-nine {\n\tbackground: #ae8c64;\n}\n.mouse-pointer.style-nine.large {\n\t-webkit-box-shadow: 0 0 30px rgba(174,140,100, 0.4);\n\tbox-shadow: 0 0 30px rgba(174,140,100, 0.4);\n}\n.mouse-pointer.style-ten {\n\tbackground: #ff5e14;\n}\n.mouse-pointer.style-ten.large {\n\t-webkit-box-shadow: 0 0 30px rgba(255,94,20, 0.4);\n\tbox-shadow: 0 0 30px rgba(255,94,20, 0.4);\n}\n.mouse-pointer.style-11 {\n\tbackground: #fb4754;\n}\n.mouse-pointer.style-11.large {\n\t-webkit-box-shadow: 0 0 30px rgba(251,71,84, 0.4);\n\tbox-shadow: 0 0 30px rgba(251,71,84, 0.4);\n}\n.mouse-pointer.style-12 {\n\tbackground: #00d0f5;\n}\n.mouse-pointer.style-12.large {\n\t-webkit-box-shadow: 0 0 30px rgba(0,208,245, 0.4);\n\tbox-shadow: 0 0 30px rgba(0,208,245, 0.4);\n}\n.mouse-pointer.style-13 {\n\tbackground: #a44ac5;\n}\n.mouse-pointer.style-13.large {\n\t-webkit-box-shadow: 0 0 30px rgba(164,74,197, 0.4);\n\tbox-shadow: 0 0 30px rgba(164,74,197, 0.4);\n}\n.mouse-pointer.style-14 {\n\tbackground: #17be74;\n}\n.mouse-pointer.style-14.large {\n\t-webkit-box-shadow: 0 0 30px rgba(23,190,116, 0.4);\n\tbox-shadow: 0 0 30px rgba(23,190,116, 0.4);\n}\n.mouse-pointer.small {\n\twidth: 25px;\n\theight: 25px;\n\tbackground: rgba(227,87,18,0);\n\t-webkit-box-shadow: 0 0 30px #e35712;\n\tbox-shadow: 0 0 30px #e35712;\n}\n.mouse-pointer.right {\n\twidth: 50px;\n\theight: 50px;\n\tbackground: #000 !important;\n\t.icon {\n\t\topacity: 1;\n\t\t-webkit-transform: translate(-50%, -50%);\n\t\t-ms-transform: translate(-50%, -50%);\n\t\ttransform: translate(-50%, -50%);\n\t\t-webkit-transition-delay: .2s;\n\t\t-o-transition-delay: .2s;\n\t\ttransition-delay: .2s;\n\t}\n}\n.mouse-pointer.right.large {\n\t.icon {\n\t\topacity: 0;\n\t}\n\tbackground: transparent !important;\n}\n.mouse-pointer.zoom {\n\twidth: 80px;\n\theight: 80px;\n\tbackground: rgba(227,87,18,0);\n\tborder: 2px solid #e35712;\n}\n.mouse-pointer.open {\n\twidth: 80px;\n\theight: 80px;\n\tbackground: rgba(227,87,18,0);\n\tborder: 2px solid #e35712;\n}\n.mouse-pointer.black {\n\tbackground: #000;\n}\n.mouse-pointer.black.large {\n\tbackground: rgba(0,0,0,.4);\n\t-webkit-box-shadow: 0 0 30px rgba(0,0,0,0.2);\n\tbox-shadow: 0 0 30px rgba(0,0,0,0.2);\n}\n.mouse-pointer.black.small {\n\tbackground: rgba(0,0,0,.5);\n\t-webkit-box-shadow: 0 0 30px rgba(0,0,0,0.2);\n\tbox-shadow: 0 0 30px rgba(0,0,0,0.2);\n}\n.mouse-pointer.black.right {\n\tbackground: rgba(0,0,0,0);\n\tborder: 2px solid #000;\n}\n.mouse-pointer.black.zoom {\n\tbackground: rgba(0,0,0,0);\n\tborder: 2px solid #000;\n}\n.mouse-pointer.black.open {\n\tbackground: rgba(0,0,0,0);\n\tborder: 2px solid #000;\n}\n.touch {\n\t.mouse-pointer {\n\t\tdisplay: none;\n\t}\n}\n.mouse-pointer.transparent {\n\tdisplay: none;\n\ttransition: all 500ms ease;\n}\n.main__footer {\n\t.top-inner {\n\t\t// background: linear-gradient(238deg, rgba(246, 236, 79, 0.58) 0%, rgba(0, 6, 26, 0.00) 100%);\n\t\tbackground: linear-gradient(238deg, #00061A 0%, #060E26 100%) !important;\n\t\tpadding: 23px 50px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t\tborder-radius: 4px;\n\t}\n\t.inner__box {\n\t\toverflow: hidden;\n\t\ttransition: all 500ms ease;\n\t\t&:hover {\n\t\t\t.image__box {\n\t\t\t\ta {\n\t\t\t\t\t&:before {\n\t\t\t\t\t\topacity: 0.2;\n\t\t\t\t\t\ttransform: scale(1.1);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.image__box {\n\t\toverflow: hidden;\n\t\tposition: relative;\n\t\timg {\n\t\t\twidth: 100%;\n\t\t\ttransition: all 500ms ease;\n\t\t}\n\t\ta {\n\t\t\t&:before {\n\t\t\t\tcontent: \"\";\n\t\t\t\tbackground: -webkit-linear-gradient(0deg, #c335da, #fc2643 100%);\n\t\t\t\tposition: absolute;\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t\ttransform: scale(0.0);\n\t\t\t\ttransition: all 500ms ease;\n\t\t\t}\n\t\t}\n\t}\n}\n.left__top {\n\th3 {\n\t\tfont-weight: 400;\n\t}\n}\n.footer__one {\n\tbackground: #00061A;\n\tpadding: 150px 0px 30px;\n\tposition: relative;\n\toverflow: hidden;\n}\n.footer-widget {\n\t.text {\n\t\tp {\n\t\t\tcolor: #fff;\n\t\t}\n\t}\n\t.widget-title {\n\t\tpadding-bottom: 40px;\n\t\tposition: relative;\n\t\t&:after {\n\t\t\tcontent: \"\";\n\t\t\tbackground: #ff8c2e;\n\t\t\twidth: 37px;\n\t\t\theight: 2px;\n\t\t\tposition: absolute;\n\t\t\tleft: 0;\n\t\t\ttop: 37px;\n\t\t}\n\t}\n\t.btn-box {\n\t\tdisplay: flex;\n\t}\n}\n.footer-logo-widget {\n\t.text {\n\t\tp {\n\t\t\tpadding: 30px 0px 20px;\n\t\t}\n\t}\n}\n.news-letter-widget {\n\t.form-group {\n\t\tinput {\n\t\t\tborder-radius: 5px;\n\t\t\tborder: 1px solid rgba(255, 255, 255, 0.15);\n\t\t\tcolor: rgba(255, 255, 255, 0.25);\n\t\t\tfont-family: Rubik;\n\t\t\tfont-size: 12px;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 400;\n\t\t\tline-height: 24px;\n\t\t\tletter-spacing: 2.4px;\n\t\t\ttext-transform: uppercase;\n\t\t\twidth: 100%;\n\t\t\tpadding: 22px;\n\t\t}\n\t\tpadding-top: 22px;\n\t\tposition: relative;\n\t\t.btn-box {\n\t\t\tposition: absolute;\n\t\t\tright: 8px;\n\t\t\ttop: 30px;\n\t\t}\n\t}\n}\n.widget_content {\n\tul.instagram_list {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tflex-wrap: wrap;\n\t\tgap: 5px;\n\t}\n}\n.footer-bottom {\n\tpadding-top: 120px;\n\t.copyright {\n\t\tp {\n\t\t\ttext-align: center;\n\t\t\tcolor: #fff;\n\t\t\ta {\n\t\t\t\tcolor: #ff8c2e;\n\t\t\t}\n\t\t}\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tgap: 32px;\n\t\twidth: 100%;\n\t}\n}\n.footer-top {\n\tposition: relative;\n\tmargin-bottom: -60px;\n\tz-index: 9;\n}\n.see__pad {\n\tpadding: 60px 0px;\n}\n.p_relative {\n\tposition: relative !important;\n}\n.p_absolute {\n\tposition: absolute !important;\n}\n.mt-5 {\n\tmargin-top: 5px !important;\n}\n.mt-10 {\n\tmargin-top: 10px !important;\n}\n.mt-15 {\n\tmargin-top: 15px !important;\n}\n.mt-20 {\n\tmargin-top: 20px !important;\n}\n.mt-25 {\n\tmargin-top: 25px !important;\n}\n.mt-30 {\n\tmargin-top: 30px !important;\n}\n.mt-35 {\n\tmargin-top: 35px !important;\n}\n.mt-40 {\n\tmargin-top: 40px !important;\n}\n.mt-45 {\n\tmargin-top: 45px !important;\n}\n.mt-50 {\n\tmargin-top: 50px !important;\n}\n.mt-55 {\n\tmargin-top: 55px !important;\n}\n.mt-60 {\n\tmargin-top: 60px !important;\n}\n.mt-65 {\n\tmargin-top: 65px !important;\n}\n.mt-70 {\n\tmargin-top: 70px !important;\n}\n.mt-75 {\n\tmargin-top: 75px !important;\n}\n.mt-80 {\n\tmargin-top: 80px !important;\n}\n.mb-5 {\n\tmargin-bottom: 5px !important;\n\tmargin-bottom: 5px !important;\n}\n.mb-10 {\n\tmargin-bottom: 10px !important;\n}\n.mb-15 {\n\tmargin-bottom: 15px !important;\n}\n.mb-20 {\n\tmargin-bottom: 20px !important;\n}\n.mb-25 {\n\tmargin-bottom: 25px !important;\n}\n.mb-30 {\n\tmargin-bottom: 30px !important;\n}\n.mb-35 {\n\tmargin-bottom: 35px !important;\n}\n.mb-40 {\n\tmargin-bottom: 40px !important;\n}\n.mb-45 {\n\tmargin-bottom: 45px !important;\n}\n.mb-50 {\n\tmargin-bottom: 50px !important;\n}\n.mb-55 {\n\tmargin-bottom: 55px !important;\n}\n.mb-60 {\n\tmargin-bottom: 60px !important;\n}\n.mb-65 {\n\tmargin-bottom: 65px !important;\n}\n.mb-70 {\n\tmargin-bottom: 70px !important;\n}\n.mb-75 {\n\tmargin-bottom: 75px !important;\n}\n.mb-80 {\n\tmargin-bottom: 80px !important;\n}\n.ml-0 {\n\tmargin-left: 0px !important;\n\tmargin-left: 0px !important;\n}\n.mr-0 {\n\tmargin-right: 0px !important;\n\tmargin-right: 0px !important;\n}\n.mb-0 {\n\tmargin-bottom: 0px !important;\n}\n.ml-5 {\n\tmargin-left: 5px !important;\n}\n.ml-10 {\n\tmargin-left: 10px !important;\n}\n.ml-15 {\n\tmargin-left: 15px !important;\n}\n.ml-20 {\n\tmargin-left: 20px !important;\n}\n.ml-25 {\n\tmargin-left: 25px !important;\n}\n.ml-30 {\n\tmargin-left: 30px !important;\n}\n.ml-35 {\n\tmargin-left: 35px !important;\n}\n.ml-40 {\n\tmargin-left: 40px !important;\n}\n.ml-45 {\n\tmargin-left: 45px !important;\n}\n.ml-50 {\n\tmargin-left: 50px !important;\n}\n.ml-55 {\n\tmargin-left: 55px !important;\n}\n.ml-60 {\n\tmargin-left: 60px !important;\n}\n.ml-65 {\n\tmargin-left: 65px !important;\n}\n.ml-70 {\n\tmargin-left: 70px !important;\n}\n.ml-75 {\n\tmargin-left: 75px !important;\n}\n.ml-80 {\n\tmargin-left: 80px !important;\n}\n.mr-5 {\n\tmargin-right: 5px !important;\n}\n.mr-10 {\n\tmargin-right: 10px !important;\n}\n.mr-15 {\n\tmargin-right: 15px !important;\n}\n.mr-20 {\n\tmargin-right: 20px !important;\n}\n.mr-25 {\n\tmargin-right: 25px !important;\n}\n.mr-30 {\n\tmargin-right: 30px !important;\n}\n.mr-35 {\n\tmargin-right: 35px !important;\n}\n.mr-40 {\n\tmargin-right: 40px !important;\n}\n.mr-45 {\n\tmargin-right: 45px !important;\n}\n.mr-50 {\n\tmargin-right: 50px !important;\n}\n.mr-55 {\n\tmargin-right: 55px !important;\n}\n.mr-60 {\n\tmargin-right: 60px !important;\n}\n.mr-65 {\n\tmargin-right: 65px !important;\n}\n.mr-70 {\n\tmargin-right: 70px !important;\n}\n.mr-75 {\n\tmargin-right: 75px !important;\n}\n.mr-80 {\n\tmargin-right: 80px !important;\n}\n.pt-0 {\n\tpadding-top: 0px !important;\n}\n.pl-0 {\n\tpadding-left: 0px !important;\n}\n.pr-0 {\n\tpadding-right: 0px !important;\n}\n.pb-5 {\n\tpadding-bottom: 5px !important;\n\tpadding-bottom: 5px !important;\n}\n.mt-0 {\n\tmargin-top: 0px !important;\n}\n.pt-10 {\n\tpadding-top: 10px !important;\n}\n.pt-15 {\n\tpadding-top: 15px !important;\n}\n.pt-20 {\n\tpadding-top: 20px !important;\n}\n.pt-25 {\n\tpadding-top: 25px !important;\n}\n.pt-30 {\n\tpadding-top: 30px !important;\n}\n.pt-35 {\n\tpadding-top: 35px !important;\n}\n.pt-40 {\n\tpadding-top: 40px !important;\n}\n.pt-45 {\n\tpadding-top: 45px !important;\n}\n.pt-50 {\n\tpadding-top: 50px !important;\n}\n.pt-55 {\n\tpadding-top: 55px !important;\n}\n.pt-60 {\n\tpadding-top: 60px !important;\n}\n.pt-65 {\n\tpadding-top: 65px !important;\n}\n.pt-70 {\n\tpadding-top: 70px !important;\n}\n.pt-75 {\n\tpadding-top: 75px !important;\n}\n.pt-80 {\n\tpadding-top: 80px !important;\n}\n.pt-100 {\n\tpadding-top: 100px !important;\n}\n.pt-140 {\n\tpadding-top: 140px;\n}\n.pb-10 {\n\tpadding-bottom: 10px !important;\n}\n.pb-15 {\n\tpadding-bottom: 15px !important;\n}\n.pb-20 {\n\tpadding-bottom: 20px !important;\n}\n.pb-25 {\n\tpadding-bottom: 25px !important;\n}\n.pb-24 {\n\tpadding-bottom: 24px !important;\n}\n.pb-30 {\n\tpadding-bottom: 30px !important;\n}\n.pb-35 {\n\tpadding-bottom: 35px !important;\n}\n.pb-40 {\n\tpadding-bottom: 40px !important;\n}\n.pb-45 {\n\tpadding-bottom: 45px !important;\n}\n.pb-50 {\n\tpadding-bottom: 50px !important;\n}\n.pb-55 {\n\tpadding-bottom: 55px !important;\n}\n.pb-60 {\n\tpadding-bottom: 60px !important;\n}\n.pb-65 {\n\tpadding-bottom: 65px !important;\n}\n.pb-70 {\n\tpadding-bottom: 70px !important;\n}\n.pb-75 {\n\tpadding-bottom: 75px !important;\n}\n.pb-80 {\n\tpadding-bottom: 80px !important;\n}\n.pb-100 {\n\tpadding-bottom: 100px !important;\n}\n.pb-140 {\n\tpadding-bottom: 140px;\n}\n.pl-5 {\n\tpadding-left: 5px !important;\n}\n.pl-10 {\n\tpadding-left: 10px !important;\n}\n.pl-15 {\n\tpadding-left: 15px !important;\n}\n.pl-20 {\n\tpadding-left: 20px !important;\n}\n.pl-25 {\n\tpadding-left: 25px !important;\n}\n.pl-30 {\n\tpadding-left: 30px !important;\n}\n.pl-35 {\n\tpadding-left: 35px !important;\n}\n.pl-40 {\n\tpadding-left: 40px !important;\n}\n.pl-45 {\n\tpadding-left: 45px !important;\n}\n.pl-50 {\n\tpadding-left: 50px !important;\n}\n.pl-55 {\n\tpadding-left: 55px !important;\n}\n.pl-60 {\n\tpadding-left: 60px !important;\n}\n.pl-65 {\n\tpadding-left: 65px !important;\n}\n.pl-70 {\n\tpadding-left: 70px !important;\n}\n.pl-75 {\n\tpadding-left: 75px !important;\n}\n.pl-80 {\n\tpadding-left: 80px !important;\n}\n.pr-5 {\n\tpadding-right: 5px !important;\n}\n.pr-10 {\n\tpadding-right: 10px !important;\n}\n.pr-15 {\n\tpadding-right: 15px !important;\n}\n.pr-20 {\n\tpadding-right: 20px !important;\n}\n.pr-25 {\n\tpadding-right: 25px !important;\n}\n.pr-30 {\n\tpadding-right: 30px !important;\n}\n.pr-35 {\n\tpadding-right: 35px !important;\n}\n.pr-40 {\n\tpadding-right: 40px !important;\n}\n.pr-45 {\n\tpadding-right: 45px !important;\n}\n.pr-50 {\n\tpadding-right: 50px !important;\n}\n.pr-55 {\n\tpadding-right: 55px !important;\n}\n.pr-60 {\n\tpadding-right: 60px !important;\n}\n.pr-65 {\n\tpadding-right: 65px !important;\n}\n.pr-70 {\n\tpadding-right: 70px !important;\n}\n.pr-75 {\n\tpadding-right: 75px !important;\n}\n.pr-80 {\n\tpadding-right: 80px !important;\n}\n.sub__title {\n\th4 {\n\t\tcolor: #ff8c2e;\n\t\tfont-family: Archivo;\n\t\tfont-size: 20px;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: normal;\n\t\tletter-spacing: 13.2px;\n\t\ttext-transform: uppercase;\n\t}\n}\n.title__data {\n\tposition: relative;\n\t// padding-left: 61px;\n\tpadding-bottom: 60px;\n\t// &:before {\n\t// \tcontent: \"\";\n\t// \tbackground-image: url(../../images/resource/02.png);\n\t// \twidth: 50px;\n\t// \theight: 70px;\n\t// \tposition: absolute;\n\t// \tbackground-repeat: no-repeat;\n\t// \tleft: 0;\n\t// \ttop: 5px;\n\t// \tbackground-size: contain;\n\t// }\n}\n.title {\n\tpadding-top: 10px;\n}\n.owl-nav {\n\tdisplay: none;\n}\n.owl-dots {\n\tdisplay: none;\n}\n@media (min-width:1296px) {\n\t.container {\n\t\tmax-width: 1296px;\n\t\tpadding: 0px 15px;\n\t}\n}\n\n@media only screen and (max-width: 991px) {\n\t.see__pad {\n\t\tmargin: 120px 0px 60px !important;\n\t}\n}\n","/* Responsive Css */\n@media only screen and (max-width: 1800px) {\n  .choose___two {\n    .pattern-1 {\n      display: none;\n    }\n  }\n  .choose__us__data {\n    &:before {\n      left: 0px;\n    }\n  }\n}\n@media only screen and (max-width: 1449px) {\n  .post__date {\n    ul {\n      li.two {\n        display: none;\n      }\n    }\n  }\n  .choose__us.three {\n    .pattern-2 {\n      left: 0;\n    }\n  }\n  .consultation__text {\n    position: relative;\n    width: auto;\n    left: 0;\n    position: relative;\n    left: 0;\n  }\n  .consultation__img {\n    margin-top: 50px;\n    margin-top: 50px;\n  }\n  .home__three {\n    padding-left: 100px;\n  }\n  .service__block__two {\n    padding: 155px 70px 50px;\n  }\n}\n@media only screen and (max-width: 1231px) {\n  .funfact__content.three {\n    margin-top: 0;\n  }\n}\n@media only screen and (max-width: 1231px) {\n  .funfact__content.three {\n    margin-top: 0;\n  }\n}\n@media only screen and (max-width: 1319px) {\n  .home__three .funfact__content.three {\n    margin-top: 0;\n  }\n}\n@media only screen and (max-width: 1200px) {\n  .main-header.header__style__one {\n    .btn-box {\n      display: none;\n    }\n  }\n  .choose__us__data {\n    &:before {\n      left: 0;\n    }\n  }\n  .testimonial__section {\n    .swiper-wrapper {\n      > * {\n        &:nth-child(even) {\n          margin-top: 0px;\n        }\n      }\n    }\n  }\n  .see__pad {\n    padding: 50px 0px;\n  }\n  br {\n    display: none;\n  }\n  .banner__one {\n    .banner__bg {\n      display: none;\n    }\n  }\n  .accomplised__section {\n    padding-top: 40px;\n  }\n  .funfact__content.three {\n    margin-top: 0px;\n  }\n  .test__bg {\n    display: none;\n  }\n  .news__block {\n    margin-bottom: 20px;\n  }\n  .post__date, .detail__post__date {\n    ul {\n      gap: 20px;\n    }\n  }\n  .protfolio__inner {\n    margin-right: 0;\n  }\n  .portfolio__block {\n    img {\n      width: 100%;\n    }\n  }\n  .page__title {\n    padding: 150px 0px;\n    .title {\n      font-size: 60px;\n      line-height: 70px;\n    }\n  }\n  .pride__block {\n    h1 {\n      font-size: 60px;\n      line-height: 70px;\n      padding: 0px 20px;\n    }\n  }\n  .testimonial___data {\n    .row {\n      > div {\n        &:nth-child(even) {\n          margin-top: 0px;\n        }\n      }\n    }\n  }\n  .testimonials__block__one.page {\n    margin-bottom: 50px;\n  }\n  // .tags-list-1 {\n  // \tdisplay: block;\n  // }\n  // .tags__left {\n  // \tdisplay: block;\n  // }\n  .comments__box {\n    display: block;\n  }\n  .blog__inner__box {\n    padding: 40px;\n  }\n  .home__three {\n    .about__block {\n      margin-top: 0;\n    }\n  }\n  .consultation__text {\n    padding-top: 50px;\n  }\n  .footer__one {\n    padding-top: 100px;\n  }\n  .service__contact.three {\n    padding-bottom: 100px;\n  }\n  .main-header.header__three {\n    position: relative;\n    width: auto;\n  }\n  .header__three {\n    .outer-box {\n      display: flex !important;\n      height: auto;\n      justify-content: space-between;\n      padding: 0px 20px;\n    }\n    .logo-box {\n      position: relative;\n      left: 0 !important;\n      padding: 30px 0px !important;\n      transform: translate(0px, 0px);\n      top: 0;\n    }\n    .menu-area {\n      position: relative;\n      left: 0;\n      top: 0;\n      transform: translate(0px, 0px);\n    }\n    .banner__media_two {\n      display: none;\n    }\n  }\n  .home__three {\n    padding-left: 0px;\n  }\n  .service__details__left {\n    margin-bottom: 50px;\n  }\n  .error__page {\n    h1.title {\n      font-size: 200px;\n    }\n  }\n  .core_value_content.remove_gap_core_value {\n    margin-top: 0;\n  }\n}\n@media only screen and (min-width: 768px) {\n  .main-menu {\n    .navigation {\n      > li {\n        > ul {\n          display: block !important;\n          visibility: hidden;\n          opacity: 0;\n          > li {\n            > ul {\n              display: block !important;\n              visibility: hidden;\n              opacity: 0;\n            }\n          }\n        }\n        > .megamenu {\n          display: block !important;\n          visibility: hidden;\n          opacity: 0;\n        }\n      }\n    }\n  }\n}\n@media only screen and (max-width: 1199px) {\n  .core_value_content.remove_gap_core_value_1 {\n    margin-top: 0;\n  }\n  .core_value_content.remove_gap_core_value_2 {\n    margin-top: -65px;\n  }\n}\n@media only screen and (max-width: 1087px) {\n  .core_value_content.remove_gap_core_value_1 {\n    margin-top: -65px;\n  }\n  .core_value_content.remove_gap_core_value_2 {\n    margin-top: -65px;\n  }\n}\n@media only screen and (max-width: 991px) {\n  .main-menu {\n    display: none !important;\n  }\n  .sticky-header {\n    display: none !important;\n  }\n  .main-header.style-one {\n    .outer-container {\n      &:before {\n        display: none !important;\n      }\n    }\n  }\n  .menu-area {\n    .mobile-nav-toggler {\n      display: block;\n      padding: 10px;\n    }\n  }\n  .megamenu {\n    ul {\n      li {\n        &:first-child {\n          display: none;\n        }\n      }\n    }\n  }\n  .pattern-layer {\n    display: none;\n  }\n  .header-top-one {\n    .top__inner {\n      display: none;\n    }\n  }\n  .brand__content {\n    .brand__name {\n      h1 {\n        font-size: 40px;\n      }\n    }\n  }\n  .brand__section {\n    .brand-carousel {\n      padding: 40px 0px;\n    }\n  }\n  .icon__image__banner {\n    position: absolute;\n    left: 50%;\n    bottom: -61px;\n    transform: translate(-50%, 0%);\n  }\n  .banner__right {\n    padding-top: 100px;\n    figure.image-box {\n      img {\n        width: 100%;\n      }\n    }\n  }\n  .scroll-to-top {\n    display: none;\n  }\n  .service__block {\n    &:before {\n      padding: 1px;\n    }\n    margin-bottom: 20px;\n  }\n  .about__block {\n    padding-bottom: 50px;\n  }\n  .funfact__content.about {\n    bottom: 50px;\n  }\n  .choose__block {\n    padding: 0px 0px 50px;\n  }\n  .team__block {\n    margin-bottom: 60px;\n  }\n  .funfact__data {\n    justify-content: start;\n    padding-top: 50px;\n  }\n  .vision_mission_wrapper {\n    grid-template-columns: repeat(1, 1fr);\n    width: 80%;\n  }\n  .office-wrapper {\n    grid-template-columns: repeat(1, 1fr);\n    width: 100%;\n    gap: 32px;\n  }\n  .office-map-wrapper {\n    height: 480px;\n  }\n  .news-articles-wrapper {\n    flex-direction: column;\n    gap: 20px;\n    padding: 0 12px;\n  }\n  .accomplised__data {\n    padding: 100px 20px;\n  }\n  .testimonials__info {\n    padding: 100px;\n  }\n  .blog__section {\n    .normaol__text {\n      padding-left: 0;\n      padding-bottom: 50px;\n    }\n  }\n  .main__footer {\n    .top-inner {\n      display: block;\n      .right__top {\n        padding-top: 20px;\n      }\n    }\n  }\n  .footer-column {\n    padding-bottom: 20px;\n  }\n  .main-header.two {\n    top: 20px;\n  }\n  .about__two__img__block {\n    figure {\n      img {\n        width: 100%;\n      }\n    }\n    .about__two__circle {\n      right: 20px;\n    }\n  }\n  .about__text__two {\n    padding-bottom: 20px;\n    justify-content: start;\n  }\n  .choose_img__block {\n    img {\n      width: 100%;\n    }\n  }\n  .choose__text__block {\n    padding-top: 50px;\n  }\n  .accomplised__data.two {\n    padding: 0;\n  }\n  .brand__section_two {\n    padding: 0px 20px 100px;\n  }\n  .price__content {\n    margin-bottom: 60px;\n  }\n  .service__form__data {\n    padding: 0;\n  }\n  .service__contact__block {\n    padding: 80px 40px;\n  }\n  .service__contact__img {\n    position: relative;\n    padding-top: 50px;\n  }\n  .project__page {\n    margin: 0 20px;\n  }\n  .contact__right {\n    padding: 40px;\n  }\n  .banner__media {\n    display: none;\n  }\n  section.banner__one {\n    margin-top: 120px;\n  }\n  .banner__one.home__three__banner {\n    padding-top: 100px;\n  }\n  .consultation__img {\n    img {\n      width: 100%;\n    }\n  }\n  .accomplised__data.two.three {\n    padding: 20px;\n  }\n  .home__three__banner {\n    .banner__mission__block {\n      h3 {\n        padding-bottom: 10px;\n      }\n    }\n  }\n  .pro__info {\n    margin: 50px 0px 0px;\n    width: 100%;\n    max-width: 100%;\n  }\n  .news___block {\n    width: 100%;\n  }\n  .inner-box {\n    .image-box {\n      img {\n        height: 300px;\n      }\n    }\n  }\n  .blog__details__content {\n    .blog__image {\n      img {\n        height: 480px;\n      }\n    }\n  }\n  .post__date {\n    ul {\n      flex-direction: column;\n      align-items: flex-start;\n    }\n  }\n  .core_value_content.remove_gap_core_value_1 {\n    margin-top: 0px;\n  }\n  .core_value_content.remove_gap_core_value_2 {\n    margin-top: -65px;\n  }\n  .industry__block {\n    width: 150px;\n  }\n  .industry__icon {\n    width: 100px;\n    height: 110px;\n    i {\n      width: 100px;\n      height: 110px;\n    }\n    img {\n      width: 150px;\n    }\n  }\n  .industry__text {\n    button h4 {\n      font-size: 16px;\n    }\n  }\n  .footer-bottom {\n    .copyright {\n      flex-direction: column-reverse;\n    }\n  }\n  .social-media-wrapper {\n    margin-bottom: 64px;\n  }\n}\n@media only screen and (max-width: 910px) {\n  .core_value_content.remove_gap_core_value_1 {\n    margin-top: -65px;\n  }\n  .core_value_content.remove_gap_core_value_2 {\n    margin-top: -65px;\n  }\n}\n@media only screen and (max-width: 767px) {\n  .banner__title {\n    h1 {\n      font-size: 50px;\n      line-height: 60px;\n    }\n  }\n  .sub__title {\n    h4 {\n      font-size: 16px;\n      letter-spacing: 5.2px;\n    }\n  }\n  h2 {\n    font-size: 30px;\n    font-weight: 700;\n    line-height: 40px;\n  }\n  .team__data {\n    .team__data__left {\n      padding-bottom: 20px;\n    }\n    display: block;\n  }\n  .brand__section.p_relative.see__pad {\n    padding: 50px 0px 0px;\n  }\n  .mission__block {\n    padding: 40px;\n  }\n  .home__three__banner {\n    .banner__mission__block {\n      margin-bottom: 20px;\n    }\n  }\n  .pro__info {\n    margin: 50px 0px 0px;\n    width: 100%;\n    max-width: 100%;\n    ul {\n      display: block;\n      li {\n        margin-bottom: 20px;\n      }\n    }\n  }\n  .core_value_content.remove_gap_core_value_1 {\n    margin-top: -65px;\n  }\n  .core_value_content.remove_gap_core_value_2 {\n    margin-top: -65px;\n  }\n}\n@media only screen and (max-width: 683px) {\n  .core_value_content.remove_gap_core_value_1 {\n    margin-top: 0px;\n  }\n  .core_value_content.remove_gap_core_value_2 {\n    margin-top: -65px;\n  }\n}\n@media only screen and (max-width: 599px) {\n  .product__block__wrapper {\n    padding: 0 40px 100px;\n  }\n  .industry__block__wrapper {\n    padding: 0 40px 100px;\n  }\n  .new__service__block__wrapper {\n    padding: 0 40px 100px;\n  }\n  .service__block {\n    padding: 40px 30px 80px;\n  }\n  .service__data {\n    padding: 90px 10px 0px;\n  }\n  .testimonials__info {\n    padding: 40px 49px 80px;\n  }\n  .testimonial__top {\n    display: block;\n  }\n  .main__footer {\n    .top-inner {\n      padding: 20px;\n    }\n    .left__top {\n      h3 {\n        font-size: 25px;\n        line-height: 35px;\n      }\n    }\n  }\n  .banner__two {\n    .content-box {\n      h2 {\n        font-size: 50px;\n        line-height: 60px;\n      }\n    }\n  }\n  section.banner__two {\n    padding-top: 200px;\n  }\n  .banner__mission__block {\n    display: block;\n  }\n  .pride__block {\n    h1 {\n      font-size: 40px;\n      line-height: 50px;\n      padding: 0px 20px;\n    }\n  }\n  .bread__crumb {\n    li {\n      letter-spacing: 4px;\n    }\n  }\n  .core_value_content.remove_gap_core_value_1 {\n    margin-top: 0;\n  }\n  .core_value_content.remove_gap_core_value_2 {\n    margin-top: -65px;\n  }\n}\n@media only screen and (max-width: 499px) {\n  .mobile-menu {\n    width: 100%;\n  }\n  .main-header {\n    .btn-box {\n      display: none;\n    }\n    .search-box-outer {\n      .dropdown-menu {\n        width: 300px;\n      }\n    }\n  }\n  .funfact__data {\n    justify-content: center;\n  }\n  .vision_mission_wrapper {\n    grid-template-columns: repeat(1, 1fr);\n    width: 80%;\n  }\n  .office-wrapper {\n    grid-template-columns: repeat(1, 1fr);\n    width: 100%;\n    gap: 32px;\n  }\n  .office-map-wrapper {\n    height: 480px;\n  }\n  .news-articles-wrapper {\n    flex-direction: column;\n    gap: 20px;\n    padding: 0 12px;\n  }\n  .brand__content {\n    .brand__name {\n      h1 {\n        font-size: 30px;\n      }\n    }\n  }\n  .brand__section {\n    .brand-carousel {\n      padding: 45px 20px;\n    }\n  }\n  .banner__two {\n    .content-box {\n      h2 {\n        font-size: 40px;\n        line-height: 50px;\n      }\n    }\n  }\n  .service__block__two {\n    padding: 100px 40px 50px;\n  }\n  .brand__section_two {\n    .brand__content {\n      .brand__name {\n        h1 {\n          font-size: 35px;\n        }\n      }\n    }\n  }\n  .choose_us_block {\n    li {\n      font-size: 20px;\n      line-height: 30px;\n      padding: 15px 0px;\n    }\n  }\n  .consultation__list {\n    li {\n      a {\n        font-size: 20px;\n        padding: 20px 0px 20px 85px;\n      }\n    }\n  }\n  .sidebar__widget_network {\n    padding: 100px 20px;\n  }\n  .error__page {\n    h1.title {\n      font-size: 100px;\n    }\n  }\n  .news___block {\n    width: 100%;\n  }\n  .inner-box {\n    .image-box {\n      img {\n        height: 300px;\n      }\n    }\n  }\n  .blog__details__content {\n    .blog__image {\n      img {\n        height: 300px;\n      }\n    }\n  }\n  .core_value_content.remove_gap_core_value_1 {\n    margin-top: 0;\n  }\n  .core_value_content.remove_gap_core_value_2 {\n    margin-top: 0;\n  }\n}\n@media only screen and (max-width: 399px) {\n  .header-top-one {\n    .top-right {\n      li.search-box-outer {\n        display: none;\n      }\n    }\n  }\n  .banner__left {\n    padding-top: 26px;\n  }\n  .testimonials__info {\n    clip-path: none;\n    padding: 41px 30px 80px;\n  }\n  .protfolio__button {\n    width: 80%;\n  }\n  .contact__right {\n    padding: 40px 20px;\n  }\n  .pro__info {\n    padding: 40px;\n  }\n}\n","@font-face {\n  font-family: 'icomoon';\n  src:  url('../fonts/icomoon.eot?buz9qd');\n  src:  url('../fonts/icomoon.eot?buz9qd#iefix') format('embedded-opentype'),\n    url('../fonts/icomoon.ttf?buz9qd') format('truetype'),\n    url('../fonts/icomoon.woff?buz9qd') format('woff'),\n    url('../fonts/icomoon.svg?buz9qd#icomoon') format('svg');\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n\n[class^=\"icon-\"], [class*=\" icon-\"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'icomoon' !important;\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-17:before {\n  content: \"\\e910\";\n}\n.icon-18:before {\n  content: \"\\e911\";\n}\n.icon-16:before {\n  content: \"\\e90f\";\n}\n.icon-01:before {\n  content: \"\\e900\";\n}\n.icon-02:before {\n  content: \"\\e901\";\n}\n.icon-03:before {\n  content: \"\\e902\";\n}\n.icon-04:before {\n  content: \"\\e903\";\n}\n.icon-05:before {\n  content: \"\\e904\";\n}\n.icon-06:before {\n  content: \"\\e905\";\n}\n.icon-07:before {\n  content: \"\\e906\";\n}\n.icon-08:before {\n  content: \"\\e907\";\n}\n.icon-09:before {\n  content: \"\\e908\";\n}\n.icon-10:before {\n  content: \"\\e909\";\n}\n.icon-11:before {\n  content: \"\\e90a\";\n}\n.icon-12:before {\n  content: \"\\e90b\";\n}\n.icon-13:before {\n  content: \"\\e90c\";\n}\n.icon-14:before {\n  content: \"\\e90d\";\n}\n.icon-15:before {\n  content: \"\\e90e\";\n}\n.icon-19:before {\n  content: \"\\e912\";\n}\n.icon-20:before {\n  content: \"\\e913\";\n}\n.icon-fa-times:before {\n  content: \"\\e914\";\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
